<div *ngIf="leadDetailPageType === 0" style="width: 100%;" fxLayout="column" fxLayout.gt-sm="row">
    <div fxFlex="30" fxFlex.lt-md="0" fxLayout="column" class="column-1" [formGroup]="firstFormGroup">
        <div fxLayout="row" fxLayoutAlign="start center" style="margin-top: 2px; margin-bottom: 10px;">
            <button [attr.guide]="sanitizedUrl + '-back-btn'" class="bgc" matTooltip="Back" (click)="back()"
                mat-raised-button style="display: flex; align-items: center; padding: 0px 9px; border-radius: 4px;">
                <mat-icon style="color: white;">keyboard_backspace</mat-icon>
                <span style="margin-left: 8px;">Back</span>
            </button>
            <h1 fxLayoutAlign="center center" style="margin: 0; font-size: 24px;  margin-left: 12px;"
                class="colorPrimary">Lead Details</h1>
        </div>

        <div class="usderinfo">
            <div fxLayout="row">
                <div fxFlex="70" class="col-70">
                    <!-- <button [attr.guide]="'lead-detail-btn-1' + '__' + sanitizedUrl" class="bgc" matTooltip="Back" (click)="back()" mat-icon-button
                    style="display: flex; align-items: center; padding: 0px 9px; border-radius: 4px;">
                    <mat-icon style="color: white;">keyboard_backspace</mat-icon>
                   
                </button> -->
                </div>
                <div fxFlex="10" class="col-10" style="cursor: pointer;">
                    <button [attr.guide]="sanitizedUrl + '-walkin-btn'" style="padding-right: 10px;" class="fav-button"
                        type="button" mat-icon-button (click)="walkIn(LeadDetailsObject)"
                        [ngClass]="{ 'favorite': LeadDetailsObject?.walkIn==1 }">
                        <mat-icon style="font-size: 22px;">{{ LeadDetailsObject?.walkIn==1 ? 'directions_walk' :
                            'directions_walk' }}</mat-icon>
                    </button>

                </div>

                <div fxFlex="10" *ngIf="dialerType == 7" class="col-10" style="cursor: pointer;">
                    <button [attr.guide]="sanitizedUrl + '-dialer-btn'" mat-icon-button class="fav-button" type="button"
                        (click)="newdialer(LeadDetailsObject)">
                        <mat-icon>call</mat-icon>
                    </button>
                </div>
                <div fxFlex="10" class="col-10" style="cursor: pointer;">
                    <button [attr.guide]="sanitizedUrl + '-favorite-btn'" class="fav-button" type="button"
                        mat-icon-button (click)="toggleFavorite(LeadDetailsObject)"
                        [ngClass]="{ 'favorite': LeadDetailsObject?.favourite==1 }">
                        <mat-icon>{{ LeadDetailsObject?.favourite==1 ? 'favorite' : 'favorite_border' }}</mat-icon>
                    </button>
                </div>
                <div fxFlex="10" class="col-10" *ngIf="!editMode;" style="cursor: pointer;">
                    <button [attr.guide]="sanitizedUrl + '-edit-btn'" class="fav-button" type="button" mat-icon-button
                        (click)="editForm()">
                        <mat-icon>edit</mat-icon>
                    </button>

                    <!-- <mat-icon (click)="editForm()" class="iconcss">edit</mat-icon> -->
                </div>
                <div fxFlex="10" class="col-10" *ngIf="editMode;" style="cursor: pointer;">

                    <button [attr.guide]="sanitizedUrl + '-save-btn'" type="button" mat-icon-button
                        (click)="submitNew()">
                        <mat-icon *ngIf="text =='Save' " class="iconcss">check</mat-icon>
                        <mat-icon *ngIf="text !='Save' ">
                            <mat-spinner style="stroke: red;" diameter="20">
                            </mat-spinner>
                        </mat-icon>
                    </button>


                </div>

                <div fxFlex="10" class="col-10" *ngIf="editMode;" style="cursor: pointer;">

                    <button [attr.guide]="sanitizedUrl + '-close-btn'" type="button" mat-icon-button (click)="close()">
                        <mat-icon class="iconcss">close</mat-icon>
                    </button>
                </div>
                <div fxFlex="5" class="col-10" *ngIf="!editMode;" style="cursor: pointer;">
                    <!-- <mat-icon class="iconcss">share</mat-icon> -->
                </div>
            </div>

            <div fxLayout="row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">star_border</mat-icon>
                </div>
                <div fxFlex="60" class="col-60" style="margin-top: 5px;">
                    <h6 style="color: white;" [ngClass]="{'underline': editMode}">
                        <ng-container *ngIf="!editMode; else editName">
                            {{LeadDetailsObject?.name}}
                        </ng-container>
                        <ng-template #editName>
                            <input [attr.guide]="sanitizedUrl + '-name-input'" formControlName="Name"
                                placeholder="Name" />
                        </ng-template>
                    </h6>
                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>

            <div class="row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">thumbs_up_down</mat-icon>
                </div>
                <div fxFlex="80" class="col-80">
                    <p style="color: white;margin-top: 5px;">
                        <i>
                            <ng-container *ngIf="!editMode; else editStatus">
                                {{LeadDetailsObject?.statusName}} {{LeadDetailsObject?.secondaryLeadStatus}}
                            </ng-container>
                            <ng-template #editStatus>
                                <!-- <mat-form-field class="my-custom-field" style="width: 100%;">
                                    <mat-label class="white-text">Lead Status</mat-label>
                                    <mat-select formControlName="LeadStatus" class="white-text">
                                        <mat-option *ngFor="let status of leadStatusList" [value]="status.statusId"
                                            class="white-text">
                                            {{ status.statusName }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field> -->

                                <mat-form-field class="my-custom-field" style="width: 100%;" fxFlex>
                                    <mat-label class="white-text">Lead Status</mat-label>
                                    <mat-select class="white-text" formControlName="LeadStatus"
                                        [disableOptionCentering]="true" #singleSelect autocomplete="off">
                                        <mat-option>
                                            <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                                [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                                [preventHomeEndKeyPropagation]="true"
                                                noEntriesFoundLabel="No data found">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option class="white-text"
                                            (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId)"
                                            *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                            [value]="opt.statusId">
                                            {{opt.statusName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>




                            </ng-template>
                        </i>
                    </p>
                </div>
                <div fxFlex="10" class="col-10">
                </div>
            </div>

            <ng-container *ngIf="editMode">

                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                    <div *ngIf="formInit" fxFlex="10" class="col-10">
                        <!-- <mat-icon class="iconcss">thumbs_up_down</mat-icon> -->
                    </div>

                    <div *ngIf="formInit" fxFlex>

                        <simple-dynamic-form [layout]="2" [formValue]="patchValues" (submitLeadDetail)="saveNew($event)"
                            [status]="firstFormGroup.value.LeadStatus" [formType]="'standard'" [type]="2"
                            (submit)="onFormSubmitted($event)" [fields]="regConfig">

                        </simple-dynamic-form>

                    </div>
                    <div fxFlex="10" class="col-10">
                    </div>

                </div>
            </ng-container>

            <div fxLayout="row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">mail</mat-icon>
                </div>
                <div fxFlex="90" class="col-90" style="color: white;margin-top: 5px;">
                    <ng-container *ngIf="!editMode; else editEmail">
                        <span class="textcss">{{LeadDetailsObject?.email}}</span>
                    </ng-container>
                    <ng-template #editEmail>
                        <input [attr.guide]="sanitizedUrl + '-email-input'" width="100%" formControlName="Email"
                            placeholder="Email" />
                    </ng-template>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>
            <div fxLayout="row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">call</mat-icon>
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">
                    <ng-container *ngIf="!editMode; else editPhoneNo">


                        <span *ngIf="encryptPhone==0" style="cursor: pointer;"
                            (click)="phoneNumbercall(LeadDetailsObject)"
                            class="textcss">{{LeadDetailsObject?.phoneNumber}}</span>

                        <span *ngIf="encryptPhone==1" style="cursor: pointer;"
                            (click)="phoneNumbercall(LeadDetailsObject)"
                            class="textcss">{{LeadDetailsObject?.phoneNumber| slice:0:4 }} ****</span>
                    </ng-container>
                    <ng-template #editPhoneNo>
                        <input [attr.guide]="sanitizedUrl + '-phonenumber-input'" formControlName="PhoneNumber"
                            placeholder="PhoneNumber" />
                    </ng-template>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>
            <div fxLayout="row">
                <div fxFlex="10" class="col-10">
                    <img src="assets/icons/whatsapp.svg" alt="Whatsapp"
                        (click)="phonewhatsapp(LeadDetailsObject); $event.stopPropagation()"
                        style="width: 20px; height: 20px; cursor: pointer; display: inline-block; vertical-align: middle;">
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">
                    <ng-container *ngIf="!editMode; else editPhoneNo">

                        <span *ngIf="encryptPhone==0" style="cursor: pointer;"
                            (click)="phonewhatsapp(LeadDetailsObject)"
                            class="textcss">{{LeadDetailsObject?.phoneNumber}}</span>

                        <span *ngIf="encryptPhone==1" style="cursor: pointer;"
                            (click)="phonewhatsapp(LeadDetailsObject)" class="textcss">{{LeadDetailsObject?.phoneNumber|
                            slice:0:4 }} ****</span>
                    </ng-container>
                    <ng-template #editPhoneNo>
                        <input [attr.guide]="sanitizedUrl + '-phonenumber-input'" formControlName="PhoneNumber"
                            placeholder="PhoneNumber" />
                    </ng-template>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>

            <div fxLayout="row">
                <div fxFlex="10" class="col-10">
                    <mat-icon (click)="phoneSms(LeadDetailsObject); $event.stopPropagation()" style="cursor: pointer;">
                        textsms
                    </mat-icon>
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">
                    <ng-container *ngIf="!editMode; else editPhoneNo">

                        <span *ngIf="encryptPhone==0" style="cursor: pointer;" (click)="phoneSms(LeadDetailsObject)"
                            class="textcss">{{LeadDetailsObject?.phoneNumber}}</span>

                        <span *ngIf="encryptPhone==1" style="cursor: pointer;" (click)="phoneSms(LeadDetailsObject)"
                            class="textcss">{{LeadDetailsObject?.phoneNumber| slice:0:4 }} ****</span>
                    </ng-container>
                    <ng-template #editPhoneNo>
                        <input [attr.guide]="sanitizedUrl + '-phonenumber-input'" formControlName="PhoneNumber"
                            placeholder="PhoneNumber" />
                    </ng-template>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>

            <div *ngIf="additionalSpec?.Address && additionalSpec?.Address.length>0" fxLayout="row">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">location_on</mat-icon>
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 3px;">
                    <!-- <ng-container *ngIf="!editMode; else editAddress">
                        <span class="textcss">{{additionalSpec?.Address}}</span>
                    </ng-container>
                    <ng-template #editAddress>
                        <input [attr.guide]="'lead-detail-inp-address' + '__' + sanitizedUrl" formControlName="Address" placeholder="Address" />
                    </ng-template> -->

                    <span class="textcss" style="word-wrap: break-word;">{{additionalSpec?.Address}}</span>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>


            <div fxLayout="row" *ngIf="additionalAttributeEnable==1">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">person_outline</mat-icon>
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">
                    <ng-container *ngIf="!editMode; else editCrName">
                        <span style="cursor: pointer;" class="textcss">{{additionalSpec?.CrName}}</span>
                    </ng-container>
                    <ng-template #editCrName>
                        <input [attr.guide]="'lead-detail-inp-crname' + '__' + sanitizedUrl" formControlName="CrName"
                            placeholder="Cr Name" />
                    </ng-template>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>

            <div fxLayout="row" *ngIf="additionalAttributeEnable==1">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">assignment</mat-icon>

                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">
                    <ng-container *ngIf="!editMode; else editCrNo">
                        <span style="cursor: pointer;" class="textcss">{{additionalSpec?.CrNo}}</span>
                    </ng-container>
                    <ng-template #editCrNo>
                        <input [attr.guide]="'lead-detail-inp-crno' + '__' + sanitizedUrl" formControlName="CrNo"
                            placeholder="Cr No" />
                    </ng-template>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>

            <div fxLayout="row" *ngIf="mapLink?.length>0">
                <div fxFlex="10" class="col-10">
                    <mat-icon (click)="navigatelink(mapLink)" style="cursor: pointer;">location_on
                    </mat-icon>
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">

                    <span style="cursor: pointer;word-wrap: break-word;" (click)="navigatelink(mapLink)"
                        class="textcss">{{mapLink}}</span>


                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>

            <div fxLayout="row" *ngIf="defaultForm&&editMode">
                <div fxFlex="10" class="col-10">
                    <mat-icon class="iconcss">thumbs_up_down</mat-icon>
                </div>
                <div fxFlex="70" class="col-70" style="color: white;margin-top: 5px;">

                    <simple-dynamic-form [layout]="2" [formValue]="patchValues" (submitLeadDetail)="saveNew($event)"
                        [status]="firstFormGroup.value.LeadStatus" [formType]="'standard'" [type]="2"
                        (submit)="onFormSubmitted($event)" [fields]="defaultConfig">
                    </simple-dynamic-form>

                </div>
                <div fxFlex="20" class="col-20">
                </div>
            </div>


            <div *ngIf="customField9 && !editMode">
                <div *ngFor="let item of defaultConfig " fxLayout="row"
                    style="flex-wrap: wrap; color: white; margin-top: 5px;">

                    <div fxFlex="10" class="col-10">
                        <mat-icon class="iconcss">label_important</mat-icon>
                    </div>

                    <div fxFlex="90" class="col-90">

                        <span><strong>{{item.name}}:</strong> {{patchValues[item.name]}}</span>
                    </div>

                </div>
            </div>

        </div>


        <div class="leadscore score">
            <div style="text-align: center;padding: 10px;">
                <h5 style="color: #fff;">{{LeadDetailsObject?.score || 0.0}}</h5>
                <span style="color: #fff;
                font-size: 13px;
                font-weight: 600;">Lead Score</span>
            </div>
        </div>
        <br>

        <table id="customers" *ngIf="leadPropertiesDisplay==1">
            <tr class="bgs">
                <th colspan="2">
                    <span>{{leadPropertiesName}}</span>
                </th>
            </tr>
            <tr>
                <td>Owner</td>
                <td>{{LeadDetailsObject?.ownerEmail}}</td>
            </tr>
            <tr>
                <td>Lead Source</td>
                <td>{{LeadDetailsObject?.sourceName}}</td>
            </tr>
            <tr>
                <td>Lead Age</td>
                <td>{{leadAge}}</td>
            </tr>
            <tr *ngIf="crmType==1 && LeadDetailsObject?.budget != null ">
                <td>Budget</td>
                <td>{{LeadDetailsObject?.budget}}</td>
            </tr>
            <tr *ngIf="crmType==1 && LeadDetailsObject?.budgetMin != null ">
                <td>Budget Min</td>
                <td>{{LeadDetailsObject?.budgetMin}}</td>
            </tr>
            <tr *ngIf="crmType==1 && LeadDetailsObject?.propertyType != null">
                <td>Property Type</td>
                <td>{{LeadDetailsObject?.propertyType}}</td>
            </tr>


        </table>

        <br>

        <table id="customers" *ngIf="additionalAttributeEnable==1">

            <tr *ngIf="customField1 !=null">
                <th colspan="2">
                    {{additionalAttributeName}}
                </th>
            </tr>
            <ng-container *ngIf="customField1">

                <tr *ngFor="let item of customField1 | keyvalue">
                    <td>
                        {{item.key}}
                    </td>
                    <td>
                        <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                            class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                        <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                            [innerHTML]="LeadDetailsObject?.statusName"> </p>
                        <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                            [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                        <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                            [innerHTML]="LeadDetailsObject?.category"> </p>
                        <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                            [innerHTML]="LeadDetailsObject?.product"> </p>
                    </td>
                </tr>

            </ng-container>

        </table>

    </div>
    <div fxFlex="70" fxFlex.lt-md="100" fxLayout.xs="column" class="column-2 colmob">

        <div fxLayoutGap.lt-md="10px" fxLayout="column" fxLayout.gt-sm="row wrap"
            style="padding-bottom: 10px; display: flex; flex-wrap: wrap; align-items: center;">
            <div fxLayoutGap.lt-md="10px" fxLayout.xs="column">


                <!-- <button [attr.guide]="'lead-detail-btn-4' + '__' + sanitizedUrl" mat-raised-button class="matcss" [matMenuTriggerFor]="menu" class="btntask">
                    <mat-icon class="icon-css">assignment</mat-icon>
                  Task
                </button> -->
                <!-- <button [attr.guide]="'lead-detail-btn-5' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                    <mat-icon class="icon-css">assignment</mat-icon>
                    <span style="font-size: 13px;color: gray;">Task</span>
                </button> -->

                <mat-menu #menu="matMenu">
                    <button [attr.guide]="'lead-detail-btn-6' + '__' + sanitizedUrl" *ngIf="crmType!=2" mat-menu-item
                        (click)="addLeadActivity('Follow Up',0,null)">Follow Up
                    </button>
                    <button [attr.guide]="'lead-detail-btn-7' + '__' + sanitizedUrl" mat-menu-item
                        (click)="addLeadActivity('Phone Call',0,null)">Phone Call</button>
                    <button [attr.guide]="'pipeline-btn-91' + '__' + sanitizedUrl" mat-menu-item
                        (click)="addSiteVisitPopup()">Site visit</button>
                    <button [attr.guide]="'lead-detail-btn-8' + '__' + sanitizedUrl" *ngIf="enableLocation == '1'"
                        mat-menu-item (click)="addLeadActivityone('Location',0,null)">Location</button>
                    <button [attr.guide]="'lead-detail-btn-9' + '__' + sanitizedUrl" *ngIf="enableCallNotes == 0"
                        mat-menu-item (click)="addLeadActivityone('Connected',0,null)">Connected</button>
                    <button [attr.guide]="'lead-detail-btn-10' + '__' + sanitizedUrl" *ngIf="enableCallNotes == 0"
                        mat-menu-item (click)="addLeadActivityone('Not Connected',0,null)">Not Connected</button>
                </mat-menu>

            </div>
            <!-- <div fxLayout.xs="column">

                <button [attr.guide]="'lead-detail-btn-11' + '__' + sanitizedUrl" mat-raised-button class="matcss" [matMenuTriggerFor]="action">
                    <mat-icon class="icon-css">edit</mat-icon>
                    <span style="font-size: 13px;color: gray;">Lead Actions</span>
                </button>

                <mat-menu #action="matMenu">
                    <button [attr.guide]="'lead-detail-btn-12' + '__' + sanitizedUrl" (click)="transferLead()" mat-menu-item>Change Owner</button>
                </mat-menu>

                <button [attr.guide]="'lead-detail-btn-13' + '__' + sanitizedUrl" (click)="openEmailPopup()" mat-button class="matcss">
                    <mat-icon class="icon-css">mail</mat-icon>
                    <span style="font-size: 13px;color: gray;">Email Status</span>
                </button>

            </div> -->
            <!-- 
            <div *ngIf="crmType==1" fxLayout.xs="column">

                <button [attr.guide]="'lead-detail-btn-14' + '__' + sanitizedUrl" (click)="newSearch(LeadDetailsObject)" mat-raised-button class="matcss">
                    <mat-icon class="icon-css">search</mat-icon>
                    <span style="font-size: 13px;color: gray;">Search</span>
                </button>

            </div> -->

            <!-- <div *ngIf="enableInvoiceInLead==1" fxLayout.xs="column">

                <button [attr.guide]="'lead-detail-btn-15' + '__' + sanitizedUrl" (click)="navigateToInvoice(LeadDetailsObject)" mat-raised-button class="matcss">
                    <mat-icon class="icon-css">library_books</mat-icon>
                    <span style="font-size: 13px;color: gray;">Invoice</span>
                </button>

            </div> -->
            <div fxLayout.xs="column">

                <!-- <button [attr.guide]="'lead-detail-btn-16' + '__' + sanitizedUrl" (click)="openEmailPopup()" mat-raised-button class="matcss">
                    <mat-icon class="icon-css">email</mat-icon>
                    <span style="font-size: 13px;color: gray;">Email</span>
                </button> -->

            </div>


        </div>

        <div fxLayoutGap.lt-md="10px" fxLayout="column" fxLayout.gt-sm="row wrap"
            style="padding-bottom: 10px; display: flex; flex-wrap: wrap; align-items: center;">
            <div fxLayoutGap.lt-md="10px" fxLayout.xs="column">


                <button *ngIf="taskButtonEnable" [attr.guide]="'lead-detail-btn-task-menu' + '__' + sanitizedUrl"
                    mat-button class="matcss" [matMenuTriggerFor]="menu">
                    <mat-icon class="icon-css">assignment</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{taskButtonName}}</span>
                </button>

                <mat-menu #menu="matMenu">
                    <button [attr.guide]="'lead-detail-btn-17' + '__' + sanitizedUrl" *ngIf="crmType!=2" mat-menu-item
                        (click)="addLeadActivity('Follow Up',0,null)">Follow Up
                    </button>
                    <button [attr.guide]="'lead-detail-btn-18' + '__' + sanitizedUrl" mat-menu-item
                        (click)="addLeadActivity('Phone Call',0,null)">Phone Call</button>
                    <button [attr.guide]="'pipeline-btn-97' + '__' + sanitizedUrl" mat-menu-item
                        (click)="addSiteVisitPopup()">Site visit</button>
                    <button [attr.guide]="'lead-detail-btn-19' + '__' + sanitizedUrl" mat-menu-item
                        (click)="addLeadActivityone('Location',0,null)">Location</button>
                </mat-menu>

            </div>
            <div fxLayout.xs="column">

                <button *ngIf="leadActionsbuttonEnable"
                    [attr.guide]="'lead-detail-btn-actions-menu' + '__' + sanitizedUrl" mat-raised-button class="matcss"
                    [matMenuTriggerFor]="action">
                    <mat-icon class="icon-css">edit</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{leadActionsbutton}}</span>
                </button>

            </div>

            <div fxLayout.xs="column">
                <mat-menu #action="matMenu">
                    <button [attr.guide]="'lead-detail-btn-20' + '__' + sanitizedUrl" (click)="transferLead()"
                        mat-menu-item>Change Owner</button>
                </mat-menu>
            </div>


            <div fxLayout.xs="column">
                <button *ngIf="sendEmailbutttonEnable" [attr.guide]="'lead-detail-btn-email' + '__' + sanitizedUrl"
                    (click)="openEmailPopup()" mat-button class="matcss">
                    <mat-icon class="icon-css">mail</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{sendEmailbuttton}}</span>
                </button>
            </div>

            <div fxLayout.xs="column">
                <button *ngIf="sendEmailTemplateEnable"
                    [attr.guide]="'lead-detail-btn-email-template' + '__' + sanitizedUrl" (click)="sendEmailMessage()"
                    mat-button class="matcss">
                    <mat-icon class="icon-css">mail</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{sendEmailTemplate}}</span>
                </button>
            </div>


            <div fxLayout.xs="column">
                <button *ngIf="sendSmsEnable" [attr.guide]="'lead-detail-btn-sms' + '__' + sanitizedUrl"
                    (click)="openSendSmsPopup()" mat-button class="matcss">
                    <mat-icon class="icon-css">sms</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{sendSms}}</span>
                </button>
            </div>


            <div fxLayout.xs="column">
                <button *ngIf="documentEnable" [attr.guide]="'lead-detail-btn-document' + '__' + sanitizedUrl"
                    (click)="downloadDocumentPopup()" mat-button class="matcss">
                    <mat-icon class="icon-css">download</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{document}}</span>
                </button>

            </div>

            <div fxLayout.xs="column">

                <button *ngIf="builderSearchPopupEnable" [attr.guide]="'lead-detail-btn-search' + '__' + sanitizedUrl"
                    (click)="newSearch(LeadDetailsObject)" mat-raised-button class="matcss">
                    <mat-icon class="icon-css">search</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{builderSearchPopup}}</span>
                </button>

            </div>

            <div *ngIf="enableInvoiceInLead==1" fxLayout.xs="column">

                <button *ngIf="invoicebuttonEnable" [attr.guide]="'lead-detail-btn-invoice' + '__' + sanitizedUrl"
                    (click)="navigateToInvoice(LeadDetailsObject)" mat-raised-button class="matcss">
                    <mat-icon class="icon-css">library_books</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{invoicebutton}}</span>
                </button>

            </div>
            <div fxLayout.xs="column">

                <button *ngIf="quotationbuttonEnable" [attr.guide]="'lead-detail-btn-quotation' + '__' + sanitizedUrl"
                    (click)="navigateToQuotation(LeadDetailsObject)" mat-raised-button class="matcss">
                    <mat-icon class="icon-css">request_quote</mat-icon>
                    <span style="font-size: 13px;color: gray;">{{quotationbutton}}</span>
                </button>
            </div>







        </div>

        <div style="padding: 10px 10px 0 10px;">
            <mat-form-field style="width: 100%;">
                <input [attr.guide]="'lead-detail-inp-199' + '__' + sanitizedUrl" matInput placeholder="Search..."
                    [(ngModel)]="globalSearchText" (input)="onSearchChange()"
                    (ngModelChange)="onGlobalSearchChange($event)"
                    (keydown.backspace)="onGlobalSearchBackspace($event)" />
                <button [attr.guide]="'lead-detail-btn-clear-search' + '__' + sanitizedUrl" mat-icon-button matSuffix
                    *ngIf="globalSearchText" aria-label="Clear search" (click)="resetSearch()"
                    style="height:28px;width:28px;min-width:28px;padding:0;">
                    <mat-icon style="font-size:16px;line-height:28px;">close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div>
            <mat-tab-group [(selectedIndex)]="searchTabIndex" (selectedIndexChange)="onType0TabChange($event)"
                style="border: 1px solid lightgray;" class="btntask1">
                <mat-tab [attr.guide]="'lead-detail-tab-' + sanitizeUrl(tab.label) + '__' + sanitizedUrl"
                    *ngFor="let tab of (leadTabs && leadTabs.length > 0 ? leadTabs : type8Sections)"
                    [label]="tab.label">
                    <ng-container [ngSwitch]="(tab.name || tab.componentKey || tab.label || '')?.toLowerCase().trim()">
                        <div *ngSwitchCase="'activity'">
                            <ng-container *ngIf="init && activityHistoryType == 1">
                                <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                    [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                                    [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                    [leadActivityList]="leadActivityList">
                                </calsoft-activity>
                            </ng-container>
                            <ng-container *ngIf="activityHistoryType == 0">
                                <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                                    [groupedActivities]="groupedActivities"
                                    (scrollChange)="onScrollNew()"></calsoft-activity-new>
                            </ng-container>
                        </div>
                        <div *ngSwitchCase="'activityhistory'">
                            <ng-container *ngIf="init && activityHistoryType == 1">
                                <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                    [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                                    [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                    [leadActivityList]="leadActivityList">
                                </calsoft-activity>
                            </ng-container>
                            <ng-container *ngIf="activityHistoryType == 0">
                                <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                                    [groupedActivities]="groupedActivities"
                                    (scrollChange)="onScrollNew()"></calsoft-activity-new>
                            </ng-container>
                        </div>
                        <div *ngSwitchCase="'activity history'">
                            <ng-container *ngIf="init && activityHistoryType == 1">
                                <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                    [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                                    [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                    [leadActivityList]="leadActivityList">
                                </calsoft-activity>
                            </ng-container>
                            <ng-container *ngIf="activityHistoryType == 0">
                                <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                                    [groupedActivities]="groupedActivities"
                                    (scrollChange)="onScrollNew()"></calsoft-activity-new>
                            </ng-container>
                        </div>

                        <div *ngSwitchCase="'retry'" style="padding: 20px;">
                            <calsoft-lead-retry-history *ngIf="leadDetails" [leadId]="leadDetails.entityId">
                            </calsoft-lead-retry-history>
                        </div>
                        <div *ngSwitchCase="'retries'" style="padding: 20px;">
                            <calsoft-lead-retry-history *ngIf="leadDetails" [leadId]="leadDetails.entityId">
                            </calsoft-lead-retry-history>
                        </div>

                        <ng-container *ngIf="usedInSite || filterList || additionalSpec">
                            <div *ngSwitchCase="'leaddetail'">
                                <table
                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">
                                    <tr>
                                        <th colspan="2">
                                            {{leadCommonPropertiesName}}
                                        </th>
                                    </tr>
                                    <ng-container *ngIf="!type3">
                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                            <td>{{item.key}}</td>
                                            <td>
                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                                <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-container *ngIf="type3">
                                        <tr *ngFor="let item of customList ">
                                            <td>{{item[0]}}</td>
                                            <td>
                                                <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item[1]">
                                                </p>
                                                <p *ngIf="item[0]=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item[0]=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item[0]=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item[0]=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </table>

                                <table
                                    *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">
                                    <tr>
                                        <th colspan="2">
                                            {{leadPropertiesName}}
                                        </th>
                                    </tr>
                                    <ng-container *ngIf="!type2">
                                        <tr *ngFor="let item of valuesList | keyvalue">
                                            <td>{{item.key}}</td>
                                            <td>
                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                                <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-container *ngIf="type2">
                                        <tr *ngFor="let item of filterList | keyvalue">
                                            <td>{{item.key}}</td>
                                            <td>
                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                                <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </table>

                                <table
                                    *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">
                                    <tr>
                                        <th colspan="2">
                                            {{leadAdditionalPropertiesName}}
                                        </th>
                                    </tr>
                                    <ng-container *ngIf="!type1">
                                        <tr *ngFor="let item of additionalSpec | keyvalue">
                                            <td>{{item.key}}</td>
                                            <td>
                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                                <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-container *ngIf="type1">
                                        <tr *ngFor="let item of additionalSpecList ">
                                            <td>{{item[0]}}</td>
                                            <td>
                                                <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item[1]">
                                                </p>
                                                <p *ngIf="item[0]=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item[0]=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item[0]=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item[0]=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </table>
                            </div>
                            <div *ngSwitchCase="'lead detail'">
                                <table
                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">
                                    <tr>
                                        <th colspan="2">{{leadCommonPropertiesName}}</th>
                                    </tr>
                                    <ng-container *ngIf="!type3">
                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                            <td>{{item.key}}</td>
                                            <td>
                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                    class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                                <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </table>
                            </div>
                        </ng-container>

                        <div *ngSwitchCase="'tasks'">
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Notes</th>
                                    <th *ngIf="enableLocation == '1'">OutCome</th>
                                    <th *ngIf="enableLocation == '1'">Location</th>
                                    <th>Action</th>
                                </tr>
                                <tr *ngFor="let lead of leadActivityList;">
                                    <td>{{lead.activityType}}</td>
                                    <td>{{lead.createdDate | calsoftDate}}</td>
                                    <td>{{lead.notes}}</td>
                                    <td *ngIf="enableLocation == '1'">{{lead.phoneCallOutcome}}</td>
                                    <td *ngIf="enableLocation == '1'">{{lead.customerAddress}}</td>
                                    <td>
                                        <button [attr.guide]="'lead-detail-btn-21' + '__' + sanitizedUrl"
                                            mat-icon-button [matMenuTriggerFor]="menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-22' + '__' + sanitizedUrl"
                                                (click)="addLeadActivity('Edit', 0, lead)" mat-menu-item>
                                                <mat-icon>edit</mat-icon>
                                                Edit
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-23' + '__' + sanitizedUrl"
                                                *ngIf="lead.status==0" (click)="addLeadActivityNew('Edit', 0, lead,3)"
                                                mat-menu-item>
                                                <mat-icon>check</mat-icon>
                                                <span>Mark complete</span>
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-24' + '__' + sanitizedUrl"
                                                (click)="deleteLeadDialog(lead.id)" mat-menu-item>
                                                <mat-icon>delete</mat-icon>
                                                Delete
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div *ngSwitchCase="'task'">
                            <table>
                                <tr>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Notes</th>
                                    <th *ngIf="enableLocation == '1'">OutCome</th>
                                    <th *ngIf="enableLocation == '1'">Location</th>
                                    <th>Action</th>
                                </tr>
                                <tr *ngFor="let lead of leadActivityList;">
                                    <td>{{lead.activityType}}</td>
                                    <td>{{lead.createdDate | calsoftDate}}</td>
                                    <td>{{lead.notes}}</td>
                                    <td *ngIf="enableLocation == '1'">{{lead.phoneCallOutcome}}</td>
                                    <td *ngIf="enableLocation == '1'">{{lead.customerAddress}}</td>
                                    <td>
                                        <button [attr.guide]="'lead-detail-btn-21' + '__' + sanitizedUrl"
                                            mat-icon-button [matMenuTriggerFor]="menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-22' + '__' + sanitizedUrl"
                                                (click)="addLeadActivity('Edit', 0, lead)" mat-menu-item>
                                                <mat-icon>edit</mat-icon>
                                                Edit
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-23' + '__' + sanitizedUrl"
                                                *ngIf="lead.status==0" (click)="addLeadActivityNew('Edit', 0, lead,3)"
                                                mat-menu-item>
                                                <mat-icon>check</mat-icon>
                                                <span>Mark complete</span>
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-24' + '__' + sanitizedUrl"
                                                (click)="deleteLeadDialog(lead.id)" mat-menu-item>
                                                <mat-icon>delete</mat-icon>
                                                Delete
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <div *ngSwitchCase="'email'">
                            <div class="mailbox-container">
                                <div class="mailbox-toggle-container">
                                    <mat-button-toggle-group [(value)]="currentMailBox" (change)="loadEmails($event)">
                                        <mat-button-toggle (click)="loadEmails({ value: 'INBOX' })" value="INBOX">Inbox
                                        </mat-button-toggle>
                                        <mat-button-toggle (click)="loadEmails({ value: 'Sent' })" value="Sent">Sent
                                        </mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                                <div class="mailbox-content">
                                    <div class="mailbox-email-list" [class.full-width]="!selectedIndex">
                                        <ng-container *ngIf="isLoading; else emailListTemplate">
                                            <div class="loading-spinner">
                                                <mat-spinner diameter="40"></mat-spinner>
                                                <p>Loading emails...</p>
                                            </div>
                                        </ng-container>
                                        <ng-template #emailListTemplate>
                                            <mat-paginator [length]="totalEmails" [pageSize]="pageSizeEmail"
                                                [pageIndex]="pageIndex" (page)="onPageChange($event)">
                                            </mat-paginator>
                                            <mat-nav-list>
                                                <mat-list-item *ngFor="let email of emails; let i = index" [ngClass]="{
                                                    'mailbox-email-list-item': true,
                                                    'active': i === selectedIndex
                                                    }" (click)="selectEmail(i)">
                                                    <div class="mailbox-email-list-item">
                                                        <div class="mailbox-email-header">
                                                            <span class="mailbox-email-subject">{{ email.subject
                                                                }}</span>
                                                            <span class="mailbox-email-date">{{ email.sentDate |
                                                                date:'medium' }}</span>
                                                        </div>
                                                        <div class="mailbox-email-preview">
                                                            <span class="mailbox-email-from-to">
                                                                {{ currentMailBox === 'INBOX' ?
                                                                extractEmailAddress(email.from) : email.to }}
                                                            </span>
                                                            <span class="mailbox-email-body-preview">
                                                                {{ truncateSafeHTML(email.body, 150) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </mat-list-item>
                                            </mat-nav-list>
                                        </ng-template>
                                    </div>
                                    <div *ngIf="emailVisble; else placeholder" class="mailbox-email-wrapper">
                                        <div class="mailbox-email-detail" [ngClass]="{ 'show-detail': isMobileView }">
                                            <button [attr.guide]="'lead-detail-btn-25' + '__' + sanitizedUrl"
                                                class="back-button" *ngIf="isMobileView" (click)="backToList()">
                                                ← Back
                                            </button>
                                            <div class="mailbox-email-detail-header">
                                                <h2>{{ emailObject.subject }}</h2>
                                                <div class="mailbox-email-meta">
                                                    <div><strong>From:</strong> {{ emailObject.from }}</div>
                                                    <div><strong>To:</strong> {{ emailObject.to }}</div>
                                                    <div><strong>Date:</strong> {{ emailObject.sentDate | date:'medium'
                                                        }}</div>
                                                </div>
                                            </div>
                                            <div class="mailbox-email-body"
                                                [innerHTML]="linkifyAndSanitize(emailObject.body)"></div>
                                            <div class="mailbox-email-attachments"
                                                *ngIf="emails[selectedIndex]?.attachments?.length > 0">
                                                <h4>Attachments</h4>
                                                <ul>
                                                    <li *ngFor="let file of emails[selectedIndex].attachments">
                                                        <div *ngIf="isImage(file.contentType)">
                                                            <calsoft-common-images
                                                                [src]="serverPathEmail + file.fileName"
                                                                [height]="'50px'" [width]="'auto'"
                                                                [alt]="file.fileName">
                                                            </calsoft-common-images>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-template #placeholder>
                                        <div class="mailbox-placeholder">
                                            <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                            <h3>Select an email to read</h3>
                                            <p>Choose a message from your Mails to view it here</p>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'emails'">
                            <!-- same email -->
                        </div>

                        <div *ngSwitchCase="'chats'">
                            <div *ngIf="leadLoaded && whatAppchatType === 1">
                                <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                    [isFromPhone]="true">
                                </calsoft-whatsapp-chat-details>
                            </div>
                            <div *ngIf="leadLoaded && whatAppchatType === 2">
                                <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                                </calsoft-whats-app-new-client>
                            </div>
                        </div>
                        <div *ngSwitchCase="'chat'">
                            <div *ngIf="leadLoaded && whatAppchatType === 1">
                                <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                    [isFromPhone]="true">
                                </calsoft-whatsapp-chat-details>
                            </div>
                            <div *ngIf="leadLoaded && whatAppchatType === 2">
                                <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                                </calsoft-whats-app-new-client>
                            </div>
                        </div>
                        <div *ngSwitchCase="'whatsapp'">
                            <div *ngIf="leadLoaded && whatAppchatType === 1">
                                <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                    [isFromPhone]="true">
                                </calsoft-whatsapp-chat-details>
                            </div>
                            <div *ngIf="leadLoaded && whatAppchatType === 2">
                                <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                                </calsoft-whats-app-new-client>
                            </div>
                        </div>

                        <ng-container *ngIf="leadNoteDisplay==1">
                            <div *ngSwitchCase="'notes'">
                                <div class="padding-10">
                                    <div class="editSets">
                                        <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                            <span>Notes</span>
                                            <button [attr.guide]="'lead-detail-btn-26' + '__' + sanitizedUrl"
                                                *ngIf="noteList.length>0" mat-icon-button>
                                                <mat-icon (click)="createNote(null,0)">add</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div *ngIf="noteList.length==0" class="padding-10" style="background-color: gray;"
                                        fxLayout="column" fxLayoutAlign="center center">
                                        <mat-icon> insert_drive_file</mat-icon>
                                        <div style="color: white; background: none;" class="title padding-10">
                                            Add notes to your lead!
                                        </div>
                                        <div class="create Note">
                                            <button [attr.guide]="'lead-detail-btn-27' + '__' + sanitizedUrl"
                                                mat-flat-button color="primary" (click)="createNote(null,0)">
                                                <span class="medium-x">Create Note</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div>
                                        <div id="responsieTable">
                                            <table class="rwd-table" *ngIf="noteList.length>0">
                                                <tr>
                                                    <th>Notes</th>
                                                    <th>Created Date</th>
                                                    <th>Updated Date</th>
                                                    <th>Created by</th>
                                                    <th>Updated by</th>
                                                    <th>Action</th>
                                                </tr>
                                                <ng-container *ngFor="let note of noteList">
                                                    <tr *ngIf="note.documentType==0">
                                                        <td data-th="Notes" [innerHTML]="note.notes | mentionHighlight">
                                                        </td>
                                                        <td data-th="Created Date">{{note.createdDate | calsoftDate}}
                                                        </td>
                                                        <td data-th="Updated Date">{{note.updatedDate | calsoftDate}}
                                                        </td>
                                                        <td data-th="Created by">{{note.createdBy == null ?
                                                            LeadDetailsObject?.ownerEmail : note.createdBy}}</td>
                                                        <td data-th="Updated by">{{note.updatedBy == null ?
                                                            LeadDetailsObject?.ownerEmail : note.updatedBy}}</td>
                                                        <td data-th="Action">
                                                            <button
                                                                [attr.guide]="'lead-detail-btn-28' + '__' + sanitizedUrl"
                                                                mat-icon-button [matMenuTriggerFor]="menu28">
                                                                <mat-icon>more_vert</mat-icon>
                                                            </button>
                                                            <mat-menu #menu28="matMenu">
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-29' + '__' + sanitizedUrl"
                                                                    (click)="createNote(note, note.noteId)"
                                                                    mat-menu-item>
                                                                    <mat-icon>edit</mat-icon>
                                                                    Edit
                                                                </button>
                                                                <button mat-menu-item *ngIf="note.noteType !== 'REPLY'"
                                                                    (click)="toggleReply(note.noteId)">
                                                                    <mat-icon>reply</mat-icon>
                                                                    Reply
                                                                </button>
                                                            </mat-menu>
                                                        </td>
                                                    </tr>
                                                    <tr
                                                        *ngIf="note.documentType==0 && replyingToNoteId === note.noteId">
                                                        <td colspan="6">
                                                            <div
                                                                style="display:flex;gap:8px;align-items:flex-start;padding:8px 0;">
                                                                <mat-icon
                                                                    style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                                                <mat-form-field appearance="outline" style="flex:1">
                                                                    <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                                    <textarea matInput rows="2" [(ngModel)]="replyText"
                                                                        placeholder="Write a reply..."></textarea>
                                                                </mat-form-field>
                                                                <button mat-raised-button color="primary"
                                                                    style="margin-top:6px"
                                                                    [disabled]="!replyText?.trim()"
                                                                    (click)="submitReply(note)">
                                                                    Send
                                                                </button>
                                                                <button mat-icon-button style="margin-top:4px"
                                                                    (click)="toggleReply(null)">
                                                                    <mat-icon>close</mat-icon>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngSwitchCase="'note'">
                                <!-- same note -->
                            </div>
                        </ng-container>

                        <ng-container *ngIf="jsonRecieved!=null">
                            <div *ngSwitchCase="'originallead'">
                                <table id="details">
                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                        <td>{{ item.key === 'adGroupName' ? 'Campaign Name' : item.key }}</td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div *ngSwitchCase="'original lead format'">
                                <table id="details">
                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                        <td>{{ item.key === 'adGroupName' ? 'Campaign Name' : item.key }}</td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div *ngSwitchCase="'original lead'">
                                <table id="details">
                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                        <td>{{ item.key === 'adGroupName' ? 'Campaign Name' : item.key }}</td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </ng-container>

                        <div *ngSwitchCase="'documents'">
                            <div class="padding-10">
                                <div class="editSets1">
                                    <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                        <span>Documents</span>
                                        <button [attr.guide]="'lead-detail-btn-30' + '__' + sanitizedUrl"
                                            mat-icon-button>
                                            <mat-icon (click)="createFile(null,0)">add</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngFor="let note of noteList;">
                                    <div fxLayout="column" *ngIf="note.notesDocument?.length>0">
                                        <div fxLayout="row" class="padding-10" fxLayoutAlign="start center">
                                            <span [innerHTML]="note.notes | mentionHighlight"></span>
                                            <div class="padding-10" *ngIf="note.documentType==1">
                                                <calsoft-videos [value]="serverPathNotes + note.notesDocument">
                                                </calsoft-videos>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==2">
                                                <calsoft-audios [value]="serverPathNotes + note.notesDocument">
                                                </calsoft-audios>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==3">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img src="assets/images/pdf.png" width="36" height="36"
                                                                alt="PDF File">: {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-31' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==4">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img width="36" height="36"
                                                                [src]="serverPathNotes + note.notesDocument + cid"
                                                                alt="Uploaded Image"> : {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-32' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==5">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img src="assets/images/docx.png" width="36" height="36"
                                                                alt="DOCX File"> : {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-33' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==6">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img src="assets/images/excel.png" width="36" height="36"
                                                                alt="Excel File"> : {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-34' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'document'">
                            <div class="padding-10">
                                <div class="editSets1">
                                    <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                        <span>Documents</span>
                                        <button [attr.guide]="'lead-detail-btn-30' + '__' + sanitizedUrl"
                                            mat-icon-button>
                                            <mat-icon (click)="createFile(null,0)">add</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngFor="let note of noteList;">
                                    <div fxLayout="column" *ngIf="note.notesDocument?.length>0">
                                        <div fxLayout="row" class="padding-10" fxLayoutAlign="start center">
                                            <span [innerHTML]="note.notes | mentionHighlight"></span>
                                            <div class="padding-10" *ngIf="note.documentType==1">
                                                <calsoft-videos [value]="serverPathNotes + note.notesDocument">
                                                </calsoft-videos>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==2">
                                                <calsoft-audios [value]="serverPathNotes + note.notesDocument">
                                                </calsoft-audios>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==3">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img src="assets/images/pdf.png" width="36" height="36"
                                                                alt="PDF File">: {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-31' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==4">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img width="36" height="36"
                                                                [src]="serverPathNotes + note.notesDocument + cid"
                                                                alt="Uploaded Image"> : {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-32' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==5">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img src="assets/images/docx.png" width="36" height="36"
                                                                alt="DOCX File"> : {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-33' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="padding-10" *ngIf="note.documentType==6">
                                                <div fxLayout="column">
                                                    <div fxLayout="row">
                                                        <span fxLayoutAlign="start center">
                                                            <img src="assets/images/excel.png" width="36" height="36"
                                                                alt="Excel File"> : {{note.notesDocument}}
                                                        </span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-34' + '__' + sanitizedUrl"
                                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)"
                                                            color="warn" mat-icon-button type="button">
                                                            <mat-icon>download</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div *ngSwitchCase="'payment'">
                            <div class="padding-10">
                                <div class="editSets1">
                                    <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                        <span>Payment</span>
                                        <button [attr.guide]="'lead-detail-btn-35' + '__' + sanitizedUrl"
                                            mat-icon-button>
                                            <mat-icon (click)="createPayment(null,0)">add</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <table *ngIf="noteList.length>0">
                                    <tr>
                                        <th>Notes</th>
                                        <th>Created Date</th>
                                        <th>Updated Date</th>
                                        <th>Action</th>
                                    </tr>
                                    <ng-container *ngFor="let note of noteList">
                                        <tr *ngIf="note.documentType==5">
                                            <td [innerHTML]="note.notes | mentionHighlight"></td>
                                            <td>{{note.createdDate | calsoftDate}}</td>
                                            <td>{{note.updatedDate | calsoftDate}}</td>
                                            <td>
                                                <button [attr.guide]="'lead-detail-btn-36' + '__' + sanitizedUrl"
                                                    mat-icon-button [matMenuTriggerFor]="menu">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                                <mat-menu #menu="matMenu">
                                                    <button [attr.guide]="'lead-detail-btn-37' + '__' + sanitizedUrl"
                                                        (click)="createNote(note, note.noteId)" mat-menu-item>
                                                        <mat-icon>edit</mat-icon>
                                                        Edit
                                                    </button>
                                                </mat-menu>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </table>
                            </div>
                        </div>
                        <div *ngSwitchCase="'payments'">
                            <div class="padding-10">
                                <div class="editSets1">
                                    <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                        <span>Payment</span>
                                        <button [attr.guide]="'lead-detail-btn-35' + '__' + sanitizedUrl"
                                            mat-icon-button>
                                            <mat-icon (click)="createPayment(null,0)">add</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <table *ngIf="noteList.length>0">
                                    <tr>
                                        <th>Notes</th>
                                        <th>Created Date</th>
                                        <th>Updated Date</th>
                                        <th>Action</th>
                                    </tr>
                                    <ng-container *ngFor="let note of noteList">
                                        <tr *ngIf="note.documentType==5">
                                            <td [innerHTML]="note.notes | mentionHighlight"></td>
                                            <td>{{note.createdDate | calsoftDate}}</td>
                                            <td>{{note.updatedDate | calsoftDate}}</td>
                                            <td>
                                                <button [attr.guide]="'lead-detail-btn-36' + '__' + sanitizedUrl"
                                                    mat-icon-button [matMenuTriggerFor]="menu">
                                                    <mat-icon>more_vert</mat-icon>
                                                </button>
                                                <mat-menu #menu="matMenu">
                                                    <button [attr.guide]="'lead-detail-btn-37' + '__' + sanitizedUrl"
                                                        (click)="createNote(note, note.noteId)" mat-menu-item>
                                                        <mat-icon>edit</mat-icon>
                                                        Edit
                                                    </button>
                                                </mat-menu>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </table>
                            </div>
                        </div>

                        <div *ngSwitchCase="'calendar'">
                            <calsoft-google-calendar-service-account [leadId]="leadId"
                                [type]="2"></calsoft-google-calendar-service-account>
                        </div>

                        <div *ngSwitchCase="'deals'">
                            <calsoft-deals [enableSmartView]="false" [leadId]="leadId" [type]="2"></calsoft-deals>
                        </div>
                        <div *ngSwitchCase="'deal'">
                            <calsoft-deals [enableSmartView]="false" [leadId]="leadId" [type]="2"></calsoft-deals>
                        </div>

                        <div *ngSwitchCase="'calls'">
                            <div class="call-section-bg">
                                <div class="tab-pane fade" id="calls">
                                    <div class="card">
                                        <div
                                            class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                            <h4 class="fw-semibold">Calls</h4>

                                            <!-- <button [attr.guide]="'lead-detail-btn-38' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                            <mat-menu #menu="matMenu">
                                                <button [attr.guide]="'lead-detail-btn-39' + '__' + sanitizedUrl"
                                                    *ngIf="crmType!=2" mat-menu-item
                                                    (click)="addLeadActivityone('Follow Up',0,null)">Follow Up
                                                </button>
                                                <button [attr.guide]="'lead-detail-btn-40' + '__' + sanitizedUrl"
                                                    mat-menu-item
                                                    (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                                    Call</button>
                                                <button [attr.guide]="'lead-detail-btn-41' + '__' + sanitizedUrl"
                                                    mat-menu-item
                                                    (click)="addLeadActivityone('Location',0,null)">Location</button>
                                            </mat-menu>
                                        </div>
                                        <div class="card-body" *ngIf="calllist?.length > 0; else noData">
                                            <div class="card mb-3" *ngFor="let lead of calllist;">
                                                <div class="card-body">
                                                    <div
                                                        class="d-sm-flex align-items-center justify-content-between pb-2">
                                                        <div class="d-flex align-items-center mb-2"
                                                            style="display: flex;">
                                                            <span class="avatar-md me-2 flex-shrink-0">
                                                                <mat-icon class="default-icon">person</mat-icon>
                                                            </span>
                                                            <p><span
                                                                    class="text-dark fw-medium">{{lead.customerName}}</span>
                                                                logged a call on {{lead.updatedDate}}</p>
                                                        </div>
                                                        <div class="d-inline-flex align-items-center mb-2">
                                                            <div class="dropdown me-2">
                                                                <a href="javascript:void(0);" class="py-1" [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    {{lead.phoneCallOutcome | titlecase}}
                                                                    <i class="ti ti-chevron-down ms-2"></i>
                                                                </a>
                                                            </div>
                                                            <div class="dropdown">
                                                                <a href="javascript:void(0);"
                                                                    class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                        class="ti ti-dots-vertical"></i></a>
                                                                <div class="dropdown-menu dropdown-menu-right">
                                                                    <a class="dropdown-item"
                                                                        href="javascript:void(0);"><i
                                                                            class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                                    <a class="dropdown-item"
                                                                        href="javascript:void(0);"><i
                                                                            class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span [innerHTML]="lead.notes"> </span>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-template #noData>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="'call'">
                            <div class="call-section-bg">
                                <div class="tab-pane fade" id="calls">
                                    <div class="card">
                                        <div
                                            class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                            <h4 class="fw-semibold">Calls</h4>
                                            <mat-menu #menu="matMenu">
                                                <button [attr.guide]="'lead-detail-btn-39' + '__' + sanitizedUrl"
                                                    *ngIf="crmType!=2" mat-menu-item
                                                    (click)="addLeadActivityone('Follow Up',0,null)">Follow Up
                                                </button>
                                                <button [attr.guide]="'lead-detail-btn-40' + '__' + sanitizedUrl"
                                                    mat-menu-item
                                                    (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                                    Call</button>
                                                <button [attr.guide]="'lead-detail-btn-41' + '__' + sanitizedUrl"
                                                    mat-menu-item
                                                    (click)="addLeadActivityone('Location',0,null)">Location</button>
                                            </mat-menu>
                                        </div>
                                        <div class="card-body" *ngIf="calllist?.length > 0; else noData">
                                            <div class="card mb-3" *ngFor="let lead of calllist;">
                                                <div class="card-body">
                                                    <div
                                                        class="d-sm-flex align-items-center justify-content-between pb-2">
                                                        <div class="d-flex align-items-center mb-2"
                                                            style="display: flex;">
                                                            <span class="avatar-md me-2 flex-shrink-0">
                                                                <mat-icon class="default-icon">person</mat-icon>
                                                            </span>
                                                            <p><span
                                                                    class="text-dark fw-medium">{{lead.customerName}}</span>
                                                                logged a call on {{lead.updatedDate}}</p>
                                                        </div>
                                                        <div class="d-inline-flex align-items-center mb-2">
                                                            <div class="dropdown me-2">
                                                                <a href="javascript:void(0);" class="py-1" [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    {{lead.phoneCallOutcome | titlecase}}
                                                                    <i class="ti ti-chevron-down ms-2"></i>
                                                                </a>
                                                            </div>
                                                            <div class="dropdown">
                                                                <a href="javascript:void(0);"
                                                                    class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                    data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                        class="ti ti-dots-vertical"></i></a>
                                                                <div class="dropdown-menu dropdown-menu-right">
                                                                    <a class="dropdown-item"
                                                                        href="javascript:void(0);"><i
                                                                            class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                                    <a class="dropdown-item"
                                                                        href="javascript:void(0);"><i
                                                                            class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span [innerHTML]="lead.notes"> </span>
                                                </div>
                                            </div>
                                        </div>
                                        <ng-template #noData>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- ================================================== -->
                        <!-- COLLABORATION TAB                                   -->
                        <!-- ================================================== -->
                        <div *ngSwitchCase="'collaboration'" class="collab-tab-root">
                            <mat-tab-group animationDuration="200ms" class="collab-inner-tabs">

                                <!-- Notes & Replies -->
                                <mat-tab label="Notes">
                                    <calsoft-collaboration-notes resourceType="LEAD"
                                        [resourceId]="LeadDetailsObject?.entityId" [currentUser]="currentUserObj">
                                    </calsoft-collaboration-notes>
                                </mat-tab>

                                <!-- Tasks -->
                                <mat-tab label="Tasks">
                                    <calsoft-crm-task-panel resourceType="LEAD"
                                        [resourceId]="LeadDetailsObject?.entityId" [currentUser]="currentUserObj"
                                        [userList]="collaborationUsers">
                                    </calsoft-crm-task-panel>
                                </mat-tab>

                                <!-- Activity Timeline -->
                                <mat-tab label="Timeline">
                                    <calsoft-activity-feed [leadId]="LeadDetailsObject?.entityId" [taskType]="1">
                                    </calsoft-activity-feed>
                                </mat-tab>

                                <!-- Delegation -->
                                <mat-tab label="Ownership">
                                    <calsoft-delegation-panel resourceType="LEAD"
                                        [resourceId]="LeadDetailsObject?.entityId"
                                        [currentOwnerId]="LeadDetailsObject?.ownerId"
                                        [currentOwnerName]="LeadDetailsObject?.ownerIdName"
                                        [currentUser]="currentUserObj" [userList]="collaborationUsers"
                                        (delegated)="getAllLeadDetails(leadId)">
                                    </calsoft-delegation-panel>
                                </mat-tab>
                            </mat-tab-group>
                        </div>

                        <!-- FALLBACK FOR DYNAMIC / CUSTOM TABS -->
                        <div *ngSwitchDefault class="new-leadType-five type8-container" style="width: 100%;">
                            <!-- If has child tabs -->
                            <div class="type8-child-tabs-bar" *ngIf="getActiveChildTabs(tab).length > 0"
                                style="width: 100%; max-width: 100%; min-width: 0; overflow-x: auto; overflow-y: hidden; box-sizing: border-box; -webkit-overflow-scrolling: touch; border-bottom: 2px solid #e2e8f0; margin-top: 14px; margin-bottom: 16px; padding: 4px 0 8px 0; background: #ffffff; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                                <div
                                    style="display: flex; gap: 8px; flex-wrap: nowrap; min-width: max-content; align-items: center; padding: 2px 8px;">
                                    <button *ngFor="let child of getActiveChildTabs(tab)" type="button" mat-button
                                        style="flex: 0 0 auto; white-space: nowrap; font-size: 14px; line-height: 24px; min-height: 38px; padding: 6px 20px; border-radius: 6px 6px 0 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center;"
                                        (click)="selectType8ChildTab(child)" [ngStyle]="{
                                            'border-bottom': isChildTabActive(child) ? '3px solid #1666eb' : '3px solid transparent',
                                            'font-weight': isChildTabActive(child) ? '600' : '500',
                                            'color': isChildTabActive(child) ? '#1666eb' : '#475569',
                                            'background-color': isChildTabActive(child) ? '#eff6ff' : 'transparent'
                                        }">
                                        <span style="display: inline-block;">{{ child.label || child.name || 'Tab'
                                            }}</span>
                                    </button>
                                </div>
                            </div>

                            <div class="right-content-area" style="padding: 10px; width: 100%;">
                                <div [ngSwitch]="activeType8ComponentKey" class="dynamic-content" style="width: 100%;">

                                    <!-- 1. OVERVIEW -->
                                    <div *ngSwitchCase="'overview'" class="overview">
                                        <div class="overview-cont">
                                            <header class="overview-header">
                                                <h1 class="title">Overview</h1>
                                                <mat-form-field>
                                                    <input
                                                        [attr.guide]="'lead-detail-inp-t8-ov-srch' + '__' + sanitizedUrl"
                                                        matInput placeholder="Search..." [(ngModel)]="globalSearchText"
                                                        (keydown.enter)="onGlobalSearchChange(globalSearchText)"
                                                        (keydown.backspace)="onGlobalSearchBackspace($event)" />
                                                    <button mat-icon-button matSuffix *ngIf="globalSearchText"
                                                        aria-label="Clear search" (click)="resetSearch()"
                                                        style="height:28px;width:28px;min-width:28px;padding:0;">
                                                        <mat-icon
                                                            style="font-size:16px;line-height:28px;">close</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                            </header>

                                            <!-- Lifecycle and Status Pipeline Section -->
                                            <section *ngIf="!isSearching" class="pipeline-section"
                                                style="margin-bottom: 20px;">
                                                <div class="status-pipeline-wrapper">
                                                    <label>Status</label>
                                                    <div class="status-pipeline">
                                                        <div *ngFor="let step of filtereddropdownTypeList; let i = index"
                                                            class="strip-stage" [ngClass]="{
                                                'stage-current': step.statusName === LeadDetailsObject?.statusName,
                                                'stage-completed': i <= currentStatusIndex,
                                                'last-stage': i === filtereddropdownTypeList.length - 1
                                            }" [attr.data-toggle]="'tooltip'" [attr.data-html]="'true'"
                                                            [attr.data-container]="'body'"
                                                            [attr.title]="generateTooltip(step)"
                                                            (click)="updateLeadStatusNew($event,step)">
                                                            <span>{{ step.statusName }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>

                                            <!-- Overview Details Cards -->
                                            <div class="details-content">
                                                <div class="content-section">
                                                    <div class="section-header">
                                                        <h3>Basic Information</h3>
                                                    </div>
                                                    <div class="section-body">
                                                        <div class="details-grid-4col">
                                                            <div class="info-item"><label>Email</label>
                                                                <div class="value-display">
                                                                    <a [attr.guide]="'lead-detail-lnk-t8-ov-email' + '__' + sanitizedUrl"
                                                                        [matTooltip]="LeadDetailsObject?.email"
                                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                                        || '—'}}</a>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-email' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('email', 'Email', 'text')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Name</label>
                                                                <div class="value-display">
                                                                    <a [matTooltip]="LeadDetailsObject?.name">{{LeadDetailsObject?.name
                                                                        || '—'}}</a>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-name' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('name', 'Name', 'text')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Company</label>
                                                                <div class="value-display">
                                                                    <a [attr.guide]="'lead-detail-lnk-t8-ov-comp' + '__' + sanitizedUrl"
                                                                        [matTooltip]="LeadDetailsObject?.company"
                                                                        (click)="goToCompany()">{{LeadDetailsObject?.company
                                                                        ||
                                                                        '—'}}</a>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-comp' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('company', 'Company', 'text')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Job Title</label>
                                                                <div class="value-display">
                                                                    <a [matTooltip]="LeadDetailsObject?.jobtitle">{{LeadDetailsObject?.jobtitle
                                                                        || '—'}}</a>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-job' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Phone</label>
                                                                <div class="value-display">
                                                                    <a [attr.guide]="'lead-detail-lnk-t8-ov-phone' + '__' + sanitizedUrl"
                                                                        [matTooltip]="LeadDetailsObject?.phoneNumber"
                                                                        (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{LeadDetailsObject?.phoneNumber
                                                                        || '—'}}</a>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-phone' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Sales Owner</label>
                                                                <div class="value-display">
                                                                    <span class="value mobile-truncate-email"
                                                                        matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{LeadDetailsObject?.ownerIdName
                                                                        || '—'}}</span>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-owner' + '__' + sanitizedUrl"
                                                                        (click)="transferLead()" class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Lead Status</label>
                                                                <div class="value-display">
                                                                    <span
                                                                        [matTooltip]="LeadDetailsObject?.statusName">{{LeadDetailsObject?.statusName
                                                                        || '—'}}</span>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-status' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('leadStatus', 'Lead Status', 'select')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div class="info-item"><label>Lead Source</label>
                                                                <div class="value-display">
                                                                    <span
                                                                        [matTooltip]="LeadDetailsObject?.sourceName">{{LeadDetailsObject?.sourceName
                                                                        || '—'}}</span>
                                                                    <button
                                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-source' + '__' + sanitizedUrl"
                                                                        (click)="openEditPopup('sourceName', 'Lead Source', 'select')"
                                                                        class="edit-btn">
                                                                        <mat-icon>edit</mat-icon>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 2. CONTACT DETAILS / BASIC INFORMATION / ALL DETAILS (Unified Single Page) -->
                                    <div *ngSwitchCase="'contactDetails'">
                                        <ng-container *ngTemplateOutlet="type8ContactDetailsTpl"></ng-container>
                                    </div>
                                    <div *ngSwitchCase="'allDetails'">
                                        <ng-container *ngTemplateOutlet="type8ContactDetailsTpl"></ng-container>
                                    </div>
                                    <div *ngSwitchCase="'basicInformation'">
                                        <ng-container *ngTemplateOutlet="type8ContactDetailsTpl"></ng-container>
                                    </div>

                                    <!-- 3. MY VIEWS / LEAD INFORMATION / ORIGINAL LEAD FORMAT (Unified Single Page) -->
                                    <div *ngSwitchCase="'myViews'">
                                        <ng-container *ngTemplateOutlet="type8MyViewsTpl"></ng-container>
                                    </div>
                                    <div *ngSwitchCase="'leadInformation'">
                                        <ng-container *ngTemplateOutlet="type8MyViewsTpl"></ng-container>
                                    </div>
                                    <div *ngSwitchCase="'originalLeadFormat'">
                                        <ng-container *ngTemplateOutlet="type8MyViewsTpl"></ng-container>
                                    </div>

                                    <!-- TEMPLATE: UNIFIED CONTACT DETAILS -->
                                    <ng-template #type8ContactDetailsTpl>
                                        <div class="contact-details-container">
                                            <div class="details-header">
                                                <h2>Contact details</h2>
                                            </div>

                                            <div class="details-tabs">
                                                <button [attr.guide]="'lead-detail-btn-t8-all' + '__' + sanitizedUrl"
                                                    [class.active]="activeView === 'all'" (click)="setView('all')">All
                                                    details</button>
                                                <button [attr.guide]="'lead-detail-btn-t8-basic' + '__' + sanitizedUrl"
                                                    [class.active]="activeView === 'basic'"
                                                    (click)="setView('basic')">Basic
                                                    information</button>
                                            </div>

                                            <div class="details-content" [class.basic-view]="activeViewNew === 'basic'">
                                                <div *ngIf="activeView === 'all'">
                                                    <div class="content-section">
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-tgl-basic' + '__' + sanitizedUrl"
                                                            class="section-toggle" (click)="toggleBasicInfo()">
                                                            <i class="icon-chevron"
                                                                [class.rotated]="isBasicInfoOpen"></i>
                                                            <h3>Basic information</h3>
                                                        </button>
                                                        <div class="section-body" *ngIf="isBasicInfoOpen">
                                                            <div class="details-grid-4col">
                                                                <div class="info-item">
                                                                    <label
                                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">Email</label>
                                                                    <div class="value-display">
                                                                        <a class="small-email-text"
                                                                            [attr.guide]="'lead-detail-lnk-t8-email' + '__' + sanitizedUrl"
                                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-email' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Name</label>
                                                                    <div class="value-display">
                                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') ===
                                                                            -1 &&
                                                                            LeadDetailsObject?.name?.length > 20) ?
                                                                            (LeadDetailsObject?.name | slice:0:20) +
                                                                            '...' :
                                                                            LeadDetailsObject?.name }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-name' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Company</label>
                                                                    <div class="value-display">
                                                                        <a [attr.guide]="'lead-detail-lnk-t8-comp' + '__' + sanitizedUrl"
                                                                            (click)="goToCompany()">{{LeadDetailsObject?.company
                                                                            }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-comp' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Job title</label>
                                                                    <div class="value-display">
                                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-job' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="content-section">
                                                        <div class="section-header">
                                                            <h4>Telephone numbers</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <div class="info-item">
                                                                    <label>Mobile</label>
                                                                    <div class="value-display">
                                                                        <a [attr.guide]="'lead-detail-lnk-t8-mob' + '__' + sanitizedUrl"
                                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                                            LeadDetailsObject?.phoneNumber }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-mob' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Work phone</label>
                                                                    <div class="value-display">
                                                                        <a
                                                                            href="tel:{{LeadDetailsObject?.secondaryphoneno}}">{{
                                                                            LeadDetailsObject?.secondaryphoneno }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-workph' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="content-section">
                                                        <div class="section-header">
                                                            <h4>Sales owner</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <div class="info-item">
                                                                    <label>Sales owner</label>
                                                                    <div class="value-display">
                                                                        <span class="value mobile-truncate-email"
                                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                                            LeadDetailsObject?.ownerIdName || '-'
                                                                            }}</span>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-ed-owner' + '__' + sanitizedUrl"
                                                                            (click)="transferLead()" class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="content-section">
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-tgl-more' + '__' + sanitizedUrl"
                                                            class="section-toggle" (click)="toggleMoreFields()">
                                                            <i class="icon-chevron"
                                                                [class.rotated]="isMoreFieldsOpen"></i>
                                                            <h3>More fields</h3>
                                                        </button>
                                                        <div class="section-body" *ngIf="isMoreFieldsOpen">
                                                            <div class="sub-section">
                                                                <div class="section-header">
                                                                    <h4>Location</h4>
                                                                </div>
                                                                <div class="section-body">
                                                                    <div class="details-grid-4col">
                                                                        <div class="info-item">
                                                                            <label>Address</label>
                                                                            <div class="value-display">
                                                                                <a>{{
                                                                                    LeadDetailsObject?.additionalSpec?.Address
                                                                                    ||
                                                                                    LeadDetailsObject?.address }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-addr' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('Address', 'Address', 'text')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item"
                                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.State">
                                                                            <label>City</label>
                                                                            <div class="value-display">
                                                                                <a>{{
                                                                                    LeadDetailsObject?.isCustomizedValue?.City
                                                                                    ||
                                                                                    LeadDetailsObject?.city }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-city' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('City', 'City', 'select')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item"
                                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.Country">
                                                                            <label>State</label>
                                                                            <div class="value-display">
                                                                                <a>{{
                                                                                    LeadDetailsObject?.isCustomizedValue?.State
                                                                                    ||
                                                                                    LeadDetailsObject?.state }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-state' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('State', 'State', 'select')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item">
                                                                            <label>Country</label>
                                                                            <div class="value-display">
                                                                                <a>{{
                                                                                    LeadDetailsObject?.isCustomizedValue?.Country
                                                                                    ||
                                                                                    LeadDetailsObject?.country }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-country' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('Country', 'Country', 'select')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item">
                                                                            <label>Zipcode</label>
                                                                            <div class="value-display">
                                                                                <a>{{
                                                                                    LeadDetailsObject?.isCustomizedValue?.Pincode
                                                                                    ||
                                                                                    LeadDetailsObject?.pincode }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-pin' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('pincode', 'Pincode', 'text')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="sub-section">
                                                                <div class="section-header">
                                                                    <h4>Lifecycle stage</h4>
                                                                </div>
                                                                <div class="section-body">
                                                                    <div class="details-grid-4col">
                                                                        <div class="info-item">
                                                                            <label>Status</label>
                                                                            <div class="value-display">
                                                                                <a>{{LeadDetailsObject?.statusName}}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-status' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('statusName', 'Status Name', 'select')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item">
                                                                            <label>Lost reason</label>
                                                                            <div class="value-display">
                                                                                <a
                                                                                    *ngIf="LeadDetailsObject?.lostReason; else addReasonT8">{{
                                                                                    LeadDetailsObject?.lostReason }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-lost' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('lostReason', 'Lost Reason', 'text')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                                <ng-template #addReasonT8>
                                                                                    <span
                                                                                        style="color: rgb(93, 93, 207);"
                                                                                        class="value placeholder"
                                                                                        (click)="lostReason()">
                                                                                        Click to add
                                                                                    </span>
                                                                                </ng-template>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item">
                                                                            <label>Score</label>
                                                                            <div class="value-display">
                                                                                <a>{{ LeadDetailsObject?.score }}</a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="sub-section">
                                                                <div class="section-header">
                                                                    <h4>Social profiles</h4>
                                                                </div>
                                                                <div class="section-body">
                                                                    <div class="details-grid-4col">
                                                                        <div class="info-item">
                                                                            <label>LinkedIn</label>
                                                                            <div class="value-display">
                                                                                <a>{{ LeadDetailsObject?.linkedIn }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-in' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('linkedIn', 'LinkedIn', 'text')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item">
                                                                            <label>Twitter</label>
                                                                            <div class="value-display">
                                                                                <a>{{ LeadDetailsObject?.twitter }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-tw' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('twitter', 'Twitter', 'text')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="info-item">
                                                                            <label>Facebook</label>
                                                                            <div class="value-display">
                                                                                <a>{{ LeadDetailsObject?.facebook }}</a>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-ed-fb' + '__' + sanitizedUrl"
                                                                                    (click)="openEditPopup('facebook', 'Facebook', 'text')"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div *ngIf="activeView === 'basic'">
                                                    <div class="content-section">
                                                        <div class="section-header">
                                                            <h3>Basic information</h3>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <div class="info-item">
                                                                    <label>Email</label>
                                                                    <div class="value-display">
                                                                        <a class="small-email-text"
                                                                            [attr.guide]="'lead-detail-lnk-t8-b-email' + '__' + sanitizedUrl"
                                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email}}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-email' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Name</label>
                                                                    <div class="value-display">
                                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') ===
                                                                            -1 &&
                                                                            LeadDetailsObject?.name?.length > 20) ?
                                                                            (LeadDetailsObject?.name | slice:0:20) +
                                                                            '...' :
                                                                            LeadDetailsObject?.name }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-name' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Company</label>
                                                                    <div class="value-display">
                                                                        <a [attr.guide]="'lead-detail-lnk-t8-b-comp' + '__' + sanitizedUrl"
                                                                            (click)="goToCompany()">{{LeadDetailsObject?.company
                                                                            }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-comp' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Job title</label>
                                                                    <div class="value-display">
                                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-job' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="content-section">
                                                        <div class="section-header">
                                                            <h4>Telephone numbers</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <div class="info-item">
                                                                    <label>Mobile</label>
                                                                    <div class="value-display">
                                                                        <a [attr.guide]="'lead-detail-lnk-t8-b-mob' + '__' + sanitizedUrl"
                                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                                            LeadDetailsObject?.phoneNumber }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-mob' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div class="info-item">
                                                                    <label>Work phone</label>
                                                                    <div class="value-display">
                                                                        <a [attr.guide]="'lead-detail-lnk-t8-b-workph' + '__' + sanitizedUrl"
                                                                            (click)="LeadDetailsObject?.secondaryphoneno ? phoneNumbercallSecondary(LeadDetailsObject) : null">{{
                                                                            LeadDetailsObject?.secondaryphoneno }}</a>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-workph' + '__' + sanitizedUrl"
                                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                                            class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="content-section">
                                                        <div class="section-header">
                                                            <h4>Sales owner</h4>
                                                        </div>
                                                        <div class="section-body">
                                                            <div class="details-grid-4col">
                                                                <div class="info-item">
                                                                    <label>Sales owner</label>
                                                                    <div class="value-display">
                                                                        <span class="value mobile-truncate-email"
                                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                                            LeadDetailsObject?.ownerIdName || '-'
                                                                            }}</span>
                                                                        <button
                                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-owner' + '__' + sanitizedUrl"
                                                                            (click)="transferLead()" class="edit-btn">
                                                                            <mat-icon>edit</mat-icon>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>

                                    <!-- TEMPLATE: UNIFIED MY VIEWS -->
                                    <ng-template #type8MyViewsTpl>
                                        <div class="contact-details-container">
                                            <div class="details-header">
                                                <h2>My Views</h2>
                                                <div class="header-actions">
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-manage-flds' + '__' + sanitizedUrl"
                                                        (click)="manageFields()" class="btn-secondary">Manage
                                                        fields</button>
                                                </div>
                                            </div>

                                            <div class="details-tabs">
                                                <button
                                                    [attr.guide]="'lead-detail-btn-t8-v-basic' + '__' + sanitizedUrl"
                                                    [class.active]="activeViewNew === 'basic'"
                                                    (click)="setViewNew('basic')">Lead
                                                    information</button>
                                                <button [attr.guide]="'lead-detail-btn-t8-v-orig' + '__' + sanitizedUrl"
                                                    [class.active]="activeViewNew === 'Original'"
                                                    (click)="setViewNew('Original')">Original Lead Format</button>
                                            </div>

                                            <div class="details-content">
                                                <div *ngIf="activeViewNew === 'Original'">
                                                    <div class="content-section">
                                                        <ng-container
                                                            *ngIf="jsonRecieved && (jsonRecieved | keyvalue).length > 0; else noRecordT8">
                                                            <div>
                                                                <table id="details">
                                                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                                                        <td>{{ item.key === 'adGroupName' ? 'Campaign
                                                                            Name' : item.key
                                                                            }}</td>
                                                                        <td>
                                                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                                class="blackColor wordBreak"
                                                                                [innerHTML]="item.value">
                                                                            </p>
                                                                            <p *ngIf="item.key=='Lead Status'"
                                                                                class="blackColor wordBreak"
                                                                                [innerHTML]="LeadDetailsObject?.statusName">
                                                                            </p>
                                                                            <p *ngIf="item.key=='Lead Source'"
                                                                                class="blackColor wordBreak"
                                                                                [innerHTML]="LeadDetailsObject?.sourceName">
                                                                            </p>
                                                                            <p *ngIf="item.key=='Category'"
                                                                                class="blackColor wordBreak"
                                                                                [innerHTML]="LeadDetailsObject?.category">
                                                                            </p>
                                                                            <p *ngIf="item.key=='Product'"
                                                                                class="blackColor wordBreak"
                                                                                [innerHTML]="LeadDetailsObject?.product">
                                                                            </p>
                                                                        </td>
                                                                    </tr>
                                                                </table>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #noRecordT8>
                                                            <div class="text-center text-muted py-4">
                                                                <p>No data found.</p>
                                                            </div>
                                                        </ng-template>
                                                    </div>
                                                </div>

                                                <div *ngIf="activeViewNew === 'basic'">
                                                    <div class="content-section" *ngIf="manageFieldCustomization == 0">
                                                        <ng-container>
                                                            <div>
                                                                <table
                                                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">
                                                                    <tr>
                                                                        <th colspan="2">{{leadCommonPropertiesName ||
                                                                            'Lead
                                                                            Information'}}</th>
                                                                    </tr>
                                                                    <ng-container *ngIf="!type3">
                                                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                                                            <td>{{item.key}}</td>
                                                                            <td>
                                                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="item.value"></p>
                                                                                <p *ngIf="item.key=='Lead Status'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.statusName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Lead Source'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.sourceName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Category'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.category">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.product">
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                    <ng-container *ngIf="type3">
                                                                        <tr *ngFor="let item of customList">
                                                                            <td>{{item[0]}}</td>
                                                                            <td>
                                                                                <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' && item[0]!='Lead_Source' &&item[0]!='Lead_Status' && item[0]!='Lead Source' && item[0]!='Category' && item[0]!='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="item[1]">
                                                                                </p>
                                                                                <p *ngIf="item[0]=='Lead Status' || item[0]=='Lead_Status'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.statusName">
                                                                                </p>
                                                                                <p *ngIf="item[0]=='Lead Source' || item[0]=='Lead_Source'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.sourceName">
                                                                                </p>
                                                                                <p *ngIf="item[0]=='Category'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.category">
                                                                                </p>
                                                                                <p *ngIf="item[0]=='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.product">
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                </table>

                                                                <table
                                                                    *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">
                                                                    <tr>
                                                                        <th colspan="2">{{leadPropertiesName || 'Lead
                                                                            Information'}}
                                                                        </th>
                                                                    </tr>
                                                                    <ng-container *ngIf="!type2">
                                                                        <tr *ngFor="let item of valuesList | keyvalue">
                                                                            <td>{{item.key}}</td>
                                                                            <td>
                                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' && item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="item.value"></p>
                                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.statusName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.sourceName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.category">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.product">
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                    <ng-container *ngIf="type2">
                                                                        <tr *ngFor="let item of filterList | keyvalue">
                                                                            <td>{{item.key}}</td>
                                                                            <td>
                                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' && item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="item.value"></p>
                                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.statusName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.sourceName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.category">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.product">
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                </table>

                                                                <table
                                                                    *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">
                                                                    <tr>
                                                                        <th colspan="2">{{leadAdditionalPropertiesName
                                                                            || 'Lead
                                                                            Additional Information'}}</th>
                                                                    </tr>
                                                                    <ng-container *ngIf="!type1">
                                                                        <tr
                                                                            *ngFor="let item of additionalSpec | keyvalue">
                                                                            <td>{{item.key}}</td>
                                                                            <td>
                                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' && item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="item.value"></p>
                                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.statusName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.sourceName">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.category">
                                                                                </p>
                                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                                    class="blackColor wordBreak"
                                                                                    [innerHTML]="LeadDetailsObject?.product">
                                                                                </p>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                    <ng-container *ngIf="type1">
                                                                        <tr *ngFor="let item of additionalSpecList">
                                                                            <td>{{ item[0] }}</td>
                                                                            <td>
                                                                                <ng-container [ngSwitch]="item[0]">
                                                                                    <p *ngSwitchCase="'Lead Status'"
                                                                                        class="blackColor wordBreak">{{
                                                                                        LeadDetailsObject?.statusName }}
                                                                                    </p>
                                                                                    <p *ngSwitchCase="'Lead_Status'"
                                                                                        class="blackColor wordBreak">{{
                                                                                        LeadDetailsObject?.statusName }}
                                                                                    </p>
                                                                                    <p *ngSwitchCase="'Lead Source'"
                                                                                        class="blackColor wordBreak">{{
                                                                                        LeadDetailsObject?.sourceName }}
                                                                                    </p>
                                                                                    <p *ngSwitchCase="'Lead_Source'"
                                                                                        class="blackColor wordBreak">{{
                                                                                        LeadDetailsObject?.sourceName }}
                                                                                    </p>
                                                                                    <p *ngSwitchCase="'Category'"
                                                                                        class="blackColor wordBreak">{{
                                                                                        LeadDetailsObject?.category }}
                                                                                    </p>
                                                                                    <p *ngSwitchCase="'Product'"
                                                                                        class="blackColor wordBreak">{{
                                                                                        LeadDetailsObject?.product }}
                                                                                    </p>
                                                                                    <p *ngSwitchDefault
                                                                                        class="blackColor wordBreak">{{
                                                                                        item[1] }}</p>
                                                                                </ng-container>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-container>
                                                                </table>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #noRecordT8Info>
                                                            <div class="text-center text-muted py-4">
                                                                <p>No data found.</p>
                                                            </div>
                                                        </ng-template>
                                                    </div>

                                                    <div class="content-section" *ngIf="manageFieldCustomization == 1">
                                                        <ng-container *ngIf="mappedGroups?.length > 0; else noDataT8">
                                                            <div class="content-section"
                                                                *ngFor="let group of mappedGroups">
                                                                <div class="section-header">
                                                                    <h3>{{ group.groupName }}</h3>
                                                                </div>
                                                                <div class="section-body">
                                                                    <div class="details-grid-4col">
                                                                        <div class="info-item"
                                                                            *ngFor="let field of group.fields"
                                                                            [class.expanded]="field.expanded">
                                                                            <label>{{ field.fieldName }}</label>
                                                                            <div class="value-display">
                                                                                <ng-container
                                                                                    [ngSwitch]="field.fieldKey">
                                                                                    <a [attr.guide]="'lead-detail-lnk-t8-fld-email' + '__' + sanitizedUrl"
                                                                                        *ngSwitchCase="'Email'"
                                                                                        [matTooltip]="field.value"
                                                                                        (click)="field.value !== '-' ? openEmailPopup() : null">
                                                                                        {{ field.value }}
                                                                                    </a>
                                                                                    <span *ngSwitchDefault
                                                                                        [matTooltip]="field.value"
                                                                                        (click)="field.expanded = !field.expanded">
                                                                                        {{ field.value }}
                                                                                    </span>
                                                                                </ng-container>
                                                                                <button
                                                                                    [attr.guide]="'lead-detail-btn-t8-fld-ed' + '__' + sanitizedUrl"
                                                                                    *ngIf="!field.isReadOnly"
                                                                                    (click)="openEditPopupNew(field.fieldKey, field.fieldName, field.fieldType, field); $event.stopPropagation()"
                                                                                    class="edit-btn">
                                                                                    <mat-icon>edit</mat-icon>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ng-container>
                                                        <ng-template #noDataT8>
                                                            <div class="text-center text-muted py-4">
                                                                <p>No fields configured.</p>
                                                            </div>
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-template>

                                    <!-- 8. ACTIVITIES (Timeline Hub) -->
                                    <div *ngSwitchCase="'activities'">
                                        <div class="activities-container" fxLayout="column">
                                            <div class="activity-timeline-feed"
                                                style="background:#fff; border-radius:8px; padding:16px;">
                                                <div class="timeline-header" fxLayout="row"
                                                    fxLayoutAlign="space-between center" style="margin-bottom:16px;">
                                                    <h3 style="margin:0;">Activity Timeline</h3>
                                                    <div fxLayoutGap="8px">
                                                        <button mat-raised-button color="primary"
                                                            (click)="createNote(null, 0)">Add
                                                            Note</button>
                                                        <button mat-stroked-button
                                                            (click)="addLeadActivity('Phone Call', 0, null)">Add
                                                            Task</button>
                                                    </div>
                                                </div>
                                                <div class="timeline-body">
                                                    <div *ngFor="let group of groupedActivities | keyvalue"
                                                        class="activity-date-group">
                                                        <h4 class="date-header"
                                                            style="color:#64748b; margin:12px 0 8px 0;">{{ group.key
                                                            }}</h4>
                                                        <div *ngFor="let item of group.value" class="activity-item"
                                                            style="padding:10px 14px; border-left:3px solid #3b82f6; margin-bottom:8px; background:#f8fafc; border-radius:4px;">
                                                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                                                <span style="font-weight:600; font-size:13px;">{{
                                                                    item.activityType ||
                                                                    item.title || 'Activity' }}</span>
                                                                <span style="font-size:12px; color:#94a3b8;">{{
                                                                    item.createdDate |
                                                                    calsoftDate }}</span>
                                                            </div>
                                                            <p style="margin:4px 0 0 0; font-size:13px; color:#334155;">
                                                                {{
                                                                item.description || item.notes || item.name }}</p>
                                                        </div>
                                                    </div>
                                                    <div *ngIf="!leadActivityList || leadActivityList.length === 0"
                                                        style="text-align:center; padding:30px; color:#94a3b8;">
                                                        No activities recorded yet.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 9. ACTIVITY -->
                                    <div *ngSwitchCase="'activity'">
                                        <div class="activity-timeline-feed"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <div *ngFor="let group of groupedActivities | keyvalue"
                                                class="activity-date-group">
                                                <h4 class="date-header" style="color:#64748b; margin:12px 0 8px 0;">{{
                                                    group.key }}</h4>
                                                <div *ngFor="let item of group.value" class="activity-item"
                                                    style="padding:10px 14px; border-left:3px solid #3b82f6; margin-bottom:8px; background:#f8fafc; border-radius:4px;">
                                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                                        <span style="font-weight:600; font-size:13px;">{{
                                                            item.activityType ||
                                                            item.title || 'Activity' }}</span>
                                                        <span style="font-size:12px; color:#94a3b8;">{{ item.createdDate
                                                            | calsoftDate
                                                            }}</span>
                                                    </div>
                                                    <p style="margin:4px 0 0 0; font-size:13px; color:#334155;">{{
                                                        item.description ||
                                                        item.notes || item.name }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 10. NOTES -->
                                    <div *ngSwitchCase="'notes'">
                                        <div class="notes-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <div fxLayout="row" fxLayoutAlign="space-between center"
                                                style="margin-bottom:16px;">
                                                <h3 style="margin:0;">Notes</h3>
                                                <button mat-raised-button color="primary"
                                                    (click)="createNote(null, 0)">Add
                                                    Note</button>
                                            </div>
                                            <div *ngIf="noteList && noteList.length > 0; else emptyNotesT8">
                                                <div *ngFor="let note of noteList" class="note-card"
                                                    style="border:1px solid #e2e8f0; border-radius:6px; padding:12px; margin-bottom:12px;">
                                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                                        <span style="font-weight:600;">{{note.createdBy}}</span>
                                                        <span style="font-size:12px; color:#94a3b8;">{{note.createdDate
                                                            |
                                                            calsoftDate}}</span>
                                                    </div>
                                                    <p style="margin:8px 0;">{{note.notes}}</p>
                                                    <div fxLayout="row" fxLayoutGap="8px">
                                                        <button mat-button color="primary"
                                                            (click)="toggleReply(note.noteId)">Reply</button>
                                                        <button mat-button color="warn"
                                                            (click)="deleteNote(note)">Delete</button>
                                                    </div>
                                                    <div *ngIf="replyingToNoteId === note.noteId"
                                                        style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;margin-top:8px;">
                                                        <mat-form-field appearance="outline" style="flex:1">
                                                            <mat-label>Reply</mat-label>
                                                            <textarea matInput rows="2" [(ngModel)]="replyText"
                                                                placeholder="Write a reply..."></textarea>
                                                        </mat-form-field>
                                                        <button mat-raised-button color="primary"
                                                            [disabled]="!replyText?.trim()"
                                                            (click)="submitReply(note)">Send</button>
                                                        <button mat-icon-button
                                                            (click)="toggleReply(null)"><mat-icon>close</mat-icon></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <ng-template #emptyNotesT8>
                                                <div style="text-align:center; padding:30px; color:#94a3b8;">No notes
                                                    found.</div>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <!-- 11. TASKS -->
                                    <div *ngSwitchCase="'tasks'">
                                        <div class="tasks-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                                        </div>
                                    </div>

                                    <!-- 12. MEETINGS -->
                                    <div *ngSwitchCase="'meetings'">
                                        <div class="meetings-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <calsoft-leadsmeeting [leadId]="leadId"
                                                [googleCalendarList]="googleCalendarList" [meetingType]="1" [type]="1"
                                                class="width-table"></calsoft-leadsmeeting>
                                        </div>
                                    </div>

                                    <!-- 13. CHATS -->
                                    <div *ngSwitchCase="'chats'">
                                        <div class="chats-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <div *ngIf="leadLoaded && whatAppchatType === 1">
                                                <calsoft-whatsapp-chat-details
                                                    [contactId]="LeadDetailsObject?.phoneNumber"
                                                    [isFromPhone]="true"></calsoft-whatsapp-chat-details>
                                            </div>
                                            <div *ngIf="leadLoaded && whatAppchatType === 2">
                                                <calsoft-whats-app-new-client
                                                    [phoneNumber]="LeadDetailsObject?.phoneNumber"></calsoft-whats-app-new-client>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 14. EMAIL -->
                                    <div *ngSwitchCase="'email'">
                                        <div class="email-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <div class="mailbox-container">
                                                <div class="mailbox-toggle-container" style="margin-bottom:12px;">
                                                    <mat-button-toggle-group [(value)]="currentMailBox"
                                                        (change)="loadEmails($event)">
                                                        <mat-button-toggle value="INBOX">Inbox</mat-button-toggle>
                                                        <mat-button-toggle value="Sent">Sent</mat-button-toggle>
                                                    </mat-button-toggle-group>
                                                </div>
                                                <div class="mailbox-content">
                                                    <mat-nav-list *ngIf="emails && emails.length > 0; else noEmailsT8">
                                                        <mat-list-item *ngFor="let email of emails; let i = index"
                                                            [ngClass]="{'active': i === selectedIndex}"
                                                            (click)="selectEmail(i)">
                                                            <div style="padding: 8px 0;">
                                                                <div style="font-weight:600;">{{email.subject}}</div>
                                                                <div style="font-size:12px; color:#64748b;">
                                                                    {{email.from}} &bull;
                                                                    {{email.sentDate | date:'medium'}}</div>
                                                            </div>
                                                        </mat-list-item>
                                                    </mat-nav-list>
                                                    <ng-template #noEmailsT8>
                                                        <div style="text-align:center; padding:30px; color:#94a3b8;">No
                                                            emails found.
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 15. CALLS -->
                                    <div *ngSwitchCase="'calls'">
                                        <div class="calls-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <h3 style="margin:0 0 16px 0;">Call History</h3>
                                            <div *ngIf="calllist && calllist.length > 0; else noCallsT8">
                                                <table id="details" style="width:100%;">
                                                    <thead>
                                                        <tr>
                                                            <th>Call Type</th>
                                                            <th>Duration</th>
                                                            <th>Agent</th>
                                                            <th>Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let call of calllist">
                                                            <td>{{call.activityType || 'Outbound'}}</td>
                                                            <td>{{call.callDuration || '—'}}</td>
                                                            <td>{{call.ownerName || call.createdBy || '—'}}</td>
                                                            <td>{{call.createdDate | calsoftDate}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <ng-template #noCallsT8>
                                                <div style="text-align:center; padding:30px; color:#94a3b8;">No calls
                                                    recorded.</div>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <!-- 16. EMAIL STATUS -->
                                    <div *ngSwitchCase="'emailStatus'">
                                        <div class="email-status-page"
                                            style="background:#fff; border-radius:8px; padding:16px;">
                                            <h3 style="margin:0 0 16px 0;">Email Status Logs</h3>
                                            <div *ngIf="emailList && emailList.length > 0; else noEmailStatusT8">
                                                <table id="details" style="width:100%;">
                                                    <thead>
                                                        <tr>
                                                            <th>Subject</th>
                                                            <th>Status</th>
                                                            <th>Recipient</th>
                                                            <th>Date</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let item of emailList">
                                                            <td>{{item.subject}}</td>
                                                            <td>{{item.status || 'Sent'}}</td>
                                                            <td>{{item.toEmail || item.email}}</td>
                                                            <td>{{item.createdDate | calsoftDate}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <ng-template #noEmailStatusT8>
                                                <div style="text-align:center; padding:30px; color:#94a3b8;">No email
                                                    logs available.
                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>

                                    <!-- 17. COMPANY -->
                                    <div *ngSwitchCase="'company'">
                                        <div class="width-table">
                                            <div class="deal-page1">
                                                <calsoft-account-companies-table [defaultSet]="defaultSet" [type]="1"
                                                    [defaultSetType]="defaultSetType"
                                                    [leadId]="relatedCompanyId"></calsoft-account-companies-table>
                                            </div>
                                            <!-- <div class="info-item"><label>Industry</label>
                                    <div class="value-display"><span>{{LeadDetailsObject?.industry || '—'}}</span></div>
                                </div>
                                <div class="info-item"><label>Website</label>
                                    <div class="value-display"><a [href]="LeadDetailsObject?.website"
                                            target="_blank">{{LeadDetailsObject?.website || '—'}}</a></div>
                                </div>
                                <div class="info-item"><label>CR No</label>
                                    <div class="value-display"><span>{{LeadDetailsObject?.CrNo || '—'}}</span></div>
                                </div>
                            </div> -->
                                        </div>
                                    </div>

                                    <!-- 18. DEALS -->
                                    <div *ngSwitchCase="'deals'">
                                        <div class="width-table">
                                            <div class="deal-page1">
                                                <calsoft-deal-table [type]="2" [dealsPrimaryType]="0" [DealType]="2"
                                                    [data]="LeadDetailsObject" [defaultSet]="defaultSet"
                                                    [defaultSetType]="defaultSetType" [leadId]="leadId"
                                                    [dealsTableView]="1"></calsoft-deal-table>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 19. NEXT ACTION -->
                                    <div *ngSwitchCase="'nextAction'">
                                        <calsoft-next-best-action-card [leadId]="leadId">
                                        </calsoft-next-best-action-card>
                                    </div>

                                    <!-- 20. FILES -->
                                    <div *ngSwitchCase="'files'">
                                        <div class="card">
                                            <div class="width-table">
                                                <div class="width-table">
                                                    <div class="editSets1 ">
                                                        <div class="title " fxLayout="row"
                                                            fxLayoutAlign="space-between center">
                                                            <span>Files</span>

                                                            <button
                                                                [attr.guide]="'lead-detail-btn-t8-file-add' + '__' + sanitizedUrl"
                                                                mat-icon-button>
                                                                <mat-icon (click)="createFile(null,0)">
                                                                    add
                                                                </mat-icon>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div style="overflow-x:auto;">
                                                        <table>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th>Owner</th>
                                                                <th>File Type</th>
                                                                <th>Added On</th>
                                                                <th>Download</th>
                                                                <th>Action</th>
                                                            </tr>
                                                            <tr *ngFor="let note of noteList;">
                                                                <ng-container
                                                                    *ngIf="note.notesDocument && note.notesDocument.length > 0">

                                                                    <td>
                                                                        <img *ngIf="note.documentType == '4'" width="36"
                                                                            height="36"
                                                                            [src]="serverPathNotes + note.notesDocument + cid"
                                                                            alt="Uploaded Image">

                                                                        <img *ngIf="note.documentType == '1'"
                                                                            src="assets/images/mp4.png" width="36"
                                                                            height="36" alt="Vedio File">

                                                                        <img *ngIf="note.documentType == '2'"
                                                                            src="assets/images/mp3.png" width="36"
                                                                            height="36" alt="Audio File">

                                                                        <img *ngIf="note.documentType == '3'"
                                                                            src="assets/images/pdf.png" width="36"
                                                                            height="36" alt="PDF File">

                                                                        <img *ngIf="note.documentType == '5' || note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                                            src="assets/images/docx.png" width="36"
                                                                            height="36" alt="DOCX File">

                                                                        <img *ngIf="note.documentType == '6' || note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                                            src="assets/images/excel.png" width="36"
                                                                            height="36" alt="Excel File">
                                                                    </td>
                                                                    <td>{{note.createdBy}}</td>
                                                                    <td>{{note.resource}}</td>
                                                                    <td>{{note.createdDate | calsoftDate}}</td>
                                                                    <td style="cursor: pointer;"
                                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)">
                                                                        <mat-icon>download</mat-icon>
                                                                    </td>
                                                                    <td style="cursor: pointer;"
                                                                        (click)="deleteNote(note)">
                                                                        <mat-icon>delete</mat-icon>
                                                                    </td>
                                                                </ng-container>

                                                            </tr>

                                                        </table>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 21. SEQUENCES -->
                                    <div *ngSwitchCase="'sequences'">
                                        <div class="width-table">
                                            <div class="deal-page1">
                                                <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- UNCONFIGURED FALLBACK -->
                                    <div *ngSwitchDefault>
                                        <div class="unconfigured-section-notice"
                                            style="padding: 40px 20px; text-align: center; background: #fff; border-radius: 8px; border: 1px dashed #cbd5e1; margin: 20px 0;">
                                            <mat-icon
                                                style="font-size: 48px; width: 48px; height: 48px; color: #94a3b8;">extension_off</mat-icon>
                                            <h3 style="margin-top: 16px; color: #334155;">Component is not configured
                                            </h3>
                                            <p
                                                style="color: #64748b; font-size: 14px; max-width: 480px; margin: 8px auto 0 auto;">
                                                The component key '<strong>{{activeType8ComponentKey ||
                                                    'empty'}}</strong>' is not
                                                currently registered or enabled for rendering.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</div>
<div *ngIf="leadDetailPageType === 1" class="hubspot-lead-detail-wrapper" fxLayout="column" fxLayout.gt-sm="row">

    <!-- LEFT COLUMN -->
    <div class="hub-left-column" fxFlex="25" fxFlex.lt-md="100" [formGroup]="firstFormGroup">
        <!-- Top Contact Card -->
        <div class="hub-white-card hub-contact-card">
            <div class="hub-card-header-row">
                <a [attr.guide]="'lead-detail-lnk-42' + '__' + sanitizedUrl" class="hub-back-link" (click)="back()">
                    <mat-icon>chevron_left</mat-icon>
                    <span>Contacts</span>
                </a>
                <button type="button" class="hub-actions-dropdown-btn" [matMenuTriggerFor]="hubContactActionsMenu">
                    <span>Actions</span>
                    <mat-icon>arrow_drop_down</mat-icon>
                </button>
                <mat-menu #hubContactActionsMenu="matMenu">
                    <button mat-menu-item (click)="openEditDialog()">
                        <mat-icon>edit</mat-icon>
                        <span>Edit Contact</span>
                    </button>
                    <button mat-menu-item (click)="createNote(null, 0)">
                        <mat-icon>note_add</mat-icon>
                        <span>Add Note</span>
                    </button>
                    <button mat-menu-item (click)="addLeadActivity('Follow Up', 0, null)">
                        <mat-icon>task</mat-icon>
                        <span>Create Task</span>
                    </button>
                </mat-menu>
            </div>

            <!-- Profile Info with HubSpot Sprocket -->
            <div class="hub-profile-section">
                <div class="hub-profile-brand-row">
                    <div class="hub-name-container">
                        <h2 class="hub-contact-heading">{{ LeadDetailsObject?.name || 'Contact' }}</h2>
                    </div>
                </div>

                <div class="hub-contact-role"
                    *ngIf="LeadDetailsObject?.jobtitle || LeadDetailsObject?.jobTitle || LeadDetailsObject?.company || LeadDetailsObject?.Company || associatedCompany?.name">
                    {{ LeadDetailsObject?.jobtitle || LeadDetailsObject?.jobTitle || '' }}
                    <span
                        *ngIf="(LeadDetailsObject?.jobtitle || LeadDetailsObject?.jobTitle) && (LeadDetailsObject?.company || LeadDetailsObject?.Company || associatedCompany?.name)">
                        at </span>
                    <span>{{ associatedCompany?.name || LeadDetailsObject?.company || LeadDetailsObject?.Company || ''
                        }}</span>
                </div>

                <div class="hub-contact-email-row" *ngIf="LeadDetailsObject?.email">
                    <a href="javascript:void(0)" (click)="openEmailPopup()" class="hub-email-text">
                        {{ LeadDetailsObject?.email }}
                    </a>
                    <mat-icon class="hub-link-icon" (click)="openEmailPopup()" style="cursor: pointer;"
                        matTooltip="Email">open_in_new</mat-icon>
                    <button [attr.guide]="'lead-detail-btn-44' + '__' + sanitizedUrl" mat-icon-button
                        class="hub-copy-btn" (click)="copyEmail()" matTooltip="Copy email">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                </div>
            </div>

            <!-- 6 Circle Action Buttons Row -->
            <div class="hub-circle-actions-row">
                <!-- Note -->
                <div class="hub-circle-item" (click)="createNote(null, 0)">
                    <button type="button" class="hub-round-btn" matTooltip="Add Note">
                        <mat-icon>description</mat-icon>
                    </button>
                    <span class="hub-round-lbl">Note</span>
                </div>

                <!-- Email -->
                <div class="hub-circle-item" (click)="callicon({icon: 'email'})">
                    <button type="button" class="hub-round-btn" matTooltip="Email">
                        <mat-icon>email</mat-icon>
                    </button>
                    <span class="hub-round-lbl">Email</span>
                </div>

                <!-- Call -->
                <div class="hub-circle-item" (click)="callicon({icon: 'call'})">
                    <button type="button" class="hub-round-btn" matTooltip="Call">
                        <mat-icon>call</mat-icon>
                    </button>
                    <span class="hub-round-lbl">Call</span>
                </div>

                <!-- Task -->
                <div class="hub-circle-item" [matMenuTriggerFor]="moreMenu">
                    <button type="button" class="hub-round-btn" matTooltip="Task">
                        <mat-icon>format_list_bulleted</mat-icon>
                    </button>
                    <span class="hub-round-lbl">Task</span>
                </div>

                <!-- Meeting -->
                <div class="hub-circle-item" (click)="callicon({icon: 'event'})">
                    <button type="button" class="hub-round-btn" matTooltip="Meeting">
                        <mat-icon>calendar_today</mat-icon>
                    </button>
                    <span class="hub-round-lbl">Meeti...</span>
                </div>

                <!-- More -->
                <div class="hub-circle-item" [matMenuTriggerFor]="hubExtraCircleMenu">
                    <button type="button" class="hub-round-btn" matTooltip="More">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <span class="hub-round-lbl">More</span>
                </div>

                <mat-menu #moreMenu="matMenu">
                    <button [attr.guide]="'lead-detail-btn-45' + '__' + sanitizedUrl" *ngIf="crmType!=2" mat-menu-item
                        (click)="addLeadActivity('Follow Up', 0, null)">
                        Follow Up
                    </button>
                    <button [attr.guide]="'lead-detail-btn-46' + '__' + sanitizedUrl" mat-menu-item
                        (click)="addLeadActivity('Phone Call', 0, null)">
                        Phone Call
                    </button>
                    <button [attr.guide]="'lead-detail-btn-47' + '__' + sanitizedUrl" *ngIf="enableLocation == '1'"
                        mat-menu-item (click)="addLeadActivityone('Location',0,null)">Location</button>
                </mat-menu>

                <mat-menu #hubExtraCircleMenu="matMenu">
                    <mat-form-field class="search-box" style="margin: 8px 12px; width: 180px;">
                        <mat-label>Search</mat-label>
                        <input [attr.guide]="'lead-detail-inp-50' + '__' + sanitizedUrl" matInput
                            [(ngModel)]="searchText" placeholder="Search..." />
                    </mat-form-field>
                    <button [attr.guide]="'lead-detail-btn-51' + '__' + sanitizedUrl" mat-menu-item
                        *ngFor="let item of filteredMenuItems()" (click)="onMenuItemClick(item)">
                        {{ item }}
                    </button>
                </mat-menu>
            </div>
        </div>

        <!-- Bottom Key info... Card -->
        <div class="hub-white-card hub-info-card">
            <div class="hub-info-card-header" (click)="toggleCollapse()">
                <div class="hub-info-card-title">
                    <mat-icon class="hub-chevron-icon" [class.rotated]="isCollapsed">keyboard_arrow_down</mat-icon>
                    <span>About this contact</span>
                </div>
                <div class="hub-info-card-actions" (click)="$event.stopPropagation()">
                    <button type="button" class="hub-actions-link-btn" [matMenuTriggerFor]="hubKeyInfoMenu">
                        <span>Actions</span>
                        <mat-icon>arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #hubKeyInfoMenu="matMenu">
                        <button mat-menu-item (click)="editFormTwo($event)">Edit Properties</button>
                    </mat-menu>
                </div>
            </div>

            <div class="hub-info-card-body" *ngIf="!isCollapsed">
                <div class="hub-prop-row">
                    <div class="hub-prop-label">Contact owner</div>
                    <div class="hub-prop-val">{{ LeadDetailsObject?.ownerEmail || 'No owner' }}</div>
                </div>

                <div class="hub-prop-row">
                    <div class="hub-prop-label">Lifecycle Stage</div>
                    <div class="hub-prop-val">
                        <span class="hub-lifecycle-tag">{{ LeadDetailsObject?.statusName || 'Lead' }}</span>
                    </div>
                </div>

                <div class="hub-prop-row">
                    <div class="hub-prop-label">Lead Status</div>
                    <div class="hub-prop-val">
                        <ng-container *ngIf="!editMode; else editStatusTpl">
                            {{ LeadDetailsObject?.secondaryLeadStatus || (LeadDetailsObject?.statusName ?
                            LeadDetailsObject?.statusName : '--') }}
                        </ng-container>
                        <ng-template #editStatusTpl>
                            <mat-form-field appearance="outline" style="width: 100%;">
                                <mat-label>Lead Status</mat-label>
                                <mat-select formControlName="LeadStatus" [disableOptionCentering]="true" #singleSelect
                                    autocomplete="off">
                                    <mat-option>
                                        <ngx-mat-select-search name="Lead Status Search" ngDefaultControl
                                            [formControl]="typeYFilterControl" placeholderLabel="Lead Status Search"
                                            [preventHomeEndKeyPropagation]="true" noEntriesFoundLabel="No data found">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let opt of filtereddropdownTypeList; let i=index;"
                                        [value]="opt.statusId"
                                        (onSelectionChange)="createDynamicForm($event,opt.dynamicFormGroupId,opt.statusId)">
                                        {{ opt.statusName }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </ng-template>
                    </div>
                </div>

                <div class="hub-prop-row">
                    <div class="hub-prop-label">Company</div>
                    <div class="hub-prop-val"
                        style="display: flex; align-items: center; justify-content: space-between;">
                        <ng-container *ngIf="!editMode; else editCompanyTpl">
                            <a href="javascript:void(0)" (click)="goToCompany()" class="hub-email-text"
                                *ngIf="associatedCompany?.name || LeadDetailsObject?.company || LeadDetailsObject?.Company; else noCompanyText"
                                [matTooltip]="'View Company'">
                                {{ associatedCompany?.name || LeadDetailsObject?.company || LeadDetailsObject?.Company
                                }}
                            </a>
                            <ng-template #noCompanyText>
                                <span style="color: #94a3b8;">--</span>
                            </ng-template>
                            <button type="button" mat-icon-button
                                style="width: 24px; height: 24px; line-height: 24px; padding: 0;"
                                (click)="openEditPopup('company', 'Company', 'text')" matTooltip="Edit Company">
                                <mat-icon
                                    style="font-size: 15px; width: 15px; height: 15px; color: #64748b;">edit</mat-icon>
                            </button>
                        </ng-container>
                        <ng-template #editCompanyTpl>
                            <input [(ngModel)]="LeadDetailsObject.company" placeholder="Company" class="hub-edit-input"
                                [ngModelOptions]="{standalone: true}"
                                (change)="LeadDetailsObject.Company = LeadDetailsObject.company" />
                        </ng-template>
                    </div>
                </div>

                <!-- Dynamic Fields -->
                <ng-container *ngFor="let field of dynamicFields">
                    <div class="hub-prop-row">
                        <div class="hub-prop-label">{{ field.placeholder }}</div>
                        <div class="hub-prop-val">
                            <ng-container *ngIf="!editMode; else editField">
                                {{ LeadDetailsObject[field.property] || '--' }}
                            </ng-container>
                            <ng-template #editField>
                                <input [attr.guide]="'lead-detail-inp-53' + '__' + sanitizedUrl"
                                    [formControlName]="field.formControlName" [placeholder]="field.placeholder"
                                    [(ngModel)]="LeadDetailsObject[field.property]" class="hub-edit-input" />
                            </ng-template>
                        </div>
                    </div>
                </ng-container>

                <!-- Save button when editMode is active -->
                <div class="hub-save-btn-row" *ngIf="editMode">
                    <button [attr.guide]="'lead-detail-btn-55' + '__' + sanitizedUrl" mat-raised-button color="primary"
                        (click)="submitNew()">
                        <span *ngIf="text === 'Save'">Save</span>
                        <mat-spinner *ngIf="text !== 'Save'" diameter="20"></mat-spinner>
                    </button>
                </div>

                <!-- Dynamic Form Section -->
                <ng-container *ngIf="editMode && formInit">
                    <div style="margin-top: 12px;">
                        <simple-dynamic-form [layout]="2" [leadStyle]="2" [formValue]="patchValues"
                            (submitLeadDetail)="saveNew($event)" [status]="firstFormGroup.value.LeadStatus"
                            [formType]="'newstandard'" [type]="2" (submit)="onFormSubmitted($event)"
                            [fields]="regConfig">
                        </simple-dynamic-form>
                    </div>
                </ng-container>

                <!-- Tables if enabled -->
                <table id="customers" *ngIf="leadPropertiesDisplay==1" class="hub-props-table mt-2">
                    <tr>
                        <th colspan="2">{{leadPropertiesName}}</th>
                    </tr>
                    <tr>
                        <td>Owner</td>
                        <td>{{LeadDetailsObject?.ownerEmail}}</td>
                    </tr>
                    <tr>
                        <td>Lead Source</td>
                        <td>{{LeadDetailsObject?.sourceName}}</td>
                    </tr>
                    <tr>
                        <td>Lead Age</td>
                        <td>{{leadAge}}</td>
                    </tr>
                    <tr *ngIf="crmType==1 && LeadDetailsObject?.budget != null">
                        <td>Budget</td>
                        <td>{{LeadDetailsObject?.budget}}</td>
                    </tr>
                    <tr *ngIf="crmType==1 && LeadDetailsObject?.budgetMin != null">
                        <td>Budget Min</td>
                        <td>{{LeadDetailsObject?.budgetMin}}</td>
                    </tr>
                    <tr *ngIf="crmType==1 && LeadDetailsObject?.propertyType != null">
                        <td>Property Type</td>
                        <td>{{LeadDetailsObject?.propertyType}}</td>
                    </tr>
                </table>

                <table id="customers" *ngIf="additionalAttributeEnable==1" class="hub-props-table mt-2">
                    <tr *ngIf="customField1 !=null">
                        <th colspan="2">{{additionalAttributeName}}</th>
                    </tr>
                    <ng-container *ngIf="customField1">
                        <tr *ngFor="let item of customField1 | keyvalue">
                            <td>{{item.key}}</td>
                            <td>
                                <p class="blackColor wordBreak" [innerHTML]="item.value"></p>
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </div>
    </div>

    <!-- CENTER COLUMN -->
    <div class="hub-center-column" fxFlex>

        <!-- Sub-tabs bar -->
        <div class="hub-subtabs-bar">
            <div *ngFor="let tab of hubSubTabs" class="hub-subtab-btn" [class.active]="selectedTab === tab.id"
                (click)="selectTab(tab.id)">
                {{ tab.label }}
            </div>
        </div>

        <!-- Tab Content Area -->
        <div class="hub-tab-body">
            <!-- Activities and Tasks Tab -->
            <div *ngIf="selectedTab === 'activities' || selectedTab === 'tasks'">

                <!-- Lead Activities Timeline Component -->
                <div class="hub-real-activities">
                    <div *ngIf="init && activityHistoryType == 1">
                        <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                            [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                            [totalSize]="totalSize" [leadid]="leadId" fxFlex [leadActivityList]="leadActivityList">
                        </calsoft-activity>
                    </div>
                    <ng-container *ngIf="activityHistoryType == 0">
                        <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                            [groupedActivities]="groupedActivities"
                            (scrollChange)="onScrollNew()"></calsoft-activity-new>
                    </ng-container>
                </div>
            </div>

            <!-- Notes Section -->
            <div *ngIf="selectedTab === 'notes'" class="hub-white-card p-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold mb-0" style="color: #2d3e50;">Notes</h5>
                    <button [attr.guide]="'lead-detail-btn-61' + '__' + sanitizedUrl" mat-raised-button color="primary"
                        (click)="createNote(null,0)">
                        <mat-icon>add</mat-icon> Create Note
                    </button>
                </div>

                <div *ngIf="noteList.length == 0" class="hub-empty-state-card text-center p-4">
                    <mat-icon
                        style="font-size: 40px; width: 40px; height: 40px; color: #7c98b6;">insert_drive_file</mat-icon>
                    <div class="mt-2 fw-semibold" style="color: #2d3e50;">Add notes to your lead!</div>
                    <button [attr.guide]="'lead-detail-btn-62' + '__' + sanitizedUrl" mat-flat-button color="primary"
                        class="mt-3" (click)="createNote(null,0)">Create Note</button>
                </div>

                <div class="table-responsive" *ngIf="noteList.length > 0">
                    <table class="table hub-clean-table">
                        <thead>
                            <tr>
                                <th class="col-notes">Notes</th>
                                <th class="col-date">Created Date</th>
                                <th class="col-date">Updated Date</th>
                                <th class="col-user">Created By</th>
                                <th class="col-user">Updated By</th>
                                <th class="col-action text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let note of noteList">
                                <tr *ngIf="note.documentType == 0">
                                    <td class="col-notes">
                                        <div class="note-content-wrapper" [innerHTML]="note.notes | mentionHighlight">
                                        </div>
                                    </td>
                                    <td class="col-date">
                                        <div class="date-primary">{{ note.createdDate ? (note.createdDate |
                                            date:'mediumDate') : '-' }}</div>
                                        <div class="date-secondary" *ngIf="note.createdDate">{{ note.createdDate |
                                            date:'shortTime' }}</div>
                                    </td>
                                    <td class="col-date">
                                        <div class="date-primary">{{ note.updatedDate ? (note.updatedDate |
                                            date:'mediumDate') : '-' }}</div>
                                        <div class="date-secondary" *ngIf="note.updatedDate">{{ note.updatedDate |
                                            date:'shortTime' }}</div>
                                    </td>
                                    <td class="col-user">
                                        <span class="user-text" [title]="note.createdBy || ''">{{ note.createdBy || '-'
                                            }}</span>
                                    </td>
                                    <td class="col-user">
                                        <span class="user-text" [title]="note.updatedBy || ''">{{ note.updatedBy || '-'
                                            }}</span>
                                    </td>
                                    <td class="col-action text-center">
                                        <button [attr.guide]="'lead-detail-btn-63' + '__' + sanitizedUrl"
                                            mat-icon-button [matMenuTriggerFor]="menu63">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu63="matMenu">
                                            <button mat-menu-item (click)="createNote(note, note.noteId)">
                                                <mat-icon>edit</mat-icon> Edit
                                            </button>
                                            <button mat-menu-item *ngIf="note.noteType !== 'REPLY'"
                                                (click)="toggleReply(note.noteId)">
                                                <mat-icon>reply</mat-icon> Reply
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                                <tr *ngIf="note.documentType==0 && replyingToNoteId === note.noteId">
                                    <td colspan="6">
                                        <div style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;">
                                            <mat-icon
                                                style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                            <mat-form-field appearance="outline" style="flex:1">
                                                <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                <textarea matInput rows="2" [(ngModel)]="replyText"
                                                    placeholder="Write a reply..."></textarea>
                                            </mat-form-field>
                                            <button mat-raised-button color="primary" style="margin-top:6px"
                                                [disabled]="!replyText?.trim()"
                                                (click)="submitReply(note)">Send</button>
                                            <button mat-icon-button style="margin-top:4px" (click)="toggleReply(null)">
                                                <mat-icon>close</mat-icon>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Calls Section -->
            <div *ngIf="selectedTab === 'calls'" class="hub-white-card p-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold mb-0" style="color: #2d3e50;">Calls</h5>
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="callMenuTop">
                        <mat-icon>call</mat-icon> Log Call
                    </button>
                    <mat-menu #callMenuTop="matMenu">
                        <button [attr.guide]="'lead-detail-btn-65' + '__' + sanitizedUrl" *ngIf="crmType!=2"
                            mat-menu-item (click)="addLeadActivityone('Follow Up',0,null)">Follow Up</button>
                        <button [attr.guide]="'lead-detail-btn-66' + '__' + sanitizedUrl" mat-menu-item
                            (click)="addLeadActivityone('Phone Call',0,null)">Phone Call</button>
                        <button [attr.guide]="'lead-detail-btn-67' + '__' + sanitizedUrl" *ngIf="enableLocation == '1'"
                            mat-menu-item (click)="addLeadActivityone('Location',0,null)">Location</button>
                    </mat-menu>
                </div>

                <div class="card mb-3" *ngFor="let lead of calllist;">
                    <div class="card-body">
                        <div class="d-sm-flex align-items-center justify-content-between pb-2">
                            <div class="d-flex align-items-center mb-2">
                                <span class="avatar-md me-2 flex-shrink-0">
                                    <mat-icon class="default-icon">person</mat-icon>
                                </span>
                                <p class="mb-0">
                                    <span class="text-dark fw-medium">{{lead.customerName}}</span>
                                    logged a call on {{lead.updatedDate}}
                                </p>
                            </div>
                            <div class="d-inline-flex align-items-center mb-2">
                                <div class="dropdown me-2">
                                    <a href="javascript:void(0);" class="py-1 badge" [ngClass]="{
                                        'bg-success': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                        'bg-danger': lead.phoneCallOutcome === 'failed',
                                        'bg-warning': lead.phoneCallOutcome === 'call Not Answered'
                                    }">
                                        {{lead.phoneCallOutcome | titlecase}}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <span [innerHTML]="lead.notes"></span>
                    </div>
                </div>
            </div>

            <!-- Files Section -->
            <div *ngIf="selectedTab === 'files'" class="hub-white-card p-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold mb-0" style="color: #2d3e50;">Documents</h5>
                    <button [attr.guide]="'lead-detail-btn-68' + '__' + sanitizedUrl" mat-raised-button color="primary"
                        (click)="createFile(null,0)">
                        <mat-icon>add</mat-icon> Upload
                    </button>
                </div>
                <div *ngFor="let note of noteList">
                    <div fxLayout="row">
                        <div class="p-2" *ngIf="note.documentType == 1">
                            <video controls style="max-width: 100%; border-radius: 6px;">
                                <source [src]="serverPathVedio + note.notesDocument" />
                            </video>
                        </div>
                        <div class="p-2" *ngIf="note.documentType == 2">
                            <audio controls style="width: 100%;">
                                <source [src]="serverPath + note.notesDocument" />
                            </audio>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Email / Payment Section -->
            <div *ngIf="selectedTab === 'email'" class="hub-white-card p-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-semibold mb-0" style="color: #2d3e50;">Payments & Emails</h5>
                    <div>
                        <button [attr.guide]="'lead-detail-btn-69' + '__' + sanitizedUrl" mat-raised-button
                            color="primary" (click)="createPayment(null,0)">
                            <mat-icon>add</mat-icon> Add Payment
                        </button>
                        <button mat-stroked-button color="primary" class="ms-2" (click)="callicon({icon: 'email'})">
                            <mat-icon>email</mat-icon> Compose Email
                        </button>
                    </div>
                </div>

                <div class="table-responsive" *ngIf="noteList.length>0">
                    <table class="table hub-clean-table">
                        <thead>
                            <tr>
                                <th class="col-notes">Notes</th>
                                <th class="col-date">Created Date</th>
                                <th class="col-date">Updated Date</th>
                                <th class="col-action text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let note of noteList">
                                <tr *ngIf="note.documentType==5">
                                    <td class="col-notes">
                                        <div class="note-content-wrapper" [innerHTML]="note.notes | mentionHighlight">
                                        </div>
                                    </td>
                                    <td class="col-date">{{note.createdDate | calsoftDate}}</td>
                                    <td class="col-date">{{note.updatedDate | calsoftDate}}</td>
                                    <td class="col-action text-center">
                                        <button [attr.guide]="'lead-detail-btn-70' + '__' + sanitizedUrl"
                                            mat-icon-button [matMenuTriggerFor]="payMenu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #payMenu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-71' + '__' + sanitizedUrl"
                                                (click)="createNote(note, note.noteId)" mat-menu-item>
                                                <mat-icon>edit</mat-icon> Edit
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Meetings Section -->
            <div *ngIf="selectedTab === 'meetings'" class="hub-white-card p-3 text-center">
                <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #7c98b6;">event</mat-icon>
                <h5 class="fw-semibold mt-2" style="color: #2d3e50;">Schedule a Meeting</h5>
                <p style="color: #7c98b6;">Connect your calendar to book meetings directly with this contact.</p>
                <button mat-raised-button color="primary" (click)="callicon({icon: 'event'})">
                    <mat-icon>calendar_today</mat-icon> Schedule Meeting
                </button>
            </div>
        </div>
    </div>

    <!-- DIVIDER WITH COLLAPSE TOGGLE -->
    <div class="hub-panel-divider">
        <button type="button" class="hub-divider-toggle-btn" (click)="toggleRightPanel()"
            [matTooltip]="isRightPanelOpen ? 'Collapse side panel' : 'Expand side panel'">
            <mat-icon>{{ isRightPanelOpen ? 'keyboard_arrow_right' : 'keyboard_arrow_left' }}</mat-icon>
        </button>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="hub-right-column" *ngIf="isRightPanelOpen" fxFlex="25" fxFlex.lt-md="100">
        <div class="hub-assoc-stack">
            <div *ngFor="let section of sections" class="hub-white-card hub-assoc-card">
                <div class="hub-assoc-header" (click)="toggleSection(section)">
                    <div class="hub-assoc-title-group">
                        <mat-icon class="hub-chevron-icon"
                            [class.rotated]="section.isOpen">keyboard_arrow_right</mat-icon>
                        <span class="hub-assoc-title">{{ section.title }}</span>
                        <span class="hub-assoc-count" *ngIf="section.count !== null && section.count !== undefined">({{
                            section.count }})</span>
                    </div>

                    <div class="hub-assoc-actions-group" (click)="$event.stopPropagation()">
                        <a [attr.guide]="'lead-detail-lnk-72' + '__' + sanitizedUrl" href="javascript:void(0)"
                            class="hub-action-add-link" *ngIf="section.action && !section.isDropdownAction"
                            (click)="onAddSectionClick(section)">
                            {{ section.action }}
                        </a>

                        <a [attr.guide]="'lead-detail-lnk-73' + '__' + sanitizedUrl" href="javascript:void(0)"
                            class="hub-action-add-dropdown" *ngIf="section.action && section.isDropdownAction"
                            [matMenuTriggerFor]="attachMenu">
                            {{ section.action }} <mat-icon>arrow_drop_down</mat-icon>
                        </a>
                        <mat-menu #attachMenu="matMenu">
                            <button mat-menu-item (click)="createFile(null, 0)">Upload Attachment</button>
                        </mat-menu>
                    </div>
                </div>

                <div class="hub-assoc-content" *ngIf="section.isOpen">
                    <div *ngIf="section.hasCompanyInfo">
                        <div *ngIf="associatedCompany?.name || LeadDetailsObject?.company || LeadDetailsObject?.Company; else noCompanyBox"
                            class="hub-company-box">
                            <div class="hub-primary-badge">Primary</div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div style="width: 100%;">
                                    <div class="hub-comp-name" (click)="goToCompany()"
                                        style="cursor: pointer; font-weight: 600; color: #0073ea;"
                                        [matTooltip]="'View Company Details'">
                                        {{ associatedCompany?.name || LeadDetailsObject?.company ||
                                        LeadDetailsObject?.Company }}
                                    </div>
                                    <div class="hub-comp-url"
                                        *ngIf="associatedCompany?.website || LeadDetailsObject?.website">
                                        <span>{{ associatedCompany?.website || LeadDetailsObject?.website }}</span>
                                        <a [href]="getSafeUrl(associatedCompany?.website || LeadDetailsObject?.website)"
                                            target="_blank"
                                            style="color: inherit; text-decoration: none; display: inline-flex; align-items: center;">
                                            <mat-icon class="sm-icon">open_in_new</mat-icon>
                                        </a>
                                        <mat-icon class="sm-icon"
                                            (click)="copyText(associatedCompany?.website || LeadDetailsObject?.website)"
                                            style="cursor: pointer;" matTooltip="Copy">content_copy</mat-icon>
                                    </div>
                                    <div class="hub-comp-phone"
                                        *ngIf="associatedCompany?.phoneNumber || LeadDetailsObject?.phoneNumber">
                                        Phone: {{ associatedCompany?.phoneNumber || LeadDetailsObject?.phoneNumber }}
                                    </div>
                                    <div class="hub-comp-meta" *ngIf="associatedCompany?.industryType"
                                        style="font-size: 12px; color: #64748b; margin-top: 4px;">
                                        Industry: {{ associatedCompany?.industryType }}
                                    </div>
                                    <div class="hub-comp-meta" *ngIf="associatedCompany?.openDealAmount"
                                        style="font-size: 12px; color: #64748b; margin-top: 2px;">
                                        Open Deals: ₹ {{ associatedCompany?.openDealAmount }}
                                    </div>
                                    <div class="hub-comp-meta" *ngIf="associatedCompany?.ownerEmail"
                                        style="font-size: 12px; color: #64748b; margin-top: 2px;">
                                        Sales Owner: {{ associatedCompany?.ownerEmail }}
                                    </div>
                                    <div class="hub-comp-meta" *ngIf="associatedCompany?.noOfemployees"
                                        style="font-size: 12px; color: #64748b; margin-top: 2px;">
                                        Employees: {{ associatedCompany?.noOfemployees }}
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between mt-2">
                                <a href="javascript:void(0)" (click)="goToCompany()"
                                    class="hub-comp-view-link d-inline-block">View associated Company</a>
                                <button type="button" mat-button
                                    style="font-size: 12px; min-height: 24px; line-height: 24px; padding: 0 6px; color: #64748b;"
                                    (click)="openEditPopup('company', 'Company', 'text')">Change</button>
                            </div>
                        </div>
                        <ng-template #noCompanyBox>
                            <p class="hub-assoc-desc">No company associated with this record.</p>
                            <div style="display: flex; gap: 8px; flex-wrap: wrap;">
                                <button mat-stroked-button class="hub-assoc-btn mt-2"
                                    (click)="openEditPopup('company', 'Company', 'text')">
                                    + Associate Company
                                </button>
                                <button mat-stroked-button class="hub-assoc-btn mt-2"
                                    (click)="onAddSectionClick(section)">
                                    + Create Company
                                </button>
                            </div>
                        </ng-template>
                    </div>

                    <p class="hub-assoc-desc" *ngIf="!section.hasCompanyInfo">{{ section.content }}</p>

                    <button [attr.guide]="'lead-detail-btn-75' + '__' + sanitizedUrl" mat-stroked-button
                        class="hub-assoc-btn mt-2" *ngIf="section.hasButton">
                        {{ section.buttonText }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- lead-detail.component.html -->
<div *ngIf="leadDetailPageType === 2" class="zhType-container">

    <div class="header-container">
        <button [attr.guide]="'lead-detail-btn-76' + '__' + sanitizedUrl" (click)="back()" mat-icon-button
            class="back-button">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <div class="profile-section">
            <div class="avatar">CM</div>
            <div class="profile-info">
                <div class="name"> {{ (LeadDetailsObject?.name?.indexOf(' ') === -1 && LeadDetailsObject?.name?.length >
                    20) ? (LeadDetailsObject?.name | slice:0:20) + '...' : LeadDetailsObject?.name }}</div>
                <!-- <div class="region">- Ragoni of France</div> -->
            </div>
        </div>

        <div class="action-buttons">
            <button [attr.guide]="'lead-detail-btn-77' + '__' + sanitizedUrl" (click)="openEmailPopup()"
                mat-stroked-button>
                <mat-icon>send</mat-icon> Email Status
            </button>
            <button [attr.guide]="'lead-detail-btn-78' + '__' + sanitizedUrl" (click)="openSendSmsPopup()"
                mat-stroked-button>
                <mat-icon>send</mat-icon> Send Sms
            </button>

            <button [attr.guide]="'lead-detail-btn-79' + '__' + sanitizedUrl" mat-stroked-button>
                <mat-icon>swap_horiz</mat-icon> Convert
            </button>
            <button [attr.guide]="'lead-detail-btn-80' + '__' + sanitizedUrl" (click)="openEditPopup1()"
                mat-stroked-button>
                <mat-icon>edit</mat-icon> Edit
            </button>
            <button [attr.guide]="'lead-detail-btn-81' + '__' + sanitizedUrl" mat-stroked-button
                [matMenuTriggerFor]="menu">
                <mat-icon>assignment</mat-icon>
                <span>Task</span>
            </button>

            <mat-menu #menu="matMenu">
                <button [attr.guide]="'lead-detail-btn-82' + '__' + sanitizedUrl" *ngIf="crmType!=2" mat-menu-item
                    (click)="addLeadActivity('Follow Up',0,null)">Follow Up
                </button>
                <button [attr.guide]="'lead-detail-btn-83' + '__' + sanitizedUrl" mat-menu-item
                    (click)="addLeadActivity('Phone Call',0,null)">Phone Call</button>
                <button [attr.guide]="'lead-detail-btn-84' + '__' + sanitizedUrl" *ngIf="enableLocation == '1'"
                    mat-menu-item (click)="addLeadActivityone('Location',0,null)">Location</button>
            </mat-menu>
            <button [attr.guide]="'lead-detail-btn-85' + '__' + sanitizedUrl" mat-stroked-button
                [matMenuTriggerFor]="action">
                <mat-icon>edit</mat-icon>
                <span>Lead Actions</span>
            </button>
            <mat-menu #action="matMenu">
                <button [attr.guide]="'lead-detail-btn-86' + '__' + sanitizedUrl" (click)="transferLead()"
                    mat-menu-item>Change Owner</button>
            </mat-menu>

            <button [attr.guide]="'lead-detail-btn-87' + '__' + sanitizedUrl" mat-stroked-button
                (click)="navigateToInvoice(LeadDetailsObject)">
                <mat-icon>library_books</mat-icon>
                <span>Invoice</span>
            </button>
        </div>
    </div>


    <div class="content-container">

        <div class="vertical-tabs">
            <mat-nav-list>
                <mat-list-item *ngFor="let tab of leadTabs" [class.active]="selectedTab === tab.name"
                    (click)="selectTab(tab.name)">
                    <!-- <mat-icon matListIcon>{{tab.icon}}</mat-icon> -->
                    <span matLine>{{tab.label}}</span>
                </mat-list-item>
            </mat-nav-list>
        </div>
        <div class="content-panel">
            <ng-container [ngSwitch]="selectedTab">
                <div *ngSwitchCase="'activity'" class="tab-content">
                    <ng-container *ngIf="init && activityHistoryType == 1">
                        <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                            [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                            [totalSize]="totalSize" [leadid]="leadId" fxFlex [leadActivityList]="leadActivityList">
                        </calsoft-activity>
                    </ng-container>

                    <ng-container *ngIf="activityHistoryType == 0">
                        <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                            [groupedActivities]="groupedActivities"
                            (scrollChange)="onScrollNew()"></calsoft-activity-new>
                    </ng-container>

                </div>
                <div *ngSwitchCase="'leadDetail'" class="tab-content">
                    <table
                        *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                        <tr>
                            <th colspan="2">
                                {{leadCommonPropertiesName}}
                            </th>
                        </tr>
                        <ng-container *ngIf="!type3">

                            <tr *ngFor="let item of usedInSite | keyvalue">
                                <td>
                                    {{item.key}}
                                </td>
                                <td>
                                    <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                        class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                    <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                    <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                    <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.category"> </p>
                                    <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.product"> </p>
                                </td>
                            </tr>

                        </ng-container>
                        <ng-container *ngIf="type3">

                            <tr *ngFor="let item of customList ">


                                <td>
                                    {{item[0]}}
                                </td>
                                <td>
                                    <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                        class="blackColor wordBreak" [innerHTML]="item[1]">
                                    </p>


                                    <p *ngIf="item[0]=='Lead Status'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                    <p *ngIf="item[0]=='Lead Source'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                    <p *ngIf="item[0]=='Category'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.category"> </p>
                                    <p *ngIf="item[0]=='Product'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.product"> </p>

                                </td>
                            </tr>

                        </ng-container>
                    </table>

                    <table *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                        <tr>
                            <th colspan="2">
                                {{leadPropertiesName}}
                            </th>
                        </tr>


                        <ng-container *ngIf="!type2">

                            <tr *ngFor="let item of valuesList | keyvalue">
                                <td>
                                    {{item.key}}
                                </td>
                                <td>

                                    <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source'"
                                        class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                    <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                    <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                </td>

                            </tr>

                        </ng-container>
                        <ng-container *ngIf="type2">

                            <tr *ngFor="let item of filterList | keyvalue">


                                <td>
                                    {{item.key}}
                                </td>
                                <td>
                                    <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                        class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                    <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                    <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                    <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.category"> </p>
                                    <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.product"> </p>
                                </td>
                            </tr>

                        </ng-container>

                    </table>

                    <table
                        *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                        <tr>
                            <th colspan="2">
                                {{leadAdditionalPropertiesName}}
                            </th>
                        </tr>


                        <ng-container *ngIf="!type1">

                            <tr *ngFor="let item of additionalSpec | keyvalue">
                                <td>
                                    {{item.key}}
                                </td>
                                <td>
                                    <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                        class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                    <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                    <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                    <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.category"> </p>
                                    <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.product"> </p>
                                </td>
                            </tr>

                        </ng-container>
                        <ng-container *ngIf="type1">

                            <tr *ngFor="let item of additionalSpecList ">


                                <td>
                                    {{item[0]}}
                                </td>
                                <td>
                                    <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                        class="blackColor wordBreak" [innerHTML]="item[1]">
                                    </p>

                                    <p *ngIf="item[0]=='Lead Status'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                    <p *ngIf="item[0]=='Lead Source'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                    <p *ngIf="item[0]=='Category'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.category"> </p>
                                    <p *ngIf="item[0]=='Product'" class="blackColor wordBreak"
                                        [innerHTML]="LeadDetailsObject?.product"> </p>

                                </td>
                            </tr>

                        </ng-container>


                    </table>
                </div>
                <div *ngSwitchCase="'tasks'" class="tab-content">
                    <table>
                        <tr>
                            <th>Type</th>
                            <th>Date</th>
                            <th>Notes</th>
                            <th>Action</th>
                        </tr>
                        <tr *ngFor="let lead of leadActivityList;">
                            <td>{{lead.activityType}}</td>
                            <td>{{lead.createdDate | calsoftDate}}</td>
                            <td>{{lead.notes}}</td>
                            <td>
                                <button [attr.guide]="'lead-detail-btn-88' + '__' + sanitizedUrl" mat-icon-button
                                    [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button [attr.guide]="'lead-detail-btn-89' + '__' + sanitizedUrl"
                                        (click)="addLeadActivity('Edit', 0, lead)" mat-menu-item>
                                        <mat-icon>edit</mat-icon>
                                        Edit
                                    </button>
                                    <button [attr.guide]="'lead-detail-btn-90' + '__' + sanitizedUrl"
                                        (click)="deleteLeadDialog(lead.id)" mat-menu-item>
                                        <mat-icon>delete</mat-icon>
                                        Delete
                                    </button>

                                </mat-menu>
                            </td>

                        </tr>

                    </table>
                </div>
                <div *ngSwitchCase="'email'" class="tab-content">
                    <div class="mailbox-container">

                        <div class="mailbox-toggle-container">
                            <mat-button-toggle-group [(value)]="currentMailBox" (change)="loadEmails($event)">
                                <mat-button-toggle value="INBOX">Inbox</mat-button-toggle>
                                <mat-button-toggle value="Sent">Sent</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>


                        <div class="mailbox-content" *ngIf="!isLoading; else loading">

                            <div class="mailbox-email-list" [class.full-width]="!selectedEmail">
                                <mat-paginator [length]="totalEmails" [pageSize]="pageSizeEmail" [pageIndex]="pageIndex"
                                    (page)="onPageChange($event)">
                                </mat-paginator>

                                <mat-nav-list>
                                    <mat-list-item *ngFor="let email of emails; let i = index"
                                        [ngClass]="{'mailbox-email-list-item': true, 'active': i === selectedIndex}"
                                        (click)="selectEmail(i)">
                                        <div class="mailbox-email-list-item">
                                            <div class="mailbox-email-header">
                                                <span class="mailbox-email-subject">{{ email.subject }}</span>
                                                <span class="mailbox-email-date">{{ email.sentDate | date:'medium'
                                                    }}</span>
                                            </div>
                                            <div class="mailbox-email-preview">
                                                <span class="mailbox-email-from-to">
                                                    {{ currentMailBox === 'INBOX' ? extractEmailAddress(email.from)
                                                    : email.to }}
                                                </span>
                                                <span class="mailbox-email-body-preview">
                                                    {{ truncateSafeHTML(email.body, 150) }}
                                                </span>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                </mat-nav-list>
                            </div>


                            <div class="mailbox-email-detail" *ngIf="selectedEmail; else placeholder">
                                <div class="mailbox-email-detail-header">
                                    <h2>{{ selectedEmail.subject }}</h2>
                                    <div class="mailbox-email-meta">
                                        <div><strong>From:</strong> {{
                                            extractEmailAddress(selectedEmail.from) }}
                                        </div>
                                        <div><strong>To:</strong> {{ selectedEmail.to }}</div>
                                        <div><strong>Date:</strong> {{ selectedEmail.sentDate | date:
                                            'medium' }}
                                        </div>
                                    </div>
                                </div>
                                <div class="mailbox-email-body" [innerHTML]="linkifyAndSanitize(selectedEmail.body)">
                                </div>



                                <div class="mailbox-email-attachments" *ngIf="selectedEmail?.attachments?.length > 0">
                                    <h4>Attachments</h4>
                                    <ul>
                                        <li *ngFor="let file of selectedEmail.attachments">
                                            <div *ngIf="isImage(file.contentType)">
                                                <calsoft-common-images [src]="serverPathEmail + file.fileName"
                                                    [height]="'50px'" [width]="'auto'" [alt]="">

                                                </calsoft-common-images>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                            </div>

                            <ng-template #placeholder>
                                <div class="mailbox-placeholder">
                                    <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                    <h3>Select an email to read</h3>
                                    <p>Choose a message from your {{ currentMailBox }} to view it here</p>
                                </div>
                            </ng-template>
                        </div>

                        <ng-template #loading>
                            <div class="mailbox-loading-overlay">
                                <mat-spinner diameter="40"></mat-spinner>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div *ngSwitchCase="'chats'" class="tab-content">
                    <div *ngIf="leadLoaded && whatAppchatType === 1">
                        <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                            [isFromPhone]="true">
                        </calsoft-whatsapp-chat-details>
                    </div>
                    <div *ngIf="leadLoaded && whatAppchatType === 2">
                        <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                        </calsoft-whats-app-new-client>
                    </div>
                </div>
                <ng-container *ngIf="leadNoteDisplay==1">
                    <div *ngSwitchCase="'notes'" class="tab-content">
                        <div class="padding-10">

                            <div class="editSets">
                                <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                    <span>Notes</span>
                                    <button [attr.guide]="'lead-detail-btn-91' + '__' + sanitizedUrl"
                                        *ngIf="noteList.length>0" mat-icon-button>
                                        <mat-icon (click)="createNote(null,0)">
                                            add
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>




                            <div *ngIf="noteList.length==0" class="padding-10" style="background-color: gray;"
                                fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon> insert_drive_file</mat-icon>

                                <div style="color: white; background: none;" class="title padding-10">
                                    Add notes to your lead!
                                </div>

                                <div class="create Note">
                                    <button [attr.guide]="'lead-detail-btn-92' + '__' + sanitizedUrl" mat-flat-button
                                        color="primary" (click)="createNote(null,0)">
                                        <span class="medium-x">Create Note</span>
                                    </button>
                                </div>
                            </div>

                            <div>


                                <div id="responsieTable">


                                    <table class="rwd-table" *ngIf="noteList.length>0">

                                        <tr>

                                            <th>Notes</th>

                                            <th>Created Date</th>
                                            <th>Updated Date</th>
                                            <th>Created by</th>
                                            <th>Updated by</th>
                                            <th>Action</th>
                                        </tr>
                                        <ng-container *ngFor="let note of noteList">
                                            <tr *ngIf="note.documentType==0">
                                                <td data-th="Notes" [innerHTML]="note.notes | mentionHighlight"></td>
                                                <td data-th="Created Date">{{note.createdDate | calsoftDate}}</td>
                                                <td data-th="Updated Date">{{note.updatedDate | calsoftDate}}</td>
                                                <td data-th="Created by">{{note.createdBy == null ?
                                                    LeadDetailsObject?.ownerEmail : note.createdBy}}</td>
                                                <td data-th="Updated by">{{note.updatedBy == null ?
                                                    LeadDetailsObject?.ownerEmail : note.updatedBy}}</td>
                                                <td data-th="Action">
                                                    <button [attr.guide]="'lead-detail-btn-93' + '__' + sanitizedUrl"
                                                        mat-icon-button [matMenuTriggerFor]="menu93">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                    <mat-menu #menu93="matMenu">
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-94' + '__' + sanitizedUrl"
                                                            (click)="createNote(note, note.noteId)" mat-menu-item>
                                                            <mat-icon>edit</mat-icon>
                                                            Edit
                                                        </button>
                                                        <button mat-menu-item *ngIf="note.noteType !== 'REPLY'"
                                                            (click)="toggleReply(note.noteId)">
                                                            <mat-icon>reply</mat-icon>
                                                            Reply
                                                        </button>
                                                    </mat-menu>
                                                </td>
                                            </tr>
                                            <!-- Inline reply box -->
                                            <tr *ngIf="note.documentType==0 && replyingToNoteId === note.noteId">
                                                <td colspan="6">
                                                    <div
                                                        style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;">
                                                        <mat-icon
                                                            style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                                        <mat-form-field appearance="outline" style="flex:1">
                                                            <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                            <textarea matInput rows="2" [(ngModel)]="replyText"
                                                                placeholder="Write a reply..."></textarea>
                                                        </mat-form-field>
                                                        <button mat-raised-button color="primary" style="margin-top:6px"
                                                            [disabled]="!replyText?.trim()"
                                                            (click)="submitReply(note)">Send</button>
                                                        <button mat-icon-button style="margin-top:4px"
                                                            (click)="toggleReply(null)">
                                                            <mat-icon>close</mat-icon>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>


                                    </table>

                                </div>

                            </div>




                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="jsonRecieved!=null">
                    <div *ngSwitchCase="'originalLead'" class="tab-content">
                        <table id="details">
                            <tr *ngFor="let item of jsonRecieved | keyvalue">
                                <td>
                                    {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key }}
                                </td>
                                <td>
                                    <p class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </ng-container>
                <div *ngSwitchCase="'documents'" class="tab-content">
                    <div class="padding-10">

                        <div class="editSets1">
                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                <span>Documents</span>

                                <button [attr.guide]="'lead-detail-btn-95' + '__' + sanitizedUrl" mat-icon-button>
                                    <mat-icon (click)="createDocument(null,0)">
                                        add
                                    </mat-icon>
                                </button>
                            </div>
                        </div>

                        <div *ngFor="let note of noteList;">
                            <div fxLayout="column" *ngIf="note.notesDocument?.length>0">
                                <div fxLayout="row" class="padding-10" fxLayoutAlign="start center">
                                    <span [innerHTML]="note.notes | mentionHighlight"></span>


                                    <div class="padding-10" *ngIf="note.documentType==2">
                                        <calsoft-audios [value]="serverPath + note.notesDocument">
                                        </calsoft-audios>
                                    </div>

                                    <div class="padding-10" *ngIf="note.documentType==1">
                                        <calsoft-videos [value]="serverPathVedio + note.notesDocument">
                                        </calsoft-videos>
                                    </div>

                                    <div class="padding-10" *ngIf="note.documentType==3">
                                        <div fxLayout="column">

                                            <div fxLayout="row">
                                                <span fxLayoutAlign="start center">
                                                    Pdf : {{note.notesDocument}}
                                                </span>

                                                <button [attr.guide]="'lead-detail-btn-96' + '__' + sanitizedUrl"
                                                    (click)="download(note.notesDocument)" color="warn" mat-icon-button
                                                    type="button">
                                                    <mat-icon>download

                                                    </mat-icon>

                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="padding-10" *ngIf="note.documentType==4">
                                        <div fxLayout="column">
                                            <div fxLayout="row">

                                                <calsoft-common-images [src]="serverPathImage + note.notesDocument"
                                                    [height]="'50%'" [width]="'50%'" [alt]="">

                                                </calsoft-common-images>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div *ngSwitchCase="'payment'" class="tab-content">
                    <div class="padding-10">

                        <div class="editSets1">
                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                <span>Payment</span>

                                <button [attr.guide]="'lead-detail-btn-97' + '__' + sanitizedUrl" mat-icon-button>
                                    <mat-icon (click)="createPayment(null,0)">
                                        add
                                    </mat-icon>
                                </button>
                            </div>
                        </div>

                        <table *ngIf="noteList.length>0">

                            <tr>

                                <th>Notes</th>

                                <th>Created Date</th>
                                <th>Updated Date</th>
                                <th>Action</th>
                            </tr>
                            <ng-container *ngFor="let note of noteList">
                                <tr *ngIf="note.documentType==5">
                                    <td [innerHTML]="note.notes | mentionHighlight"></td>
                                    <td>{{note.createdDate | calsoftDate}}</td>
                                    <td>{{note.updatedDate | calsoftDate}}</td>
                                    <td>
                                        <button [attr.guide]="'lead-detail-btn-98' + '__' + sanitizedUrl"
                                            mat-icon-button [matMenuTriggerFor]="menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-99' + '__' + sanitizedUrl"
                                                (click)="createNote(note, note.noteId)" mat-menu-item>
                                                <mat-icon>edit</mat-icon>
                                                Edit
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            </ng-container>


                        </table>

                    </div>
                </div>
                <div *ngSwitchCase="'calendar'" class="tab-content">
                    <calsoft-leadsmeeting [meetingType]="1" [googleCalendarList]="googleCalendarList" [leadId]="leadId"
                        [type]="2"></calsoft-leadsmeeting>
                </div>
                <div *ngSwitchCase="'deals'" class="tab-content">
                    <calsoft-deals [enableSmartView]="false" [leadId]="leadId" [type]="2"></calsoft-deals>
                </div>
                <div *ngSwitchCase="'calls'" class="tab-content">
                    <div class="call-section-bg">
                        <div class="tab-pane fade" id="calls">
                            <div class="card">
                                <div
                                    class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                    <h4 class="fw-semibold">Calls</h4>

                                    <!-- <button [attr.guide]="'lead-detail-btn-100' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                    <mat-menu #menu="matMenu">
                                        <button [attr.guide]="'lead-detail-btn-101' + '__' + sanitizedUrl"
                                            *ngIf="crmType!=2" mat-menu-item
                                            (click)="addLeadActivityone('Follow Up',0,null)">Follow Up
                                        </button>
                                        <button [attr.guide]="'lead-detail-btn-102' + '__' + sanitizedUrl" mat-menu-item
                                            (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                            Call</button>
                                        <button [attr.guide]="'lead-detail-btn-103' + '__' + sanitizedUrl"
                                            *ngIf="enableLocation == '1'" mat-menu-item
                                            (click)="addLeadActivityone('Location',0,null)">Location</button>
                                    </mat-menu>
                                </div>
                                <div class="card-body">
                                    <div class="card mb-3" *ngFor="let lead of calllist;">

                                        <div class="card-body">
                                            <div class="d-sm-flex align-items-center justify-content-between pb-2">
                                                <div class="d-flex align-items-center mb-2" style="display: flex;">
                                                    <span class="avatar-md me-2 flex-shrink-0">
                                                        <mat-icon class="default-icon">person</mat-icon>
                                                    </span>
                                                    <p><span class="text-dark fw-medium">{{lead.customerName}}</span>
                                                        logged a call on {{lead.updatedDate}}</p>
                                                </div>
                                                <div class="d-inline-flex align-items-center mb-2">
                                                    <div class="dropdown me-2">
                                                        <a href="javascript:void(0);" class="py-1" [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {{lead.phoneCallOutcome | titlecase}}
                                                            <i class="ti ti-chevron-down ms-2"></i>
                                                        </a>


                                                    </div>
                                                    <div class="dropdown">
                                                        <a href="javascript:void(0);"
                                                            class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                            data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                class="ti ti-dots-vertical"></i></a>
                                                        <div class="dropdown-menu dropdown-menu-right">
                                                            <a class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span [innerHTML]="lead.notes"> </span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>




            </ng-container>
        </div>
    </div>
</div>

<div *ngIf="leadDetailPageType === 3" style="width: 100%;" fxLayout="column" fxLayout.gt-sm="row"
    class="Detail-type-four">
    <div class="container-element" fxFlex fxLayout="column" fxLayoutGap="16px">
        <!-- Top Section -->
        <mat-tab-group style="border: 1px solid lightgray;" class="btntask1">
            <mat-tab [attr.guide]="'lead-detail-tab-104' + '__' + sanitizedUrl" *ngFor="let tab of leadTabs"
                [label]="tab.label">
                <ng-container [ngSwitch]="tab.name">
                    <div *ngSwitchCase="'activity'">
                        <ng-container *ngIf="init && activityHistoryType == 1">
                            <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                                [totalSize]="totalSize" [leadid]="leadId" fxFlex [leadActivityList]="leadActivityList">
                            </calsoft-activity>
                        </ng-container>

                        <ng-container *ngIf="activityHistoryType == 0">
                            <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                                [groupedActivities]="groupedActivities"
                                (scrollChange)="onScrollNew()"></calsoft-activity-new>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="usedInSite || filterList || additionalSpec">
                        <div *ngSwitchCase="'leadDetail'">
                            <table
                                *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                                <tr>
                                    <th colspan="2">
                                        {{leadCommonPropertiesName}}
                                    </th>
                                </tr>
                                <ng-container *ngIf="!type3">

                                    <tr *ngFor="let item of usedInSite | keyvalue">
                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                                <ng-container *ngIf="type3">

                                    <tr *ngFor="let item of customList ">


                                        <td>
                                            {{item[0]}}
                                        </td>
                                        <td>
                                            <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item[1]">
                                            </p>

                                            <p *ngIf="item[0]=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item[0]=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item[0]=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item[0]=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                            </table>

                            <table
                                *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                                <tr>
                                    <th colspan="2">
                                        {{leadPropertiesName}}
                                    </th>
                                </tr>


                                <ng-container *ngIf="!type2">

                                    <tr *ngFor="let item of valuesList | keyvalue">
                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                                <ng-container *ngIf="type2">

                                    <tr *ngFor="let item of filterList | keyvalue">


                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>

                            </table>

                            <table
                                *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                                <tr>
                                    <th colspan="2">
                                        {{leadAdditionalPropertiesName}}
                                    </th>
                                </tr>


                                <ng-container *ngIf="!type1">

                                    <tr *ngFor="let item of additionalSpec | keyvalue">
                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                                <ng-container *ngIf="type1">

                                    <tr *ngFor="let item of additionalSpecList ">


                                        <td>
                                            {{item[0]}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>


                            </table>
                        </div>
                    </ng-container>
                    <div *ngSwitchCase="'tasks'">
                        <table>
                            <tr>
                                <th>Type</th>
                                <th>Date</th>
                                <th>Notes</th>
                                <th>Action</th>
                            </tr>
                            <tr *ngFor="let lead of leadActivityList;">
                                <td>{{lead.activityType}}</td>
                                <td>{{lead.createdDate | calsoftDate}}</td>
                                <td>{{lead.notes}}</td>
                                <td>
                                    <button [attr.guide]="'lead-detail-btn-105' + '__' + sanitizedUrl" mat-icon-button
                                        [matMenuTriggerFor]="menu">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button [attr.guide]="'lead-detail-btn-106' + '__' + sanitizedUrl"
                                            (click)="addLeadActivity('Edit', 0, lead)" mat-menu-item>
                                            <mat-icon>edit</mat-icon>
                                            Edit
                                        </button>
                                        <button [attr.guide]="'lead-detail-btn-107' + '__' + sanitizedUrl"
                                            (click)="deleteLeadDialog(lead.id)" mat-menu-item>
                                            <mat-icon>delete</mat-icon>
                                            Delete
                                        </button>

                                    </mat-menu>
                                </td>

                            </tr>

                        </table>
                    </div>


                    <div *ngSwitchCase="'email'">
                        <div class="mailbox-container">

                            <div class="mailbox-toggle-container">
                                <mat-button-toggle-group [(value)]="currentMailBox" (change)="loadEmails($event)">
                                    <mat-button-toggle value="INBOX">Inbox</mat-button-toggle>
                                    <mat-button-toggle value="Sent">Sent</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>


                            <div class="mailbox-content" *ngIf="!isLoading; else loading">

                                <div class="mailbox-email-list" [class.full-width]="!selectedEmail">
                                    <mat-paginator [length]="totalEmails" [pageSize]="pageSizeEmail"
                                        [pageIndex]="pageIndex" (page)="onPageChange($event)">
                                    </mat-paginator>

                                    <mat-nav-list>
                                        <mat-list-item *ngFor="let email of emails; let i = index"
                                            [ngClass]="{'mailbox-email-list-item': true, 'active': i === selectedIndex}"
                                            (click)="selectEmail(i)">
                                            <div class="mailbox-email-list-item">
                                                <div class="mailbox-email-header">
                                                    <span class="mailbox-email-subject">{{ email.subject }}</span>
                                                    <span class="mailbox-email-date">{{ email.sentDate | date:'medium'
                                                        }}</span>
                                                </div>
                                                <div class="mailbox-email-preview">
                                                    <span class="mailbox-email-from-to">
                                                        {{ currentMailBox === 'INBOX' ? extractEmailAddress(email.from)
                                                        : email.to }}
                                                    </span>
                                                    <span class="mailbox-email-body-preview"
                                                        [innerHTML]="linkifyAndSanitize(truncateText(email.body, 150))"></span>
                                                </div>
                                            </div>
                                        </mat-list-item>
                                    </mat-nav-list>
                                </div>


                                <div class="mailbox-email-detail" *ngIf="selectedEmail; else placeholder">
                                    <div class="mailbox-email-detail-header">
                                        <h2>{{ selectedEmail.subject }}</h2>
                                        <div class="mailbox-email-meta">
                                            <div><strong>From:</strong> {{
                                                extractEmailAddress(selectedEmail.from) }}
                                            </div>
                                            <div><strong>To:</strong> {{ selectedEmail.to }}</div>
                                            <div><strong>Date:</strong> {{ selectedEmail.sentDate | date:
                                                'medium' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mailbox-email-body"
                                        [innerHTML]="linkifyAndSanitize(selectedEmail.body)"></div>
                                </div>

                                <ng-template #placeholder>
                                    <div class="mailbox-placeholder">
                                        <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                        <h3>Select an email to read</h3>
                                        <p>Choose a message from your {{ currentMailBox }} to view it here</p>
                                    </div>
                                </ng-template>
                            </div>

                            <ng-template #loading>
                                <div class="mailbox-loading-overlay">
                                    <mat-spinner diameter="40"></mat-spinner>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div *ngSwitchCase="'chats'">
                        <div *ngIf="leadLoaded && whatAppchatType === 1">
                            <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                [isFromPhone]="true">
                            </calsoft-whatsapp-chat-details>
                        </div>
                        <div *ngIf="leadLoaded && whatAppchatType === 2">
                            <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                            </calsoft-whats-app-new-client>
                        </div>
                    </div>
                    <ng-container *ngIf="leadNoteDisplay==1">
                        <div *ngSwitchCase="'notes'">
                            <div class="padding-10">

                                <div class="editSets">
                                    <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                        <span>Notes</span>
                                        <button [attr.guide]="'lead-detail-btn-108' + '__' + sanitizedUrl"
                                            *ngIf="noteList.length>0" mat-icon-button>
                                            <mat-icon (click)="createNote(null,0)">
                                                add
                                            </mat-icon>
                                        </button>
                                    </div>
                                </div>




                                <div *ngIf="noteList.length==0" class="padding-10" style="background-color: gray;"
                                    fxLayout="column" fxLayoutAlign="center center">
                                    <mat-icon> insert_drive_file</mat-icon>

                                    <div style="color: white; background: none;" class="title padding-10">
                                        Add notes to your lead!
                                    </div>

                                    <div class="create Note">
                                        <button [attr.guide]="'lead-detail-btn-109' + '__' + sanitizedUrl"
                                            mat-flat-button color="primary" (click)="createNote(null,0)">
                                            <span class="medium-x">Create Note</span>
                                        </button>
                                    </div>
                                </div>

                                <div>


                                    <div id="responsieTable">


                                        <table class="rwd-table" *ngIf="noteList.length>0">

                                            <tr>

                                                <th>Notes</th>

                                                <th>Created Date</th>
                                                <th>Updated Date</th>
                                                <th>Created by</th>
                                                <th>Updated by</th>
                                                <th>Action</th>
                                            </tr>
                                            <ng-container *ngFor="let note of noteList">
                                                <tr *ngIf="note.documentType==0">
                                                    <td data-th="Notes" [innerHTML]="note.notes | mentionHighlight">
                                                    </td>
                                                    <td data-th="Created Date">{{note.createdDate | calsoftDate}}</td>
                                                    <td data-th="Updated Date">{{note.updatedDate | calsoftDate}}</td>
                                                    <td data-th="Created by">{{note.createdBy == null ?
                                                        LeadDetailsObject?.ownerEmail : note.createdBy}}</td>
                                                    <td data-th="Updated by">{{note.updatedBy == null ?
                                                        LeadDetailsObject?.ownerEmail : note.updatedBy}}</td>
                                                    <td data-th="Action">
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-110' + '__' + sanitizedUrl"
                                                            mat-icon-button [matMenuTriggerFor]="menu110">
                                                            <mat-icon>more_vert</mat-icon>
                                                        </button>
                                                        <mat-menu #menu110="matMenu">
                                                            <button
                                                                [attr.guide]="'lead-detail-btn-111' + '__' + sanitizedUrl"
                                                                (click)="createNote(note, note.noteId)" mat-menu-item>
                                                                <mat-icon>edit</mat-icon>
                                                                Edit
                                                            </button>
                                                            <button mat-menu-item *ngIf="note.noteType !== 'REPLY'"
                                                                (click)="toggleReply(note.noteId)">
                                                                <mat-icon>reply</mat-icon>
                                                                Reply
                                                            </button>
                                                        </mat-menu>
                                                    </td>
                                                </tr>
                                                <!-- Inline reply box -->
                                                <tr *ngIf="note.documentType==0 && replyingToNoteId === note.noteId">
                                                    <td colspan="6">
                                                        <div
                                                            style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;">
                                                            <mat-icon
                                                                style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                                            <mat-form-field appearance="outline" style="flex:1">
                                                                <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                                <textarea matInput rows="2" [(ngModel)]="replyText"
                                                                    placeholder="Write a reply..."></textarea>
                                                            </mat-form-field>
                                                            <button mat-raised-button color="primary"
                                                                style="margin-top:6px" [disabled]="!replyText?.trim()"
                                                                (click)="submitReply(note)">Send</button>
                                                            <button mat-icon-button style="margin-top:4px"
                                                                (click)="toggleReply(null)">
                                                                <mat-icon>close</mat-icon>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>


                                        </table>

                                    </div>

                                </div>




                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="jsonRecieved!=null">
                        <div *ngSwitchCase="'originalLead'">
                            <table id="details">
                                <tr *ngFor="let item of jsonRecieved | keyvalue">
                                    <td>
                                        {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key }}
                                    </td>
                                    <td>
                                        <p class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </ng-container>
                    <div *ngSwitchCase="'documents'">
                        <div class="padding-10">

                            <div class="editSets1">
                                <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                    <span>Files</span>

                                    <button [attr.guide]="'lead-detail-btn-112' + '__' + sanitizedUrl" mat-icon-button>
                                        <mat-icon (click)="createDocument(null,0)">
                                            add
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div *ngFor="let note of noteList;">
                                <div fxLayout="column" *ngIf="note.notesDocument?.length>0">
                                    <div fxLayout="row" class="padding-10" fxLayoutAlign="start center">
                                        <span [innerHTML]="note.notes | mentionHighlight"></span>


                                        <div class="padding-10" *ngIf="note.documentType==2">
                                            <calsoft-audios [value]="serverPath + note.notesDocument">
                                            </calsoft-audios>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==1">
                                            <calsoft-videos [value]="serverPathVedio + note.notesDocument">
                                            </calsoft-videos>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==3">
                                            <div fxLayout="column">

                                                <div fxLayout="row">
                                                    <span fxLayoutAlign="start center">
                                                        Pdf : {{note.notesDocument}}
                                                    </span>

                                                    <button [attr.guide]="'lead-detail-btn-113' + '__' + sanitizedUrl"
                                                        (click)="download(note.notesDocument)" color="warn"
                                                        mat-icon-button type="button">
                                                        <mat-icon>download

                                                        </mat-icon>

                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==4">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <calsoft-common-images [src]="serverPathImage + note.notesDocument"
                                                        [height]="'50%'" [width]="'50%'" [alt]="">

                                                    </calsoft-common-images>

                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                    <div *ngSwitchCase="'payment'">
                        <div class="padding-10">

                            <div class="editSets1">
                                <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                    <span>Payment</span>

                                    <button [attr.guide]="'lead-detail-btn-114' + '__' + sanitizedUrl" mat-icon-button>
                                        <mat-icon (click)="createPayment(null,0)">
                                            add
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>

                            <table *ngIf="noteList.length>0">

                                <tr>

                                    <th>Notes</th>

                                    <th>Created Date</th>
                                    <th>Updated Date</th>
                                    <th>Action</th>
                                </tr>
                                <ng-container *ngFor="let note of noteList">
                                    <tr *ngIf="note.documentType==5">
                                        <td [innerHTML]="note.notes | mentionHighlight"></td>
                                        <td>{{note.createdDate | calsoftDate}}</td>
                                        <td>{{note.updatedDate | calsoftDate}}</td>
                                        <td>
                                            <button [attr.guide]="'lead-detail-btn-115' + '__' + sanitizedUrl"
                                                mat-icon-button [matMenuTriggerFor]="menu">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                            <mat-menu #menu="matMenu">
                                                <button [attr.guide]="'lead-detail-btn-116' + '__' + sanitizedUrl"
                                                    (click)="createNote(note, note.noteId)" mat-menu-item>
                                                    <mat-icon>edit</mat-icon>
                                                    Edit
                                                </button>
                                            </mat-menu>
                                        </td>
                                    </tr>
                                </ng-container>


                            </table>

                        </div>
                    </div>
                    <div *ngSwitchCase="'calendar'">
                        <calsoft-leadsmeeting [leadId]="leadId" [googleCalendarList]="googleCalendarList"
                            [meetingType]="1" [type]="2"></calsoft-leadsmeeting>
                    </div>
                    <div *ngSwitchCase="'deals'">
                        <calsoft-deals [enableSmartView]="false" [leadId]="leadId" [type]="2"></calsoft-deals>
                    </div>
                    <div *ngSwitchCase="'calls'">
                        <div class="call-section-bg">
                            <div class="tab-pane fade" id="calls">
                                <div class="card">
                                    <div
                                        class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                        <h4 class="fw-semibold">Calls</h4>

                                        <!-- <button [attr.guide]="'lead-detail-btn-117' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-118' + '__' + sanitizedUrl"
                                                *ngIf="crmType!=2" mat-menu-item
                                                (click)="addLeadActivityone('Follow Up',0,null)">Follow Up
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-119' + '__' + sanitizedUrl"
                                                mat-menu-item (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                                Call</button>
                                            <button [attr.guide]="'lead-detail-btn-120' + '__' + sanitizedUrl"
                                                *ngIf="enableLocation == '1'" mat-menu-item
                                                (click)="addLeadActivityone('Location',0,null)">Location</button>
                                        </mat-menu>
                                    </div>
                                    <div class="card-body">
                                        <div class="card mb-3" *ngFor="let lead of calllist;">

                                            <div class="card-body">
                                                <div class="d-sm-flex align-items-center justify-content-between pb-2">
                                                    <div class="d-flex align-items-center mb-2" style="display: flex;">
                                                        <span class="avatar-md me-2 flex-shrink-0">
                                                            <mat-icon class="default-icon">person</mat-icon>
                                                        </span>
                                                        <p><span
                                                                class="text-dark fw-medium">{{lead.customerName}}</span>
                                                            logged a call on {{lead.updatedDate}}</p>
                                                    </div>
                                                    <div class="d-inline-flex align-items-center mb-2">
                                                        <div class="dropdown me-2">
                                                            <a href="javascript:void(0);" class="py-1" [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                                {{lead.phoneCallOutcome | titlecase}}
                                                                <i class="ti ti-chevron-down ms-2"></i>
                                                            </a>


                                                        </div>
                                                        <div class="dropdown">
                                                            <a href="javascript:void(0);"
                                                                class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                    class="ti ti-dots-vertical"></i></a>
                                                            <div class="dropdown-menu dropdown-menu-right">
                                                                <a class="dropdown-item" href="javascript:void(0);"><i
                                                                        class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                                <a class="dropdown-item" href="javascript:void(0);"><i
                                                                        class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span [innerHTML]="lead.notes"> </span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </mat-tab>


        </mat-tab-group>

    </div>


</div>

<div *ngIf="leadDetailPageType === 4">
    <div class="contact-header-container">
        <div class="header-top">
            <div class="header-left">
                <div class="avatar">
                    <!-- <img src="https://i.pravatar.cc/150?u=spector" alt="Spector Calista" /> -->
                </div>
                <div class="name-and-title">
                    <div class="name-line">
                        <h1>{{ LeadDetailsObject?.name }}</h1>
                        <!-- <div class="info-icons">
                            <mat-icon>email</mat-icon>
                            <mat-icon>phone</mat-icon>
                            <mat-icon>info</mat-icon>
                        </div> -->
                    </div>
                    <h4 *ngIf="LeadDetailsObject?.jobTitle">{{ LeadDetailsObject?.jobTitle }}</h4>
                    <p class="title">{{LeadDetailsObject?.email}}</p>
                </div>
                <div class="score-section">
                    <div class="score-info">
                        <span class="score-label">Lead Score</span>
                        <span class="score-value">{{LeadDetailsObject?.score || 0.0}}</span>
                    </div>
                    <!-- <div class="customer-fit">
          <span class="fit-label">Customer fit <mat-icon class="label-icon">info_outline</mat-icon></span>
          <div class="star-rating">
            <mat-icon class="filled">star</mat-icon>
            <mat-icon class="filled">star</mat-icon>
            <mat-icon class="filled">star</mat-icon>
            <mat-icon>star_border</mat-icon>
            <mat-icon>star_border</mat-icon>
          </div>
        </div> 
        <a class="score-factors-link">Show key scoring factors</a>
        -->
                </div>
            </div>
            <div class="header-right">
                <!-- <button [attr.guide]="'lead-detail-btn-121' + '__' + sanitizedUrl" mat-stroked-button><mat-icon>visibility</mat-icon> See all details</button>
                <button [attr.guide]="'lead-detail-btn-122' + '__' + sanitizedUrl" mat-stroked-button class="btn-nav"><mat-icon>chevron_left</mat-icon></button>
                <button [attr.guide]="'lead-detail-btn-123' + '__' + sanitizedUrl" mat-stroked-button class="btn-nav"><mat-icon>chevron_right</mat-icon></button> -->
            </div>
        </div>

        <div class="action-bar">
            <div *ngFor="let icon of icons">
                <button [attr.guide]="'lead-detail-btn-124' + '__' + sanitizedUrl" mat-stroked-button
                    (click)="callicon(icon)" *ngIf=" icon.label !== 'Create a task'">
                    <mat-icon>{{
                        icon.icon }}</mat-icon> {{ icon.name }}
                </button>
                <button [attr.guide]="'lead-detail-btn-125' + '__' + sanitizedUrl" mat-stroked-button
                    [matMenuTriggerFor]="moreMenu" *ngIf="icon.label === 'Create a task'">
                    <mat-icon>{{ icon.icon }}</mat-icon>{{ icon.name }}
                </button>
            </div>
            <mat-menu #moreMenu="matMenu">
                <button [attr.guide]="'lead-detail-btn-126' + '__' + sanitizedUrl" *ngIf="crmType!=2" mat-menu-item
                    (click)="addLeadActivity('Follow Up', 0, null)">
                    Follow Up
                </button>
                <button [attr.guide]="'lead-detail-btn-127' + '__' + sanitizedUrl" mat-menu-item
                    (click)="addLeadActivity('Phone Call', 0, null)">
                    Phone Call
                </button>
                <button [attr.guide]="'pipeline-btn-95' + '__' + sanitizedUrl" mat-menu-item
                    (click)="addSiteVisitPopup()">Site visit</button>
                <button [attr.guide]="'lead-detail-btn-128' + '__' + sanitizedUrl" *ngIf="enableLocation == '1'"
                    mat-menu-item (click)="addLeadActivityone('Location',0,null)">Location</button>
            </mat-menu>
        </div>

        <mat-divider></mat-divider>

    </div>

    <div>
        <div class="page-container">
            <aside class="sidebar">
                <ul class="sidebar-menu">
                    <li>
                        <a [attr.guide]="'lead-detail-lnk-129' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'activity'" (click)="selectTabs('activity')">
                            <span class="material-icons">history</span>
                            Activity History
                        </a>
                    </li>

                    <li *ngIf="usedInSite!=null || filterList!=null || additionalSpec!=null">
                        <a [attr.guide]="'lead-detail-lnk-130' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Lead'" (click)="selectTabs('Lead')">
                            <span class="material-icons">person</span>
                            Lead Detail
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-131' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'tasks'" (click)="selectTabs('tasks')">
                            <span class="material-icons">task_alt</span>
                            Tasks
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-132' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Chats'" (click)="selectTabs('Chats')">
                            <span class="material-icons">chat</span>
                            Chats
                        </a>
                    </li>

                    <li *ngIf="leadNoteDisplay === 1">
                        <a [attr.guide]="'lead-detail-lnk-133' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Notes'" (click)="selectTabs('Notes')">
                            <span class="material-icons">note_add</span>
                            Notes
                        </a>
                    </li>

                    <li *ngIf="jsonRecieved!=null">
                        <a [attr.guide]="'lead-detail-lnk-134' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Original'" (click)="selectTabs('Original')">
                            <span class="material-icons">code</span>
                            Original Lead Format
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-135' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Documents'" (click)="selectTabs('Documents')">
                            <span class="material-icons">folder</span>
                            Documents
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-136' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Payment'" (click)="selectTabs('Payment')">
                            <span class="material-icons">payment</span>
                            Payment
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-137' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Calender'" (click)="selectTabs('Calender')">
                            <span class="material-icons">calendar_today</span>
                            Calendar
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-138' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Deals'" (click)="selectTabs('Deals')">
                            <span class="material-icons">handshake</span>
                            Deals
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-139' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Email Sent'" (click)="selectTabs('Email Sent')">
                            <span class="material-icons">email</span>
                            Email
                        </a>
                    </li>

                    <li>
                        <a [attr.guide]="'lead-detail-lnk-140' + '__' + sanitizedUrl"
                            [class.active]="activeTab === 'Calls'" (click)="selectTabs('Calls')">
                            <span class="material-icons">call</span>
                            Calls
                        </a>
                    </li>
                </ul>
            </aside>

            <main class="main-content">
                <div *ngIf="activeTab === 'activity'">
                    <ng-container *ngIf="init && activityHistoryType == 1">
                        <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                            [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                            [totalSize]="totalSize" [leadid]="leadId" fxFlex [leadActivityList]="leadActivityList">
                        </calsoft-activity>
                    </ng-container>

                    <ng-container *ngIf="activityHistoryType == 0">
                        <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                            [groupedActivities]="groupedActivities"
                            (scrollChange)="onScrollNew()"></calsoft-activity-new>
                    </ng-container>

                </div>
                <ng-container *ngIf="usedInSite || filterList || additionalSpec">
                    <div *ngIf="activeTab === 'Lead'">
                        <div>
                            <table
                                *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                                <tr>
                                    <th colspan="2">
                                        {{leadCommonPropertiesName}}
                                    </th>
                                </tr>
                                <ng-container *ngIf="!type3">

                                    <tr *ngFor="let item of usedInSite | keyvalue">
                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                                <ng-container *ngIf="type3">

                                    <tr *ngFor="let item of customList ">


                                        <td>
                                            {{item[0]}}
                                        </td>
                                        <td>
                                            <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' &&item[0]!='Category' &&item[0]!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item[1]">
                                            </p>

                                            <p *ngIf="item[0]=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item[0]=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item[0]=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item[0]=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                            </table>

                            <table
                                *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                                <tr>
                                    <th colspan="2">
                                        {{leadPropertiesName}}
                                    </th>
                                </tr>


                                <ng-container *ngIf="!type2">

                                    <tr *ngFor="let item of valuesList | keyvalue">
                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                                <ng-container *ngIf="type2">

                                    <tr *ngFor="let item of filterList | keyvalue">


                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>

                            </table>

                            <table
                                *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                                <tr>
                                    <th colspan="2">
                                        {{leadAdditionalPropertiesName}}
                                    </th>
                                </tr>


                                <ng-container *ngIf="!type1">

                                    <tr *ngFor="let item of additionalSpec | keyvalue">
                                        <td>
                                            {{item.key}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>
                                <ng-container *ngIf="type1">

                                    <tr *ngFor="let item of additionalSpecList ">


                                        <td>
                                            {{item[0]}}
                                        </td>
                                        <td>
                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                class="blackColor wordBreak" [innerHTML]="item.value"> </p>

                                            <p *ngIf="item.key=='Lead Status'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                            <p *ngIf="item.key=='Lead Source'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                        </td>
                                    </tr>

                                </ng-container>


                            </table>
                        </div>
                    </div>
                </ng-container>
                <div *ngIf="activeTab === 'tasks'">
                    <table>
                        <tr>
                            <th>Type</th>
                            <th>Date</th>
                            <th>Notes</th>
                            <th>Action</th>
                        </tr>
                        <tr *ngFor="let lead of leadActivityList;">
                            <td>{{lead.activityType}}</td>
                            <td>{{lead.createdDate | calsoftDate}}</td>
                            <td>{{lead.notes}}</td>
                            <td>
                                <button [attr.guide]="'lead-detail-btn-141' + '__' + sanitizedUrl" mat-icon-button
                                    [matMenuTriggerFor]="menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button [attr.guide]="'lead-detail-btn-142' + '__' + sanitizedUrl"
                                        (click)="addLeadActivity('Edit', 0, lead)" mat-menu-item>
                                        <mat-icon>edit</mat-icon>
                                        Edit
                                    </button>
                                    <button [attr.guide]="'lead-detail-btn-143' + '__' + sanitizedUrl"
                                        (click)="deleteLeadDialog(lead.id)" mat-menu-item>
                                        <mat-icon>delete</mat-icon>
                                        Delete
                                    </button>

                                </mat-menu>
                            </td>

                        </tr>

                    </table>
                </div>


                <div *ngIf="activeTab === 'Email Sent'">
                    <div class="mailbox-container">

                        <div class="mailbox-toggle-container">
                            <mat-button-toggle-group [(value)]="currentMailBox" (change)="loadEmails($event)">
                                <mat-button-toggle (click)="loadEmails({ value: 'INBOX' })" value="INBOX">Inbox
                                </mat-button-toggle>
                                <mat-button-toggle (click)="loadEmails({ value: 'Sent' })" value="Sent">Sent
                                </mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>


                        <div class="mailbox-content">

                            <div class="mailbox-email-list" [class.full-width]="!selectedIndex">
                                <ng-container *ngIf="isLoading; else emailListTemplate">
                                    <div class="loading-spinner">
                                        <mat-spinner diameter="40"></mat-spinner>
                                        <p>Loading emails...</p>
                                    </div>
                                </ng-container>
                                <ng-template #emailListTemplate>
                                    <mat-paginator [length]="totalEmails" [pageSize]="pageSizeEmail"
                                        [pageIndex]="pageIndex" (page)="onPageChange($event)">
                                    </mat-paginator>

                                    <mat-nav-list>
                                        <mat-list-item *ngFor="let email of emails; let i = index" [ngClass]="{
                                                    'mailbox-email-list-item': true,
                                                    'active': i === selectedIndex
                                                    }" (click)="selectEmail(i)">
                                            <div class="mailbox-email-list-item">
                                                <div class="mailbox-email-header">
                                                    <span class="mailbox-email-subject">{{ email.subject }}</span>
                                                    <span class="mailbox-email-date">{{ email.sentDate |
                                                        date:'medium'
                                                        }}</span>
                                                </div>
                                                <div class="mailbox-email-preview">
                                                    <span class="mailbox-email-from-to">
                                                        {{ currentMailBox === 'INBOX' ?
                                                        extractEmailAddress(email.from)
                                                        : email.to }}
                                                    </span>
                                                    <span class="mailbox-email-body-preview">
                                                        {{ truncateSafeHTML(email.body, 150) }}
                                                    </span>


                                                </div>
                                            </div>
                                        </mat-list-item>
                                    </mat-nav-list>
                                </ng-template>

                            </div>



                            <div *ngIf="emailVisble; else placeholder" class="mailbox-email-wrapper">

                                <div class="mailbox-email-detail" [ngClass]="{ 'show-detail': isMobileView }">
                                    <button [attr.guide]="'lead-detail-btn-144' + '__' + sanitizedUrl"
                                        class="back-button" *ngIf="isMobileView" (click)="backToList()">
                                        ← Back
                                    </button>
                                    <div class="mailbox-email-detail-header">
                                        <h2>{{ emailObject.subject }}</h2>
                                        <div class="mailbox-email-meta">
                                            <!-- <div><strong>From:</strong> {{ emailObject.from[0].address }}
                                                </div> -->
                                            <div><strong>To:</strong> {{ emailObject.to }}</div>
                                            <div><strong>Date:</strong> {{ emailObject.sentDate | date:'medium' }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mailbox-email-body" [innerHTML]="emailObject.body"></div>
                                    <div class="mailbox-email-attachments"
                                        *ngIf="emails[selectedIndex]?.attachments?.length > 0">
                                        <h4>Attachments</h4>
                                        <ul>
                                            <li *ngFor="let file of emails[selectedIndex].attachments">
                                                <div *ngIf="isImage(file.contentType)">

                                                    <!-- <img [src]="newserverpath + file.fileName" [alt]="file.fileName"
                                                        style="height: 50px; width: 100%"> -->

                                                    <!-- Debug text removed -->
                                                    <calsoft-common-images [src]="serverPathEmail + file.fileName"
                                                        [height]="'50px'" [width]="'auto'" [alt]="file.fileName">
                                                    </calsoft-common-images>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>


                            </div>


                            <ng-template #placeholder>
                                <div class="mailbox-placeholder">
                                    <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                    <h3>Select an email to read</h3>
                                    <p>Choose a message from your Mails to view it here</p>
                                </div>
                            </ng-template>
                        </div>

                        <ng-template #loading>
                            <div class="global-loading">
                                <mat-spinner></mat-spinner>
                                <p>Fetching emails...</p>
                            </div>
                        </ng-template>
                        <ng-template #emptyState>
                            <div class="empty-state">
                                <div class="empty-icon">📭</div>
                                <h3>No emails found</h3>
                                <p>Your folder is empty</p>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div *ngIf="activeTab === 'Chats'">
                    <div *ngIf="leadLoaded && whatAppchatType === 1">
                        <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                            [isFromPhone]="true">
                        </calsoft-whatsapp-chat-details>
                    </div>
                    <div *ngIf="leadLoaded && whatAppchatType === 2">
                        <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                        </calsoft-whats-app-new-client>
                    </div>
                </div>
                <ng-container *ngIf="leadNoteDisplay==1">
                    <div *ngIf="activeTab === 'Notes'">
                        <div class="padding-10">

                            <div class="editSets">
                                <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                    <span>Notes</span>
                                    <button [attr.guide]="'lead-detail-btn-145' + '__' + sanitizedUrl"
                                        *ngIf="noteList.length>0" mat-icon-button>
                                        <mat-icon (click)="createNote(null,0)">
                                            add
                                        </mat-icon>
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="noteList.length==0" class="padding-10" style="background-color: gray;"
                                fxLayout="column" fxLayoutAlign="center center">
                                <mat-icon> insert_drive_file</mat-icon>

                                <div style="color: white; background: none;" class="title padding-10">
                                    Add notes to your lead!
                                </div>

                                <div class="create Note">
                                    <button [attr.guide]="'lead-detail-btn-146' + '__' + sanitizedUrl" mat-flat-button
                                        color="primary" (click)="createNote(null,0)">
                                        <span class="medium-x">Create Note</span>
                                    </button>
                                </div>
                            </div>

                            <div>


                                <div id="responsieTable">


                                    <table class="rwd-table" *ngIf="noteList.length>0">

                                        <tr>

                                            <th>Notes</th>

                                            <th>Created Date</th>
                                            <th>Updated Date</th>
                                            <th>Created by</th>
                                            <th>Updated by</th>
                                            <th>Action</th>
                                        </tr>
                                        <ng-container *ngFor="let note of noteList">
                                            <tr *ngIf="note.documentType==0">
                                                <td data-th="Notes" [innerHTML]="note.notes | mentionHighlight"></td>
                                                <td data-th="Created Date">{{note.createdDate | calsoftDate}}</td>
                                                <td data-th="Updated Date">{{note.updatedDate | calsoftDate}}</td>
                                                <td data-th="Created by">{{note.createdBy == null ?
                                                    LeadDetailsObject?.ownerEmail : note.createdBy}}</td>
                                                <td data-th="Updated by">{{note.updatedBy == null ?
                                                    LeadDetailsObject?.ownerEmail : note.updatedBy}}</td>
                                                <td data-th="Action">
                                                    <button [attr.guide]="'lead-detail-btn-147' + '__' + sanitizedUrl"
                                                        mat-icon-button [matMenuTriggerFor]="menu147">
                                                        <mat-icon>more_vert</mat-icon>
                                                    </button>
                                                    <mat-menu #menu147="matMenu">
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-148' + '__' + sanitizedUrl"
                                                            (click)="createNote(note, note.noteId)" mat-menu-item>
                                                            <mat-icon>edit</mat-icon>
                                                            Edit
                                                        </button>
                                                        <button mat-menu-item *ngIf="note.noteType !== 'REPLY'"
                                                            (click)="toggleReply(note.noteId)">
                                                            <mat-icon>reply</mat-icon> Reply
                                                        </button>
                                                    </mat-menu>
                                                </td>
                                            </tr>
                                            <tr *ngIf="note.documentType==0 && replyingToNoteId === note.noteId">
                                                <td colspan="6">
                                                    <div
                                                        style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;">
                                                        <mat-icon
                                                            style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                                        <mat-form-field appearance="outline" style="flex:1">
                                                            <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                            <textarea matInput rows="2" [(ngModel)]="replyText"
                                                                placeholder="Write a reply..."></textarea>
                                                        </mat-form-field>
                                                        <button mat-raised-button color="primary" style="margin-top:6px"
                                                            [disabled]="!replyText?.trim()"
                                                            (click)="submitReply(note)">Send</button>
                                                        <button mat-icon-button style="margin-top:4px"
                                                            (click)="toggleReply(null)">
                                                            <mat-icon>close</mat-icon>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>


                                    </table>

                                </div>

                            </div>

                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="jsonRecieved!=null">
                    <div *ngIf="activeTab === 'Original'">
                        <table id="details">
                            <tr *ngFor="let item of jsonRecieved | keyvalue">
                                <td>
                                    {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key }}
                                </td>
                                <td>
                                    <p class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </ng-container>
                <div *ngIf="activeTab === 'Documents'">
                    <div class="padding-10">

                        <div class="editSets1">
                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                <span>Documents</span>

                                <button [attr.guide]="'lead-detail-btn-149' + '__' + sanitizedUrl" mat-icon-button>
                                    <mat-icon (click)="createDocument(null,0)">
                                        add
                                    </mat-icon>
                                </button>
                            </div>
                        </div>

                        <div *ngFor="let note of noteList;">
                            <div fxLayout="column" *ngIf="note.notesDocument?.length>0">
                                <div fxLayout="row" class="padding-10" fxLayoutAlign="start center">
                                    <span [innerHTML]="note.notes | mentionHighlight"></span>


                                    <div class="padding-10" *ngIf="note.documentType==2">
                                        <calsoft-audios [value]="serverPath + note.notesDocument">
                                        </calsoft-audios>
                                    </div>

                                    <div class="padding-10" *ngIf="note.documentType==1">
                                        <calsoft-videos [value]="serverPathVedio + note.notesDocument">
                                        </calsoft-videos>
                                    </div>

                                    <div class="padding-10" *ngIf="note.documentType==3">
                                        <div fxLayout="column">

                                            <div fxLayout="row">
                                                <span fxLayoutAlign="start center">
                                                    Pdf : {{note.notesDocument}}
                                                </span>

                                                <button [attr.guide]="'lead-detail-btn-150' + '__' + sanitizedUrl"
                                                    (click)="download(note.notesDocument)" color="warn" mat-icon-button
                                                    type="button">
                                                    <mat-icon>download

                                                    </mat-icon>

                                                </button>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="padding-10" *ngIf="note.documentType==4">
                                        <div fxLayout="column">
                                            <div fxLayout="row">

                                                <calsoft-common-images [src]="serverPathImage + note.notesDocument"
                                                    [height]="'50%'" [width]="'50%'" [alt]="">

                                                </calsoft-common-images>

                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
                <div *ngIf="activeTab === 'Payment'">
                    <div class="padding-10">

                        <div class="editSets1">
                            <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                <span>Payment</span>

                                <button [attr.guide]="'lead-detail-btn-151' + '__' + sanitizedUrl" mat-icon-button>
                                    <mat-icon (click)="createPayment(null,0)">
                                        add
                                    </mat-icon>
                                </button>
                            </div>
                        </div>

                        <table *ngIf="noteList.length>0">

                            <tr>

                                <th>Notes</th>

                                <th>Created Date</th>
                                <th>Updated Date</th>
                                <th>Action</th>
                            </tr>
                            <ng-container *ngFor="let note of noteList">
                                <tr *ngIf="note.documentType==5">
                                    <td [innerHTML]="note.notes | mentionHighlight"></td>
                                    <td>{{note.createdDate | calsoftDate}}</td>
                                    <td>{{note.updatedDate | calsoftDate}}</td>
                                    <td>
                                        <button [attr.guide]="'lead-detail-btn-152' + '__' + sanitizedUrl"
                                            mat-icon-button [matMenuTriggerFor]="menu">
                                            <mat-icon>more_vert</mat-icon>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-153' + '__' + sanitizedUrl"
                                                (click)="createNote(note, note.noteId)" mat-menu-item>
                                                <mat-icon>edit</mat-icon>
                                                Edit
                                            </button>
                                        </mat-menu>
                                    </td>
                                </tr>
                            </ng-container>


                        </table>

                    </div>
                </div>
                <div *ngIf="activeTab === 'Calender'">
                    <calsoft-leadsmeeting [leadId]="leadId" [googleCalendarList]="googleCalendarList" [meetingType]="1"
                        [type]="2"></calsoft-leadsmeeting>
                </div>
                <div *ngIf="activeTab === 'Deals'">
                    <calsoft-deals [enableSmartView]="false" [leadId]="leadId" [type]="2"></calsoft-deals>
                </div>
                <div *ngIf="activeTab === 'Calls'">
                    <div class="call-section-bg">
                        <div class="tab-pane fade" id="calls">
                            <div class="card">
                                <div
                                    class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                    <h4 class="fw-semibold">Calls</h4>

                                    <!-- <button [attr.guide]="'lead-detail-btn-154' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                    <mat-menu #menu="matMenu">
                                        <button [attr.guide]="'lead-detail-btn-155' + '__' + sanitizedUrl"
                                            *ngIf="crmType!=2" mat-menu-item
                                            (click)="addLeadActivityone('Follow Up',0,null)">Follow Up
                                        </button>
                                        <button [attr.guide]="'lead-detail-btn-156' + '__' + sanitizedUrl" mat-menu-item
                                            (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                            Call</button>
                                        <button [attr.guide]="'pipeline-btn-96' + '__' + sanitizedUrl" mat-menu-item
                                            (click)="addSiteVisitPopup()">Site visit</button>
                                        <button [attr.guide]="'lead-detail-btn-157' + '__' + sanitizedUrl"
                                            *ngIf="enableLocation == '1'" mat-menu-item
                                            (click)="addLeadActivityone('Location',0,null)">Location</button>
                                    </mat-menu>
                                </div>
                                <div class="card-body" *ngIf="calllist?.length > 0; else noData">
                                    <div class="card mb-3" *ngFor="let lead of calllist;">

                                        <div class="card-body">
                                            <div class="d-sm-flex align-items-center justify-content-between pb-2">
                                                <div class="d-flex align-items-center mb-2" style="display: flex;">
                                                    <span class="avatar-md me-2 flex-shrink-0">
                                                        <mat-icon class="default-icon">person</mat-icon>
                                                    </span>
                                                    <p><span class="text-dark fw-medium">{{lead.customerName}}</span>
                                                        logged a call on {{lead.updatedDate}}</p>
                                                </div>
                                                <div class="d-inline-flex align-items-center mb-2">
                                                    <div class="dropdown me-2">
                                                        <a href="javascript:void(0);" class="py-1" [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                            {{lead.phoneCallOutcome | titlecase}}
                                                            <i class="ti ti-chevron-down ms-2"></i>
                                                        </a>


                                                    </div>
                                                    <div class="dropdown">
                                                        <a href="javascript:void(0);"
                                                            class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                            data-bs-toggle="dropdown" aria-expanded="false"><i
                                                                class="ti ti-dots-vertical"></i></a>
                                                        <div class="dropdown-menu dropdown-menu-right">
                                                            <a class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                            <a class="dropdown-item" href="javascript:void(0);"><i
                                                                    class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <span [innerHTML]="lead.notes"> </span>
                                        </div>
                                    </div>

                                </div>

                                <ng-template #noData>
                                    <div class="text-center text-muted py-4">
                                        <p>No data found.</p>
                                    </div>
                                </ng-template>

                            </div>
                        </div>
                    </div>
                </div>

            </main>

        </div>

    </div>
</div>
<div *ngIf="leadDetailPageType ===5" class="new-leadType-five" fxLayout="column" fxFlex>

    <div class="lead-detail-page" fxLayout="column" fxFlex>

        <div class="header-container" fxLayout="row" fxLayoutAlign="space-between center" fxHide.lt-md fxHide.md>

            <div class="header-left" fxFlex="24" fxLayout="row" fxLayoutAlign="start center">

                <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn"
                    (click)="back()"><span class="material-symbols-outlined">keyboard_backspace</span>
                    Back</button>

            </div>

            <div class="header-right" fxFlex="76" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
                <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn"
                    (click)="openEmailPopup()"><span class="material-symbols-outlined">email</span>
                    Email</button>

                <button [attr.guide]="'lead-detail-btn-159' + '__' + sanitizedUrl" class="header-btn"
                    (click)="transferLead()">
                    <span class="material-symbols-outlined">person_outline</span>
                    Change Owner
                </button>

                <button [attr.guide]="'lead-detail-btn-160' + '__' + sanitizedUrl" *ngIf="documentEnable"
                    class="header-btn" (click)="downloadDocumentPopup()">
                    <span class="material-symbols-outlined">download</span>
                    {{document}}
                </button>

                <button [attr.guide]="'lead-detail-btn-161' + '__' + sanitizedUrl" *ngIf="invoicebuttonEnable"
                    class="header-btn" (click)="navigateToInvoice(LeadDetailsObject)">
                    <span class="material-symbols-outlined">library_books </span>
                    {{invoicebutton}}
                </button>


                <button [attr.guide]="'lead-detail-btn-162' + '__' + sanitizedUrl" *ngIf="quotationbuttonEnable"
                    class="header-btn" (click)="navigateToQuotation(LeadDetailsObject)">
                    <span class="material-symbols-outlined">request_quote</span>
                    {{quotationbutton}}
                </button>
                <button [attr.guide]="'lead-detail-btn-163' + '__' + sanitizedUrl" *ngIf="sendEmailTemplateEnable"
                    class="header-btn" (click)="sendEmailMessage()"><span class="material-symbols-outlined">mail</span>
                    {{sendEmailTemplate}}
                </button>


                <button [attr.guide]="'lead-detail-btn-164' + '__' + sanitizedUrl" *ngIf="builderSearchPopupEnable"
                    class="header-btn" (click)="newSearch(LeadDetailsObject)"><span
                        class="material-symbols-outlined">search</span>
                    {{builderSearchPopup}}
                </button>

                <button [attr.guide]="'lead-detail-btn-165' + '__' + sanitizedUrl" class="header-btn"
                    (click)="phoneNumbercall(LeadDetailsObject)"><span class="material-symbols-outlined">call</span>
                    Call</button>
                <!-- <button [attr.guide]="'lead-detail-btn-166' + '__' + sanitizedUrl" class="header-btn"><span class="material-symbols-outlined">sms</span> SMS</button> -->
                <button [attr.guide]="'lead-detail-btn-167' + '__' + sanitizedUrl" class="header-btn"
                    (click)="addLeadActivity('Phone Call',0,null)"><span class="material-symbols-outlined">task</span>
                    Task</button>

                <button [attr.guide]="'lead-detail-btn-168' + '__' + sanitizedUrl" class="header-btn"
                    (click)="goToMeeting()"><span class="material-symbols-outlined">meeting_room</span> Meeting</button>
                <!-- <button [attr.guide]="'lead-detail-btn-169' + '__' + sanitizedUrl" class="header-btn-secondary"><span class="material-symbols-outlined">sell</span> Sales activities
                <span class="material-symbols-outlined">arrow_drop_down</span></button> -->
                <button [attr.guide]="'lead-detail-btn-170' + '__' + sanitizedUrl" (click)="goToDeals()"
                    class="header-btn-primary">
                    <span class="material-symbols-outlined">add</span> Add deal</button>
                <button [attr.guide]="'lead-detail-btn-171' + '__' + sanitizedUrl" type="button" class="header-btn"
                    [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                    <span class="material-symbols-outlined">more_vert</span>
                </button>
            </div>



            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-172' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-173' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>
        </div>

        <div class="header-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" fxHide fxShow.lt-lg>
            <div class="mobile-actions header-actions-compact" fxLayout="row" fxLayoutAlign="end center"
                fxLayoutGap="8px">

                <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn"
                    (click)="back()"><span class="material-symbols-outlined">keyboard_backspace</span>
                    Back</button>


                <button [attr.guide]="'lead-detail-btn-email' + '__' + sanitizedUrl" mat-icon-button class="action-icon"
                    matTooltip="Email" aria-label="Email" (click)="openEmailPopup()">
                    <span class="material-symbols-outlined">email</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-call' + '__' + sanitizedUrl" mat-icon-button class="action-icon"
                    matTooltip="Call" aria-label="Call" (click)="phoneNumbercall(LeadDetailsObject)">
                    <span class="material-symbols-outlined">call</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-change-owner' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" matTooltip="Change Owner" aria-label="Change Owner" (click)="transferLead()">
                    <span class="material-symbols-outlined">person</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-174' + '__' + sanitizedUrl" mat-flat-button color="primary"
                    class="primary-compact header-btn-primary" (click)="goToDeals()">
                    <span class="material-symbols-outlined">add</span>
                    <span class="label">Add deal</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-more-actions' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" [matMenuTriggerFor]="moreActionsMenu" aria-label="More actions">
                    <mat-icon>more_horiz</mat-icon>
                </button>

                <button [attr.guide]="'lead-detail-btn-edit-or-delete' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" [matMenuTriggerFor]="editDeleteMenu" aria-label="Edit or Delete">
                    <mat-icon>more_vert</mat-icon>
                </button>

            </div>

            <mat-menu #editDeleteMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-175' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-176' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>

            <mat-menu #moreActionsMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-177' + '__' + sanitizedUrl" mat-menu-item
                    (click)="addLeadActivity('Phone Call',0,null)">Task</button>
                <button [attr.guide]="'lead-detail-btn-178' + '__' + sanitizedUrl" mat-menu-item
                    (click)="goToMeeting()">Meeting</button>
                <button [attr.guide]="'lead-detail-btn-179' + '__' + sanitizedUrl" mat-menu-item
                    (click)="downloadDocumentPopup()" *ngIf="documentEnable">Document</button>
                <button [attr.guide]="'lead-detail-btn-180' + '__' + sanitizedUrl" mat-menu-item
                    (click)="navigateToInvoice(LeadDetailsObject)"
                    *ngIf="invoicebuttonEnable">{{invoicebutton}}</button>
                <button [attr.guide]="'lead-detail-btn-181' + '__' + sanitizedUrl" mat-menu-item
                    (click)="navigateToQuotation(LeadDetailsObject)"
                    *ngIf="quotationbuttonEnable">{{quotationbutton}}</button>
                <button [attr.guide]="'lead-detail-btn-182' + '__' + sanitizedUrl" mat-menu-item
                    (click)="sendEmailMessage()" *ngIf="sendEmailTemplateEnable">{{sendEmailTemplate}}</button>
                <button [attr.guide]="'lead-detail-btn-183' + '__' + sanitizedUrl" mat-menu-item
                    (click)="newSearch(LeadDetailsObject)"
                    *ngIf="builderSearchPopupEnable">{{builderSearchPopup}}</button>
            </mat-menu>
        </div>

        <div class="main-content-wrapper" fxLayout="row" fxLayout.lt-md="column" fxFlex>

            <div class="left-sidebar" fxFlex="22" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="10px">
                <div class="profile-card">
                    <div class="profile-header" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <div class="avatar-container" (click)="openViewDialog()">
                                <!-- <img *ngIf="!imageError" [src]="basePath + LeadDetailsObject?.image + '&cid=' + cid"
                                alt="Profile Avatar" class="avatar-image" (error)="setError()" /> -->

                                <img *ngIf="LeadDetailsObject?.image; else initialAvatar" [src]="uploadedImageUrl"
                                    alt="Profile Avatar" class="avatar-image" />



                                <!-- If no image, show initials -->
                                <ng-template #initialAvatar>
                                    <div class="avatar-initial">
                                        {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                                    </div>
                                </ng-template>

                                <!-- <div *ngIf="imageError" class="avatar-fallback">
                                {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                            </div> -->

                                <div class="overlay">
                                    <div class="overlay-text">
                                        {{ LeadDetailsObject?.image ? 'View' : 'Add' }}</div>


                                </div>
                            </div>
                            <div class="overlay-details" style="min-width: 0; overflow: hidden;">
                                <div class="name-row"
                                    style="display:flex;align-items:center;gap:8px;min-width: 0;overflow: hidden;">
                                    <h2 class="name"
                                        style="margin:0; flex: 1; min-width: 0; white-space: normal; word-break: break-word; line-height: 1.4;">
                                        {{ (LeadDetailsObject?.name?.indexOf(' ') === -1
                                        && LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                        slice:0:20) + '...' : LeadDetailsObject?.name }}</h2>
                                    <button [attr.guide]="'lead-detail-btn-184' + '__' + sanitizedUrl" class="edit-btn"
                                        style="opacity: 1;margin-left: 5px; flex-shrink: 0;"
                                        (click)="openEditPopup('name', 'Name', 'text')">
                                        <mat-icon style="color: black;">edit</mat-icon>
                                    </button>
                                </div>
                                <div class="social-icons">

                                    <a [attr.guide]="'lead-detail-lnk-185' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('facebook', $event)">
                                        <img [src]="LeadDetailsObject?.facebook 
              ? 'https://img.icons8.com/fluent/48/000000/facebook-new.png' 
              : 'https://img.icons8.com/ios/48/000000/facebook--v1.png'" />
                                    </a>


                                    <a [attr.guide]="'lead-detail-lnk-186' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('twitter', $event)">
                                        <img [src]="LeadDetailsObject?.twitter 
              ? 'https://img.icons8.com/ios-filled/50/000000/x.png' 
              : 'https://img.icons8.com/ios-filled/50/000000/x.png'" />
                                    </a>


                                    <a [attr.guide]="'lead-detail-lnk-187' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('linkedIn', $event)">
                                        <img [src]="LeadDetailsObject?.linkedIn 
              ? 'https://img.icons8.com/fluent/48/000000/linkedin.png' 
              : 'https://img.icons8.com/ios/48/000000/linkedin.png'" />
                                    </a>

                                    <a class="social-edit-btn" [matMenuTriggerFor]="socialMenu">
                                        <mat-icon style="color: black;">edit</mat-icon>
                                    </a>


                                </div>

                                <mat-menu #socialMenu="matMenu" class="social-menu" [hasBackdrop]="true">
                                    <form [formGroup]="firstFormGroup" class="social-form" style="padding:10px;">
                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>Facebook</mat-label>
                                            <input [attr.guide]="'lead-detail-inp-facebook' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="facebook" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>Twitter</mat-label>
                                            <input [attr.guide]="'lead-detail-inp-twitter' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="twitter" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>LinkedIn</mat-label>
                                            <input [attr.guide]="'lead-detail-inp-linkedin' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="linkedIn" />
                                        </mat-form-field>

                                        <div class="social-actions">
                                            <button [attr.guide]="'lead-detail-btn-188' + '__' + sanitizedUrl"
                                                mat-button matMenuClose>Cancel</button>
                                            <button [attr.guide]="'lead-detail-btn-189' + '__' + sanitizedUrl"
                                                mat-flat-button color="primary" (click)="editProfileUrl()"
                                                matMenuClose>Save</button>
                                        </div>
                                    </form>
                                </mat-menu>
                            </div>
                        </div>

                        <div class="profile-info">

                            <!-- <p style="cursor: pointer;" class="title flex items-center gap-2"
                                [style.pointerEvents]="!LeadDetailsObject?.company ? 'none' : 'auto'"
                                [style.opacity]="!LeadDetailsObject?.company ? '0.6' : '1'">
                                <mat-icon style="font-size: 16px; padding-top: 5px;" class="primary-icon">
                                    corporate_fare
                                </mat-icon>
                                <span
                                    (click)="LeadDetailsObject?.company ? companyDetailPage(LeadDetailsObject?.companyId) : null">
                                    {{ LeadDetailsObject?.company || '—' }}
                                </span>
                            </p> -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.company ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.company ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.company ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        corporate_fare
                                    </mat-icon>

                                    <span style="font-weight: bold;color: black;"
                                        (click)="LeadDetailsObject?.companyId ? companyDetailPage(LeadDetailsObject?.companyId) : null">
                                        <span>
                                            {{ LeadDetailsObject?.company || '—' }}
                                        </span>
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-btn-190' + '__' + sanitizedUrl" class="edit-btn"
                                    style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('company', 'Company', 'text'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>


                            <div class="flex items-center" style="word-break: break-all;">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.jobtitle ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.jobtitle ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.jobtitle ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        work
                                    </mat-icon>

                                    <span>
                                        {{ LeadDetailsObject?.jobtitle || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-btn-191' + '__' + sanitizedUrl" class="edit-btn"
                                    style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('jobtitle', 'Jobtitle', 'text') ;$event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                            <!-- Email -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.email ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.email ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.email ? '0.6' : '1'">
                                    <mat-icon (click)="LeadDetailsObject?.email ? openEmailPopup() : null"
                                        style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        mail
                                    </mat-icon>

                                    <span style="word-break: break-all;"
                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">
                                        {{ LeadDetailsObject?.email || '—' }}
                                    </span>

                                    <mat-icon *ngIf="LeadDetailsObject?.email"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.email ? copyToClipboard(LeadDetailsObject?.email) : null">
                                        content_copy
                                    </mat-icon>
                                </p>
                                <button [attr.guide]="'lead-detail-btn-192' + '__' + sanitizedUrl" class="edit-btn"
                                    style="opacity: 1;margin-left: 5px;"
                                    (click)="openEditPopup('email', 'Email', 'text')">
                                    <mat-icon style="font-size: 16px; padding-top: 8px;">edit</mat-icon>
                                </button>
                            </div>

                            <div class="flex items-center">
                                <!-- Phone -->
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.phoneNumber ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.phoneNumber ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.phoneNumber ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">call</mat-icon>

                                    <span
                                        (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">
                                        {{ LeadDetailsObject?.phoneNumber || '—' }}
                                    </span>
                                    <mat-icon *ngIf="LeadDetailsObject?.phoneNumber"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.phoneNumber ? copyToClipboard(LeadDetailsObject?.phoneNumber) : null">
                                        content_copy
                                    </mat-icon>
                                </p>

                                <!-- Edit Button -->
                                <button [attr.guide]="'lead-detail-btn-193' + '__' + sanitizedUrl"
                                    class="edit-btn title" style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('phoneNumber', 'Phone Number', 'number'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                            <!-- WhatsApp -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2" style="display: inline-flex;"
                                    [style.cursor]="LeadDetailsObject?.phoneNumber ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.phoneNumber ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.phoneNumber ? '0.6' : '1'">
                                    <mat-icon style="font-size: 19px;" [icIcon]="icWhatsapp"></mat-icon>
                                    <span style="margin-bottom: -6px;"
                                        (click)="LeadDetailsObject?.phoneNumber ? phonewhatsapp(LeadDetailsObject) : null">
                                        {{ LeadDetailsObject?.phoneNumber || '—' }}
                                    </span>

                                    <mat-icon *ngIf="LeadDetailsObject?.phoneNumber"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.phoneNumber ? copyToClipboard(LeadDetailsObject?.phoneNumber) : null">
                                        content_copy
                                    </mat-icon>
                                </p>

                                <button [attr.guide]="'lead-detail-btn-194' + '__' + sanitizedUrl"
                                    class="edit-btn title" style="opacity: 1;margin-left: 10px;"
                                    (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                            <!-- <p style="cursor: pointer;" class="title flex items-center gap-2">
                                <mat-icon style="font-size: 16px;padding-top: 5px;"
                                    class="primary-icon">attribution</mat-icon>
                                {{ LeadDetailsObject?.ownerEmail }}
                            </p> -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.ownerIdName ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.ownerIdName ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.ownerIdName ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        attribution
                                    </mat-icon>

                                    <!-- <span (click)="LeadDetailsObject?.ownerIdName ? openEmailPopup() : null">
                                        {{ LeadDetailsObject?.ownerIdName || '—' }}
                                    </span> -->
                                    <span>
                                        {{ LeadDetailsObject?.ownerIdName || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-btn-195' + '__' + sanitizedUrl"
                                    class="edit-btn title" style="opacity: 1;margin-left: 10px;"
                                    (click)="transferLead(); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.statusName ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.statusName ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.statusName ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        info
                                    </mat-icon>

                                    <!-- <span
                                        (click)="LeadDetailsObject?.statusName ? openStatusDetail(LeadDetailsObject?.statusName) : null">
                                        {{ LeadDetailsObject?.statusName || '—' }}
                                    </span> -->
                                    <span>
                                        {{ LeadDetailsObject?.statusName || '—' }}
                                    </span>
                                </p>

                                <button [attr.guide]="'lead-detail-btn-196' + '__' + sanitizedUrl" class="edit-btn"
                                    style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('statusName', 'Status Name', 'select'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                            <div class="flex items-center" *ngIf="defaultForm&&editMode">
                                <p class="title items-center gap-2" style="width: 100%;">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        thumbs_up_down
                                    </mat-icon>
                                    <span style="flex: 1;">
                                        <simple-dynamic-form [layout]="2" [formValue]="patchValues"
                                            (submitLeadDetail)="saveNew($event)"
                                            [status]="firstFormGroup.value.LeadStatus" [formType]="'standard'"
                                            [type]="2" (submit)="onFormSubmitted($event)" [fields]="defaultConfig">
                                        </simple-dynamic-form>
                                    </span>
                                </p>
                            </div>

                            <div *ngIf="customField9 && !editMode">
                                <div *ngFor="let item of defaultConfig" class="flex items-center">
                                    <p class="title items-center gap-2">
                                        <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                            label_important
                                        </mat-icon>
                                        <span>
                                            <strong>{{item.name}}:</strong> {{patchValues[item.name]}}
                                        </span>
                                    </p>
                                    <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                        (click)="openEditPopupNew(item.name, item.name, item.type, item); $event.stopPropagation()">
                                        <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                    </button>
                                </div>
                            </div>

                            <!-- Secondary Phone -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.secondaryphoneno ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.secondaryphoneno ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.secondaryphoneno ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">call</mat-icon>

                                    <span>
                                        {{ LeadDetailsObject?.secondaryphoneno || '—' }}
                                    </span>
                                    <!-- Copy Icon -->
                                    <mat-icon *ngIf="LeadDetailsObject?.secondaryphoneno"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.secondaryphoneno ? copyToClipboard(LeadDetailsObject?.secondaryphoneno) : null">
                                        content_copy
                                    </mat-icon>
                                </p>

                                <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>

                        </div>
                    </div>

                    <div class="score-card">
                        <div class="score-header">
                            <span>Score</span>
                            <!-- <span class="customer-fit">
                                <span> Customer fit</span>
                                <span class="material-symbols-outlined info-icon">info</span>
                            </span> -->
                            <!-- <span class="material-symbols-outlined arrow-icon">chevron_right</span> -->
                        </div>
                        <div class="score-content">
                            <h3 class="score-value">{{ LeadDetailsObject?.score || 0.0 }}</h3>
                            <div class="stars">
                                <ng-container *ngFor="let star of starsArray; let i = index">
                                    <span class="material-symbols-outlined" [ngClass]="{ 'fill': i < filledStars }">
                                        star
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>


                <nav class="left-navigation">
                    <div class="nav-header">
                        <span>Contact information</span>
                        <!-- <button [attr.guide]="'lead-detail-btn-197' + '__' + sanitizedUrl" class="settings-btn">
                            <span class="material-symbols-outlined">settings</span>
                        </button> -->
                    </div>
                    <ul>
                        <li *ngFor="let tab of tabs" (click)="setActiveTab(tab.name)"
                            [class.active]="activeTab === tab.name">
                            <span class="material-symbols-outlined icon">{{ tab.icon }}</span>
                            <span class="tab-name">{{ tab.name }}</span>
                        </li>
                    </ul>
                </nav>

            </div>

            <div class="right-content-area" fxLayout="row" fxLayout.lt-sm="column" fxFlex="78" fxFlex.lt-md="100">
                <div [ngSwitch]="activeTab" class="dynamic-content" style="width: 100%;">
                    <div *ngSwitchCase="'Overview'" class="overview">
                        <!-- 
  This container holds the entire overview screen.
  It's structured with a main content area on the left and a notes section on the right.
  This layout stacks vertically on smaller screens for responsiveness.
-->
                        <div class="overview-cont">
                            <header class="overview-header">
                                <h1 class="title">Overview</h1>
                                <!-- <button [attr.guide]="'lead-detail-btn-198' + '__' + sanitizedUrl" class="customize-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    Customize overview
                                </button> -->

                                <mat-form-field>
                                    <input [attr.guide]="'lead-detail-inp-199' + '__' + sanitizedUrl" matInput
                                        placeholder="Search..." [(ngModel)]="globalSearchText"
                                        (keydown.enter)="onGlobalSearchChange(globalSearchText)"
                                        (keydown.backspace)="onGlobalSearchBackspace($event)" />
                                    <button [attr.guide]="'lead-detail-btn-clear-search' + '__' + sanitizedUrl"
                                        mat-icon-button matSuffix *ngIf="globalSearchText" aria-label="Clear search"
                                        (click)="resetSearch()"
                                        style="height:28px;width:28px;min-width:28px;padding:0;">
                                        <mat-icon style="font-size:16px;line-height:28px;">close</mat-icon>
                                    </button>
                                </mat-form-field>

                            </header>

                            <!-- Lifecycle and Status Pipeline Section -->
                            <section *ngIf="!isSearching" class="pipeline-section">

                                <div class="status-pipeline-wrapper">
                                    <label>Status</label>
                                    <div class="status-pipeline">
                                        <div *ngFor="let step of filtereddropdownTypeList; let i = index"
                                            class="strip-stage" [ngClass]="{
         'stage-current': step.statusName === LeadDetailsObject.statusName,
         'stage-completed': i <= currentStatusIndex,
         'last-stage': i === filtereddropdownTypeList.length - 1
       }" [attr.data-toggle]="'tooltip'" [attr.data-html]="'true'" [attr.data-container]="'body'"
                                            [attr.title]="generateTooltip(step)"
                                            (click)="updateLeadStatusNew($event,step)">
                                            <span>{{ step.statusName }}</span>
                                        </div>
                                    </div>



                                </div>
                            </section>
                        </div>


                        <div *ngIf="!isSearching" class="overview-container">

                            <!-- Main Content Section (Left) -->
                            <main class="main-content-two" fxFlex="55">
                                <!-- Header: Title and Customize Button -->

                                <!-- Summary Section (Collapsible) -->
                                <!-- <section class="summary-section" fxLayout="row">
                                    <div class="summary-header">
                                        <div class="summary-title">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                            <span>Summary</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="dropdown-icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </section> -->

                                <!-- Key Stakeholder Tag -->
                                <section class="tags-section">
                                    <div class="info-item">
                                        <label>Lifecycle stage</label>
                                        <div class="value-display">
                                            <span>{{ lifeCycleStage }}</span>
                                            <!-- <button [attr.guide]="'lead-detail-btn-200' + '__' + sanitizedUrl" (click)="openEditPopup('lifeCycleStage', 
                                            'Lifecycle stage', 'select')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button> -->
                                        </div>

                                    </div>
                                    <div style="cursor: pointer;" (click)="opentagName()" class="tag key-stakeholder"
                                        [style.background-color]="LeadDetailsObject?.tagNameColour">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                        </svg>
                                        {{LeadDetailsObject?.tagName || "No Tag"}}
                                    </div>
                                </section>

                                <!-- Contact Info Grid -->
                                <section class="info-grid">
                                    <div *ngIf="mapLink?.length>0" class="info-item">
                                        <label>Location</label>
                                        <div class="value-display">
                                            <a [attr.guide]="'lead-detail-lnk-201' + '__' + sanitizedUrl"
                                                (click)="navigatelink(mapLink)">{{ mapLink }}</a>
                                            <button [attr.guide]="'lead-detail-btn-202' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('mapLink', 'MapLink', 'text')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Company</label>
                                        <div class="value-display">
                                            <a [attr.guide]="'lead-detail-lnk-203' + '__' + sanitizedUrl"
                                                (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                            <button [attr.guide]="'lead-detail-btn-204' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('company', 'Company', 'text')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Email</label>
                                        <div class="value-display">
                                            <a class="small-email-text"
                                                [attr.guide]="'lead-detail-lnk-205' + '__' + sanitizedUrl"
                                                (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject.email
                                                }}</a>
                                            <button [attr.guide]="'lead-detail-btn-206' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('email', 'Email', 'text')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Mobile</label>
                                        <div class="value-display">
                                            <a [attr.guide]="'lead-detail-lnk-207' + '__' + sanitizedUrl"
                                                (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                LeadDetailsObject.phoneNumber
                                                }}</a>
                                            <button [attr.guide]="'lead-detail-btn-208' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Sales owner</label>
                                        <div class="value-display">
                                            <span class="value mobile-truncate-email"
                                                matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                LeadDetailsObject?.ownerIdName || '-' }}</span>
                                            <!-- <button [attr.guide]="'lead-detail-btn-209' + '__' + sanitizedUrl" (click)="transferLead()"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button> -->
                                            <button [attr.guide]="'lead-detail-btn-210' + '__' + sanitizedUrl"
                                                (click)="transferLead()" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Created at</label>
                                        <div class="value-display">
                                            <span>{{ LeadDetailsObject.createdDate | date:'MMM dd, yyyy, h:mm a'
                                                }}</span>
                                            <!-- <button [attr.guide]="'lead-detail-btn-211' + '__' + sanitizedUrl" (click)="openEditPopup('createdDate', 'Created Date', 'text')"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button> -->
                                        </div>

                                    </div>

                                    <div class="info-item">
                                        <label>Lead Source</label>
                                        <div class="value-display">
                                            <span>{{ LeadDetailsObject.sourceName || '-' }}</span>
                                            <button [attr.guide]="'lead-detail-btn-211' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('sourceName', 'Lead Source', 'select')"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                </section>

                                <a [attr.guide]="'lead-detail-lnk-212' + '__' + sanitizedUrl"
                                    (click)="showToContactDetials()" class="show-all-link">
                                    Show all
                                    <svg xmlns="http://www.w3.org/2000/svg" class="dropdown-icon" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </a>

                                <!-- Action Cards Section -->
                                <section class="action-cards-section">
                                    <div class="action-card">
                                        <div class="card-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.826-2.616-.826-3.723 0l-.17.127c-.89.67-2.178.67-3.067 0C2.36 11.41.966 11.41.1 12.284c-.866.866-.866 2.267 0 3.133l.17.127c.89.67 2.178.67 3.067 0l.659-.494m8.243-4.553c.428-.32.954-.32 1.382 0l.17.127c.89.67 2.178.67 3.067 0C21.64 13.37 23.034 13.37 23.9 14.24c.866.866.866 2.267 0 3.133l-.17.127c-.89.67-2.178.67-3.067 0l-.659-.494" />
                                            </svg>
                                        </div>
                                        <div class="card-content">
                                            <p *ngIf="noOfDeals > 0">
                                                {{ noOfDeals }} deal(s) associated with {{
                                                (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }}.
                                            </p>
                                            <p *ngIf="noOfDeals === 0">
                                                No open deals associated with {{ (LeadDetailsObject?.name?.indexOf(' ')
                                                === -1 && LeadDetailsObject?.name?.length > 20) ?
                                                (LeadDetailsObject?.name | slice:0:20) + '...' : LeadDetailsObject?.name
                                                }}.
                                            </p>

                                            <div class="card-links" *ngIf="noOfDeals === 0">
                                                <a [attr.guide]="'lead-detail-lnk-213' + '__' + sanitizedUrl"
                                                    (click)="goToDeals()" class="action-link">
                                                    Add deal
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <!-- Meetings -->
                                    <div class="action-card">
                                        <div class="card-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div class="card-content">
                                            <p *ngIf="noOfMeetings > 0">
                                                {{ noOfMeetings }} upcoming meeting(s) with {{
                                                (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }}.
                                            </p>
                                            <p *ngIf="noOfMeetings === 0">
                                                No upcoming meetings with {{ (LeadDetailsObject?.name?.indexOf(' ') ===
                                                -1 && LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }}.
                                            </p>

                                            <div class="card-links" *ngIf="noOfMeetings === 0">
                                                <a [attr.guide]="'lead-detail-lnk-214' + '__' + sanitizedUrl"
                                                    (click)="addMeeting()" class="action-link">Add meeting</a>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- MailBox -->
                                    <div class="action-card">
                                        <div class="card-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div class="card-content">
                                            <p>
                                                {{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }} hasn't been contacted
                                                yet.
                                            </p>
                                            <div class="card-links">
                                                <a [attr.guide]="'lead-detail-lnk-215' + '__' + sanitizedUrl"
                                                    (click)="openEmailPopup()" class="action-link">Click here to send
                                                    mail</a>
                                            </div>
                                        </div>
                                    </div>

                                </section>

                            </main>

                            <!-- Notes Section (Right) -->
                            <div class="notes-container" fxFlex="40">
                                <aside class="add-note-section notes-section">
                                    <div (click)="createNote(null, 0)">
                                        <span>Add a Note...</span>
                                    </div>
                                </aside>

                                <main class="notes-list" *ngIf="noteList.length > 0; else noNotes">
                                    <div *ngFor="let note of noteList" class="note-item">
                                        <div class="note-content"
                                            [class.truncated]="note.notes.length > 250 && !isExpanded(note.noteId)"
                                            [innerHTML]="note.notes | mentionHighlight">
                                        </div>

                                        <a *ngIf="note.notes.length > 250" (click)="toggleShowMore(note.noteId)"
                                            class="show-more-link">
                                            {{ isExpanded(note.noteId) ? 'Show less' : 'Show more' }}
                                        </a>


                                        <div class="padding-10" *ngIf="note.documentType == 1">
                                            <video [style.height]="'150px'" [style.width]="'75%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </video>
                                        </div>
                                        <div class="padding-10" *ngIf="note.documentType == 2">
                                            <audio [style.width]="'25%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </audio>
                                        </div>


                                        <div class="padding-10" *ngIf="note.documentType==3">
                                            <div fxLayout="column">

                                                <div fxLayout="row">
                                                    <span fxLayoutAlign="start center">
                                                        Pdf : {{note.notesDocument}}
                                                    </span>

                                                    <button [attr.guide]="'lead-detail-btn-216' + '__' + sanitizedUrl"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid, note.documentType)"
                                                        color="warn" mat-icon-button type="button">
                                                        <mat-icon>download

                                                        </mat-icon>

                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==4">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <calsoft-common-images [src]="serverPathNotes + note.notesDocument"
                                                        [height]="'50%'" [width]="'25%'" [alt]="">

                                                    </calsoft-common-images>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==5">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <img *ngIf="note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                        src="assets/images/docx.png" width="36" height="36"
                                                        alt="DOCX File">

                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==6">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <img *ngIf="note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                        src="assets/images/excel.png" width="36" height="36"
                                                        alt="Excel File">

                                                </div>
                                            </div>
                                        </div>

                                        <div class="note-meta">
                                            <mat-icon class="edit-icon" (click)="createNote(note, note.noteId)"
                                                style="height: auto;">edit_square</mat-icon>
                                            <span>
                                                {{ note.createdBy == null ? LeadDetailsObject?.ownerEmail :
                                                note.createdBy }}
                                            </span>
                                            <span class="dot">•</span>
                                            <span>{{ note.createdDate | date:'mediumDate' }}</span>
                                        </div>
                                    </div>
                                </main>

                                <ng-template #noNotes>
                                    <div class="empty-state-two">
                                        <mat-icon>note_add</mat-icon>
                                        <p>No notes yet.</p>
                                        <span>Add a note to get started.</span>
                                    </div>
                                </ng-template>

                            </div>

                        </div>

                        <div *ngIf="isSearching">

                            <calsoft-views [searchText]="globalSearchText" [leadPropertiesName]="leadPropertiesName"
                                [leadPropertiesDisplay]="leadPropertiesDisplay" [LeadDetailsObject]="LeadDetailsObject"
                                [leadAdditionalPropertiesDisplay]="leadAdditionalPropertiesDisplay"
                                [leadAdditionalPropertiesName]="leadAdditionalPropertiesName" [valuesList]="filterList"
                                [additionalSpec]="additionalSpec"
                                [leadCommonPropertiesDisplay]="leadCommonPropertiesDisplay" [usedInSite]="usedInSite"
                                [type3]="type3" [leadCommonPropertiesName]="leadCommonPropertiesName"
                                [activeViewNew]="activeViewNew"></calsoft-views>
                        </div>


                    </div>

                    <div *ngSwitchCase="'Contact details'">
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>Contact details</h2>
                                <!-- <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-217' + '__' + sanitizedUrl" class="btn-secondary">View field edit history</button>
                                    <button [attr.guide]="'lead-detail-btn-218' + '__' + sanitizedUrl" class="btn-secondary">Manage fields</button>
                                </div> -->
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-219' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'all'" (click)="setView('all')">All
                                    details</button>
                                <button [attr.guide]="'lead-detail-btn-220' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'basic'" (click)="setView('basic')">Basic
                                    information</button>
                            </div>
                            <!--
                            <div class="details-toolbar">
                                <div class="search-bar">
                                    <i class="icon-search"></i>
                                    <input [attr.guide]="'lead-detail-inp-221' + '__' + sanitizedUrl" type="text" placeholder="Search fields" />
                                </div>
                                 <div class="toggle-switch">
                                    <span>Show empty fields</span>
                                    <label class="switch">
                                        <input [attr.guide]="'lead-detail-inp-222' + '__' + sanitizedUrl" type="checkbox" checked />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
 -->
                            <div class="details-content" [class.basic-view]="activeViewNew === 'basic'">
                                <div *ngIf="activeView === 'all'">
                                    <!-- <div class="all-details-tags">
                                        <span class="label">Tags</span>
                                        <span class="tag">{{ contact.tags[0] }}</span>
                                    </div> -->

                                    <div class="content-section">
                                        <button [attr.guide]="'lead-detail-btn-223' + '__' + sanitizedUrl"
                                            class="section-toggle" (click)="toggleBasicInfo()">
                                            <i class="icon-chevron" [class.rotated]="isBasicInfoOpen"></i>
                                            <h3>Basic information</h3>
                                        </button>
                                        <div class="section-body" *ngIf="isBasicInfoOpen">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Email</span><a class="value link">{{ LeadDetailsObject?.email }}</a></div> -->
                                                <div class="info-item">
                                                    <label
                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">Email</label>
                                                    <div class="value-display">
                                                        <a class="small-email-text"
                                                            [attr.guide]="'lead-detail-lnk-224' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-225' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Name</span><span
                                                        class="value">{{LeadDetailsObject?.name }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Name</label>
                                                    <div class="value-display">
                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                            LeadDetailsObject?.name?.length > 20) ?
                                                            (LeadDetailsObject?.name | slice:0:20) + '...' :
                                                            LeadDetailsObject?.name }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-226' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Last name</span><span
                                                        class="value">{{ contact.lastName }}</span></div> -->
                                                <!-- <div class="field-item"><span class="label">Account</span><a class="value link">{{ LeadDetailsObject?.company }}</a></div> -->
                                                <div class="info-item">
                                                    <label>Company</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-227' + '__' + sanitizedUrl"
                                                            (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-228' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Job title</span><span
                                                        class="value">{{ LeadDetailsObject?.jobtitle }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Job title</label>
                                                    <div class="value-display">
                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-229' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Telephone numbers</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Mobile</span><span
                                                        class="value">{{ LeadDetailsObject?.phoneNumber }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Mobile</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-230' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject.phoneNumber
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-231' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Work phone</span><span
                                                        class="value">{{ LeadDetailsObject?.secondaryphoneno
                                                        }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Work phone</label>
                                                    <div class="value-display">
                                                        <a href="tel:{{LeadDetailsObject?.secondaryphoneno}}">{{
                                                            LeadDetailsObject.secondaryphoneno
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-232' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Sales owner</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Sales owner</span><span
                                                        class="value">{{ LeadDetailsObject?.ownerIdName?.split('@')[0] |
                                                        titlecase }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <span class="value mobile-truncate-email"
                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                            LeadDetailsObject?.ownerIdName || '-' }}</span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-233' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <button [attr.guide]="'lead-detail-btn-234' + '__' + sanitizedUrl"
                                            class="section-toggle" (click)="toggleMoreFields()">
                                            <i class="icon-chevron" [class.rotated]="isMoreFieldsOpen"></i>
                                            <h3>More fields</h3>
                                        </button>
                                        <div class="section-body" *ngIf="isMoreFieldsOpen">

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Location</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item" style="grid-column: span 4;"><span
                                                                class="label">Address</span><span class="value">{{
                                                                LeadDetailsObject?.additionalSpec?.Address }}</span>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>Address</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.additionalSpec?.Address}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-235' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('Address', 'Address', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">City</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.City }}</span>
                                                        </div> -->
                                                        <div class="info-item"
                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.State">
                                                            <label>City</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.City}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-236' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('City', 'City', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">State</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.State }}</span>
                                                        </div> -->
                                                        <div class="info-item"
                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.Country">
                                                            <label>State</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.State }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-237' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('State', 'State', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Country</span><span
                                                                class="value">{{ LeadDetailsObject?.country }}</span>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>Country</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.Country}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-238' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('Country', 'Country', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Zipcode</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.pincode }}</span>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>Zipcode</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.zipCode}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-239' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('pincode', 'Pincode', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Lifecycle stage</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item"><span class="label">Lifecycle
                                                                stage</span><span class="value strong">{{
                                                                contact.lifecycleStage }}</span></div> -->
                                                        <!-- <div class="field-item"><span class="label">Status</span><span
                                                                class="value strong">{{ LeadDetailsObject.statusName
                                                                }}</span></div> -->

                                                        <div class="info-item">
                                                            <label>Status</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject.statusName}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-240' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('statusName', 'Status Name', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>

                                                        <div class="info-item">
                                                            <label>Lost reason</label>
                                                            <div class="value-display">
                                                                <a
                                                                    *ngIf="LeadDetailsObject?.lostReason; else addReason">{{
                                                                    LeadDetailsObject.lostReason
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-241' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('lostReason', 'Lost Reason', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>

                                                                <ng-template #addReason>
                                                                    <span style="color: rgb(93, 93, 207);"
                                                                        class="value placeholder"
                                                                        (click)="lostReason()">
                                                                        Click to add
                                                                    </span>
                                                                </ng-template>
                                                            </div>

                                                        </div>

                                                        <!-- <div class="field-item">
                                                            <span class="label">Lost reason</span>

                                                           
                                                            <span class="value"
                                                                *ngIf="LeadDetailsObject?.lostReason; else addReason">
                                                                {{ LeadDetailsObject.lostReason }}
                                                            </span>

                                                            <ng-template #addReason>
                                                                <span style="color: rgb(93, 93, 207);"
                                                                    class="value placeholder" (click)="lostReason()">
                                                                    Click to add
                                                                </span>
                                                            </ng-template>
                                                        </div> -->

                                                        <!-- <div class="field-item"><span class="label">Subscription
                                                                status</span><span class="value strong">{{
                                                                contact.subscriptionStatus }}</span></div> -->
                                                        <!-- <div class="field-item" style="grid-column: span 2;"><span
                                                                class="label">Subscription types</span><span
                                                                class="value">{{ contact.subscriptionTypes }}</span>
                                                        </div> -->
                                                        <!-- <div class="field-item"><span class="label">Unsubscribe
                                                                reason</span><span class="value placeholder">Click to
                                                                add</span></div>
                                                        <div class="field-item"><span class="label">Other unsubscribe
                                                                reasons</span><span class="value placeholder">Click to
                                                                add</span></div> -->
                                                        <!-- <div class="field-item"><span class="label">Customer fit</span>
                                                            <div class="stars">
                                                                <ng-container
                                                                    *ngFor="let star of starsArray; let i = index">
                                                                    <span class="material-symbols-outlined"
                                                                        [ngClass]="{ 'fill': i < filledStars }">
                                                                        star
                                                                    </span>
                                                                </ng-container>
                                                            </div>
                                                        </div> -->
                                                        <!-- <div class="field-item"><span class="label">Score</span><span
                                                                class="value strong">{{ LeadDetailsObject.score
                                                                }}</span>
                                                        </div> -->

                                                        <div class="info-item">
                                                            <label>Score</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.score}}</a>

                                                            </div>

                                                        </div>

                                                        <!-- <div class="field-item"><span
                                                                class="label">Territory</span><span
                                                                class="value placeholder">Click to add</span></div> -->
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Social profiles</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item"><span class="label">LinkedIn</span><a class="value link">{{ LeadDetailsObject.linkedIn }}</a>
                                                        </div>
                                                        <div class="field-item"><span class="label">Twitter</span><a class="value link">{{ LeadDetailsObject.twitter }}</a>
                                                        </div>
                                                        <div class="field-item"><span class="label">Facebook</span><a class="value link">{{ LeadDetailsObject.facebook }}</a>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>LinkedIn</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.linkedIn}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-242' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('linkedIn', 'LinkedIn', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Twitter</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.twitter}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-243' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('twitter', 'Twitter', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Facebook</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.facebook}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-244' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('facebook', 'Facebook', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="activeView === 'basic'">

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h3>Basic information</h3>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Email</span><a class="value link">{{ LeadDetailsObject?.email }}</a></div>
                                                <div class="field-item"><span class="label">Name</span><span
                                                        class="value">{{LeadDetailsObject?.name }}</span></div>
                                                <div class="field-item"><span class="label">Account</span><a class="value link">{{ LeadDetailsObject?.company }}</a></div>
                                                <div class="field-item"><span class="label">Job title</span><span
                                                        class="value">{{ LeadDetailsObject?.jobtitle }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Email</label>
                                                    <div class="value-display">
                                                        <a class="small-email-text"
                                                            [attr.guide]="'lead-detail-lnk-245' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-246' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Name</label>
                                                    <div class="value-display">
                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                            LeadDetailsObject?.name?.length > 20) ?
                                                            (LeadDetailsObject?.name | slice:0:20) + '...' :
                                                            LeadDetailsObject?.name }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-247' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Company</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-248' + '__' + sanitizedUrl"
                                                            (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-249' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Job title</label>
                                                    <div class="value-display">
                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-250' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Telephone numbers</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Mobile</span><span
                                                        class="value">{{ LeadDetailsObject?.phoneNumber }}</span></div>
                                                <div class="field-item"><span class="label">Work phone</span><span
                                                        class="value">{{ LeadDetailsObject?.secondaryphoneno}}</span>
                                                </div> -->
                                                <div class="info-item">
                                                    <label>Mobile</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-251' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject.phoneNumber
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-252' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Work phone</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-253' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.secondaryphoneno ? phoneNumbercallSecondary(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject.secondaryphoneno
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-254' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Sales owner</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Sales owner</span><span
                                                        class="value">{{ LeadDetailsObject?.ownerIdName?.split('@')[0] |
                                                        titlecase }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <span class="value mobile-truncate-email"
                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                            LeadDetailsObject?.ownerIdName || '-' }}</span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-255' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'My Views'">
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>My Views</h2>
                                <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-256' + '__' + sanitizedUrl"
                                        (click)="manageFields()" class="btn-secondary">Manage fields</button>
                                </div>
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-257' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'basic'" (click)="setViewNew('basic')">Lead
                                    information</button>
                                <button [attr.guide]="'lead-detail-btn-258' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'Original'" (click)="setViewNew('Original')">
                                    Original Lead Format</button>

                            </div>

                            <div class="details-content">
                                <div *ngIf="activeViewNew === 'Original'">

                                    <div class="content-section">

                                        <ng-container
                                            *ngIf="jsonRecieved && (jsonRecieved | keyvalue).length > 0; else noRecord">
                                            <div>
                                                <table id="details">
                                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                                        <td>
                                                            {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key
                                                            }}
                                                        </td>
                                                        <td>
                                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                class="blackColor wordBreak" [innerHTML]="item.value">
                                                            </p>

                                                            <p *ngIf="item.key=='Lead Status'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                            <p *ngIf="item.key=='Lead Source'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #noRecord>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>

                                    </div>

                                </div>

                                <div *ngIf="activeViewNew === 'basic'">

                                    <div class="content-section" *ngIf="manageFieldCustomization == 0">

                                        <ng-container>
                                            <div>

                                                <table
                                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadCommonPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>
                                                    <ng-container *ngIf="!type3">

                                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                                            </td>
                                                        </tr>

                                                    </ng-container>
                                                    <ng-container *ngIf="type3">

                                                        <tr *ngFor="let item of customList ">


                                                            <td>
                                                                {{item[0]}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source'
                                                                 && item[0]!='Lead_Source' &&item[0]!='Lead_Status' && item[0]!='Lead Source' && item[0]!='Category' && item[0]!='Product'"
                                                                    class="blackColor wordBreak" [innerHTML]="item[1]">
                                                                </p>


                                                                <p *ngIf="item[0]=='Lead Status' || item[0]=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item[0]=='Lead Source' || item[0]=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item[0]=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item[0]=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>
                                                </table>


                                                <table
                                                    *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>


                                                    <ng-container *ngIf="!type2">

                                                        <tr *ngFor="let item of valuesList | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>

                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>

                                                        </tr>

                                                    </ng-container>
                                                    <ng-container *ngIf="type2">

                                                        <tr *ngFor="let item of filterList | keyvalue">


                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>

                                                </table>

                                                <!-- spacing between consecutive tables is handled by CSS; removed <br> -->

                                                <table
                                                    *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadAdditionalPropertiesName || 'Lead Additional
                                                            Information'}}
                                                        </th>
                                                    </tr>


                                                    <ng-container *ngIf="!type1">

                                                        <tr *ngFor="let item of additionalSpec | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>

                                                    <ng-container *ngIf="type1">


                                                        <tr *ngFor="let item of additionalSpecList">
                                                            <td>{{ item[0] }}</td>
                                                            <td>

                                                                <ng-container [ngSwitch]="item[0]">

                                                                    <p *ngSwitchCase="'Lead Status'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.statusName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead_Status'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.statusName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead Source'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.sourceName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead_Source'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.sourceName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Category'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.category }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Product'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.product }}
                                                                    </p>

                                                                    <p *ngSwitchDefault class="blackColor wordBreak">
                                                                        {{ item[1] }}
                                                                    </p>

                                                                </ng-container>

                                                            </td>
                                                        </tr>


                                                    </ng-container>


                                                </table>

                                            </div>
                                        </ng-container>
                                        <ng-template #noRecord>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>

                                    </div>

                                    <div class="content-section" *ngIf="manageFieldCustomization == 1">



                                        <ng-container *ngIf="mappedGroups?.length > 0; else noData">

                                            <div class="content-section" *ngFor="let group of mappedGroups">
                                                <div class="section-header">
                                                    <h3>{{ group.groupName }}</h3>
                                                </div>

                                                <div class="section-body">
                                                    <div class="details-grid-4col">

                                                        <div class="info-item" *ngFor="let field of group.fields">

                                                            <label>{{ field.fieldName }}</label>

                                                            <div class="value-display">
                                                                <ng-container [ngSwitch]="field.fieldKey">

                                                                    <a [attr.guide]="'lead-detail-lnk-259' + '__' + sanitizedUrl"
                                                                        *ngSwitchCase="'Email'"
                                                                        (click)="field.value !== '-' ? openEmailPopup() : null">
                                                                        {{ field.value }}
                                                                    </a>

                                                                    <span *ngSwitchDefault>
                                                                        {{ field.value }}
                                                                    </span>

                                                                </ng-container>

                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-260' + '__' + sanitizedUrl"
                                                                    *ngIf="!field.isReadOnly"
                                                                    (click)="openEditPopupNew(field.fieldKey, field.fieldName, field.fieldType, field)"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </ng-container>

                                        <ng-template #noData>
                                            <div fxLayoutAlign="center center" class="text-center text-muted py-4">
                                                No data available
                                            </div>
                                        </ng-template>



                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div *ngSwitchCase="'Conversations'">
                        <div class="card">
                            <div *ngIf="leadLoaded">
                                <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                    [isFromPhone]="true"></calsoft-whatsapp-chat-details>
                            </div>
                        </div>

                    </div> -->


                    <div *ngSwitchCase="'Activities'" class="activities-new-type">
                        <div class="activity-container">

                            <div class="tabs">
                                <!-- Desktop / wide screens: horizontal tabs -->
                                <ul class="tabs-list">
                                    <li [ngClass]="{'active': activeTabInner === 'activity'}"
                                        (click)="selectTabInner('activity')">Activity timeline</li>
                                    <li [ngClass]="{'active': activeTabInner === 'notes'}"
                                        (click)="selectTabInner('notes')">Notes</li>
                                    <li [ngClass]="{'active': activeTabInner === 'tasks'}"
                                        (click)="selectTabInner('tasks')">Tasks</li>
                                    <li [ngClass]="{'active': activeTabInner === 'meetings'}"
                                        (click)="selectTabInner('meetings')">Meetings</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Chats'}"
                                        (click)="selectTabInner('Chats')">Chats</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Email Sent'}"
                                        (click)="selectTabInner('Email Sent')">Email</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Calls'}"
                                        (click)="selectTabInner('Calls')">Calls</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Email Status'}"
                                        (click)="selectTabInner('Email Status')">Email Status</li>
                                </ul>

                                <!-- Mobile / narrow screens: compact native select -->
                                <div class="tabs-select" role="presentation">
                                    <select [attr.guide]="'lead-detail-sel-select-activity-tab' + '__' + sanitizedUrl"
                                        aria-label="Select activity tab" class="tabs-select"
                                        (change)="selectTabInner($event.target.value)">
                                        <option value="activity" [selected]="activeTabInner === 'activity'">
                                            Activity timeline</option>
                                        <option value="notes" [selected]="activeTabInner === 'notes'">Notes
                                        </option>
                                        <option value="tasks" [selected]="activeTabInner === 'tasks'">Tasks
                                        </option>
                                        <option value="meetings" [selected]="activeTabInner === 'meetings'">
                                            Meetings</option>
                                        <option value="Chats" [selected]="activeTabInner === 'Chats'">Chats
                                        </option>
                                        <option value="Email Sent" [selected]="activeTabInner === 'Email Sent'">Email
                                        </option>
                                        <option value="Calls" [selected]="activeTabInner === 'Calls'">Calls
                                        </option>
                                        <option value="Email Status" [selected]="activeTabInner === 'Email Status'">
                                            Email Status
                                        </option>
                                    </select>
                                </div>

                                <!-- <button [attr.guide]="'lead-detail-btn-261' + '__' + sanitizedUrl" class="create-custom-activity-btn">+ Create custom sales activity</button> -->
                            </div>
                            <!-- <div class="filters">
                                    <span>Filter by:</span>
                                    <button [attr.guide]="'lead-detail-btn-262' + '__' + sanitizedUrl" class="filter-btn">All activities ▼</button>
                                    <button [attr.guide]="'lead-detail-btn-263' + '__' + sanitizedUrl" class="filter-btn">All time periods ▼</button>
                                </div> -->


                            <div *ngIf="activeTabInner === 'activity'" style="overflow-x: auto;">
                                <div *ngIf="activityHistoryType == 0" class="timeline">
                                    <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                                        [groupedActivities]="groupedActivities"
                                        (scrollChange)="onScrollNew()"></calsoft-activity-new>
                                </div>
                                <ng-container *ngIf="activityHistoryType == 1">



                                    <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                        [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                                        [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                        [leadActivityList]="leadActivityList">
                                    </calsoft-activity>
                                </ng-container>

                            </div>



                            <div *ngIf="activeTabInner === 'notes'" class="notes-view-container">

                                <div class="notes-header">
                                    <h2>Notes</h2>
                                    <button [attr.guide]="'lead-detail-btn-264' + '__' + sanitizedUrl"
                                        class="add-note-btn" (click)="createNote(null, 0)">
                                        <span class="material-icons-outlined">add</span>
                                        Add note
                                    </button>
                                </div>

                                <div *ngIf="noteList && noteList.length > 0; else emptyState" class="notes-list">
                                    <div *ngFor="let note of noteList" class="note-card">

                                        <div class="note-content" [innerHTML]="note.notes | mentionHighlight"></div>

                                        <div class="padding-10" *ngIf="note.documentType == 1">
                                            <video [style.height]="'150px'" [style.width]="'75%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </video>
                                        </div>
                                        <div class="padding-10" *ngIf="note.documentType == 2">
                                            <audio [style.width]="'25%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </audio>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==3">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <span fxLayoutAlign="start center">
                                                        Pdf : {{note.notesDocument}}
                                                    </span>
                                                    <button [attr.guide]="'lead-detail-btn-216' + '__' + sanitizedUrl"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid, note.documentType)"
                                                        color="warn" mat-icon-button type="button">
                                                        <mat-icon>download</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==4">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <calsoft-common-images [src]="serverPathNotes + note.notesDocument"
                                                        [height]="'50%'" [width]="'25%'" [alt]="">
                                                    </calsoft-common-images>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==5">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <img *ngIf="note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                        src="assets/images/docx.png" width="36" height="36"
                                                        alt="DOCX File">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==6">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <img *ngIf="note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                        src="assets/images/excel.png" width="36" height="36"
                                                        alt="Excel File">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="note-meta">
                                            <span *ngIf="!note.documentType || note.documentType == 0"
                                                class="material-icons-outlined edit-icon"
                                                (click)="createNote(note, note.noteId)">edit</span>
                                            <span *ngIf="note.noteType !== 'REPLY'" class="material-icons-outlined"
                                                style="cursor:pointer;color:#555;margin-left:4px;"
                                                (click)="toggleReply(note.noteId)" title="Reply">reply</span>
                                            <span class="author">{{ note.createdBy }}</span>
                                            <span class="dot">•</span>
                                            <span class="timestamp">{{ getRelativeTimenew(note.createdDate)
                                                }}</span>
                                        </div>
                                        <div *ngIf="replyingToNoteId === note.noteId"
                                            style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;margin-top:8px;">
                                            <mat-icon
                                                style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                            <mat-form-field appearance="outline" style="flex:1">
                                                <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                <textarea matInput rows="2" [(ngModel)]="replyText"
                                                    placeholder="Write a reply..."></textarea>
                                            </mat-form-field>
                                            <button mat-raised-button color="primary" style="margin-top:6px"
                                                [disabled]="!replyText?.trim()"
                                                (click)="submitReply(note)">Send</button>
                                            <button mat-icon-button style="margin-top:4px"
                                                (click)="toggleReply(null)"><mat-icon>close</mat-icon></button>
                                        </div>
                                    </div>
                                </div>

                                <ng-template #emptyState>
                                    <div class="empty-notes">
                                        <span class="material-icons-outlined empty-icon">description</span>
                                        <p>Use notes to capture talking points, action items, and ideas.</p>
                                        <button [attr.guide]="'lead-detail-btn-265' + '__' + sanitizedUrl"
                                            class="add-note-btn empty-bg-color" (click)="createNote(null, 0)">Add
                                            note</button>
                                    </div>
                                </ng-template>
                            </div>
                            <div *ngIf="activeTabInner === 'tasks'" class="tasks-view-container">

                                <div class="tasks-header">
                                    <div class="task-filters">
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'all'"
                                            (click)="setTaskFilter('all')">
                                            <span>All</span>
                                            <span class="count">{{ totalActivity }}</span>
                                        </div>
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'upcoming'"
                                            (click)="setTaskFilter('upcoming')">
                                            <span>Upcoming</span>
                                            <span class="count">{{totalActivityUpComing }}</span>
                                        </div>
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'overdue'"
                                            (click)="setTaskFilter('overdue')">
                                            <span>Overdue</span>
                                            <span class="count overdue-count">{{totalActivityDue }}</span>
                                        </div>
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'completed'"
                                            (click)="setTaskFilter('completed')">
                                            <span>Completed</span>
                                            <span class="count">{{ totalActivityCompleted }}</span>
                                        </div>
                                    </div>
                                    <div class="task-actions">

                                        <button [attr.guide]="'lead-detail-btn-266' + '__' + sanitizedUrl"
                                            class="add-task-btn" [matMenuTriggerFor]="menu">
                                            <span class="material-icons-outlined">add</span>
                                            Add task
                                        </button>

                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-267' + '__' + sanitizedUrl"
                                                *ngIf="crmType != 2" mat-menu-item
                                                (click)="addLeadActivity('Follow Up', 0, null)">
                                                Follow Up
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-268' + '__' + sanitizedUrl"
                                                mat-menu-item (click)="addLeadActivity('Phone Call', 0, null)">
                                                Phone Call
                                            </button>
                                            <button [attr.guide]="'pipeline-btn-94' + '__' + sanitizedUrl" mat-menu-item
                                                (click)="addSiteVisitPopup()">Site
                                                visit</button>
                                            <button [attr.guide]="'lead-detail-btn-269' + '__' + sanitizedUrl"
                                                *ngIf="enableLocation == '1'" mat-menu-item
                                                (click)="addLeadActivityone('Location', 0, null)">
                                                Location
                                            </button>
                                        </mat-menu>

                                    </div>
                                </div>

                                <div *ngIf="activeTaskFilter === 'all'">
                                    <calsoft-task-new (scrollChange)="onScroll()" (taskUpdated)="onTaskUpdated()"
                                        [type]="1" [onScrollValue]="onScrollValue" [taskType]="taskType"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [leadActivityListFinal]="leadActivityListFinalTasks" [totalSize]="totalSize-1"
                                        [page]="pagetwo" [total]="total" [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListTasks"></calsoft-task-new>
                                </div>


                                <div *ngIf="activeTaskFilter === 'upcoming'">
                                    <calsoft-task-new (scrollChange)="onScrollUpcoming()"
                                        (taskUpdated)="onTaskUpdated()" [type]="1"
                                        [onScrollValue]="onScrollValueUpcoming" [taskType]="taskType"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [leadActivityListFinal]="leadActivityListFinalUpcoming"
                                        [totalSize]="totalSizeUpcoming-1" [page]="pagetwoUpcoming"
                                        [total]="totalUpcoming" [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListUpcoming"></calsoft-task-new>
                                </div>


                                <div *ngIf="activeTaskFilter === 'overdue'">
                                    <calsoft-task-new (scrollChange)="onScrollUpDue()" (taskUpdated)="onTaskUpdated()"
                                        [type]="1" [onScrollValue]="onScrollValue" [taskType]="taskType"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [totalSize]="totalSizeDue-1" [page]="pagetwoDue"
                                        [leadActivityListFinal]="leadActivityListDueFinal" [total]="totalDue"
                                        [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListDue"></calsoft-task-new>
                                </div>


                                <div *ngIf="activeTaskFilter === 'completed'">
                                    <calsoft-task-new (scrollChange)="onScrollUpCompleted()"
                                        (taskUpdated)="onTaskUpdated()" [type]="1" [onScrollValue]="onScrollValue"
                                        [taskType]="taskType" [totalSize]="totalSizeDue-1" [page]="pagetwoCompleted"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [leadActivityListFinal]="leadActivityListFinalCompleted"
                                        [total]="totalSizeCompleted" [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListCompleted"></calsoft-task-new>
                                </div>

                            </div>


                            <div *ngIf="activeTabInner === 'meetings'">
                                <div class="width-table">
                                    <calsoft-leadsmeeting [leadId]="leadId" [googleCalendarList]="googleCalendarList"
                                        [meetingType]="1" [type]="1" class="width-table">
                                    </calsoft-leadsmeeting>
                                </div>
                            </div>



                            <div *ngIf="activeTabInner === 'Chats'">
                                <div *ngIf="leadLoaded && whatAppchatType === 1">
                                    <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                        [isFromPhone]="true">
                                    </calsoft-whatsapp-chat-details>
                                </div>
                                <div *ngIf="leadLoaded && whatAppchatType === 2">
                                    <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                                    </calsoft-whats-app-new-client>
                                </div>
                            </div>

                            <div *ngIf="activeTabInner === 'Email Sent'">
                                <div class="mailbox-container">

                                    <div class="mailbox-toggle-container">
                                        <mat-button-toggle-group [(value)]="currentMailBox"
                                            (change)="loadEmails($event)">
                                            <mat-button-toggle (click)="loadEmails({ value: 'INBOX' })"
                                                value="INBOX">Inbox
                                            </mat-button-toggle>
                                            <mat-button-toggle (click)="loadEmails({ value: 'Sent' })" value="Sent">Sent
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>


                                    <div class="mailbox-content">

                                        <div class="mailbox-email-list" [class.full-width]="!selectedIndex">
                                            <ng-container *ngIf="isLoading; else emailListTemplate">
                                                <div class="loading-spinner">
                                                    <mat-spinner diameter="40"></mat-spinner>
                                                    <p>Loading emails...</p>
                                                </div>
                                            </ng-container>
                                            <ng-template #emailListTemplate>
                                                <mat-paginator [length]="totalEmails" [pageSize]="pageSizeEmail"
                                                    [pageIndex]="pageIndex" (page)="onPageChange($event)">
                                                </mat-paginator>

                                                <mat-nav-list>
                                                    <mat-list-item *ngFor="let email of emails; let i = index"
                                                        [ngClass]="{
                                                    'mailbox-email-list-item': true,
                                                    'active': i === selectedIndex
                                                    }" (click)="selectEmail(i)">
                                                        <div class="mailbox-email-list-item">
                                                            <div class="mailbox-email-header">
                                                                <span class="mailbox-email-subject">{{
                                                                    email.subject }}</span>
                                                                <span class="mailbox-email-date">{{
                                                                    email.sentDate |
                                                                    date:'medium'
                                                                    }}</span>
                                                            </div>
                                                            <div class="mailbox-email-preview">
                                                                <span class="mailbox-email-from-to">
                                                                    {{ currentMailBox === 'INBOX' ?
                                                                    extractEmailAddress(email.from)
                                                                    : email.to }}
                                                                </span>
                                                                <span class="mailbox-email-body-preview">
                                                                    {{ truncateSafeHTML(email.body, 150) }}
                                                                </span>


                                                            </div>
                                                        </div>
                                                    </mat-list-item>
                                                </mat-nav-list>
                                            </ng-template>

                                        </div>



                                        <div *ngIf="emailVisble; else placeholder" class="mailbox-email-wrapper">

                                            <div class="mailbox-email-detail"
                                                [ngClass]="{ 'show-detail': isMobileView }">
                                                <button [attr.guide]="'lead-detail-btn-270' + '__' + sanitizedUrl"
                                                    class="back-button" *ngIf="isMobileView" (click)="backToList()">
                                                    ← Back
                                                </button>
                                                <div class="mailbox-email-detail-header">
                                                    <h2>{{ emailObject.subject }}</h2>
                                                    <div class="mailbox-email-meta">
                                                        <!-- <div><strong>From:</strong> {{ emailObject.from[0].address }}
                                                </div> -->
                                                        <div><strong>To:</strong> {{ emailObject.to }}</div>
                                                        <div><strong>Date:</strong> {{ emailObject.sentDate
                                                            |
                                                            date:'medium' }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mailbox-email-body" [innerHTML]="emailObject.body">
                                                </div>
                                                <div class="mailbox-email-attachments"
                                                    *ngIf="emails[selectedIndex]?.attachments?.length > 0">
                                                    <h4>Attachments</h4>
                                                    <ul>
                                                        <li *ngFor="let file of emails[selectedIndex].attachments">
                                                            <div *ngIf="isImage(file.contentType)">

                                                                <!-- <img [src]="newserverpath + file.fileName"
                                                                                [alt]="file.fileName"
                                                                                style="height: 50px; width: 100%"> -->



                                                                <calsoft-common-images
                                                                    [src]="serverPathEmail + file.fileName"
                                                                    [height]="'50px'" [width]="'auto'"
                                                                    [alt]="file.fileName">
                                                                </calsoft-common-images>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                        </div>


                                        <ng-template #placeholder>
                                            <div class="mailbox-placeholder">
                                                <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                                <h3>Select an email to read</h3>
                                                <p>Choose a message from your Mails to view it here</p>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <ng-template #loading>
                                        <div class="global-loading">
                                            <mat-spinner></mat-spinner>
                                            <p>Fetching emails...</p>
                                        </div>
                                    </ng-template>
                                    <ng-template #emptyState>
                                        <div class="empty-state">
                                            <div class="empty-icon">📭</div>
                                            <h3>No emails found</h3>
                                            <p>Your folder is empty</p>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>

                            <div *ngIf="activeTabInner === 'Calls'">
                                <div class="call-section-bg">
                                    <div class="tab-pane fade" id="calls">
                                        <div class="card">
                                            <div
                                                class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                                <h4 class="fw-semibold">Calls</h4>

                                                <!-- <button [attr.guide]="'lead-detail-btn-271' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                                <mat-menu #menu="matMenu">
                                                    <button [attr.guide]="'lead-detail-btn-272' + '__' + sanitizedUrl"
                                                        *ngIf="crmType!=2" mat-menu-item
                                                        (click)="addLeadActivityone('Follow Up',0,null)">Follow
                                                        Up
                                                    </button>
                                                    <button [attr.guide]="'lead-detail-btn-273' + '__' + sanitizedUrl"
                                                        mat-menu-item
                                                        (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                                        Call</button>
                                                    <button [attr.guide]="'pipeline-btn-99' + '__' + sanitizedUrl"
                                                        mat-menu-item (click)="addSiteVisitPopup()">Site
                                                        visit</button>
                                                    <button [attr.guide]="'lead-detail-btn-274' + '__' + sanitizedUrl"
                                                        *ngIf="enableLocation == '1'" mat-menu-item
                                                        (click)="addLeadActivityone('Location',0,null)">Location</button>
                                                </mat-menu>
                                            </div>
                                            <div class="card-body" *ngIf="calllist?.length > 0; else noData">
                                                <div class="card mb-3" *ngFor="let lead of calllist;">

                                                    <div class="card-body">
                                                        <div
                                                            class="d-sm-flex align-items-center justify-content-between pb-2">
                                                            <div class="d-flex align-items-center mb-2">
                                                                <span class="avatar-md me-2 flex-shrink-0">
                                                                    <mat-icon class="default-icon">person</mat-icon>
                                                                </span>
                                                                <p class="m-0"><span
                                                                        class="text-dark fw-medium">{{lead.customerName}}</span>
                                                                    logged a call on {{lead.updatedDate}}
                                                                </p>
                                                            </div>
                                                            <div class="d-inline-flex align-items-center mb-2">
                                                                <div class="dropdown me-2">
                                                                    <a href="javascript:void(0);" class="py-1"
                                                                        [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        {{lead.phoneCallOutcome |
                                                                        titlecase}}
                                                                        <i class="ti ti-chevron-down ms-2"></i>
                                                                    </a>


                                                                </div>
                                                                <div class="dropdown">
                                                                    <a href="javascript:void(0);"
                                                                        class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"><i
                                                                            class="ti ti-dots-vertical"></i></a>
                                                                    <div class="dropdown-menu dropdown-menu-right">
                                                                        <a class="dropdown-item"
                                                                            href="javascript:void(0);"><i
                                                                                class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                                        <a class="dropdown-item"
                                                                            href="javascript:void(0);"><i
                                                                                class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span [innerHTML]="lead.notes"> </span>
                                                    </div>
                                                </div>

                                            </div>

                                            <ng-template #noData>
                                                <div class="text-center text-muted py-4">
                                                    <p>No data found.</p>
                                                </div>
                                            </ng-template>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="activeTabInner === 'Email Status'">

                                <div>
                                    <calsoft-send-all-email [leadId]="leadId" [type]="1">
                                    </calsoft-send-all-email>
                                </div>


                            </div>

                            <div *ngIf="activeTabInner === 'Inbound Emails'">

                                <div class="width-table2">
                                    <calsoft-inbound-emails [leadObject]="LeadDetailsObject" [leadId]="leadId"
                                        [type]="1">
                                    </calsoft-inbound-emails>
                                </div>


                            </div>

                            <!-- <div *ngIf="activeTabInner === 'Email Status'">



                                    </div> -->

                        </div>
                    </div>

                    <div *ngSwitchCase="'Company'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-account-companies-table [defaultSet]="defaultSet" [type]="1"
                                    [defaultSetType]="defaultSetType"
                                    [leadId]="relatedCompanyId"></calsoft-account-companies-table>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'Deals'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-deal-table [type]="2" [dealsPrimaryType]="0" [DealType]="2"
                                    [data]="LeadDetailsObject" [defaultSet]="defaultSet"
                                    [defaultSetType]="defaultSetType" [leadId]="leadId"
                                    [dealsTableView]="1"></calsoft-deal-table>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'Next Action'">
                        <calsoft-next-best-action-card [leadId]="leadId">
                        </calsoft-next-best-action-card>
                    </div>
                    <div *ngSwitchCase="'Files'">
                        <div class="card">
                            <div class="width-table">
                                <div class="width-table">
                                    <div class="editSets1 ">
                                        <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                            <span>Files</span>

                                            <button [attr.guide]="'lead-detail-btn-275' + '__' + sanitizedUrl"
                                                mat-icon-button>
                                                <mat-icon (click)="createFile(null,0)">
                                                    add
                                                </mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <div style="overflow-x:auto;">
                                        <table>
                                            <tr>
                                                <th>Name</th>
                                                <th>Owner</th>
                                                <th>File Type</th>
                                                <th>Added On</th>
                                                <!-- <th>Tags</th> -->
                                                <th>Download</th>
                                                <th>Action</th>
                                            </tr>
                                            <tr *ngFor="let note of noteList;">
                                                <ng-container
                                                    *ngIf="note.notesDocument && note.notesDocument.length > 0">

                                                    <td>
                                                        <!-- If Image -->
                                                        <img *ngIf="note.documentType == '4'" width="36" height="36"
                                                            [src]="serverPathNotes + note.notesDocument + cid"
                                                            alt="Uploaded Image">

                                                        <!-- If Vedio -->

                                                        <img *ngIf="note.documentType == '1'"
                                                            src="assets/images/mp4.png" width="36" height="36"
                                                            alt="Vedio File">

                                                        <!-- If Audio -->

                                                        <img *ngIf="note.documentType == '2'"
                                                            src="assets/images/mp3.png" width="36" height="36"
                                                            alt="Audio File">

                                                        <!-- If Pdf -->
                                                        <img *ngIf="note.documentType == '3'"
                                                            src="assets/images/pdf.png" width="36" height="36"
                                                            alt="PDF File">

                                                        <!-- If Word -->
                                                        <img *ngIf="note.documentType == '5' || note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                            src="assets/images/docx.png" width="36" height="36"
                                                            alt="DOCX File">

                                                        <!-- If Excel -->
                                                        <img *ngIf="note.documentType == '6' || note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                            src="assets/images/excel.png" width="36" height="36"
                                                            alt="Excel File">

                                                        <!-- {{ note.notesDocument }} -->
                                                    </td>
                                                    <td>{{note.createdBy}}</td>
                                                    <td>{{note.resource}}</td>
                                                    <td>{{note.createdDate | calsoftDate}}</td>
                                                    <!-- <td>{{note.taggedUser}}</td> -->
                                                    <td style="cursor: pointer;"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)">
                                                        <mat-icon>download</mat-icon>
                                                    </td>
                                                    <td style="cursor: pointer;" (click)="deleteNote(note)">
                                                        <mat-icon>delete</mat-icon>
                                                    </td>
                                                </ng-container>

                                            </tr>


                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'Sequences'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
<div *ngIf="leadDetailPageType ===6" class="new-leadType-five" fxLayout="column" fxFlex>

    <div class="lead-detail-page" fxLayout="column" fxFlex>

        <div class="header-container" fxLayout="row" fxLayoutAlign="space-between center" fxHide.lt-md fxHide.md>

            <div class="header-left" fxFlex="24" fxLayout="row" fxLayoutAlign="start center">

                <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn"
                    (click)="back()"><span class="material-symbols-outlined">keyboard_backspace</span>
                    Back</button>

            </div>

            <div class="header-right" fxFlex="76" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">

                <button [attr.guide]="'lead-detail-btn-158' + '__' + sanitizedUrl" class="header-btn"
                    (click)="openEmailPopup()"><span class="material-symbols-outlined">email</span>
                    Email</button>

                <button [attr.guide]="'lead-detail-btn-159' + '__' + sanitizedUrl" class="header-btn"
                    (click)="transferLead()">
                    <span class="material-symbols-outlined">person_outline</span>
                    Change Owner
                </button>

                <button [attr.guide]="'lead-detail-btn-160' + '__' + sanitizedUrl" *ngIf="documentEnable"
                    class="header-btn" (click)="downloadDocumentPopup()">
                    <span class="material-symbols-outlined">download</span>
                    {{document}}
                </button>

                <button [attr.guide]="'lead-detail-btn-161' + '__' + sanitizedUrl" *ngIf="invoicebuttonEnable"
                    class="header-btn" (click)="navigateToInvoice(LeadDetailsObject)">
                    <span class="material-symbols-outlined">library_books </span>
                    {{invoicebutton}}
                </button>


                <button [attr.guide]="'lead-detail-btn-162' + '__' + sanitizedUrl" *ngIf="quotationbuttonEnable"
                    class="header-btn" (click)="navigateToQuotation(LeadDetailsObject)">
                    <span class="material-symbols-outlined">request_quote</span>
                    {{quotationbutton}}
                </button>
                <button [attr.guide]="'lead-detail-btn-163' + '__' + sanitizedUrl" *ngIf="sendEmailTemplateEnable"
                    class="header-btn" (click)="sendEmailMessage()"><span class="material-symbols-outlined">mail</span>
                    {{sendEmailTemplate}}
                </button>


                <button [attr.guide]="'lead-detail-btn-164' + '__' + sanitizedUrl" *ngIf="builderSearchPopupEnable"
                    class="header-btn" (click)="newSearch(LeadDetailsObject)"><span
                        class="material-symbols-outlined">search</span>
                    {{builderSearchPopup}}
                </button>

                <button [attr.guide]="'lead-detail-btn-165' + '__' + sanitizedUrl" class="header-btn"
                    (click)="phoneNumbercall(LeadDetailsObject)"><span class="material-symbols-outlined">call</span>
                    Call</button>
                <!-- <button [attr.guide]="'lead-detail-btn-166' + '__' + sanitizedUrl" class="header-btn"><span class="material-symbols-outlined">sms</span> SMS</button> -->
                <button [attr.guide]="'lead-detail-btn-167' + '__' + sanitizedUrl" class="header-btn"
                    (click)="addLeadActivity('Phone Call',0,null)"><span class="material-symbols-outlined">task</span>
                    Task</button>

                <button [attr.guide]="'lead-detail-btn-168' + '__' + sanitizedUrl" class="header-btn"
                    (click)="goToMeeting()"><span class="material-symbols-outlined">meeting_room</span> Meeting</button>
                <!-- <button [attr.guide]="'lead-detail-btn-169' + '__' + sanitizedUrl" class="header-btn-secondary"><span class="material-symbols-outlined">sell</span> Sales activities
                <span class="material-symbols-outlined">arrow_drop_down</span></button> -->
                <button [attr.guide]="'lead-detail-btn-170' + '__' + sanitizedUrl" (click)="goToDeals()"
                    class="header-btn-primary">
                    <span class="material-symbols-outlined">add</span> Add deal</button>
                <button [attr.guide]="'lead-detail-btn-171' + '__' + sanitizedUrl" type="button" class="header-btn"
                    [matMenuTriggerFor]="actionsMenu" (click)="$event.stopPropagation()">
                    <span class="material-symbols-outlined">more_vert</span>
                </button>
            </div>

            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-172' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-173' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>
        </div>

        <div class="header-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" fxHide fxShow.lt-lg>
            <div class="mobile-actions header-actions-compact" fxLayout="row" fxLayoutAlign="end center"
                fxLayoutGap="8px">
                <button [attr.guide]="'lead-detail-btn-email' + '__' + sanitizedUrl" mat-icon-button class="action-icon"
                    matTooltip="Email" aria-label="Email" (click)="openEmailPopup()">
                    <span class="material-symbols-outlined">email</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-call' + '__' + sanitizedUrl" mat-icon-button class="action-icon"
                    matTooltip="Call" aria-label="Call" (click)="phoneNumbercall(LeadDetailsObject)">
                    <span class="material-symbols-outlined">call</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-change-owner' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" matTooltip="Change Owner" aria-label="Change Owner" (click)="transferLead()">
                    <span class="material-symbols-outlined">person</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-174' + '__' + sanitizedUrl" mat-flat-button color="primary"
                    class="primary-compact header-btn-primary" (click)="goToDeals()">
                    <span class="material-symbols-outlined">add</span>
                    <span class="label">Add deal</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-more-actions' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" [matMenuTriggerFor]="moreActionsMenu" aria-label="More actions">
                    <mat-icon>more_horiz</mat-icon>
                </button>

                <button [attr.guide]="'lead-detail-btn-edit-or-delete' + '__' + sanitizedUrl" mat-icon-button
                    class="action-icon" [matMenuTriggerFor]="editDeleteMenu" aria-label="Edit or Delete">
                    <mat-icon>more_vert</mat-icon>
                </button>

            </div>

            <mat-menu #editDeleteMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-175' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>

                <button [attr.guide]="'lead-detail-btn-176' + '__' + sanitizedUrl"
                    [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>

            <mat-menu #moreActionsMenu="matMenu" yPosition="below" xPosition="before">
                <button [attr.guide]="'lead-detail-btn-177' + '__' + sanitizedUrl" mat-menu-item
                    (click)="addLeadActivity('Phone Call',0,null)">Task</button>
                <button [attr.guide]="'lead-detail-btn-178' + '__' + sanitizedUrl" mat-menu-item
                    (click)="goToMeeting()">Meeting</button>
                <button [attr.guide]="'lead-detail-btn-179' + '__' + sanitizedUrl" mat-menu-item
                    (click)="downloadDocumentPopup()" *ngIf="documentEnable">Document</button>
                <button [attr.guide]="'lead-detail-btn-180' + '__' + sanitizedUrl" mat-menu-item
                    (click)="navigateToInvoice(LeadDetailsObject)"
                    *ngIf="invoicebuttonEnable">{{invoicebutton}}</button>
                <button [attr.guide]="'lead-detail-btn-181' + '__' + sanitizedUrl" mat-menu-item
                    (click)="navigateToQuotation(LeadDetailsObject)"
                    *ngIf="quotationbuttonEnable">{{quotationbutton}}</button>
                <button [attr.guide]="'lead-detail-btn-182' + '__' + sanitizedUrl" mat-menu-item
                    (click)="sendEmailMessage()" *ngIf="sendEmailTemplateEnable">{{sendEmailTemplate}}</button>
                <button [attr.guide]="'lead-detail-btn-183' + '__' + sanitizedUrl" mat-menu-item
                    (click)="newSearch(LeadDetailsObject)"
                    *ngIf="builderSearchPopupEnable">{{builderSearchPopup}}</button>
            </mat-menu>
        </div>

        <div class="main-content-wrapper" fxLayout="row" fxLayout.lt-md="column" fxFlex>

            <div class="left-sidebar" fxFlex="22" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="10px">
                <div class="profile-card">
                    <div class="profile-header" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <div class="avatar-container" (click)="openViewDialog()">
                                <!-- <img *ngIf="!imageError" [src]="basePath + LeadDetailsObject?.image + '&cid=' + cid"
                                alt="Profile Avatar" class="avatar-image" (error)="setError()" /> -->

                                <img *ngIf="LeadDetailsObject?.image; else initialAvatar" [src]="uploadedImageUrl"
                                    alt="Profile Avatar" class="avatar-image" />



                                <!-- If no image, show initials -->
                                <ng-template #initialAvatar>
                                    <div class="avatar-initial">
                                        {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                                    </div>
                                </ng-template>

                                <!-- <div *ngIf="imageError" class="avatar-fallback">
                                {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                            </div> -->

                                <div class="overlay">
                                    <div class="overlay-text">
                                        {{ LeadDetailsObject?.image ? 'View' : 'Add' }}</div>


                                </div>
                            </div>
                            <div class="overlay-details" style="min-width: 0; overflow: hidden;">
                                <div class="name-row"
                                    style="display:flex;align-items:center;gap:8px;min-width: 0;overflow: hidden;">
                                    <h2 class="name"
                                        style="margin:0; flex: 1; min-width: 0; white-space: normal; word-break: break-word; line-height: 1.4;">
                                        <span *ngIf="!isEditMode">{{ (LeadDetailsObject?.name?.indexOf(' ') === -1
                                            && LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                            slice:0:20) + '...' : LeadDetailsObject?.name }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.name"
                                            style="border:none;background:transparent;font-size:inherit;font-weight:inherit;outline:none;width:100%;transition:all 160ms;" />
                                    </h2>
                                    <button [attr.guide]="'lead-detail-btn-184' + '__' + sanitizedUrl" class="edit-btn"
                                        style="opacity: 1;margin-left: 5px; flex-shrink: 0;"
                                        (click)="$event.stopPropagation(); isEditMode ? saveAllProfileEdits() : toggleEditMode()">
                                        <mat-icon *ngIf="!isEditMode" style="color: black;">edit</mat-icon>
                                        <mat-icon *ngIf="isEditMode" style="color: black;">check</mat-icon>
                                    </button>
                                </div>
                                <div class="social-icons">

                                    <a [attr.guide]="'lead-detail-lnk-185' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('facebook', $event)">
                                        <img [src]="LeadDetailsObject?.facebook 
              ? 'https://img.icons8.com/fluent/48/000000/facebook-new.png' 
              : 'https://img.icons8.com/ios/48/000000/facebook--v1.png'" />
                                    </a>


                                    <a [attr.guide]="'lead-detail-lnk-186' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('twitter', $event)">
                                        <img [src]="LeadDetailsObject?.twitter 
              ? 'https://img.icons8.com/ios-filled/50/000000/x.png' 
              : 'https://img.icons8.com/ios-filled/50/000000/x.png'" />
                                    </a>


                                    <a [attr.guide]="'lead-detail-lnk-187' + '__' + sanitizedUrl"
                                        (click)="openSocialUrl('linkedIn', $event)">
                                        <img [src]="LeadDetailsObject?.linkedIn 
              ? 'https://img.icons8.com/fluent/48/000000/linkedin.png' 
              : 'https://img.icons8.com/ios/48/000000/linkedin.png'" />
                                    </a>

                                    <a class="social-edit-btn" [matMenuTriggerFor]="socialMenu">
                                        <mat-icon style="color: black;">edit</mat-icon>
                                    </a>


                                </div>

                                <mat-menu #socialMenu="matMenu" class="social-menu" [hasBackdrop]="true">
                                    <form [formGroup]="firstFormGroup" class="social-form" style="padding:10px;">
                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>Facebook</mat-label>
                                            <input [attr.guide]="'lead-detail-inp-facebook' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="facebook" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>Twitter</mat-label>
                                            <input [attr.guide]="'lead-detail-inp-twitter' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="twitter" />
                                        </mat-form-field>

                                        <mat-form-field appearance="outline" style="width: 100%;"
                                            (click)="$event.stopPropagation()">
                                            <mat-label>LinkedIn</mat-label>
                                            <input [attr.guide]="'lead-detail-inp-linkedin' + '__' + sanitizedUrl"
                                                matInput placeholder="Enter profile URL or username"
                                                formControlName="linkedIn" />
                                        </mat-form-field>

                                        <div class="social-actions">
                                            <button [attr.guide]="'lead-detail-btn-188' + '__' + sanitizedUrl"
                                                mat-button matMenuClose>Cancel</button>
                                            <button [attr.guide]="'lead-detail-btn-189' + '__' + sanitizedUrl"
                                                mat-flat-button color="primary" (click)="editProfileUrl()"
                                                matMenuClose>Save</button>
                                        </div>
                                    </form>
                                </mat-menu>
                            </div>
                        </div>

                        <div class="profile-info">

                            <!-- <p style="cursor: pointer;" class="title flex items-center gap-2"
                                [style.pointerEvents]="!LeadDetailsObject?.company ? 'none' : 'auto'"
                                [style.opacity]="!LeadDetailsObject?.company ? '0.6' : '1'">
                                <mat-icon style="font-size: 16px; padding-top: 5px;" class="primary-icon">
                                    corporate_fare
                                </mat-icon>
                                <span
                                    (click)="LeadDetailsObject?.company ? companyDetailPage(LeadDetailsObject?.companyId) : null">
                                    {{ LeadDetailsObject?.company || '—' }}
                                </span>
                            </p> -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.company ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.company && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.company && !isEditMode ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        corporate_fare
                                    </mat-icon>

                                    <ng-container *ngIf="!isEditMode">
                                        <span style="font-weight: bold;color: black;"
                                            (click)="LeadDetailsObject?.companyId ? companyDetailPage(LeadDetailsObject?.companyId) : null">
                                            <span *ngIf="LeadDetailsObject?.companyId;else other_content">
                                                {{ LeadDetailsObject?.company || '—' }}
                                            </span>
                                        </span>
                                        <ng-template #other_content> - </ng-template>
                                    </ng-container>
                                    <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.company"
                                        placeholder="Company"
                                        style="border:none;background:transparent;font-weight:bold;outline:none;transition:all 160ms;width:160px;" />

                                </p>
                            </div>


                            <div class="flex items-center" style="word-break: break-all;">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.jobtitle ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.jobtitle && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.jobtitle && !isEditMode ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        work
                                    </mat-icon>

                                    <span>
                                        <span *ngIf="!isEditMode">{{ LeadDetailsObject?.jobtitle || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.jobtitle"
                                            placeholder="Job title"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:140px;" />
                                    </span>
                                </p>
                            </div>

                            <!-- Email -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.email ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.email && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.email && !isEditMode ? '0.6' : '1'">
                                    <mat-icon (click)="LeadDetailsObject?.email ? openEmailPopup() : null"
                                        style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        mail
                                    </mat-icon>

                                    <span style="word-break: break-all;">
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{
                                            LeadDetailsObject?.email || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.email"
                                            placeholder="Email"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:180px;" />
                                    </span>

                                    <mat-icon *ngIf="LeadDetailsObject?.email"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.email ? copyToClipboard(LeadDetailsObject?.email) : null">
                                        content_copy
                                    </mat-icon>
                                </p>
                            </div>

                            <div class="flex items-center">
                                <!-- Phone -->
                                <p class="title  items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.phoneNumber ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.phoneNumber && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.phoneNumber && !isEditMode ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">call</mat-icon>

                                    <span>
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                            LeadDetailsObject?.phoneNumber || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.phoneNumber"
                                            placeholder="Phone"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:120px;" />
                                        <mat-icon *ngIf="LeadDetailsObject?.phoneNumber"
                                            style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                            class="cursor-pointer text-gray-500 hover:text-gray-700"
                                            (click)="LeadDetailsObject?.phoneNumber ? copyToClipboard(LeadDetailsObject?.phoneNumber) : null">
                                            content_copy
                                        </mat-icon>
                                    </span>
                                </p>
                            </div>

                            <!-- WhatsApp -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2" style="display: inline-flex;"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.phoneNumber ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.phoneNumber && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.phoneNumber && !isEditMode ? '0.6' : '1'">
                                    <mat-icon style="font-size: 19px;" [icIcon]="icWhatsapp"></mat-icon>
                                    <span style="margin-bottom: -6px;">
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.phoneNumber ? phonewhatsapp(LeadDetailsObject) : null">{{
                                            LeadDetailsObject?.phoneNumber || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.phoneNumber"
                                            placeholder="WhatsApp"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:120px;" />
                                    </span>

                                    <mat-icon *ngIf="LeadDetailsObject?.phoneNumber"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.phoneNumber ? copyToClipboard(LeadDetailsObject?.phoneNumber) : null">
                                        content_copy
                                    </mat-icon>
                                </p>
                            </div>

                            <!-- <p style="cursor: pointer;" class="title flex items-center gap-2">
                                <mat-icon style="font-size: 16px;padding-top: 5px;"
                                    class="primary-icon">attribution</mat-icon>
                                {{ LeadDetailsObject?.ownerEmail }}
                            </p> -->
                            <div class="flex items-center">
                                <p class="title  items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.ownerIdName ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.ownerIdName && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.ownerIdName && !isEditMode ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        attribution
                                    </mat-icon>

                                    <span>
                                        <span *ngIf="!isEditMode">{{ LeadDetailsObject?.ownerIdName || '—' }}</span>
                                        <mat-form-field *ngIf="isEditMode" appearance="outline" class="inline-select"
                                            style="width:140px;margin:0;">
                                            <mat-select [(value)]="LeadDetailsObject.ownerId"
                                                (selectionChange)="onOwnerChange($event.value)" disableRipple>
                                                <!-- <mat-option [value]="''">-- Select owner --</mat-option> -->
                                                <mat-option *ngFor="let o of salesOwners"
                                                    [value]="(o.entityId || o.ownerId || o.OwnerId) + ''">
                                                    {{ o.email || o.ownerEmail || o.OwnerName || o.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </span>
                                </p>
                            </div>

                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.statusName ? 'pointer' : 'not-allowed')"
                                    [style.pointerEvents]="!LeadDetailsObject?.statusName && !isEditMode ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.statusName && !isEditMode ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;" class="primary-icon">
                                        info
                                    </mat-icon>

                                    <span>
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.statusName ? openStatusDetail(LeadDetailsObject?.statusName) : null">{{
                                            LeadDetailsObject?.statusName || '—' }}</span>
                                        <mat-form-field *ngIf="isEditMode" appearance="outline" class="inline-select"
                                            style="width:120px;margin:0;">
                                            <mat-select [(value)]="LeadDetailsObject.statusId"
                                                (selectionChange)="onStatusChange($event.value)" disableRipple>
                                                <!-- <mat-option [value]="''">-- Select status --</mat-option> -->
                                                <mat-option *ngFor="let s of filtereddropdownTypeList"
                                                    [value]="(s.statusId || s.id) + ''">{{ s.statusName }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </span>
                                </p>
                            </div>

                            <!-- Secondary Phone -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="LeadDetailsObject?.secondaryphoneno ? 'pointer' : 'not-allowed'"
                                    [style.pointerEvents]="!LeadDetailsObject?.secondaryphoneno ? 'none' : 'auto'"
                                    [style.opacity]="!LeadDetailsObject?.secondaryphoneno ? '0.6' : '1'">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">call</mat-icon>

                                    <span>
                                        {{ LeadDetailsObject?.secondaryphoneno || '—' }}
                                    </span>
                                    <!-- Copy Icon -->
                                    <mat-icon *ngIf="LeadDetailsObject?.secondaryphoneno"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.secondaryphoneno ? copyToClipboard(LeadDetailsObject?.secondaryphoneno) : null">
                                        content_copy
                                    </mat-icon>
                                </p>

                                <button class="edit-btn title" style="opacity: 1; margin-left: 10px;"
                                    (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number'); $event.stopPropagation()">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;">edit</mat-icon>
                                </button>
                            </div>




                        </div>
                    </div>

                    <div class="score-card">
                        <div class="score-header">
                            <span>Score</span>
                            <!-- <span class="customer-fit">
                                <span> Customer fit</span>
                                <span class="material-symbols-outlined info-icon">info</span>
                            </span> -->
                            <!-- <span class="material-symbols-outlined arrow-icon">chevron_right</span> -->
                        </div>
                        <div class="score-content">
                            <h3 class="score-value">{{ LeadDetailsObject?.score || 0.0 }}</h3>
                            <div class="stars">
                                <ng-container *ngFor="let star of starsArray; let i = index">
                                    <span class="material-symbols-outlined" [ngClass]="{ 'fill': i < filledStars }">
                                        star
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>


                <nav class="left-navigation">
                    <div class="nav-header">
                        <span>Contact information</span>
                        <!-- <button [attr.guide]="'lead-detail-btn-197' + '__' + sanitizedUrl" class="settings-btn">
                            <span class="material-symbols-outlined">settings</span>
                        </button> -->
                    </div>
                    <ul>
                        <li *ngFor="let tab of tabs" (click)="setActiveTab(tab.name)"
                            [class.active]="activeTab === tab.name">
                            <span class="material-symbols-outlined icon">{{ tab.icon }}</span>
                            <span class="tab-name">{{ tab.name }}</span>
                        </li>
                    </ul>
                </nav>

            </div>

            <div class="right-content-area" fxLayout="row" fxLayout.lt-sm="column" fxFlex="78" fxFlex.lt-md="100">
                <div [ngSwitch]="activeTab" class="dynamic-content" style="width: 100%;">
                    <div *ngSwitchCase="'Overview'" class="overview">
                        <!-- 
  This container holds the entire overview screen.
  It's structured with a main content area on the left and a notes section on the right.
  This layout stacks vertically on smaller screens for responsiveness.
-->
                        <div class="overview-cont">
                            <header class="overview-header">
                                <h1 class="title">Overview</h1>
                                <!-- <button [attr.guide]="'lead-detail-btn-198' + '__' + sanitizedUrl" class="customize-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                        <path stroke-linecap="round" stroke-linejoin="round"
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    </svg>
                                    Customize overview
                                </button> -->

                                <mat-form-field>
                                    <input [attr.guide]="'lead-detail-inp-199' + '__' + sanitizedUrl" matInput
                                        placeholder="Search..." [(ngModel)]="globalSearchText"
                                        (keydown.enter)="onGlobalSearchChange(globalSearchText)"
                                        (keydown.backspace)="onGlobalSearchBackspace($event)" />
                                    <button [attr.guide]="'lead-detail-btn-clear-search' + '__' + sanitizedUrl"
                                        mat-icon-button matSuffix *ngIf="globalSearchText" aria-label="Clear search"
                                        (click)="resetSearch()"
                                        style="height:28px;width:28px;min-width:28px;padding:0;">
                                        <mat-icon style="font-size:16px;line-height:28px;">close</mat-icon>
                                    </button>
                                </mat-form-field>

                            </header>

                            <!-- Lifecycle and Status Pipeline Section -->
                            <section *ngIf="!isSearching" class="pipeline-section">

                                <div class="status-pipeline-wrapper">
                                    <label>Status</label>
                                    <div class="status-pipeline">
                                        <div *ngFor="let step of filtereddropdownTypeList; let i = index"
                                            class="strip-stage" [ngClass]="{
         'stage-current': step.statusName === LeadDetailsObject.statusName,
         'stage-completed': i <= currentStatusIndex,
         'last-stage': i === filtereddropdownTypeList.length - 1
       }" [attr.data-toggle]="'tooltip'" [attr.data-html]="'true'" [attr.data-container]="'body'"
                                            [attr.title]="generateTooltip(step)"
                                            (click)="updateLeadStatusNew($event,step)">
                                            <span>{{ step.statusName }}</span>
                                        </div>
                                    </div>



                                </div>
                            </section>
                        </div>


                        <div *ngIf="!isSearching" class="overview-container">

                            <!-- Main Content Section (Left) -->
                            <main class="main-content-two" fxFlex="55">
                                <!-- Header: Title and Customize Button -->

                                <!-- Summary Section (Collapsible) -->
                                <!-- <section class="summary-section" fxLayout="row">
                                    <div class="summary-header">
                                        <div class="summary-title">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                            <span>Summary</span>
                                        </div>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="dropdown-icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                        </svg>
                                    </div>
                                </section> -->

                                <!-- Key Stakeholder Tag -->
                                <section class="tags-section">
                                    <div class="info-item">
                                        <label>Lifecycle stage</label>
                                        <div class="value-display">
                                            <span>{{ lifeCycleStage }}</span>
                                            <button [attr.guide]="'lead-detail-btn-200' + '__' + sanitizedUrl" (click)="openEditPopup('lifeCycleStage', 
                                            'Lifecycle stage', 'select')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div style="cursor: pointer;" (click)="opentagName()" class="tag key-stakeholder"
                                        [style.background-color]="LeadDetailsObject?.tagNameColour">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                                        </svg>
                                        {{LeadDetailsObject?.tagName || "No Tag"}}
                                    </div>
                                </section>

                                <!-- Contact Info Grid -->
                                <section class="info-grid">
                                    <div *ngIf="mapLink?.length>0" class="info-item">
                                        <label>Location</label>
                                        <div class="value-display">
                                            <a [attr.guide]="'lead-detail-lnk-201' + '__' + sanitizedUrl"
                                                (click)="navigatelink(mapLink)">{{ mapLink }}</a>
                                            <button [attr.guide]="'lead-detail-btn-202' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('mapLink', 'MapLink', 'text')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Company</label>
                                        <div class="value-display">
                                            <a [attr.guide]="'lead-detail-lnk-203' + '__' + sanitizedUrl"
                                                (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                            <button [attr.guide]="'lead-detail-btn-204' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('company', 'Company', 'text')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Email</label>
                                        <div class="value-display">
                                            <a class="small-email-text"
                                                [attr.guide]="'lead-detail-lnk-205' + '__' + sanitizedUrl"
                                                (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject.email
                                                }}</a>
                                            <button [attr.guide]="'lead-detail-btn-206' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('email', 'Email', 'text')" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Mobile</label>
                                        <div class="value-display">
                                            <a [attr.guide]="'lead-detail-lnk-207' + '__' + sanitizedUrl"
                                                (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                LeadDetailsObject.phoneNumber
                                                }}</a>
                                            <button [attr.guide]="'lead-detail-btn-208' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Sales owner</label>
                                        <div class="value-display">
                                            <span class="value mobile-truncate-email"
                                                matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                LeadDetailsObject?.ownerIdName || '-' }}</span>
                                            <!-- <button [attr.guide]="'lead-detail-btn-209' + '__' + sanitizedUrl" (click)="transferLead()"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button> -->
                                            <button [attr.guide]="'lead-detail-btn-210' + '__' + sanitizedUrl"
                                                (click)="transferLead()" class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                    <div class="info-item">
                                        <label>Created at</label>
                                        <div class="value-display">
                                            <span>{{ LeadDetailsObject.createdDate | date:'MMM dd, yyyy, h:mm a'
                                                }}</span>
                                            <!-- <button [attr.guide]="'lead-detail-btn-211' + '__' + sanitizedUrl" (click)="openEditPopup('createdDate', 'Created Date', 'text')"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button> -->
                                        </div>

                                    </div>

                                    <div class="info-item">
                                        <label>Lead Source</label>
                                        <div class="value-display">
                                            <span>{{ LeadDetailsObject.sourceName || '-' }}</span>
                                            <button [attr.guide]="'lead-detail-btn-211' + '__' + sanitizedUrl"
                                                (click)="openEditPopup('sourceName', 'Lead Source', 'select')"
                                                class="edit-btn">
                                                <mat-icon>edit</mat-icon>
                                            </button>
                                        </div>

                                    </div>
                                </section>

                                <a [attr.guide]="'lead-detail-lnk-212' + '__' + sanitizedUrl"
                                    (click)="showToContactDetials()" class="show-all-link">
                                    Show all
                                    <svg xmlns="http://www.w3.org/2000/svg" class="dropdown-icon" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </a>

                                <!-- Action Cards Section -->
                                <section class="action-cards-section">
                                    <div class="action-card">
                                        <div class="card-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.826-2.616-.826-3.723 0l-.17.127c-.89.67-2.178.67-3.067 0C2.36 11.41.966 11.41.1 12.284c-.866.866-.866 2.267 0 3.133l.17.127c.89.67 2.178.67 3.067 0l.659-.494m8.243-4.553c.428-.32.954-.32 1.382 0l.17.127c.89.67 2.178.67 3.067 0C21.64 13.37 23.034 13.37 23.9 14.24c.866.866.866 2.267 0 3.133l-.17.127c-.89.67-2.178.67-3.067 0l-.659-.494" />
                                            </svg>
                                        </div>
                                        <div class="card-content">
                                            <p *ngIf="noOfDeals > 0">
                                                {{ noOfDeals }} deal(s) associated with {{
                                                (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }}.
                                            </p>
                                            <p *ngIf="noOfDeals === 0">
                                                No open deals associated with {{ (LeadDetailsObject?.name?.indexOf(' ')
                                                === -1 && LeadDetailsObject?.name?.length > 20) ?
                                                (LeadDetailsObject?.name | slice:0:20) + '...' : LeadDetailsObject?.name
                                                }}.
                                            </p>

                                            <div class="card-links" *ngIf="noOfDeals === 0">
                                                <a [attr.guide]="'lead-detail-lnk-213' + '__' + sanitizedUrl"
                                                    (click)="goToDeals()" class="action-link">
                                                    Add deal
                                                </a>
                                            </div>

                                        </div>
                                    </div>

                                    <!-- Meetings -->
                                    <div class="action-card">
                                        <div class="card-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div class="card-content">
                                            <p *ngIf="noOfMeetings > 0">
                                                {{ noOfMeetings }} upcoming meeting(s) with {{
                                                (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }}.
                                            </p>
                                            <p *ngIf="noOfMeetings === 0">
                                                No upcoming meetings with {{ (LeadDetailsObject?.name?.indexOf(' ') ===
                                                -1 && LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }}.
                                            </p>

                                            <div class="card-links" *ngIf="noOfMeetings === 0">
                                                <a [attr.guide]="'lead-detail-lnk-214' + '__' + sanitizedUrl"
                                                    (click)="addMeeting()" class="action-link">Add meeting</a>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- MailBox -->
                                    <div class="action-card">
                                        <div class="card-icon-wrapper">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <div class="card-content">
                                            <p>
                                                {{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                LeadDetailsObject?.name?.length > 20) ? (LeadDetailsObject?.name |
                                                slice:0:20) + '...' : LeadDetailsObject?.name }} hasn't been contacted
                                                yet.
                                            </p>
                                            <div class="card-links">
                                                <a [attr.guide]="'lead-detail-lnk-215' + '__' + sanitizedUrl"
                                                    (click)="openEmailPopup()" class="action-link">Click here to send
                                                    mail</a>
                                            </div>
                                        </div>
                                    </div>

                                </section>

                            </main>

                            <!-- Notes Section (Right) -->
                            <div class="notes-container" fxFlex="40">
                                <aside class="add-note-section notes-section">
                                    <div (click)="createNote(null, 0)">
                                        <span>Add a Note...</span>
                                    </div>
                                </aside>

                                <main class="notes-list" *ngIf="noteList.length > 0; else noNotes">
                                    <div *ngFor="let note of noteList" class="note-item">
                                        <div class="note-content"
                                            [class.truncated]="note.notes.length > 250 && !isExpanded(note.noteId)"
                                            [innerHTML]="note.notes | mentionHighlight">
                                        </div>

                                        <a *ngIf="note.notes.length > 250" (click)="toggleShowMore(note.noteId)"
                                            class="show-more-link">
                                            {{ isExpanded(note.noteId) ? 'Show less' : 'Show more' }}
                                        </a>


                                        <div class="padding-10" *ngIf="note.documentType == 1">
                                            <video [style.height]="'150px'" [style.width]="'75%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </video>
                                        </div>
                                        <div class="padding-10" *ngIf="note.documentType == 2">
                                            <audio [style.width]="'25%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </audio>
                                        </div>


                                        <div class="padding-10" *ngIf="note.documentType==3">
                                            <div fxLayout="column">

                                                <div fxLayout="row">
                                                    <span fxLayoutAlign="start center">
                                                        Pdf : {{note.notesDocument}}
                                                    </span>

                                                    <button [attr.guide]="'lead-detail-btn-216' + '__' + sanitizedUrl"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid, note.documentType)"
                                                        color="warn" mat-icon-button type="button">
                                                        <mat-icon>download

                                                        </mat-icon>

                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==4">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <calsoft-common-images [src]="serverPathNotes + note.notesDocument"
                                                        [height]="'50%'" [width]="'25%'" [alt]="">

                                                    </calsoft-common-images>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==5">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <img *ngIf="note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                        src="assets/images/docx.png" width="36" height="36"
                                                        alt="DOCX File">

                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==6">
                                            <div fxLayout="column">
                                                <div fxLayout="row">

                                                    <img *ngIf="note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                        src="assets/images/excel.png" width="36" height="36"
                                                        alt="Excel File">

                                                </div>
                                            </div>
                                        </div>

                                        <div class="note-meta">
                                            <mat-icon class="edit-icon" (click)="createNote(note, note.noteId)"
                                                style="height: auto;">edit_square</mat-icon>
                                            <span>
                                                {{ note.createdBy == null ? LeadDetailsObject?.ownerEmail :
                                                note.createdBy }}
                                            </span>
                                            <span class="dot">•</span>
                                            <span>{{ note.createdDate | date:'mediumDate' }}</span>
                                        </div>
                                    </div>
                                </main>

                                <ng-template #noNotes>
                                    <div class="empty-state-two">
                                        <mat-icon>note_add</mat-icon>
                                        <p>No notes yet.</p>
                                        <span>Add a note to get started.</span>
                                    </div>
                                </ng-template>

                            </div>

                        </div>

                        <div *ngIf="isSearching">

                            <calsoft-views [searchText]="globalSearchText" [leadPropertiesName]="leadPropertiesName"
                                [leadPropertiesDisplay]="leadPropertiesDisplay" [LeadDetailsObject]="LeadDetailsObject"
                                [leadAdditionalPropertiesDisplay]="leadAdditionalPropertiesDisplay"
                                [leadAdditionalPropertiesName]="leadAdditionalPropertiesName" [valuesList]="filterList"
                                [additionalSpec]="additionalSpec"
                                [leadCommonPropertiesDisplay]="leadCommonPropertiesDisplay" [usedInSite]="usedInSite"
                                [type3]="type3" [leadCommonPropertiesName]="leadCommonPropertiesName"
                                [activeViewNew]="activeViewNew"></calsoft-views>
                        </div>


                    </div>

                    <div *ngSwitchCase="'Contact details'">
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>Contact details</h2>
                                <!-- <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-217' + '__' + sanitizedUrl" class="btn-secondary">View field edit history</button>
                                    <button [attr.guide]="'lead-detail-btn-218' + '__' + sanitizedUrl" class="btn-secondary">Manage fields</button>
                                </div> -->
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-219' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'all'" (click)="setView('all')">All
                                    details</button>
                                <button [attr.guide]="'lead-detail-btn-220' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'basic'" (click)="setView('basic')">Basic
                                    information</button>
                            </div>
                            <!--
                            <div class="details-toolbar">
                                <div class="search-bar">
                                    <i class="icon-search"></i>
                                    <input [attr.guide]="'lead-detail-inp-221' + '__' + sanitizedUrl" type="text" placeholder="Search fields" />
                                </div>
                                 <div class="toggle-switch">
                                    <span>Show empty fields</span>
                                    <label class="switch">
                                        <input [attr.guide]="'lead-detail-inp-222' + '__' + sanitizedUrl" type="checkbox" checked />
                                        <span class="slider round"></span>
                                    </label>
                                </div>
                            </div>
 -->
                            <div class="details-content" [class.basic-view]="activeViewNew === 'basic'">
                                <div *ngIf="activeView === 'all'">
                                    <!-- <div class="all-details-tags">
                                        <span class="label">Tags</span>
                                        <span class="tag">{{ contact.tags[0] }}</span>
                                    </div> -->

                                    <div class="content-section">
                                        <button [attr.guide]="'lead-detail-btn-223' + '__' + sanitizedUrl"
                                            class="section-toggle" (click)="toggleBasicInfo()">
                                            <i class="icon-chevron" [class.rotated]="isBasicInfoOpen"></i>
                                            <h3>Basic information</h3>
                                        </button>
                                        <div class="section-body" *ngIf="isBasicInfoOpen">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Email</span><a class="value link">{{ LeadDetailsObject?.email }}</a></div> -->
                                                <div class="info-item">
                                                    <label
                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">Email</label>
                                                    <div class="value-display">
                                                        <a class="small-email-text"
                                                            [attr.guide]="'lead-detail-lnk-224' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-225' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Name</span><span
                                                        class="value">{{LeadDetailsObject?.name }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Name</label>
                                                    <div class="value-display">
                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                            LeadDetailsObject?.name?.length > 20) ?
                                                            (LeadDetailsObject?.name | slice:0:20) + '...' :
                                                            LeadDetailsObject?.name }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-226' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Last name</span><span
                                                        class="value">{{ contact.lastName }}</span></div> -->
                                                <!-- <div class="field-item"><span class="label">Account</span><a class="value link">{{ LeadDetailsObject?.company }}</a></div> -->
                                                <div class="info-item">
                                                    <label>Company</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-227' + '__' + sanitizedUrl"
                                                            (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-228' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Job title</span><span
                                                        class="value">{{ LeadDetailsObject?.jobtitle }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Job title</label>
                                                    <div class="value-display">
                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-229' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Telephone numbers</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Mobile</span><span
                                                        class="value">{{ LeadDetailsObject?.phoneNumber }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Mobile</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-230' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject.phoneNumber
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-231' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <!-- <div class="field-item"><span class="label">Work phone</span><span
                                                        class="value">{{ LeadDetailsObject?.secondaryphoneno
                                                        }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Work phone</label>
                                                    <div class="value-display">
                                                        <a href="tel:{{LeadDetailsObject?.secondaryphoneno}}">{{
                                                            LeadDetailsObject.secondaryphoneno
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-232' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Sales owner</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Sales owner</span><span
                                                        class="value">{{ LeadDetailsObject?.ownerIdName?.split('@')[0] |
                                                        titlecase }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <span class="value mobile-truncate-email"
                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                            LeadDetailsObject?.ownerIdName || '-' }}</span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-233' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <button [attr.guide]="'lead-detail-btn-234' + '__' + sanitizedUrl"
                                            class="section-toggle" (click)="toggleMoreFields()">
                                            <i class="icon-chevron" [class.rotated]="isMoreFieldsOpen"></i>
                                            <h3>More fields</h3>
                                        </button>
                                        <div class="section-body" *ngIf="isMoreFieldsOpen">

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Location</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item" style="grid-column: span 4;"><span
                                                                class="label">Address</span><span class="value">{{
                                                                LeadDetailsObject?.additionalSpec?.Address }}</span>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>Address</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.additionalSpec?.Address}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-235' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('Address', 'Address', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">City</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.City }}</span>
                                                        </div> -->
                                                        <div class="info-item"
                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.State">
                                                            <label>City</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.City}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-236' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('City', 'City', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">State</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.State }}</span>
                                                        </div> -->
                                                        <div class="info-item"
                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.Country">
                                                            <label>State</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.State }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-237' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('State', 'State', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Country</span><span
                                                                class="value">{{ LeadDetailsObject?.country }}</span>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>Country</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.Country}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-238' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('Country', 'Country', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <!-- <div class="field-item"><span class="label">Zipcode</span><span
                                                                class="value">{{
                                                                LeadDetailsObject?.isCustomizedValue?.pincode }}</span>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>Zipcode</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.isCustomizedValue?.Pincode}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-239' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('pincode', 'Pincode', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Lifecycle stage</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item"><span class="label">Lifecycle
                                                                stage</span><span class="value strong">{{
                                                                contact.lifecycleStage }}</span></div> -->
                                                        <!-- <div class="field-item"><span class="label">Status</span><span
                                                                class="value strong">{{ LeadDetailsObject.statusName
                                                                }}</span></div> -->

                                                        <div class="info-item">
                                                            <label>Status</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject.statusName}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-240' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('statusName', 'Status Name', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>

                                                        <div class="info-item">
                                                            <label>Lost reason</label>
                                                            <div class="value-display">
                                                                <a
                                                                    *ngIf="LeadDetailsObject?.lostReason; else addReason">{{
                                                                    LeadDetailsObject.lostReason
                                                                    }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-241' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('lostReason', 'Lost Reason', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>

                                                                <ng-template #addReason>
                                                                    <span style="color: rgb(93, 93, 207);"
                                                                        class="value placeholder"
                                                                        (click)="lostReason()">
                                                                        Click to add
                                                                    </span>
                                                                </ng-template>
                                                            </div>

                                                        </div>

                                                        <!-- <div class="field-item">
                                                            <span class="label">Lost reason</span>

                                                           
                                                            <span class="value"
                                                                *ngIf="LeadDetailsObject?.lostReason; else addReason">
                                                                {{ LeadDetailsObject.lostReason }}
                                                            </span>

                                                            <ng-template #addReason>
                                                                <span style="color: rgb(93, 93, 207);"
                                                                    class="value placeholder" (click)="lostReason()">
                                                                    Click to add
                                                                </span>
                                                            </ng-template>
                                                        </div> -->

                                                        <!-- <div class="field-item"><span class="label">Subscription
                                                                status</span><span class="value strong">{{
                                                                contact.subscriptionStatus }}</span></div> -->
                                                        <!-- <div class="field-item" style="grid-column: span 2;"><span
                                                                class="label">Subscription types</span><span
                                                                class="value">{{ contact.subscriptionTypes }}</span>
                                                        </div> -->
                                                        <!-- <div class="field-item"><span class="label">Unsubscribe
                                                                reason</span><span class="value placeholder">Click to
                                                                add</span></div>
                                                        <div class="field-item"><span class="label">Other unsubscribe
                                                                reasons</span><span class="value placeholder">Click to
                                                                add</span></div> -->
                                                        <!-- <div class="field-item"><span class="label">Customer fit</span>
                                                            <div class="stars">
                                                                <ng-container
                                                                    *ngFor="let star of starsArray; let i = index">
                                                                    <span class="material-symbols-outlined"
                                                                        [ngClass]="{ 'fill': i < filledStars }">
                                                                        star
                                                                    </span>
                                                                </ng-container>
                                                            </div>
                                                        </div> -->
                                                        <!-- <div class="field-item"><span class="label">Score</span><span
                                                                class="value strong">{{ LeadDetailsObject.score
                                                                }}</span>
                                                        </div> -->

                                                        <div class="info-item">
                                                            <label>Score</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.score}}</a>

                                                            </div>

                                                        </div>

                                                        <!-- <div class="field-item"><span
                                                                class="label">Territory</span><span
                                                                class="value placeholder">Click to add</span></div> -->
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Social profiles</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <!-- <div class="field-item"><span class="label">LinkedIn</span><a class="value link">{{ LeadDetailsObject.linkedIn }}</a>
                                                        </div>
                                                        <div class="field-item"><span class="label">Twitter</span><a class="value link">{{ LeadDetailsObject.twitter }}</a>
                                                        </div>
                                                        <div class="field-item"><span class="label">Facebook</span><a class="value link">{{ LeadDetailsObject.facebook }}</a>
                                                        </div> -->
                                                        <div class="info-item">
                                                            <label>LinkedIn</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.linkedIn}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-242' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('linkedIn', 'LinkedIn', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Twitter</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.twitter}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-243' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('twitter', 'Twitter', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                        <div class="info-item">
                                                            <label>Facebook</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject.facebook}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-244' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('facebook', 'Facebook', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="activeView === 'basic'">

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h3>Basic information</h3>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Email</span><a class="value link">{{ LeadDetailsObject?.email }}</a></div>
                                                <div class="field-item"><span class="label">Name</span><span
                                                        class="value">{{LeadDetailsObject?.name }}</span></div>
                                                <div class="field-item"><span class="label">Account</span><a class="value link">{{ LeadDetailsObject?.company }}</a></div>
                                                <div class="field-item"><span class="label">Job title</span><span
                                                        class="value">{{ LeadDetailsObject?.jobtitle }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Email</label>
                                                    <div class="value-display">
                                                        <a class="small-email-text"
                                                            [attr.guide]="'lead-detail-lnk-245' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-246' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Name</label>
                                                    <div class="value-display">
                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                            LeadDetailsObject?.name?.length > 20) ?
                                                            (LeadDetailsObject?.name | slice:0:20) + '...' :
                                                            LeadDetailsObject?.name }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-247' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Company</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-248' + '__' + sanitizedUrl"
                                                            (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-249' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Job title</label>
                                                    <div class="value-display">
                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-250' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Telephone numbers</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Mobile</span><span
                                                        class="value">{{ LeadDetailsObject?.phoneNumber }}</span></div>
                                                <div class="field-item"><span class="label">Work phone</span><span
                                                        class="value">{{ LeadDetailsObject?.secondaryphoneno}}</span>
                                                </div> -->
                                                <div class="info-item">
                                                    <label>Mobile</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-251' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject.phoneNumber
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-252' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                                <div class="info-item">
                                                    <label>Work phone</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-253' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.secondaryphoneno ? phoneNumbercallSecondary(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject.secondaryphoneno
                                                            }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-254' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Sales owner</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <!-- <div class="field-item"><span class="label">Sales owner</span><span
                                                        class="value">{{ LeadDetailsObject?.ownerIdName?.split('@')[0] |
                                                        titlecase }}</span></div> -->
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <span class="value mobile-truncate-email"
                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                            LeadDetailsObject?.ownerIdName || '-' }}</span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-255' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'My Views'">
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>My Views</h2>
                                <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-256' + '__' + sanitizedUrl"
                                        (click)="manageFields()" class="btn-secondary">Manage fields</button>
                                </div>
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-257' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'basic'" (click)="setViewNew('basic')">Lead
                                    information</button>
                                <button [attr.guide]="'lead-detail-btn-258' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'Original'" (click)="setViewNew('Original')">
                                    Original Lead Format</button>

                            </div>

                            <div class="details-content">
                                <div *ngIf="activeViewNew === 'Original'">

                                    <div class="content-section">

                                        <ng-container
                                            *ngIf="jsonRecieved && (jsonRecieved | keyvalue).length > 0; else noRecord">
                                            <div>
                                                <table id="details">
                                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                                        <td>
                                                            {{ item.key === 'adGroupName' ? 'Campaign Name' : item.key
                                                            }}
                                                        </td>
                                                        <td>
                                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                class="blackColor wordBreak" [innerHTML]="item.value">
                                                            </p>

                                                            <p *ngIf="item.key=='Lead Status'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                            <p *ngIf="item.key=='Lead Source'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.category"> </p>
                                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.product"> </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #noRecord>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>

                                    </div>

                                </div>

                                <div *ngIf="activeViewNew === 'basic'">

                                    <div class="content-section" *ngIf="manageFieldCustomization == 0">

                                        <ng-container>
                                            <div>

                                                <table
                                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadCommonPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>
                                                    <ng-container *ngIf="!type3">

                                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>
                                                            </td>
                                                        </tr>

                                                    </ng-container>
                                                    <ng-container *ngIf="type3">

                                                        <tr *ngFor="let item of customList ">


                                                            <td>
                                                                {{item[0]}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source'
                                                                 && item[0]!='Lead_Source' &&item[0]!='Lead_Status' && item[0]!='Lead Source' && item[0]!='Category' && item[0]!='Product'"
                                                                    class="blackColor wordBreak" [innerHTML]="item[1]">
                                                                </p>


                                                                <p *ngIf="item[0]=='Lead Status' || item[0]=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item[0]=='Lead Source' || item[0]=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item[0]=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item[0]=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>
                                                </table>


                                                <table
                                                    *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>


                                                    <ng-container *ngIf="!type2">

                                                        <tr *ngFor="let item of valuesList | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>

                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>

                                                        </tr>

                                                    </ng-container>
                                                    <ng-container *ngIf="type2">

                                                        <tr *ngFor="let item of filterList | keyvalue">


                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>

                                                </table>

                                                <!-- spacing between consecutive tables is handled by CSS; removed <br> -->

                                                <table
                                                    *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">

                                                    <tr>
                                                        <th colspan="2">
                                                            {{leadAdditionalPropertiesName || 'Lead Additional
                                                            Information'}}
                                                        </th>
                                                    </tr>


                                                    <ng-container *ngIf="!type1">

                                                        <tr *ngFor="let item of additionalSpec | keyvalue">
                                                            <td>
                                                                {{item.key}}
                                                            </td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' &&  item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"> </p>

                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"> </p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"> </p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"> </p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"> </p>

                                                            </td>
                                                        </tr>

                                                    </ng-container>

                                                    <ng-container *ngIf="type1">


                                                        <tr *ngFor="let item of additionalSpecList">
                                                            <td>{{ item[0] }}</td>
                                                            <td>

                                                                <ng-container [ngSwitch]="item[0]">

                                                                    <p *ngSwitchCase="'Lead Status'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.statusName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead_Status'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.statusName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead Source'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.sourceName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Lead_Source'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.sourceName }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Category'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.category }}
                                                                    </p>

                                                                    <p *ngSwitchCase="'Product'"
                                                                        class="blackColor wordBreak">
                                                                        {{ LeadDetailsObject?.product }}
                                                                    </p>

                                                                    <p *ngSwitchDefault class="blackColor wordBreak">
                                                                        {{ item[1] }}
                                                                    </p>

                                                                </ng-container>

                                                            </td>
                                                        </tr>


                                                    </ng-container>


                                                </table>

                                            </div>
                                        </ng-container>
                                        <ng-template #noRecord>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>

                                    </div>

                                    <div class="content-section" *ngIf="manageFieldCustomization == 1">



                                        <ng-container *ngIf="mappedGroups?.length > 0; else noData">

                                            <div class="content-section" *ngFor="let group of mappedGroups">
                                                <div class="section-header">
                                                    <h3>{{ group.groupName }}</h3>
                                                </div>

                                                <div class="section-body">
                                                    <div class="details-grid-4col">

                                                        <div class="info-item" *ngFor="let field of group.fields">

                                                            <label>{{ field.fieldName }}</label>

                                                            <div class="value-display">
                                                                <ng-container [ngSwitch]="field.fieldKey">

                                                                    <a [attr.guide]="'lead-detail-lnk-259' + '__' + sanitizedUrl"
                                                                        *ngSwitchCase="'Email'"
                                                                        (click)="field.value !== '-' ? openEmailPopup() : null">
                                                                        {{ field.value }}
                                                                    </a>

                                                                    <span *ngSwitchDefault>
                                                                        {{ field.value }}
                                                                    </span>

                                                                </ng-container>

                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-260' + '__' + sanitizedUrl"
                                                                    *ngIf="!field.isReadOnly"
                                                                    (click)="openEditPopupNew(field.fieldKey, field.fieldName, field.fieldType, field)"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                        </ng-container>

                                        <ng-template #noData>
                                            <div fxLayoutAlign="center center" class="text-center text-muted py-4">
                                                No data available
                                            </div>
                                        </ng-template>



                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- <div *ngSwitchCase="'Conversations'">
                        <div class="card">
                            <div *ngIf="leadLoaded">
                                <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                    [isFromPhone]="true"></calsoft-whatsapp-chat-details>
                            </div>
                        </div>

                    </div> -->


                    <div *ngSwitchCase="'Activities'" class="activities-new-type">
                        <div class="activity-container">

                            <div class="tabs">
                                <!-- Desktop / wide screens: horizontal tabs -->
                                <ul class="tabs-list">
                                    <li [ngClass]="{'active': activeTabInner === 'activity'}"
                                        (click)="selectTabInner('activity')">Activity timeline</li>
                                    <li [ngClass]="{'active': activeTabInner === 'notes'}"
                                        (click)="selectTabInner('notes')">Notes</li>
                                    <li [ngClass]="{'active': activeTabInner === 'tasks'}"
                                        (click)="selectTabInner('tasks')">Tasks</li>
                                    <li [ngClass]="{'active': activeTabInner === 'meetings'}"
                                        (click)="selectTabInner('meetings')">Meetings</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Chats'}"
                                        (click)="selectTabInner('Chats')">Chats</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Email Sent'}"
                                        (click)="selectTabInner('Email Sent')">Email</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Calls'}"
                                        (click)="selectTabInner('Calls')">Calls</li>
                                    <li [ngClass]="{'active': activeTabInner === 'Email Status'}"
                                        (click)="selectTabInner('Email Status')">Email Status</li>
                                </ul>

                                <!-- Mobile / narrow screens: compact native select -->
                                <div class="tabs-select" role="presentation">
                                    <select [attr.guide]="'lead-detail-sel-select-activity-tab' + '__' + sanitizedUrl"
                                        aria-label="Select activity tab" class="tabs-select"
                                        (change)="selectTabInner($event.target.value)">
                                        <option value="activity" [selected]="activeTabInner === 'activity'">
                                            Activity timeline</option>
                                        <option value="notes" [selected]="activeTabInner === 'notes'">Notes
                                        </option>
                                        <option value="tasks" [selected]="activeTabInner === 'tasks'">Tasks
                                        </option>
                                        <option value="meetings" [selected]="activeTabInner === 'meetings'">
                                            Meetings</option>
                                        <option value="Chats" [selected]="activeTabInner === 'Chats'">Chats
                                        </option>
                                        <option value="Email Sent" [selected]="activeTabInner === 'Email Sent'">Email
                                        </option>
                                        <option value="Calls" [selected]="activeTabInner === 'Calls'">Calls
                                        </option>
                                        <option value="Email Status" [selected]="activeTabInner === 'Email Status'">
                                            Email Status
                                        </option>
                                    </select>
                                </div>

                                <!-- <button [attr.guide]="'lead-detail-btn-261' + '__' + sanitizedUrl" class="create-custom-activity-btn">+ Create custom sales activity</button> -->
                            </div>
                            <!-- <div class="filters">
                                    <span>Filter by:</span>
                                    <button [attr.guide]="'lead-detail-btn-262' + '__' + sanitizedUrl" class="filter-btn">All activities ▼</button>
                                    <button [attr.guide]="'lead-detail-btn-263' + '__' + sanitizedUrl" class="filter-btn">All time periods ▼</button>
                                </div> -->
                            <div *ngIf="activeTabInner === 'activity'" style="overflow-x: auto;">
                                <div *ngIf="activityHistoryType == 0" class="timeline">
                                    <calsoft-activity-new [type]="1" [spinner]="spinner" [onScrollValue]="onScrollValue"
                                        [groupedActivities]="groupedActivities"
                                        (scrollChange)="onScrollNew()"></calsoft-activity-new>
                                </div>
                                <ng-container *ngIf="activityHistoryType == 1">
                                    <calsoft-activity (scrollChange)="onScroll()" [spinner]="spinner"
                                        [onScrollValue]="onScrollValue" [leadActivityListFinal]="leadActivityListFinal"
                                        [totalSize]="totalSize" [leadid]="leadId" fxFlex
                                        [leadActivityList]="leadActivityList">
                                    </calsoft-activity>
                                </ng-container>

                            </div>



                            <div *ngIf="activeTabInner === 'notes'" class="notes-view-container">

                                <div class="notes-header">
                                    <h2>Notes</h2>
                                    <button [attr.guide]="'lead-detail-btn-264' + '__' + sanitizedUrl"
                                        class="add-note-btn" (click)="createNote(null, 0)">
                                        <span class="material-icons-outlined">add</span>
                                        Add note
                                    </button>
                                </div>

                                <div *ngIf="noteList && noteList.length > 0; else emptyState" class="notes-list">
                                    <div *ngFor="let note of noteList" class="note-card">

                                        <div class="note-content" [innerHTML]="note.notes | mentionHighlight"></div>

                                        <div class="padding-10" *ngIf="note.documentType == 1">
                                            <video [style.height]="'150px'" [style.width]="'75%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </video>
                                        </div>
                                        <div class="padding-10" *ngIf="note.documentType == 2">
                                            <audio [style.width]="'25%'" controls>
                                                <source [src]="serverPathNotes + note.notesDocument + cid" />
                                            </audio>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==3">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <span fxLayoutAlign="start center">
                                                        Pdf : {{note.notesDocument}}
                                                    </span>
                                                    <button [attr.guide]="'lead-detail-btn-216' + '__' + sanitizedUrl"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid, note.documentType)"
                                                        color="warn" mat-icon-button type="button">
                                                        <mat-icon>download</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==4">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <calsoft-common-images [src]="serverPathNotes + note.notesDocument"
                                                        [height]="'50%'" [width]="'25%'" [alt]="">
                                                    </calsoft-common-images>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==5">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <img *ngIf="note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                        src="assets/images/docx.png" width="36" height="36"
                                                        alt="DOCX File">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="padding-10" *ngIf="note.documentType==6">
                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    <img *ngIf="note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                        src="assets/images/excel.png" width="36" height="36"
                                                        alt="Excel File">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="note-meta">
                                            <span *ngIf="!note.documentType || note.documentType == 0"
                                                class="material-icons-outlined edit-icon"
                                                (click)="createNote(note, note.noteId)">edit</span>
                                            <span *ngIf="note.noteType !== 'REPLY'" class="material-icons-outlined"
                                                style="cursor:pointer;color:#555;margin-left:4px;"
                                                (click)="toggleReply(note.noteId)" title="Reply">reply</span>
                                            <span class="author">{{ note.createdBy }}</span>
                                            <span class="dot">•</span>
                                            <span class="timestamp">{{ getRelativeTimenew(note.createdDate)
                                                }}</span>
                                        </div>
                                        <div *ngIf="replyingToNoteId === note.noteId"
                                            style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;margin-top:8px;">
                                            <mat-icon
                                                style="margin-top:6px;color:#888;">subdirectory_arrow_right</mat-icon>
                                            <mat-form-field appearance="outline" style="flex:1">
                                                <mat-label>Reply to {{note.createdBy}}</mat-label>
                                                <textarea matInput rows="2" [(ngModel)]="replyText"
                                                    placeholder="Write a reply..."></textarea>
                                            </mat-form-field>
                                            <button mat-raised-button color="primary" style="margin-top:6px"
                                                [disabled]="!replyText?.trim()"
                                                (click)="submitReply(note)">Send</button>
                                            <button mat-icon-button style="margin-top:4px"
                                                (click)="toggleReply(null)"><mat-icon>close</mat-icon></button>
                                        </div>
                                    </div>
                                </div>

                                <ng-template #emptyState>
                                    <div class="empty-notes">
                                        <span class="material-icons-outlined empty-icon">description</span>
                                        <p>Use notes to capture talking points, action items, and ideas.</p>
                                        <button [attr.guide]="'lead-detail-btn-265' + '__' + sanitizedUrl"
                                            class="add-note-btn empty-bg-color" (click)="createNote(null, 0)">Add
                                            note</button>
                                    </div>
                                </ng-template>
                            </div>
                            <div *ngIf="activeTabInner === 'tasks'" class="tasks-view-container">

                                <div class="tasks-header">
                                    <div class="task-filters">
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'all'"
                                            (click)="setTaskFilter('all')">
                                            <span>All</span>
                                            <span class="count">{{ totalActivity }}</span>
                                        </div>
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'upcoming'"
                                            (click)="setTaskFilter('upcoming')">
                                            <span>Upcoming</span>
                                            <span class="count">{{totalActivityUpComing }}</span>
                                        </div>
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'overdue'"
                                            (click)="setTaskFilter('overdue')">
                                            <span>Overdue</span>
                                            <span class="count overdue-count">{{totalActivityDue }}</span>
                                        </div>
                                        <div class="filter-card" [class.active]="activeTaskFilter === 'completed'"
                                            (click)="setTaskFilter('completed')">
                                            <span>Completed</span>
                                            <span class="count">{{ totalActivityCompleted }}</span>
                                        </div>
                                    </div>
                                    <div class="task-actions">

                                        <button [attr.guide]="'lead-detail-btn-266' + '__' + sanitizedUrl"
                                            class="add-task-btn" [matMenuTriggerFor]="menu">
                                            <span class="material-icons-outlined">add</span>
                                            Add task
                                        </button>

                                        <mat-menu #menu="matMenu">
                                            <button [attr.guide]="'lead-detail-btn-267' + '__' + sanitizedUrl"
                                                *ngIf="crmType != 2" mat-menu-item
                                                (click)="addLeadActivity('Follow Up', 0, null)">
                                                Follow Up
                                            </button>
                                            <button [attr.guide]="'lead-detail-btn-268' + '__' + sanitizedUrl"
                                                mat-menu-item (click)="addLeadActivity('Phone Call', 0, null)">
                                                Phone Call
                                            </button>
                                            <button [attr.guide]="'pipeline-btn-98' + '__' + sanitizedUrl" mat-menu-item
                                                (click)="addSiteVisitPopup()">Site
                                                visit</button>
                                            <button [attr.guide]="'lead-detail-btn-269' + '__' + sanitizedUrl"
                                                *ngIf="enableLocation == '1'" mat-menu-item
                                                (click)="addLeadActivityone('Location', 0, null)">
                                                Location
                                            </button>
                                        </mat-menu>

                                    </div>
                                </div>

                                <div *ngIf="activeTaskFilter === 'all'">
                                    <calsoft-task-new (scrollChange)="onScroll()" (taskUpdated)="onTaskUpdated()"
                                        [type]="1" [onScrollValue]="onScrollValue" [taskType]="taskType"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [leadActivityListFinal]="leadActivityListFinalTasks" [totalSize]="totalSize-1"
                                        [page]="pagetwo" [total]="total" [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListTasks"></calsoft-task-new>
                                </div>


                                <div *ngIf="activeTaskFilter === 'upcoming'">
                                    <calsoft-task-new (scrollChange)="onScrollUpcoming()"
                                        (taskUpdated)="onTaskUpdated()" [type]="1"
                                        [onScrollValue]="onScrollValueUpcoming" [taskType]="taskType"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [leadActivityListFinal]="leadActivityListFinalUpcoming"
                                        [totalSize]="totalSizeUpcoming-1" [page]="pagetwoUpcoming"
                                        [total]="totalUpcoming" [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListUpcoming"></calsoft-task-new>
                                </div>


                                <div *ngIf="activeTaskFilter === 'overdue'">
                                    <calsoft-task-new (scrollChange)="onScrollUpDue()" (taskUpdated)="onTaskUpdated()"
                                        [type]="1" [onScrollValue]="onScrollValue" [taskType]="taskType"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [totalSize]="totalSizeDue-1" [page]="pagetwoDue"
                                        [leadActivityListFinal]="leadActivityListDueFinal" [total]="totalDue"
                                        [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListDue"></calsoft-task-new>
                                </div>


                                <div *ngIf="activeTaskFilter === 'completed'">
                                    <calsoft-task-new (scrollChange)="onScrollUpCompleted()"
                                        (taskUpdated)="onTaskUpdated()" [type]="1" [onScrollValue]="onScrollValue"
                                        [taskType]="taskType" [totalSize]="totalSizeDue-1" [page]="pagetwoCompleted"
                                        [templateDisplayed]="templateDisplayed" [crmType]="crmType"
                                        [leadActivityListFinal]="leadActivityListFinalCompleted"
                                        [total]="totalSizeCompleted" [entityId]="leadId" [spinner]="spinner"
                                        [activityList]="leadActivityListCompleted"></calsoft-task-new>
                                </div>

                            </div>


                            <div *ngIf="activeTabInner === 'meetings'">
                                <div class="width-table">
                                    <calsoft-leadsmeeting [leadId]="leadId" [googleCalendarList]="googleCalendarList"
                                        [meetingType]="1" [type]="1" class="width-table">
                                    </calsoft-leadsmeeting>
                                </div>
                            </div>



                            <div *ngIf="activeTabInner === 'Chats'">
                                <div *ngIf="leadLoaded && whatAppchatType === 1">
                                    <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                        [isFromPhone]="true">
                                    </calsoft-whatsapp-chat-details>
                                </div>
                                <div *ngIf="leadLoaded && whatAppchatType === 2">
                                    <calsoft-whats-app-new-client [phoneNumber]="LeadDetailsObject?.phoneNumber">
                                    </calsoft-whats-app-new-client>
                                </div>
                            </div>

                            <div *ngIf="activeTabInner === 'Email Sent'">
                                <div class="mailbox-container">

                                    <div class="mailbox-toggle-container">
                                        <mat-button-toggle-group [(value)]="currentMailBox"
                                            (change)="loadEmails($event)">
                                            <mat-button-toggle (click)="loadEmails({ value: 'INBOX' })"
                                                value="INBOX">Inbox
                                            </mat-button-toggle>
                                            <mat-button-toggle (click)="loadEmails({ value: 'Sent' })" value="Sent">Sent
                                            </mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>


                                    <div class="mailbox-content">

                                        <div class="mailbox-email-list" [class.full-width]="!selectedIndex">
                                            <ng-container *ngIf="isLoading; else emailListTemplate">
                                                <div class="loading-spinner">
                                                    <mat-spinner diameter="40"></mat-spinner>
                                                    <p>Loading emails...</p>
                                                </div>
                                            </ng-container>
                                            <ng-template #emailListTemplate>
                                                <mat-paginator [length]="totalEmails" [pageSize]="pageSizeEmail"
                                                    [pageIndex]="pageIndex" (page)="onPageChange($event)">
                                                </mat-paginator>

                                                <mat-nav-list>
                                                    <mat-list-item *ngFor="let email of emails; let i = index"
                                                        [ngClass]="{
                                                    'mailbox-email-list-item': true,
                                                    'active': i === selectedIndex
                                                    }" (click)="selectEmail(i)">
                                                        <div class="mailbox-email-list-item">
                                                            <div class="mailbox-email-header">
                                                                <span class="mailbox-email-subject">{{
                                                                    email.subject }}</span>
                                                                <span class="mailbox-email-date">{{
                                                                    email.sentDate |
                                                                    date:'medium'
                                                                    }}</span>
                                                            </div>
                                                            <div class="mailbox-email-preview">
                                                                <span class="mailbox-email-from-to">
                                                                    {{ currentMailBox === 'INBOX' ?
                                                                    extractEmailAddress(email.from)
                                                                    : email.to }}
                                                                </span>
                                                                <span class="mailbox-email-body-preview">
                                                                    {{ truncateSafeHTML(email.body, 150) }}
                                                                </span>


                                                            </div>
                                                        </div>
                                                    </mat-list-item>
                                                </mat-nav-list>
                                            </ng-template>

                                        </div>



                                        <div *ngIf="emailVisble; else placeholder" class="mailbox-email-wrapper">

                                            <div class="mailbox-email-detail"
                                                [ngClass]="{ 'show-detail': isMobileView }">
                                                <button [attr.guide]="'lead-detail-btn-270' + '__' + sanitizedUrl"
                                                    class="back-button" *ngIf="isMobileView" (click)="backToList()">
                                                    ← Back
                                                </button>
                                                <div class="mailbox-email-detail-header">
                                                    <h2>{{ emailObject.subject }}</h2>
                                                    <div class="mailbox-email-meta">
                                                        <!-- <div><strong>From:</strong> {{ emailObject.from[0].address }}
                                                </div> -->
                                                        <div><strong>To:</strong> {{ emailObject.to }}</div>
                                                        <div><strong>Date:</strong> {{ emailObject.sentDate
                                                            |
                                                            date:'medium' }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="mailbox-email-body" [innerHTML]="emailObject.body">
                                                </div>
                                                <div class="mailbox-email-attachments"
                                                    *ngIf="emails[selectedIndex]?.attachments?.length > 0">
                                                    <h4>Attachments</h4>
                                                    <ul>
                                                        <li *ngFor="let file of emails[selectedIndex].attachments">
                                                            <div *ngIf="isImage(file.contentType)">

                                                                <!-- <img [src]="newserverpath + file.fileName"
                                                                                [alt]="file.fileName"
                                                                                style="height: 50px; width: 100%"> -->



                                                                <calsoft-common-images
                                                                    [src]="serverPathEmail + file.fileName"
                                                                    [height]="'50px'" [width]="'auto'"
                                                                    [alt]="file.fileName">
                                                                </calsoft-common-images>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>


                                        </div>


                                        <ng-template #placeholder>
                                            <div class="mailbox-placeholder">
                                                <mat-icon style="overflow: hidden;">drafts</mat-icon>
                                                <h3>Select an email to read</h3>
                                                <p>Choose a message from your Mails to view it here</p>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <ng-template #loading>
                                        <div class="global-loading">
                                            <mat-spinner></mat-spinner>
                                            <p>Fetching emails...</p>
                                        </div>
                                    </ng-template>
                                    <ng-template #emptyState>
                                        <div class="empty-state">
                                            <div class="empty-icon">📭</div>
                                            <h3>No emails found</h3>
                                            <p>Your folder is empty</p>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>

                            <div *ngIf="activeTabInner === 'Calls'">
                                <div class="call-section-bg">
                                    <div class="tab-pane fade" id="calls">
                                        <div class="card">
                                            <div
                                                class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                                                <h4 class="fw-semibold">Calls</h4>

                                                <!-- <button [attr.guide]="'lead-detail-btn-271' + '__' + sanitizedUrl" mat-button class="matcss" [matMenuTriggerFor]="menu">
                                    <mat-icon class="icon-css">assignment</mat-icon>
                                    <span style="font-size: 13px;color: gray;">Task</span>
                                </button> -->

                                                <mat-menu #menu="matMenu">
                                                    <button [attr.guide]="'lead-detail-btn-272' + '__' + sanitizedUrl"
                                                        *ngIf="crmType!=2" mat-menu-item
                                                        (click)="addLeadActivityone('Follow Up',0,null)">Follow
                                                        Up
                                                    </button>
                                                    <button [attr.guide]="'lead-detail-btn-273' + '__' + sanitizedUrl"
                                                        mat-menu-item
                                                        (click)="addLeadActivityone('Phone Call',0,null)">Phone
                                                        Call</button>
                                                    <button [attr.guide]="'pipeline-btn-92' + '__' + sanitizedUrl"
                                                        mat-menu-item (click)="addSiteVisitPopup()">Site
                                                        visit</button>
                                                    <button [attr.guide]="'lead-detail-btn-274' + '__' + sanitizedUrl"
                                                        *ngIf="enableLocation == '1'" mat-menu-item
                                                        (click)="addLeadActivityone('Location',0,null)">Location</button>
                                                </mat-menu>
                                            </div>
                                            <div class="card-body" *ngIf="calllist?.length > 0; else noData">
                                                <div class="card mb-3" *ngFor="let lead of calllist;">

                                                    <div class="card-body">
                                                        <div
                                                            class="d-sm-flex align-items-center justify-content-between pb-2">
                                                            <div class="d-flex align-items-center mb-2">
                                                                <span class="avatar-md me-2 flex-shrink-0">
                                                                    <mat-icon class="default-icon">person</mat-icon>
                                                                </span>
                                                                <p class="m-0"><span
                                                                        class="text-dark fw-medium">{{lead.customerName}}</span>
                                                                    logged a call on {{lead.updatedDate}}
                                                                </p>
                                                            </div>
                                                            <div class="d-inline-flex align-items-center mb-2">
                                                                <div class="dropdown me-2">
                                                                    <a href="javascript:void(0);" class="py-1"
                                                                        [ngClass]="{
                                                                'bg-success be-9': lead.phoneCallOutcome === 'completed' || lead.phoneCallOutcome === 'Answered',
                                                                'bg-danger be-9': lead.phoneCallOutcome === 'failed',
                                                                'bg-warning be-9': lead.phoneCallOutcome === 'call Not Answered'
                                                            }" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        {{lead.phoneCallOutcome |
                                                                        titlecase}}
                                                                        <i class="ti ti-chevron-down ms-2"></i>
                                                                    </a>


                                                                </div>
                                                                <div class="dropdown">
                                                                    <a href="javascript:void(0);"
                                                                        class="p-0 btn btn-icon btn-sm d-flex align-items-center justify-content-center"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"><i
                                                                            class="ti ti-dots-vertical"></i></a>
                                                                    <div class="dropdown-menu dropdown-menu-right">
                                                                        <a class="dropdown-item"
                                                                            href="javascript:void(0);"><i
                                                                                class="ti ti-edit text-blue me-1"></i>Edit</a>
                                                                        <a class="dropdown-item"
                                                                            href="javascript:void(0);"><i
                                                                                class="ti ti-trash text-danger me-1"></i>Delete</a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span [innerHTML]="lead.notes"> </span>
                                                    </div>
                                                </div>

                                            </div>

                                            <ng-template #noData>
                                                <div class="text-center text-muted py-4">
                                                    <p>No data found.</p>
                                                </div>
                                            </ng-template>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="activeTabInner === 'Email Status'">

                                <div>
                                    <calsoft-send-all-email [leadId]="leadId" [type]="1">
                                    </calsoft-send-all-email>
                                </div>


                            </div>

                            <div *ngIf="activeTabInner === 'Inbound Emails'">

                                <div class="width-table2">
                                    <calsoft-inbound-emails [leadObject]="LeadDetailsObject" [leadId]="leadId"
                                        [type]="1">
                                    </calsoft-inbound-emails>
                                </div>


                            </div>

                            <!-- <div *ngIf="activeTabInner === 'Email Status'">



                                    </div> -->

                        </div>
                    </div>

                    <div *ngSwitchCase="'Company'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-account-companies-table [defaultSet]="defaultSet" [type]="1"
                                    [defaultSetType]="defaultSetType"
                                    [leadId]="relatedCompanyId"></calsoft-account-companies-table>
                            </div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'Deals'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-deal-table [type]="2" [dealsPrimaryType]="0" [DealType]="2"
                                    [data]="LeadDetailsObject" [defaultSet]="defaultSet"
                                    [defaultSetType]="defaultSetType" [leadId]="leadId"
                                    [dealsTableView]="1"></calsoft-deal-table>
                            </div>
                        </div>
                    </div>
                    <!-- <div *ngSwitchCase="'Freddy AI insights'">
                        <div class="card">Freddy AI insights Content</div>
                    </div> -->
                    <div *ngSwitchCase="'Files'">
                        <div class="card">
                            <div class="width-table">
                                <div class="width-table">
                                    <div class="editSets1 ">
                                        <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                            <span>Files</span>

                                            <button [attr.guide]="'lead-detail-btn-275' + '__' + sanitizedUrl"
                                                mat-icon-button>
                                                <mat-icon (click)="createFile(null,0)">
                                                    add
                                                </mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <div style="overflow-x:auto;">
                                        <table>
                                            <tr>
                                                <th>Name</th>
                                                <th>Owner</th>
                                                <th>File Type</th>
                                                <th>Added On</th>
                                                <!-- <th>Tags</th> -->
                                                <th>Download</th>
                                                <th>Action</th>
                                            </tr>
                                            <tr *ngFor="let note of noteList;">
                                                <ng-container
                                                    *ngIf="note.notesDocument && note.notesDocument.length > 0">

                                                    <td>
                                                        <!-- If Image -->
                                                        <img *ngIf="note.documentType == '4'" width="36" height="36"
                                                            [src]="serverPathNotes + note.notesDocument + cid"
                                                            alt="Uploaded Image">

                                                        <!-- If Vedio -->

                                                        <img *ngIf="note.documentType == '1'"
                                                            src="assets/images/mp4.png" width="36" height="36"
                                                            alt="Vedio File">

                                                        <!-- If Audio -->

                                                        <img *ngIf="note.documentType == '2'"
                                                            src="assets/images/mp3.png" width="36" height="36"
                                                            alt="Audio File">

                                                        <!-- If Pdf -->
                                                        <img *ngIf="note.documentType == '3'"
                                                            src="assets/images/pdf.png" width="36" height="36"
                                                            alt="PDF File">

                                                        <!-- If Word -->
                                                        <img *ngIf="note.documentType == '5' || note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                            src="assets/images/docx.png" width="36" height="36"
                                                            alt="DOCX File">

                                                        <!-- If Excel -->
                                                        <img *ngIf="note.documentType == '6' || note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                            src="assets/images/excel.png" width="36" height="36"
                                                            alt="Excel File">

                                                        <!-- {{ note.notesDocument }} -->
                                                    </td>
                                                    <td>{{note.createdBy}}</td>
                                                    <td>{{note.resource}}</td>
                                                    <td>{{note.createdDate | calsoftDate}}</td>
                                                    <!-- <td>{{note.taggedUser}}</td> -->
                                                    <td style="cursor: pointer;"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)">
                                                        <mat-icon>download</mat-icon>
                                                    </td>
                                                    <td style="cursor: pointer;" (click)="deleteNote(note)">
                                                        <mat-icon>delete</mat-icon>
                                                    </td>
                                                </ng-container>

                                            </tr>


                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'Sequences'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    </div>
</div>
<!-- ========================================================================= -->
<!-- TYPE-8: FULLY DYNAMIC LEAD DETAIL LAYOUT                                  -->
<!-- ========================================================================= -->
<div *ngIf="leadDetailPageType === 7" class="new-leadType-five type8-container" fxLayout="column" fxFlex
    style="width: 100%; max-width: 100%; min-width: 0; box-sizing: border-box; overflow-x: hidden;">

    <div class="lead-detail-page" fxLayout="column" fxFlex
        style="width: 100%; max-width: 100%; min-width: 0; box-sizing: border-box; overflow-x: hidden;">

        <!-- TOP ACTIONS HEADER (Desktop) -->
        <div class="header-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" fxHide.lt-md
            fxHide.md>
            <button [attr.guide]="'lead-detail-btn-t8-back' + '__' + sanitizedUrl" class="header-btn" (click)="back()">
                <span class="material-symbols-outlined">keyboard_backspace</span> Back
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-email' + '__' + sanitizedUrl" class="header-btn"
                (click)="openEmailPopup()">
                <span class="material-symbols-outlined">email</span> Email
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-owner' + '__' + sanitizedUrl" class="header-btn"
                (click)="transferLead()">
                <span class="material-symbols-outlined">person_outline</span> Change Owner
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-doc' + '__' + sanitizedUrl" *ngIf="documentEnable"
                class="header-btn" (click)="downloadDocumentPopup()">
                <span class="material-symbols-outlined">download</span> {{document}}
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-inv' + '__' + sanitizedUrl" class="header-btn"
                (click)="navigateToInvoice(LeadDetailsObject)">
                <span class="material-symbols-outlined">library_books</span> {{invoicebutton || 'Invoice'}}
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-quot' + '__' + sanitizedUrl" class="header-btn"
                (click)="navigateToQuotation(LeadDetailsObject)">
                <span class="material-symbols-outlined">request_quote</span> {{quotationbutton || 'Quotation'}}
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-tmpl' + '__' + sanitizedUrl" *ngIf="sendEmailTemplateEnable"
                class="header-btn" (click)="sendEmailMessage()">
                <span class="material-symbols-outlined">mail</span> {{sendEmailTemplate}}
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-srch' + '__' + sanitizedUrl" *ngIf="builderSearchPopupEnable"
                class="header-btn" (click)="newSearch(LeadDetailsObject)">
                <span class="material-symbols-outlined">search</span> {{builderSearchPopup}}
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-call' + '__' + sanitizedUrl" class="header-btn"
                (click)="phoneNumbercall(LeadDetailsObject)">
                <span class="material-symbols-outlined">call</span> Call
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-task' + '__' + sanitizedUrl" class="header-btn"
                (click)="addLeadActivity('Phone Call',0,null)">
                <span class="material-symbols-outlined">task</span> Task
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-meet' + '__' + sanitizedUrl" class="header-btn"
                (click)="goToMeeting()">
                <span class="material-symbols-outlined">meeting_room</span> Meeting
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-deal' + '__' + sanitizedUrl" (click)="goToDeals()"
                class="header-btn-primary">
                <span class="material-symbols-outlined">add</span> Add deal
            </button>
            <button [attr.guide]="'lead-detail-btn-t8-more' + '__' + sanitizedUrl" type="button" class="header-btn"
                [matMenuTriggerFor]="type8ActionsMenu" (click)="$event.stopPropagation()">
                <span class="material-symbols-outlined">more_vert</span>
            </button>

            <mat-menu #type8ActionsMenu="matMenu" yPosition="below" xPosition="before">
                <button mat-menu-item (click)="navigateToInvoice(LeadDetailsObject)">
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">library_books</span>
                    <span>{{invoicebutton || 'Invoice'}}</span>
                </button>
                <button mat-menu-item (click)="navigateToQuotation(LeadDetailsObject)">
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">request_quote</span>
                    <span>{{quotationbutton || 'Quotation'}}</span>
                </button>
                <button [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>
                <button [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>
        </div>

        <!-- TOP ACTIONS HEADER (Mobile) -->
        <div class="header-container" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px" fxHide fxShow.lt-lg>
            <div class="mobile-actions header-actions-compact" fxLayout="row" fxLayoutAlign="end center"
                fxLayoutGap="8px">
                <button mat-icon-button class="action-icon" matTooltip="Email" (click)="openEmailPopup()">
                    <span class="material-symbols-outlined">email</span>
                </button>
                <button mat-icon-button class="action-icon" matTooltip="Call"
                    (click)="phoneNumbercall(LeadDetailsObject)">
                    <span class="material-symbols-outlined">call</span>
                </button>
                <button mat-icon-button class="action-icon" matTooltip="Change Owner" (click)="transferLead()">
                    <span class="material-symbols-outlined">person</span>
                </button>
                <button mat-flat-button color="primary" class="primary-compact header-btn-primary"
                    (click)="goToDeals()">
                    <span class="material-symbols-outlined">add</span>
                    <span class="label">Add deal</span>
                </button>
                <button mat-icon-button class="action-icon" [matMenuTriggerFor]="type8MobileMoreMenu">
                    <mat-icon>more_horiz</mat-icon>
                </button>
                <button mat-icon-button class="action-icon" [matMenuTriggerFor]="type8MobileEditMenu">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </div>

            <mat-menu #type8MobileEditMenu="matMenu" yPosition="below" xPosition="before">
                <button [disabled]="!resourcePrivilege?.update" (click)="editProduct()" mat-menu-item>
                    <span class="material-symbols-outlined"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">edit</span>
                    <span>Edit</span>
                </button>
                <button [disabled]="!resourcePrivilege?.delete" (click)="deleteAllProductId()" mat-menu-item>
                    <span class="material-symbols-outlined new-menu"
                        style="font-size: 20px;line-height: 1;vertical-align: sub;padding-right: 5px;">delete</span>
                    <span>Delete</span>
                </button>
            </mat-menu>

            <mat-menu #type8MobileMoreMenu="matMenu" yPosition="below" xPosition="before">
                <button mat-menu-item (click)="addLeadActivity('Phone Call',0,null)">Task</button>
                <button mat-menu-item (click)="goToMeeting()">Meeting</button>
                <button mat-menu-item (click)="downloadDocumentPopup()" *ngIf="documentEnable">Document</button>
                <button mat-menu-item (click)="navigateToInvoice(LeadDetailsObject)">{{invoicebutton ||
                    'Invoice'}}</button>
                <button mat-menu-item (click)="navigateToQuotation(LeadDetailsObject)">{{quotationbutton ||
                    'Quotation'}}</button>
                <button mat-menu-item (click)="sendEmailMessage()"
                    *ngIf="sendEmailTemplateEnable">{{sendEmailTemplate}}</button>
                <button mat-menu-item (click)="newSearch(LeadDetailsObject)"
                    *ngIf="builderSearchPopupEnable">{{builderSearchPopup}}</button>
            </mat-menu>
        </div>

        <!-- MAIN LAYOUT WRAPPER (Left Sidebar + Dynamic Right Content Area) -->
        <div class="main-content-wrapper" fxLayout="row" fxLayout.lt-md="column" fxFlex
            style="width: 100%; max-width: 100%; min-width: 0; box-sizing: border-box; overflow-x: hidden; padding: 20px 24px; gap: 20px;">

            <!-- LEFT SIDEBAR -->
            <div class="left-sidebar" fxFlex="22" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="10px"
                style="flex: 0 0 280px; width: 280px; min-width: 280px; max-width: 280px; box-sizing: border-box; overflow-y: auto; max-height: calc(100vh - 100px); align-self: flex-start; margin-top: 0; padding-top: 0;">

                <!-- Profile summary card -->
                <div class="profile-card" style="margin-top: 0;">
                    <div class="profile-header" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <div class="avatar-container" (click)="openViewDialog()">
                                <img *ngIf="LeadDetailsObject?.image; else initialAvatarT8" [src]="uploadedImageUrl"
                                    alt="Profile Avatar" class="avatar-image" />
                                <ng-template #initialAvatarT8>
                                    <div class="avatar-initial">
                                        {{ LeadDetailsObject?.name?.charAt(0) | uppercase }}
                                    </div>
                                </ng-template>
                                <div class="overlay">
                                    <div class="overlay-text">{{ LeadDetailsObject?.image ? 'View' : 'Add' }}</div>
                                </div>
                            </div>
                            <div class="overlay-details" style="min-width: 0; overflow: hidden;">
                                <div class="name-row"
                                    style="display:flex;align-items:center;gap:8px;min-width: 0;overflow: hidden;">
                                    <h2 class="name mobile-truncate-name"
                                        style="margin:0;min-width: 0;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                        *ngIf="!isEditMode">
                                        {{ LeadDetailsObject?.name || '—' }}
                                    </h2>
                                    <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.name" placeholder="Name"
                                        style="font-size:16px;font-weight:bold;border:1px solid #ccc;border-radius:4px;padding:2px 6px;width:150px;" />
                                    <button *ngIf="!isEditMode" mat-icon-button (click)="toggleEditMode()"
                                        class="profile-edit-btn" matTooltip="Edit profile" style="flex-shrink:0;">
                                        <mat-icon style="font-size: 16px;">edit</mat-icon>
                                    </button>
                                    <button *ngIf="isEditMode" mat-icon-button color="primary"
                                        (click)="saveAllProfileEdits()" class="profile-save-btn"
                                        matTooltip="Save profile" style="flex-shrink:0;">
                                        <mat-icon style="font-size: 18px;">check</mat-icon>
                                    </button>
                                    <button *ngIf="isEditMode" mat-icon-button (click)="toggleEditMode()"
                                        class="profile-cancel-btn" matTooltip="Cancel" style="flex-shrink:0;">
                                        <mat-icon style="font-size: 18px;">close</mat-icon>
                                    </button>
                                </div>
                                <p class="lead-id" style="margin:0;">Lead ID: {{ LeadDetailsObject?.leadId ||
                                    LeadDetailsObject?.entityId }}</p>
                            </div>
                        </div>

                        <!-- Profile Info Details -->
                        <div class="profile-info">
                            <div class="flex items-center">
                                <p class="title items-center gap-2"
                                    [style.cursor]="isEditMode ? 'text' : (LeadDetailsObject?.company ? 'pointer' : 'not-allowed')">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">corporate_fare</mat-icon>
                                    <ng-container *ngIf="!isEditMode">
                                        <span style="font-weight: bold;color: black;"
                                            (click)="LeadDetailsObject?.companyId ? companyDetailPage(LeadDetailsObject?.companyId) : null">
                                            {{ LeadDetailsObject?.company || '—' }}
                                        </span>
                                    </ng-container>
                                    <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.company"
                                        placeholder="Company"
                                        style="border:none;background:transparent;font-weight:bold;outline:none;transition:all 160ms;width:160px;" />
                                </p>
                            </div>

                            <div class="flex items-center" style="word-break: break-all;">
                                <p class="title items-center gap-2">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">work</mat-icon>
                                    <span>
                                        <span *ngIf="!isEditMode">{{ LeadDetailsObject?.jobtitle || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.jobtitle"
                                            placeholder="Job title"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:140px;" />
                                    </span>
                                </p>
                            </div>

                            <!-- Email -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2">
                                    <mat-icon (click)="LeadDetailsObject?.email ? openEmailPopup() : null"
                                        style="font-size: 16px; padding-top: 10px;" class="primary-icon">mail</mat-icon>
                                    <span style="word-break: break-all;">
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{
                                            LeadDetailsObject?.email || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.email"
                                            placeholder="Email"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:180px;" />
                                    </span>
                                    <mat-icon *ngIf="LeadDetailsObject?.email"
                                        style="font-size: 16px; padding-top: 8px; margin-left: 10px;"
                                        class="cursor-pointer text-gray-500 hover:text-gray-700"
                                        (click)="LeadDetailsObject?.email ? copyToClipboard(LeadDetailsObject?.email) : null">content_copy</mat-icon>
                                </p>
                            </div>

                            <!-- Phone -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">call</mat-icon>
                                    <span>
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                            LeadDetailsObject?.phoneNumber || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.phoneNumber"
                                            placeholder="Phone"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:120px;" />
                                    </span>
                                </p>
                            </div>

                            <!-- WhatsApp -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2" style="display: inline-flex;">
                                    <mat-icon style="font-size: 19px;" [icIcon]="icWhatsapp"></mat-icon>
                                    <span style="margin-bottom: -6px;">
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.phoneNumber ? phonewhatsapp(LeadDetailsObject) : null">{{
                                            LeadDetailsObject?.phoneNumber || '—' }}</span>
                                        <input *ngIf="isEditMode" [(ngModel)]="LeadDetailsObject.phoneNumber"
                                            placeholder="WhatsApp"
                                            style="border:none;background:transparent;outline:none;transition:all 160ms;width:120px;" />
                                    </span>
                                </p>
                            </div>

                            <!-- Sales Owner -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">attribution</mat-icon>
                                    <span>
                                        <span *ngIf="!isEditMode">{{ LeadDetailsObject?.ownerIdName || '—' }}</span>
                                        <mat-form-field *ngIf="isEditMode" appearance="outline" class="inline-select"
                                            style="width:140px;margin:0;">
                                            <mat-select [(value)]="LeadDetailsObject.ownerId"
                                                (selectionChange)="onOwnerChange($event.value)" disableRipple>
                                                <mat-option *ngFor="let o of salesOwners"
                                                    [value]="(o.entityId || o.ownerId || o.OwnerId) + ''">
                                                    {{ o.email || o.ownerEmail || o.OwnerName || o.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </span>
                                </p>
                            </div>

                            <!-- Lead Status -->
                            <div class="flex items-center">
                                <p class="title items-center gap-2">
                                    <mat-icon style="font-size: 16px; padding-top: 10px;"
                                        class="primary-icon">info</mat-icon>
                                    <span>
                                        <span *ngIf="!isEditMode"
                                            (click)="LeadDetailsObject?.statusName ? openStatusDetail(LeadDetailsObject?.statusName) : null">
                                            {{ LeadDetailsObject?.statusName || '—' }}
                                        </span>
                                        <mat-form-field *ngIf="isEditMode" appearance="outline" class="inline-select"
                                            style="width:120px;margin:0;">
                                            <mat-select [(value)]="LeadDetailsObject.statusId"
                                                (selectionChange)="onStatusChange($event.value)" disableRipple>
                                                <mat-option *ngFor="let s of filtereddropdownTypeList"
                                                    [value]="(s.statusId || s.id) + ''">{{ s.statusName }}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Lead score card -->
                    <div class="score-card">
                        <div class="score-header">
                            <span>Score</span>
                        </div>
                        <div class="score-content">
                            <h3 class="score-value">{{ LeadDetailsObject?.score || 0.0 }}</h3>
                            <div class="stars">
                                <ng-container *ngFor="let star of starsArray; let i = index">
                                    <span class="material-symbols-outlined"
                                        [ngClass]="{ 'fill': i < filledStars }">star</span>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- DYNAMIC MAIN SECTIONS LEFT NAVIGATION (Type-8) -->
                <nav class="left-navigation">
                    <div class="nav-header">
                        <span>Sections</span>
                    </div>
                    <div *ngIf="type8Loading" style="padding: 20px; text-align: center;">
                        <mat-spinner diameter="24"></mat-spinner>
                    </div>
                    <ul *ngIf="!type8Loading">
                        <li *ngFor="let sec of type8Sections" (click)="selectType8Section(sec)"
                            [class.active]="activeType8Section?.activityListId === sec.activityListId">
                            <span class="material-symbols-outlined icon">{{ getType8Icon(sec) }}</span>
                            <span class="tab-name">{{ sec.label }}</span>
                        </li>
                    </ul>
                    <div *ngIf="!type8Loading && (!type8Sections || type8Sections.length === 0)"
                        style="padding: 16px; color: #94a3b8; font-size: 13px; text-align: center;">
                        No active sections found.
                    </div>
                </nav>

            </div>

            <!-- DYNAMIC RIGHT CONTENT AREA -->
            <div class="right-content-area" fxLayout="column" fxFlex="78" fxFlex.lt-md="100"
                style="flex: 1 1 0%; width: calc(100% - 300px); max-width: calc(100% - 300px); min-width: 0; overflow-x: hidden; box-sizing: border-box;">

                <!-- HORIZONTAL CHILD TABS (when active section has child components/tabs) -->
                <div class="type8-child-tabs-bar" *ngIf="getActiveChildTabs(activeType8Section).length > 0"
                    style="width: 100%; max-width: 100%; min-width: 0; overflow-x: auto; overflow-y: hidden; box-sizing: border-box; -webkit-overflow-scrolling: touch; border-bottom: 2px solid #e2e8f0; margin-bottom: 20px; padding: 4px 0 8px 0; background: #ffffff; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.05);">
                    <div
                        style="display: flex; gap: 8px; flex-wrap: nowrap; min-width: max-content; align-items: center; padding: 2px 8px;">
                        <button *ngFor="let child of getActiveChildTabs(activeType8Section)" type="button" mat-button
                            style="flex: 0 0 auto; white-space: nowrap; font-size: 14px; line-height: 24px; min-height: 38px; padding: 6px 20px; border-radius: 6px 6px 0 0; cursor: pointer; display: inline-flex; align-items: center; justify-content: center;"
                            (click)="selectType8ChildTab(child)" [ngStyle]="{
                                'border-bottom': isChildTabActive(child) ? '3px solid #1666eb' : '3px solid transparent',
                                'font-weight': isChildTabActive(child) ? '600' : '500',
                                'color': isChildTabActive(child) ? '#1666eb' : '#475569',
                                'background-color': isChildTabActive(child) ? '#eff6ff' : 'transparent'
                            }">
                            <span style="display: inline-block;">{{ child.label || child.name || 'Tab' }}</span>
                        </button>
                    </div>
                </div>

                <!-- Child Tabs Missing Notice -->
                <div *ngIf="Number(activeType8Section?.type) === 0 && getActiveChildTabs(activeType8Section).length === 0 && !activeType8ComponentKey"
                    style="padding: 30px; text-align: center; background: #fff; border-radius: 8px; border: 1px dashed #cbd5e1; margin: 16px 0;">
                    <mat-icon style="font-size: 36px; color: #94a3b8;">tab_unselected</mat-icon>
                    <p style="margin-top: 8px; color: #64748b; font-size: 14px;">No active child tabs are configured for
                        this section.</p>
                </div>

                <!-- DYNAMIC COMPONENT SWITCH -->
                <div [ngSwitch]="activeType8ComponentKey" class="dynamic-content" style="width: 100%;">

                    <!-- 1. OVERVIEW -->
                    <div *ngSwitchCase="'overview'" class="overview">
                        <div class="overview-cont">
                            <header class="overview-header">
                                <h1 class="title">Overview</h1>
                                <mat-form-field>
                                    <input [attr.guide]="'lead-detail-inp-t8-ov-srch' + '__' + sanitizedUrl" matInput
                                        placeholder="Search..." [(ngModel)]="globalSearchText"
                                        (keydown.enter)="onGlobalSearchChange(globalSearchText)"
                                        (keydown.backspace)="onGlobalSearchBackspace($event)" />
                                    <button mat-icon-button matSuffix *ngIf="globalSearchText" aria-label="Clear search"
                                        (click)="resetSearch()"
                                        style="height:28px;width:28px;min-width:28px;padding:0;">
                                        <mat-icon style="font-size:16px;line-height:28px;">close</mat-icon>
                                    </button>
                                </mat-form-field>
                            </header>

                            <!-- Lifecycle and Status Pipeline Section -->
                            <section *ngIf="!isSearching" class="pipeline-section" style="margin-bottom: 20px;">
                                <div class="status-pipeline-wrapper">
                                    <label>Status</label>
                                    <div class="status-pipeline">
                                        <div *ngFor="let step of filtereddropdownTypeList; let i = index"
                                            class="strip-stage" [ngClass]="{
                                                'stage-current': step.statusName === LeadDetailsObject?.statusName,
                                                'stage-completed': i <= currentStatusIndex,
                                                'last-stage': i === filtereddropdownTypeList.length - 1
                                            }" [attr.data-toggle]="'tooltip'" [attr.data-html]="'true'"
                                            [attr.data-container]="'body'" [attr.title]="generateTooltip(step)"
                                            (click)="updateLeadStatusNew($event,step)">
                                            <span>{{ step.statusName }}</span>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <!-- Overview Details Cards -->
                            <div class="details-content">
                                <div class="content-section">
                                    <div class="section-header">
                                        <h3>Basic Information</h3>
                                    </div>
                                    <div class="section-body">
                                        <div class="details-grid-4col">
                                            <div class="info-item"><label>Email</label>
                                                <div class="value-display">
                                                    <a [attr.guide]="'lead-detail-lnk-t8-ov-email' + '__' + sanitizedUrl"
                                                        [matTooltip]="LeadDetailsObject?.email"
                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email
                                                        || '—'}}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-email' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('email', 'Email', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Name</label>
                                                <div class="value-display">
                                                    <a [matTooltip]="LeadDetailsObject?.name">{{LeadDetailsObject?.name
                                                        || '—'}}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-name' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('name', 'Name', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Company</label>
                                                <div class="value-display">
                                                    <a [attr.guide]="'lead-detail-lnk-t8-ov-comp' + '__' + sanitizedUrl"
                                                        [matTooltip]="LeadDetailsObject?.company"
                                                        (click)="goToCompany()">{{LeadDetailsObject?.company ||
                                                        '—'}}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-comp' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('company', 'Company', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Job Title</label>
                                                <div class="value-display">
                                                    <a [matTooltip]="LeadDetailsObject?.jobtitle">{{LeadDetailsObject?.jobtitle
                                                        || '—'}}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-job' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Phone</label>
                                                <div class="value-display">
                                                    <a [attr.guide]="'lead-detail-lnk-t8-ov-phone' + '__' + sanitizedUrl"
                                                        [matTooltip]="LeadDetailsObject?.phoneNumber"
                                                        (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{LeadDetailsObject?.phoneNumber
                                                        || '—'}}</a>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-phone' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Sales Owner</label>
                                                <div class="value-display">
                                                    <span class="value mobile-truncate-email"
                                                        matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{LeadDetailsObject?.ownerIdName
                                                        || '—'}}</span>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-owner' + '__' + sanitizedUrl"
                                                        (click)="transferLead()" class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Lead Status</label>
                                                <div class="value-display">
                                                    <span
                                                        [matTooltip]="LeadDetailsObject?.statusName">{{LeadDetailsObject?.statusName
                                                        || '—'}}</span>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-status' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('leadStatus', 'Lead Status', 'select')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="info-item"><label>Lead Source</label>
                                                <div class="value-display">
                                                    <span
                                                        [matTooltip]="LeadDetailsObject?.sourceName">{{LeadDetailsObject?.sourceName
                                                        || '—'}}</span>
                                                    <button
                                                        [attr.guide]="'lead-detail-btn-t8-ov-ed-source' + '__' + sanitizedUrl"
                                                        (click)="openEditPopup('sourceName', 'Lead Source', 'select')"
                                                        class="edit-btn">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2. CONTACT DETAILS / BASIC INFORMATION / ALL DETAILS (Unified Single Page) -->
                    <div *ngSwitchCase="'contactDetails'">
                        <ng-container *ngTemplateOutlet="type8ContactDetailsTpl"></ng-container>
                    </div>
                    <div *ngSwitchCase="'allDetails'">
                        <ng-container *ngTemplateOutlet="type8ContactDetailsTpl"></ng-container>
                    </div>
                    <div *ngSwitchCase="'basicInformation'">
                        <ng-container *ngTemplateOutlet="type8ContactDetailsTpl"></ng-container>
                    </div>

                    <!-- 3. MY VIEWS / LEAD INFORMATION / ORIGINAL LEAD FORMAT (Unified Single Page) -->
                    <div *ngSwitchCase="'myViews'">
                        <ng-container *ngTemplateOutlet="type8MyViewsTpl"></ng-container>
                    </div>
                    <div *ngSwitchCase="'leadInformation'">
                        <ng-container *ngTemplateOutlet="type8MyViewsTpl"></ng-container>
                    </div>
                    <div *ngSwitchCase="'originalLeadFormat'">
                        <ng-container *ngTemplateOutlet="type8MyViewsTpl"></ng-container>
                    </div>

                    <!-- TEMPLATE: UNIFIED CONTACT DETAILS -->
                    <ng-template #type8ContactDetailsTpl>
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>Contact details</h2>
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-t8-all' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'all'" (click)="setView('all')">All details</button>
                                <button [attr.guide]="'lead-detail-btn-t8-basic' + '__' + sanitizedUrl"
                                    [class.active]="activeView === 'basic'" (click)="setView('basic')">Basic
                                    information</button>
                            </div>

                            <div class="details-content" [class.basic-view]="activeViewNew === 'basic'">
                                <div *ngIf="activeView === 'all'">
                                    <div class="content-section">
                                        <button [attr.guide]="'lead-detail-btn-t8-tgl-basic' + '__' + sanitizedUrl"
                                            class="section-toggle" (click)="toggleBasicInfo()">
                                            <i class="icon-chevron" [class.rotated]="isBasicInfoOpen"></i>
                                            <h3>Basic information</h3>
                                        </button>
                                        <div class="section-body" *ngIf="isBasicInfoOpen">
                                            <div class="details-grid-4col">
                                                <div class="info-item">
                                                    <label
                                                        (click)="LeadDetailsObject?.email ? openEmailPopup() : null">Email</label>
                                                    <div class="value-display">
                                                        <a class="small-email-text"
                                                            [attr.guide]="'lead-detail-lnk-t8-email' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email}}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-email' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Name</label>
                                                    <div class="value-display">
                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                            LeadDetailsObject?.name?.length > 20) ?
                                                            (LeadDetailsObject?.name | slice:0:20) + '...' :
                                                            LeadDetailsObject?.name }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-name' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Company</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-t8-comp' + '__' + sanitizedUrl"
                                                            (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-comp' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Job title</label>
                                                    <div class="value-display">
                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-job' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Telephone numbers</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <div class="info-item">
                                                    <label>Mobile</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-t8-mob' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject?.phoneNumber }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-mob' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Work phone</label>
                                                    <div class="value-display">
                                                        <a href="tel:{{LeadDetailsObject?.secondaryphoneno}}">{{
                                                            LeadDetailsObject?.secondaryphoneno }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-workph' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Sales owner</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <span class="value mobile-truncate-email"
                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                            LeadDetailsObject?.ownerIdName || '-' }}</span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-ed-owner' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <button [attr.guide]="'lead-detail-btn-t8-tgl-more' + '__' + sanitizedUrl"
                                            class="section-toggle" (click)="toggleMoreFields()">
                                            <i class="icon-chevron" [class.rotated]="isMoreFieldsOpen"></i>
                                            <h3>More fields</h3>
                                        </button>
                                        <div class="section-body" *ngIf="isMoreFieldsOpen">
                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Location</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <div class="info-item">
                                                            <label>Address</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.additionalSpec?.Address ||
                                                                    LeadDetailsObject?.address }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-addr' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('Address', 'Address', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item"
                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.State">
                                                            <label>City</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.isCustomizedValue?.City ||
                                                                    LeadDetailsObject?.city }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-city' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('City', 'City', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item"
                                                            *ngIf="LeadDetailsObject?.isCustomizedValue?.Country">
                                                            <label>State</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.isCustomizedValue?.State ||
                                                                    LeadDetailsObject?.state }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-state' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('State', 'State', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Country</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.isCustomizedValue?.Country ||
                                                                    LeadDetailsObject?.country }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-country' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('Country', 'Country', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Zipcode</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.isCustomizedValue?.Pincode ||
                                                                    LeadDetailsObject?.pincode }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-pin' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('pincode', 'Pincode', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Lifecycle stage</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <div class="info-item">
                                                            <label>Status</label>
                                                            <div class="value-display">
                                                                <a>{{LeadDetailsObject?.statusName}}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-status' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('statusName', 'Status Name', 'select')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Lost reason</label>
                                                            <div class="value-display">
                                                                <a
                                                                    *ngIf="LeadDetailsObject?.lostReason; else addReasonT8">{{
                                                                    LeadDetailsObject?.lostReason }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-lost' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('lostReason', 'Lost Reason', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                                <ng-template #addReasonT8>
                                                                    <span style="color: rgb(93, 93, 207);"
                                                                        class="value placeholder"
                                                                        (click)="lostReason()">
                                                                        Click to add
                                                                    </span>
                                                                </ng-template>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Score</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.score }}</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="sub-section">
                                                <div class="section-header">
                                                    <h4>Social profiles</h4>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <div class="info-item">
                                                            <label>LinkedIn</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.linkedIn }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-in' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('linkedIn', 'LinkedIn', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Twitter</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.twitter }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-tw' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('twitter', 'Twitter', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div class="info-item">
                                                            <label>Facebook</label>
                                                            <div class="value-display">
                                                                <a>{{ LeadDetailsObject?.facebook }}</a>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-ed-fb' + '__' + sanitizedUrl"
                                                                    (click)="openEditPopup('facebook', 'Facebook', 'text')"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div *ngIf="activeView === 'basic'">
                                    <div class="content-section">
                                        <div class="section-header">
                                            <h3>Basic information</h3>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <div class="info-item">
                                                    <label>Email</label>
                                                    <div class="value-display">
                                                        <a class="small-email-text"
                                                            [attr.guide]="'lead-detail-lnk-t8-b-email' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.email ? openEmailPopup() : null">{{LeadDetailsObject?.email}}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-email' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('email', 'Email', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Name</label>
                                                    <div class="value-display">
                                                        <a>{{ (LeadDetailsObject?.name?.indexOf(' ') === -1 &&
                                                            LeadDetailsObject?.name?.length > 20) ?
                                                            (LeadDetailsObject?.name | slice:0:20) + '...' :
                                                            LeadDetailsObject?.name }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-name' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('name', 'Name', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Company</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-t8-b-comp' + '__' + sanitizedUrl"
                                                            (click)="goToCompany()">{{LeadDetailsObject?.company }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-comp' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('company', 'Company', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Job title</label>
                                                    <div class="value-display">
                                                        <a>{{LeadDetailsObject?.jobtitle }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-job' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('jobtitle', 'Jobtitle', 'text')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Telephone numbers</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <div class="info-item">
                                                    <label>Mobile</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-t8-b-mob' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.phoneNumber ? phoneNumbercall(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject?.phoneNumber }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-mob' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('phoneNumber', 'Phone Number', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div class="info-item">
                                                    <label>Work phone</label>
                                                    <div class="value-display">
                                                        <a [attr.guide]="'lead-detail-lnk-t8-b-workph' + '__' + sanitizedUrl"
                                                            (click)="LeadDetailsObject?.secondaryphoneno ? phoneNumbercallSecondary(LeadDetailsObject) : null">{{
                                                            LeadDetailsObject?.secondaryphoneno }}</a>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-workph' + '__' + sanitizedUrl"
                                                            (click)="openEditPopup('secondaryphoneno', 'Secondary Phone No', 'number')"
                                                            class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="content-section">
                                        <div class="section-header">
                                            <h4>Sales owner</h4>
                                        </div>
                                        <div class="section-body">
                                            <div class="details-grid-4col">
                                                <div class="info-item">
                                                    <label>Sales owner</label>
                                                    <div class="value-display">
                                                        <span class="value mobile-truncate-email"
                                                            matTooltip="{{ LeadDetailsObject?.ownerIdName }}">{{
                                                            LeadDetailsObject?.ownerIdName || '-' }}</span>
                                                        <button
                                                            [attr.guide]="'lead-detail-btn-t8-b-ed-owner' + '__' + sanitizedUrl"
                                                            (click)="transferLead()" class="edit-btn">
                                                            <mat-icon>edit</mat-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <!-- TEMPLATE: UNIFIED MY VIEWS -->
                    <ng-template #type8MyViewsTpl>
                        <div class="contact-details-container">
                            <div class="details-header">
                                <h2>My Views</h2>
                                <div class="header-actions">
                                    <button [attr.guide]="'lead-detail-btn-t8-manage-flds' + '__' + sanitizedUrl"
                                        (click)="manageFields()" class="btn-secondary">Manage fields</button>
                                </div>
                            </div>

                            <div class="details-tabs">
                                <button [attr.guide]="'lead-detail-btn-t8-v-basic' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'basic'" (click)="setViewNew('basic')">Lead
                                    information</button>
                                <button [attr.guide]="'lead-detail-btn-t8-v-orig' + '__' + sanitizedUrl"
                                    [class.active]="activeViewNew === 'Original'"
                                    (click)="setViewNew('Original')">Original Lead Format</button>
                            </div>

                            <div class="details-content">
                                <div *ngIf="activeViewNew === 'Original'">
                                    <div class="content-section">
                                        <ng-container
                                            *ngIf="jsonRecieved && (jsonRecieved | keyvalue).length > 0; else noRecordT8">
                                            <div>
                                                <table id="details">
                                                    <tr *ngFor="let item of jsonRecieved | keyvalue">
                                                        <td>{{ item.key === 'adGroupName' ? 'Campaign Name' : item.key
                                                            }}</td>
                                                        <td>
                                                            <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                class="blackColor wordBreak" [innerHTML]="item.value">
                                                            </p>
                                                            <p *ngIf="item.key=='Lead Status'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.statusName"></p>
                                                            <p *ngIf="item.key=='Lead Source'"
                                                                class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.sourceName"></p>
                                                            <p *ngIf="item.key=='Category'" class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.category"></p>
                                                            <p *ngIf="item.key=='Product'" class="blackColor wordBreak"
                                                                [innerHTML]="LeadDetailsObject?.product"></p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #noRecordT8>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>

                                <div *ngIf="activeViewNew === 'basic'">
                                    <div class="content-section" *ngIf="manageFieldCustomization == 0">
                                        <ng-container>
                                            <div>
                                                <table
                                                    *ngIf="leadCommonPropertiesDisplay==1 && usedInSite!=null&&(usedInSite | keyvalue)?.length> 0">
                                                    <tr>
                                                        <th colspan="2">{{leadCommonPropertiesName || 'Lead
                                                            Information'}}</th>
                                                    </tr>
                                                    <ng-container *ngIf="!type3">
                                                        <tr *ngFor="let item of usedInSite | keyvalue">
                                                            <td>{{item.key}}</td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' &&item.key!='Lead Source' &&item.key!='Category' &&item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"></p>
                                                                <p *ngIf="item.key=='Lead Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"></p>
                                                                <p *ngIf="item.key=='Lead Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"></p>
                                                                <p *ngIf="item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"></p>
                                                                <p *ngIf="item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"></p>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <ng-container *ngIf="type3">
                                                        <tr *ngFor="let item of customList">
                                                            <td>{{item[0]}}</td>
                                                            <td>
                                                                <p *ngIf="item[0]!='Lead Status' &&item[0]!='Lead Source' && item[0]!='Lead_Source' &&item[0]!='Lead_Status' && item[0]!='Lead Source' && item[0]!='Category' && item[0]!='Product'"
                                                                    class="blackColor wordBreak" [innerHTML]="item[1]">
                                                                </p>
                                                                <p *ngIf="item[0]=='Lead Status' || item[0]=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"></p>
                                                                <p *ngIf="item[0]=='Lead Source' || item[0]=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"></p>
                                                                <p *ngIf="item[0]=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"></p>
                                                                <p *ngIf="item[0]=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"></p>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </table>

                                                <table
                                                    *ngIf="leadPropertiesDisplay==1 && filterList!=null&&(filterList | keyvalue)?.length> 0">
                                                    <tr>
                                                        <th colspan="2">{{leadPropertiesName || 'Lead Information'}}
                                                        </th>
                                                    </tr>
                                                    <ng-container *ngIf="!type2">
                                                        <tr *ngFor="let item of valuesList | keyvalue">
                                                            <td>{{item.key}}</td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' && item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"></p>
                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"></p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"></p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"></p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"></p>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <ng-container *ngIf="type2">
                                                        <tr *ngFor="let item of filterList | keyvalue">
                                                            <td>{{item.key}}</td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' && item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"></p>
                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"></p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"></p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"></p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"></p>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </table>

                                                <table
                                                    *ngIf="leadAdditionalPropertiesDisplay==1 && additionalSpec!=null&&(additionalSpec | keyvalue)?.length> 0">
                                                    <tr>
                                                        <th colspan="2">{{leadAdditionalPropertiesName || 'Lead
                                                            Additional Information'}}</th>
                                                    </tr>
                                                    <ng-container *ngIf="!type1">
                                                        <tr *ngFor="let item of additionalSpec | keyvalue">
                                                            <td>{{item.key}}</td>
                                                            <td>
                                                                <p *ngIf="item.key!='Lead Status' && item.key!='Lead_Source' && item.key!='Lead_Status' && item.key!='Lead Source' && item.key!='Category' && item.key!='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="item.value"></p>
                                                                <p *ngIf="item.key=='Lead Status' || item.key=='Lead_Status'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.statusName"></p>
                                                                <p *ngIf="item.key=='Lead Source' || item.key=='Lead_Source'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.sourceName"></p>
                                                                <p *ngIf="item.key=='Category' || item.key=='Category'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.category"></p>
                                                                <p *ngIf="item.key=='Product' || item.key=='Product'"
                                                                    class="blackColor wordBreak"
                                                                    [innerHTML]="LeadDetailsObject?.product"></p>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                    <ng-container *ngIf="type1">
                                                        <tr *ngFor="let item of additionalSpecList">
                                                            <td>{{ item[0] }}</td>
                                                            <td>
                                                                <ng-container [ngSwitch]="item[0]">
                                                                    <p *ngSwitchCase="'Lead Status'"
                                                                        class="blackColor wordBreak">{{
                                                                        LeadDetailsObject?.statusName }}</p>
                                                                    <p *ngSwitchCase="'Lead_Status'"
                                                                        class="blackColor wordBreak">{{
                                                                        LeadDetailsObject?.statusName }}</p>
                                                                    <p *ngSwitchCase="'Lead Source'"
                                                                        class="blackColor wordBreak">{{
                                                                        LeadDetailsObject?.sourceName }}</p>
                                                                    <p *ngSwitchCase="'Lead_Source'"
                                                                        class="blackColor wordBreak">{{
                                                                        LeadDetailsObject?.sourceName }}</p>
                                                                    <p *ngSwitchCase="'Category'"
                                                                        class="blackColor wordBreak">{{
                                                                        LeadDetailsObject?.category }}</p>
                                                                    <p *ngSwitchCase="'Product'"
                                                                        class="blackColor wordBreak">{{
                                                                        LeadDetailsObject?.product }}</p>
                                                                    <p *ngSwitchDefault class="blackColor wordBreak">{{
                                                                        item[1] }}</p>
                                                                </ng-container>
                                                            </td>
                                                        </tr>
                                                    </ng-container>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #noRecordT8Info>
                                            <div class="text-center text-muted py-4">
                                                <p>No data found.</p>
                                            </div>
                                        </ng-template>
                                    </div>

                                    <div class="content-section" *ngIf="manageFieldCustomization == 1">
                                        <ng-container *ngIf="mappedGroups?.length > 0; else noDataT8">
                                            <div class="content-section" *ngFor="let group of mappedGroups">
                                                <div class="section-header">
                                                    <h3>{{ group.groupName }}</h3>
                                                </div>
                                                <div class="section-body">
                                                    <div class="details-grid-4col">
                                                        <div class="info-item" *ngFor="let field of group.fields"
                                                            [class.expanded]="field.expanded">
                                                            <label>{{ field.fieldName }}</label>
                                                            <div class="value-display">
                                                                <ng-container [ngSwitch]="field.fieldKey">
                                                                    <a [attr.guide]="'lead-detail-lnk-t8-fld-email' + '__' + sanitizedUrl"
                                                                        *ngSwitchCase="'Email'"
                                                                        [matTooltip]="field.value"
                                                                        (click)="field.value !== '-' ? openEmailPopup() : null">
                                                                        {{ field.value }}
                                                                    </a>
                                                                    <span *ngSwitchDefault [matTooltip]="field.value"
                                                                        (click)="field.expanded = !field.expanded">
                                                                        {{ field.value }}
                                                                    </span>
                                                                </ng-container>
                                                                <button
                                                                    [attr.guide]="'lead-detail-btn-t8-fld-ed' + '__' + sanitizedUrl"
                                                                    *ngIf="!field.isReadOnly"
                                                                    (click)="openEditPopupNew(field.fieldKey, field.fieldName, field.fieldType, field); $event.stopPropagation()"
                                                                    class="edit-btn">
                                                                    <mat-icon>edit</mat-icon>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <ng-template #noDataT8>
                                            <div class="text-center text-muted py-4">
                                                <p>No fields configured.</p>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <!-- 8. ACTIVITIES (Timeline Hub) -->
                    <div *ngSwitchCase="'activities'">
                        <div class="activities-container" fxLayout="column">
                            <div class="activity-timeline-feed"
                                style="background:#fff; border-radius:8px; padding:16px;">
                                <div class="timeline-header" fxLayout="row" fxLayoutAlign="space-between center"
                                    style="margin-bottom:16px;">
                                    <h3 style="margin:0;">Activity Timeline</h3>
                                    <div fxLayoutGap="8px">
                                        <button mat-raised-button color="primary" (click)="createNote(null, 0)">Add
                                            Note</button>
                                        <button mat-stroked-button (click)="addLeadActivity('Phone Call', 0, null)">Add
                                            Task</button>
                                    </div>
                                </div>
                                <div class="timeline-body">
                                    <div *ngFor="let group of groupedActivities | keyvalue" class="activity-date-group">
                                        <h4 class="date-header" style="color:#64748b; margin:12px 0 8px 0;">{{ group.key
                                            }}</h4>
                                        <div *ngFor="let item of group.value" class="activity-item"
                                            style="padding:10px 14px; border-left:3px solid #3b82f6; margin-bottom:8px; background:#f8fafc; border-radius:4px;">
                                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                                <span style="font-weight:600; font-size:13px;">{{ item.activityType ||
                                                    item.title || 'Activity' }}</span>
                                                <span style="font-size:12px; color:#94a3b8;">{{ item.createdDate |
                                                    calsoftDate }}</span>
                                            </div>
                                            <p style="margin:4px 0 0 0; font-size:13px; color:#334155;">{{
                                                item.description || item.notes || item.name }}</p>
                                        </div>
                                    </div>
                                    <div *ngIf="!leadActivityList || leadActivityList.length === 0"
                                        style="text-align:center; padding:30px; color:#94a3b8;">
                                        No activities recorded yet.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 9. ACTIVITY -->
                    <div *ngSwitchCase="'activity'">
                        <div class="activity-timeline-feed" style="background:#fff; border-radius:8px; padding:16px;">
                            <div *ngFor="let group of groupedActivities | keyvalue" class="activity-date-group">
                                <h4 class="date-header" style="color:#64748b; margin:12px 0 8px 0;">{{ group.key }}</h4>
                                <div *ngFor="let item of group.value" class="activity-item"
                                    style="padding:10px 14px; border-left:3px solid #3b82f6; margin-bottom:8px; background:#f8fafc; border-radius:4px;">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <span style="font-weight:600; font-size:13px;">{{ item.activityType ||
                                            item.title || 'Activity' }}</span>
                                        <span style="font-size:12px; color:#94a3b8;">{{ item.createdDate | calsoftDate
                                            }}</span>
                                    </div>
                                    <p style="margin:4px 0 0 0; font-size:13px; color:#334155;">{{ item.description ||
                                        item.notes || item.name }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 10. NOTES -->
                    <div *ngSwitchCase="'notes'">
                        <div class="notes-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-bottom:16px;">
                                <h3 style="margin:0;">Notes</h3>
                                <button mat-raised-button color="primary" (click)="createNote(null, 0)">Add
                                    Note</button>
                            </div>
                            <div *ngIf="noteList && noteList.length > 0; else emptyNotesT8">
                                <div *ngFor="let note of noteList" class="note-card"
                                    style="border:1px solid #e2e8f0; border-radius:6px; padding:12px; margin-bottom:12px;">
                                    <div fxLayout="row" fxLayoutAlign="space-between center">
                                        <span style="font-weight:600;">{{note.createdBy}}</span>
                                        <span style="font-size:12px; color:#94a3b8;">{{note.createdDate |
                                            calsoftDate}}</span>
                                    </div>
                                    <p style="margin:8px 0;">{{note.notes}}</p>
                                    <div fxLayout="row" fxLayoutGap="8px">
                                        <button mat-button color="primary"
                                            (click)="toggleReply(note.noteId)">Reply</button>
                                        <button mat-button color="warn" (click)="deleteNote(note)">Delete</button>
                                    </div>
                                    <div *ngIf="replyingToNoteId === note.noteId"
                                        style="display:flex;gap:8px;align-items:flex-start;padding:8px 4px;margin-top:8px;">
                                        <mat-form-field appearance="outline" style="flex:1">
                                            <mat-label>Reply</mat-label>
                                            <textarea matInput rows="2" [(ngModel)]="replyText"
                                                placeholder="Write a reply..."></textarea>
                                        </mat-form-field>
                                        <button mat-raised-button color="primary" [disabled]="!replyText?.trim()"
                                            (click)="submitReply(note)">Send</button>
                                        <button mat-icon-button
                                            (click)="toggleReply(null)"><mat-icon>close</mat-icon></button>
                                    </div>
                                </div>
                            </div>
                            <ng-template #emptyNotesT8>
                                <div style="text-align:center; padding:30px; color:#94a3b8;">No notes found.</div>
                            </ng-template>
                        </div>
                    </div>

                    <!-- 11. TASKS -->
                    <div *ngSwitchCase="'tasks'">
                        <div class="tasks-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                        </div>
                    </div>

                    <!-- 12. MEETINGS -->
                    <div *ngSwitchCase="'meetings'">
                        <div class="meetings-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <calsoft-leadsmeeting [leadId]="leadId" [googleCalendarList]="googleCalendarList"
                                [meetingType]="1" [type]="1" class="width-table"></calsoft-leadsmeeting>
                        </div>
                    </div>

                    <!-- 13. CHATS -->
                    <div *ngSwitchCase="'chats'">
                        <div class="chats-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <div *ngIf="leadLoaded && whatAppchatType === 1">
                                <calsoft-whatsapp-chat-details [contactId]="LeadDetailsObject?.phoneNumber"
                                    [isFromPhone]="true"></calsoft-whatsapp-chat-details>
                            </div>
                            <div *ngIf="leadLoaded && whatAppchatType === 2">
                                <calsoft-whats-app-new-client
                                    [phoneNumber]="LeadDetailsObject?.phoneNumber"></calsoft-whats-app-new-client>
                            </div>
                        </div>
                    </div>

                    <!-- 14. EMAIL -->
                    <div *ngSwitchCase="'email'">
                        <div class="email-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <div class="mailbox-container">
                                <div class="mailbox-toggle-container" style="margin-bottom:12px;">
                                    <mat-button-toggle-group [(value)]="currentMailBox" (change)="loadEmails($event)">
                                        <mat-button-toggle value="INBOX">Inbox</mat-button-toggle>
                                        <mat-button-toggle value="Sent">Sent</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>
                                <div class="mailbox-content">
                                    <mat-nav-list *ngIf="emails && emails.length > 0; else noEmailsT8">
                                        <mat-list-item *ngFor="let email of emails; let i = index"
                                            [ngClass]="{'active': i === selectedIndex}" (click)="selectEmail(i)">
                                            <div style="padding: 8px 0;">
                                                <div style="font-weight:600;">{{email.subject}}</div>
                                                <div style="font-size:12px; color:#64748b;">{{email.from}} &bull;
                                                    {{email.sentDate | date:'medium'}}</div>
                                            </div>
                                        </mat-list-item>
                                    </mat-nav-list>
                                    <ng-template #noEmailsT8>
                                        <div style="text-align:center; padding:30px; color:#94a3b8;">No emails found.
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 15. CALLS -->
                    <div *ngSwitchCase="'calls'">
                        <div class="calls-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <h3 style="margin:0 0 16px 0;">Call History</h3>
                            <div *ngIf="calllist && calllist.length > 0; else noCallsT8">
                                <table id="details" style="width:100%;">
                                    <thead>
                                        <tr>
                                            <th>Call Type</th>
                                            <th>Duration</th>
                                            <th>Agent</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let call of calllist">
                                            <td>{{call.activityType || 'Outbound'}}</td>
                                            <td>{{call.callDuration || '—'}}</td>
                                            <td>{{call.ownerName || call.createdBy || '—'}}</td>
                                            <td>{{call.createdDate | calsoftDate}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <ng-template #noCallsT8>
                                <div style="text-align:center; padding:30px; color:#94a3b8;">No calls recorded.</div>
                            </ng-template>
                        </div>
                    </div>

                    <!-- 16. EMAIL STATUS -->
                    <div *ngSwitchCase="'emailStatus'">
                        <div class="email-status-page" style="background:#fff; border-radius:8px; padding:16px;">
                            <h3 style="margin:0 0 16px 0;">Email Status Logs</h3>
                            <div *ngIf="emailList && emailList.length > 0; else noEmailStatusT8">
                                <table id="details" style="width:100%;">
                                    <thead>
                                        <tr>
                                            <th>Subject</th>
                                            <th>Status</th>
                                            <th>Recipient</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of emailList">
                                            <td>{{item.subject}}</td>
                                            <td>{{item.status || 'Sent'}}</td>
                                            <td>{{item.toEmail || item.email}}</td>
                                            <td>{{item.createdDate | calsoftDate}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <ng-template #noEmailStatusT8>
                                <div style="text-align:center; padding:30px; color:#94a3b8;">No email logs available.
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <!-- 17. COMPANY -->
                    <div *ngSwitchCase="'company'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-account-companies-table [defaultSet]="defaultSet" [type]="1"
                                    [defaultSetType]="defaultSetType"
                                    [leadId]="relatedCompanyId"></calsoft-account-companies-table>
                            </div>
                            <!-- <div class="info-item"><label>Industry</label>
                                    <div class="value-display"><span>{{LeadDetailsObject?.industry || '—'}}</span></div>
                                </div>
                                <div class="info-item"><label>Website</label>
                                    <div class="value-display"><a [href]="LeadDetailsObject?.website"
                                            target="_blank">{{LeadDetailsObject?.website || '—'}}</a></div>
                                </div>
                                <div class="info-item"><label>CR No</label>
                                    <div class="value-display"><span>{{LeadDetailsObject?.CrNo || '—'}}</span></div>
                                </div>
                            </div> -->
                        </div>
                    </div>

                    <!-- 18. DEALS -->
                    <div *ngSwitchCase="'deals'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-deal-table [type]="2" [dealsPrimaryType]="0" [DealType]="2"
                                    [data]="LeadDetailsObject" [defaultSet]="defaultSet"
                                    [defaultSetType]="defaultSetType" [leadId]="leadId"
                                    [dealsTableView]="1"></calsoft-deal-table>
                            </div>
                        </div>
                    </div>

                    <!-- 19. NEXT ACTION -->
                    <div *ngSwitchCase="'nextAction'">
                        <calsoft-next-best-action-card [leadId]="leadId">
                        </calsoft-next-best-action-card>
                    </div>

                    <!-- 20. FILES -->
                    <div *ngSwitchCase="'files'">
                        <div class="card">
                            <div class="width-table">
                                <div class="width-table">
                                    <div class="editSets1 ">
                                        <div class="title " fxLayout="row" fxLayoutAlign="space-between center">
                                            <span>Files</span>

                                            <button [attr.guide]="'lead-detail-btn-t8-file-add' + '__' + sanitizedUrl"
                                                mat-icon-button>
                                                <mat-icon (click)="createFile(null,0)">
                                                    add
                                                </mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                    <div style="overflow-x:auto;">
                                        <table>
                                            <tr>
                                                <th>Name</th>
                                                <th>Owner</th>
                                                <th>File Type</th>
                                                <th>Added On</th>
                                                <th>Download</th>
                                                <th>Action</th>
                                            </tr>
                                            <tr *ngFor="let note of noteList;">
                                                <ng-container
                                                    *ngIf="note.notesDocument && note.notesDocument.length > 0">

                                                    <td>
                                                        <img *ngIf="note.documentType == '4'" width="36" height="36"
                                                            [src]="serverPathNotes + note.notesDocument + cid"
                                                            alt="Uploaded Image">

                                                        <img *ngIf="note.documentType == '1'"
                                                            src="assets/images/mp4.png" width="36" height="36"
                                                            alt="Vedio File">

                                                        <img *ngIf="note.documentType == '2'"
                                                            src="assets/images/mp3.png" width="36" height="36"
                                                            alt="Audio File">

                                                        <img *ngIf="note.documentType == '3'"
                                                            src="assets/images/pdf.png" width="36" height="36"
                                                            alt="PDF File">

                                                        <img *ngIf="note.documentType == '5' || note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                            src="assets/images/docx.png" width="36" height="36"
                                                            alt="DOCX File">

                                                        <img *ngIf="note.documentType == '6' || note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                            src="assets/images/excel.png" width="36" height="36"
                                                            alt="Excel File">
                                                    </td>
                                                    <td>{{note.createdBy}}</td>
                                                    <td>{{note.resource}}</td>
                                                    <td>{{note.createdDate | calsoftDate}}</td>
                                                    <td style="cursor: pointer;"
                                                        (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)">
                                                        <mat-icon>download</mat-icon>
                                                    </td>
                                                    <td style="cursor: pointer;" (click)="deleteNote(note)">
                                                        <mat-icon>delete</mat-icon>
                                                    </td>
                                                </ng-container>

                                            </tr>

                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 21. SEQUENCES -->
                    <div *ngSwitchCase="'sequences'">
                        <div class="width-table">
                            <div class="deal-page1">
                                <calsoft-task-table [type]="2" [leadId]="leadId"></calsoft-task-table>
                            </div>
                        </div>
                    </div>

                    <!-- UNCONFIGURED FALLBACK -->
                    <div *ngSwitchDefault>
                        <div class="unconfigured-section-notice"
                            style="padding: 40px 20px; text-align: center; background: #fff; border-radius: 8px; border: 1px dashed #cbd5e1; margin: 20px 0;">
                            <mat-icon
                                style="font-size: 48px; width: 48px; height: 48px; color: #94a3b8;">extension_off</mat-icon>
                            <h3 style="margin-top: 16px; color: #334155;">Component is not configured</h3>
                            <p style="color: #64748b; font-size: 14px; max-width: 480px; margin: 8px auto 0 auto;">
                                The component key '<strong>{{activeType8ComponentKey || 'empty'}}</strong>' is not
                                currently registered or enabled for rendering.
                            </p>
                        </div>
                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

<ng-template #delete>

    <div class="index-head">
        <span>Delete</span>
    </div>
    <div class="padding-index">
        <span>Do you want to Delete a Lead Activity</span>
    </div>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'lead-detail-btn-276' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>
        <button [attr.guide]="'lead-detail-btn-277' + '__' + sanitizedUrl" [disabled]="textAccount !='OK'"
            (click)="submit()" mat-raised-button>
            {{textAccount}}
            <mat-icon *ngIf="textAccount !='OK' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #makeConnection>

    <div class="index-head popupTitle" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <span>Call Connection</span>
        </div>

        <button [attr.guide]="'lead-detail-btn-278' + '__' + sanitizedUrl" mat-icon-button>
            <mat-icon style="font-size: 18px;" (click)="closeDialog()">
                close
            </mat-icon>
        </button>
    </div>
    <div class="padding-index">
        Are u Sure Want To Make a Call
    </div>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'lead-detail-btn-279' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>
        <button [attr.guide]="'lead-detail-btn-280' + '__' + sanitizedUrl" [disabled]="textCall !='Call'"
            (click)="makeCall()" mat-raised-button>
            {{textCall}}
            <mat-icon *ngIf="textCall !='Call' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>
</ng-template>


<span *ngIf="dialerType == 2 || dialerType == 3">
    <button [attr.guide]="'lead-detail-btn-281' + '__' + sanitizedUrl" mat-button fxHide fxShow.gt-md
        (click)="opendialCall()" class="open-button" *ngIf="!dialerShow">Open Doocti
        Call</button>
</span>


<div *ngIf="dialerType == 2" id="mydailer" class="chat-popup" [ngClass]="{'minimized': isMinimized}">
    <iframe allow="camera *; geolocation *; microphone *; autoplay *; display-capture *" #myFrame
        src="https://app.doocti.com/" [ngStyle]="{'height.px': isMinimized ? 55 : 500}">
    </iframe>
    <div *ngIf="dialerShow" style="background-color: white;" fxLayoutAlign="center center" fxLayoutGap="10px">
        <button [attr.guide]="'lead-detail-btn-282' + '__' + sanitizedUrl" mat-button *ngIf="dialerShow"
            (click)="callANumber(LeadDetailsObject?.phoneNumber)" class="call-btn">
            Call
        </button>
        <button [attr.guide]="'lead-detail-btn-283' + '__' + sanitizedUrl" mat-button *ngIf="dialerShow"
            (click)="minimizeToggle()" class="call-btn">
            {{isMinimized ? 'Maximize' : 'Minimize'}}
        </button>
        <button [attr.guide]="'lead-detail-btn-284' + '__' + sanitizedUrl" mat-button *ngIf="dialerShow"
            (click)="dialClose()" class="cls-btn">Close</button>
    </div>
</div>


<!-- FreJun Dialer (dialerType == 12) is handled globally by layout.component -->


<!-- Right side panel -->
<div *ngIf="dialerEnable" class="dialer-side-panel">
    <!-- <button [attr.guide]="'lead-detail-btn-285' + '__' + sanitizedUrl" class="close-button1" (click)="sendDialPadAction('MINIMIZE_DIAL_PAD')">-</button>
    <button [attr.guide]="'lead-detail-btn-286' + '__' + sanitizedUrl" class="close-button2" (click)="sendDialPadAction('MAXIMIZE_DIAL_PAD')">&</button> -->
    <button [attr.guide]="'lead-detail-btn-287' + '__' + sanitizedUrl" class="close-button"
        (click)="closeDialer()">×</button>
    <iframe #myHelloSendFrame [src]="iframeUrl | safe: 'resourceUrl'"
        allow="microphone *; autoplay *; display-capture *" width="100%" height="100%" frameborder="0"
        (load)="onIframeLoaded()">
    </iframe>
</div>

<div *ngIf="showEditPopup" class="popup-backdrop">
    <div class="popup-container full-width-popup">
        <div class="popup-header">
            <button [attr.guide]="'lead-detail-btn-288' + '__' + sanitizedUrl" mat-icon-button
                (click)="closeEditPopup()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <span class="header-title">Edit Details</span>
        </div>
        <form [formGroup]="firstFormGroup" fxLayoutGap="20px">
            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="50" appearance="outline">
                    <mat-label>Name</mat-label>

                    <ng-container *ngIf="!editMode; else editName">
                        <input [attr.guide]="'lead-detail-inp-289' + '__' + sanitizedUrl" matInput (click)="editForm()"
                            [value]="LeadDetailsObject?.name" />
                    </ng-container>

                    <ng-template #editName>
                        <input [attr.guide]="'lead-detail-inp-name' + '__' + sanitizedUrl" matInput
                            formControlName="Name" placeholder="Name" />
                    </ng-template>

                </mat-form-field>

                <mat-form-field fxFlex="50" appearance="outline">
                    <mat-label>Email</mat-label>

                    <ng-container *ngIf="!editMode; else editEmail">
                        <input [attr.guide]="'lead-detail-inp-290' + '__' + sanitizedUrl" matInput (click)="editForm()"
                            [value]="LeadDetailsObject?.email" />
                    </ng-container>

                    <ng-template #editEmail>
                        <input [attr.guide]="'lead-detail-inp-email' + '__' + sanitizedUrl" matInput
                            formControlName="email" placeholder="Email" />
                    </ng-template>

                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="50" appearance="outline">
                    <mat-label>Phone Number</mat-label>

                    <ng-container *ngIf="!editMode; else editPhoneNo">
                        <input [attr.guide]="'lead-detail-inp-291' + '__' + sanitizedUrl" matInput (click)="editForm()"
                            [value]="LeadDetailsObject?.phoneNumber" />
                    </ng-container>

                    <ng-template #editPhoneNo>
                        <input [attr.guide]="'lead-detail-inp-phonenumber' + '__' + sanitizedUrl" matInput
                            formControlName="phoneNumber" placeholder="phoneNumber" />
                    </ng-template>

                </mat-form-field>

                <mat-form-field fxFlex="50" appearance="outline">
                    <mat-label>Source Name</mat-label>

                    <ng-container *ngIf="!editMode; else editsourceName">
                        <input [attr.guide]="'lead-detail-inp-292' + '__' + sanitizedUrl" matInput (click)="editForm()"
                            [value]="LeadDetailsObject?.sourceName" />
                    </ng-container>

                    <ng-template #editsourceName>
                        <input [attr.guide]="'lead-detail-inp-sourcename' + '__' + sanitizedUrl" matInput
                            formControlName="sourceName" placeholder="SourceName" />
                    </ng-template>

                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutGap="20px">
                <mat-form-field fxFlex="50" appearance="outline">
                    <mat-label>Owner Name</mat-label>

                    <ng-container *ngIf="!editMode; else editownerIdName">
                        <input [attr.guide]="'lead-detail-inp-293' + '__' + sanitizedUrl" matInput (click)="editForm()"
                            [value]="LeadDetailsObject?.ownerIdName" />
                    </ng-container>

                    <ng-template #editownerIdName>
                        <input [attr.guide]="'lead-detail-inp-owneridname' + '__' + sanitizedUrl" matInput
                            formControlName="ownerIdName" placeholder="Owner Name" />
                    </ng-template>

                </mat-form-field>
            </div>

            <!-- <mat-form-field appearance="outline" class="full-width">
                <mat-label>Owner Name</mat-label>

                <ng-container *ngIf="!editMode; else editName">
                    <input [attr.guide]="'lead-detail-inp-294' + '__' + sanitizedUrl" matInput [readonly]="true" [value]="LeadDetailsObject?.ownerIdName"/>
                </ng-container>

                <ng-template #editName>
                    <input [attr.guide]="'lead-detail-inp-owneridname' + '__' + sanitizedUrl" matInput formControlName="ownerIdName" placeholder="Owner Name" />
                </ng-template>

            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>

                <ng-container *ngIf="!editMode; else editName">
                    <input [attr.guide]="'lead-detail-inp-295' + '__' + sanitizedUrl" matInput [readonly]="true" [value]="LeadDetailsObject?.name"/>
                </ng-container>

                <ng-template #editName>
                    <input [attr.guide]="'lead-detail-inp-name' + '__' + sanitizedUrl" matInput formControlName="Name" placeholder="Name" />
                </ng-template>

            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>

                <ng-container *ngIf="!editMode; else editName">
                    <input [attr.guide]="'lead-detail-inp-296' + '__' + sanitizedUrl" matInput [readonly]="true" [value]="LeadDetailsObject?.name"/>
                </ng-container>

                <ng-template #editName>
                    <input [attr.guide]="'lead-detail-inp-name' + '__' + sanitizedUrl" matInput formControlName="Name" placeholder="Name" />
                </ng-template>

            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>

                <ng-container *ngIf="!editMode; else editName">
                    <input [attr.guide]="'lead-detail-inp-297' + '__' + sanitizedUrl" matInput [readonly]="true" [value]="LeadDetailsObject?.name"/>
                </ng-container>

                <ng-template #editName>
                    <input [attr.guide]="'lead-detail-inp-name' + '__' + sanitizedUrl" matInput formControlName="Name" placeholder="Name" />
                </ng-template>

            </mat-form-field> -->

            <div class="actions">
                <button [attr.guide]="'lead-detail-btn-298' + '__' + sanitizedUrl" mat-raised-button color="primary"
                    (click)="checkLeadExist()">Save</button>
                <button [attr.guide]="'lead-detail-btn-299' + '__' + sanitizedUrl" mat-button
                    (click)="closeEditPopup()">Cancel</button>
            </div>
        </form>
    </div>

</div>

<ng-template #emailtemplatedata>

    <div class="index-head">
        <span>Email Status Message</span>
    </div>
    <div class="padding-index">

    </div>

    <div *ngIf="useIndividualMail == 1" class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex>
            <mat-label>From</mat-label>
            <mat-select [formControl]="fromEmailId" [disableOptionCentering]="true" #singleSelect autocomplete="off"
                (selectionChange)="onFromEmailChange($event.value)">
                <mat-option>
                    <ngx-mat-select-search name="Email Search" ngDefaultControl [formControl]="typeEmailYFilterControl"
                        placeholderLabel="Email Search" [preventHomeEndKeyPropagation]="true"
                        noEntriesFoundLabel="No data found">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filteredEmaildropdownTypeList; let i=index;"
                    [value]="opt.userMailConfigId">
                    {{ opt.emailAddress }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="fromEmailId.hasError('required')">
                From Email is required.
            </mat-error>
        </mat-form-field>
    </div>

    <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

        <mat-form-field fxFlex appearance="outline">
            <mat-label>Select Email Template</mat-label>
            <mat-select [formControl]="emailtemplateId" [disableOptionCentering]="true" #singleSelect name="item">
                <mat-option>
                    <ngx-mat-select-search name="Email Template Message Search" ngDefaultControl
                        [formControl]="emailTemplateMessageFilterControl"
                        placeholderLabel="Email Template Message Search" [preventHomeEndKeyPropagation]="true"
                        noEntriesFoundLabel="No data found">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filteredEmailTemplateMessageTypeList;" [value]="opt.emailTemplateId">
                    {{ opt.templateName }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="emailtemplateId.hasError('required')">
                Email Template is required.
            </mat-error>
        </mat-form-field>
    </div>

    <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">


    </div>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'lead-detail-btn-300' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>
        <button [attr.guide]="'lead-detail-btn-301' + '__' + sanitizedUrl" [disabled]="textSend !='Send'"
            (click)="sendMailTemplate()" mat-raised-button>
            {{textSend}}
            <mat-icon *ngIf="textSend !='Send' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>


</ng-template>

<ng-template #tagName>

    <div class="index-head">
        <span>Update Tag</span>
    </div>
    <div class="padding-index">

    </div>

    <div class="padding-10" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">
        <mat-form-field fxFlex appearance="outline">
            <mat-label>Tag Name</mat-label>
            <mat-select [formControl]="tagNames" [disableOptionCentering]="true" #singleSelect name="item" multiple
                required (selectionChange)="onTagSelectionChange($event)">
                <mat-option>
                    <ngx-mat-select-search name="Tag Name Search" ngDefaultControl [formControl]="tagsFilterControl"
                        placeholderLabel="Tag Name Search" [preventHomeEndKeyPropagation]="true"
                        noEntriesFoundLabel="No data found">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index;" [value]="opt.statusName">
                    {{opt.statusName}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="tagNames.hasError('required') || (tagNames.touched && tagNames.invalid)">
                Tag Name is required
            </mat-error>
        </mat-form-field>
    </div>

    <div class="input-row" fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10px">


    </div>

    <div class="padding-10" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
        <button [attr.guide]="'lead-detail-btn-302' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
            tabindex="-1">Cancel</button>

        <button [attr.guide]="'lead-detail-btn-303' + '__' + sanitizedUrl" [disabled]="tagSave !='Save'"
            (click)="tagNameUpdate()" mat-raised-button>
            {{tagSave}}
            <mat-icon *ngIf="tagSave !='Save' ">
                <mat-spinner color="primary" diameter="20">
                </mat-spinner>
            </mat-icon>
        </button>
    </div>


</ng-template>



<ng-template #downloadDocument>


    <div class="padding-11" style="overflow-x: auto;">
        <div class="editSets" fxLayout="column">
            <calsoft-list [disableFilter]="1" (filterChangeColumn)="onFilterChangeColumn($event)"
                (filterChange)="onFilterChange($event)" name="Document" [filterSelectObj]="filterSelectObj"
                [columns]="columns" style="margin-bottom: 0px;">

                <div id="responsieTable" class="container">
                    <div [ngClass]="documentList.length>=5?'minimum':'none'">
                        <table class="rwd-table">
                            <tbody>
                                <tr>
                                    <th>Image</th>
                                    <th>Name</th>
                                    <th>Download</th>


                                </tr>

                                <tr *ngFor="let note of documentList;">
                                    <ng-container *ngIf="documentList.length > 0">

                                        <td>
                                            <!-- If Image -->
                                            <img *ngIf="note.documentType == '4'" width="36" height="36"
                                                [src]="serverPathNotes + note.notesDocument + cid" alt="Uploaded Image">

                                            <!-- If Vedio -->

                                            <img *ngIf="note.documentType == '1'" src="assets/images/mp4.png" width="36"
                                                height="36" alt="Vedio File">

                                            <!-- If Audio -->

                                            <img *ngIf="note.documentType == '2'" src="assets/images/mp3.png" width="36"
                                                height="36" alt="Audio File">

                                            <!-- If Pdf -->
                                            <img *ngIf="note.documentType == '3'" src="assets/images/pdf.png" width="36"
                                                height="36" alt="PDF File">

                                            <!-- If Word -->
                                            <img *ngIf="note.documentType == '5' || note.notesDocument?.endsWith('.doc') || note.notesDocument?.endsWith('.docx')"
                                                src="assets/images/docx.png" width="36" height="36" alt="DOCX File">

                                            <!-- If Excel -->
                                            <img *ngIf="note.documentType == '6' || note.notesDocument?.endsWith('.xls') || note.notesDocument?.endsWith('.xlsx')"
                                                src="assets/images/excel.png" width="36" height="36" alt="Excel File">

                                            <!-- {{ note.notesDocument }} -->
                                        </td>
                                        <td>
                                            {{note.notesDocument}}
                                        </td>
                                        <td style="cursor: pointer;"
                                            (click)="downloadNew(serverPathNotes + note.notesDocument + cid , note.documentType)">
                                            <mat-icon>download</mat-icon>
                                        </td>
                                    </ng-container>

                                </tr>
                            </tbody>
                        </table>
                        <div fxLayout="row" *ngIf="documentList.length==0" fxLayoutAlign="center center">
                            <span>No Records Found</span>
                        </div>
                    </div>
                </div>

                <div fxLayout="row" class="pager" fxLayoutAlign="end center" fxLayoutGap="5px">
                    <mat-spinner [diameter]="20" *ngIf="spinner"></mat-spinner>
                    <mat-paginator class="paginator" (page)="getUpdate($event)" showFirstLastButtons [length]="pageList"
                        [pageIndex]="page" [pageSize]="size" [pageSizeOptions]="pageSizeValue">
                    </mat-paginator>
                </div>
            </calsoft-list>
        </div>
        <div class="padding-top10 " fxLayoutGap="10px">

            <button [attr.guide]="'lead-detail-btn-304' + '__' + sanitizedUrl" mat-raised-button mat-dialog-close
                tabindex="-1">Cancel</button>
        </div>
    </div>


</ng-template>